algoliaShopify.externals = function(e) {
    function t(n) {
        if (r[n]) return r[n].exports;
        var i = r[n] = {
            i: n,
            l: !1,
            exports: {}
        };
        return e[n].call(i.exports, i, i.exports, t), i.l = !0, i.exports
    }
    var r = {};
    return t.m = e, t.c = r, t.d = function(e, r, n) {
        t.o(e, r) || Object.defineProperty(e, r, {
            configurable: !1,
            enumerable: !0,
            get: n
        })
    }, t.n = function(e) {
        var r = e && e.__esModule ? function() {
            return e.default
        } : function() {
            return e
        };
        return t.d(r, "a", r), r
    }, t.o = function(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t)
    }, t.p = "", t(t.s = 75)
}([function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = r(30);
    Object.keys(n).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === n[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return n[e]
            }
        }))
    });
    var i = r(31);
    Object.keys(i).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === i[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return i[e]
            }
        }))
    });
    var o = r(79);
    Object.keys(o).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === o[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return o[e]
            }
        }))
    });
    var a = r(80);
    Object.keys(a).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === a[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return a[e]
            }
        }))
    });
    var u = r(81);
    Object.keys(u).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === u[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return u[e]
            }
        }))
    });
    var c = r(82);
    Object.keys(c).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === c[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return c[e]
            }
        }))
    });
    var s = r(83);
    Object.keys(s).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === s[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return s[e]
            }
        }))
    });
    var l = r(84);
    Object.keys(l).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === l[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return l[e]
            }
        }))
    });
    var f = r(85);
    Object.keys(f).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === f[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return f[e]
            }
        }))
    });
    var p = r(19);
    Object.keys(p).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === p[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return p[e]
            }
        }))
    });
    var d = r(86);
    Object.keys(d).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === d[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return d[e]
            }
        }))
    });
    var h = r(87);
    Object.keys(h).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === h[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return h[e]
            }
        }))
    });
    var m = r(88);
    Object.keys(m).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === m[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return m[e]
            }
        }))
    });
    var y = r(17);
    Object.keys(y).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === y[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return y[e]
            }
        }))
    });
    var b = r(18);
    Object.keys(b).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === b[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return b[e]
            }
        }))
    });
    var v = r(38);
    Object.keys(v).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === v[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return v[e]
            }
        }))
    });
    var g = r(39);
    Object.keys(g).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === g[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return g[e]
            }
        }))
    });
    var _ = r(40);
    Object.keys(_).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === _[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return _[e]
            }
        }))
    });
    var O = r(89);
    Object.keys(O).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === O[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return O[e]
            }
        }))
    });
    var j = r(90);
    Object.keys(j).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === j[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return j[e]
            }
        }))
    });
    var P = r(91);
    Object.keys(P).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === P[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return P[e]
            }
        }))
    });
    var S = r(92);
    Object.keys(S).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === S[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return S[e]
            }
        }))
    });
    var w = r(42);
    Object.keys(w).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === w[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return w[e]
            }
        }))
    });
    var E = r(34);
    Object.keys(E).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === E[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return E[e]
            }
        }))
    });
    var R = r(93);
    Object.keys(R).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === R[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return R[e]
            }
        }))
    });
    var x = r(94);
    Object.keys(x).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === x[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return x[e]
            }
        }))
    });
    var I = r(95);
    Object.keys(I).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === I[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return I[e]
            }
        }))
    });
    var k = r(96);
    Object.keys(k).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === k[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return k[e]
            }
        }))
    });
    var M = r(97);
    Object.keys(M).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === M[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return M[e]
            }
        }))
    });
    var A = r(41);
    Object.keys(A).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === A[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return A[e]
            }
        }))
    });
    var N = r(98);
    Object.keys(N).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === N[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return N[e]
            }
        }))
    });
    var C = r(36);
    Object.keys(C).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === C[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return C[e]
            }
        }))
    });
    var T = r(99);
    Object.keys(T).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === T[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return T[e]
            }
        }))
    });
    var F = r(35);
    Object.keys(F).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === F[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return F[e]
            }
        }))
    });
    var D = r(100);
    Object.keys(D).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === D[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return D[e]
            }
        }))
    });
    var H = r(101);
    Object.keys(H).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === H[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return H[e]
            }
        }))
    });
    var L = r(32);
    Object.keys(L).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === L[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return L[e]
            }
        }))
    });
    var q = r(102);
    Object.keys(q).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === q[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return q[e]
            }
        }))
    });
    var B = r(103);
    Object.keys(B).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === B[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return B[e]
            }
        }))
    });
    var U = r(33);
    Object.keys(U).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === U[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return U[e]
            }
        }))
    });
    var W = r(104);
    Object.keys(W).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === W[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return W[e]
            }
        }))
    });
    var V = r(105);
    Object.keys(V).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === V[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return V[e]
            }
        }))
    });
    var Q = r(106);
    Object.keys(Q).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === Q[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return Q[e]
            }
        }))
    });
    var $ = r(107);
    Object.keys($).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === $[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return $[e]
            }
        }))
    });
    var G = r(108);
    Object.keys(G).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === G[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return G[e]
            }
        }))
    });
    var K = r(37);
    Object.keys(K).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === K[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return K[e]
            }
        }))
    });
    var J = r(109);
    Object.keys(J).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === J[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return J[e]
            }
        }))
    });
    var z = r(20);
    Object.keys(z).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === z[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return z[e]
            }
        }))
    })
}, function(e, t, r) {
    "use strict";

    function n(e) {
        return e && e.__esModule ? e : {
            default: e
        }
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports
}, function(e, t, r) {
    "use strict";

    function n(e, t) {
        for (var r in t) e[r] = t[r];
        return e
    }

    function i(e) {
        var t = e.parentNode;
        t && t.removeChild(e)
    }

    function o(e, t, r) {
        var n, i, o, u = {};
        for (o in t) "key" == o ? n = t[o] : "ref" == o ? i = t[o] : u[o] = t[o];
        if (arguments.length > 2 && (u.children = arguments.length > 3 ? C.call(arguments, 2) : r), "function" == typeof e && null != e.defaultProps)
            for (o in e.defaultProps) void 0 === u[o] && (u[o] = e.defaultProps[o]);
        return a(e, u, n, i, null)
    }

    function a(e, t, r, n, i) {
        var o = {
            type: e,
            props: t,
            key: r,
            ref: n,
            __k: null,
            __: null,
            __b: 0,
            __e: null,
            __d: void 0,
            __c: null,
            __h: null,
            constructor: void 0,
            __v: null == i ? ++F : i
        };
        return null == i && null != T.vnode && T.vnode(o), o
    }

    function u() {
        return {
            current: null
        }
    }

    function c(e) {
        return e.children
    }

    function s(e, t) {
        this.props = e, this.context = t
    }

    function l(e, t) {
        if (null == t) return e.__ ? l(e.__, e.__.__k.indexOf(e) + 1) : null;
        for (var r; t < e.__k.length; t++)
            if (null != (r = e.__k[t]) && null != r.__e) return r.__e;
        return "function" == typeof e.type ? l(e) : null
    }

    function f(e) {
        var t, r;
        if (null != (e = e.__) && null != e.__c) {
            for (e.__e = e.__c.base = null, t = 0; t < e.__k.length; t++)
                if (null != (r = e.__k[t]) && null != r.__e) {
                    e.__e = e.__c.base = r.__e;
                    break
                }
            return f(e)
        }
    }

    function p(e) {
        (!e.__d && (e.__d = !0) && H.push(e) && !d.__r++ || L !== T.debounceRendering) && ((L = T.debounceRendering) || q)(d)
    }

    function d() {
        var e, t, r, i, o, a, u, c;
        for (H.sort(B); e = H.shift();) e.__d && (t = H.length, i = void 0, o = void 0, u = (a = (r = e).__v).__e, (c = r.__P) && (i = [], (o = n({}, a)).__v = a.__v + 1, S(c, a, o, r.__n, void 0 !== c.ownerSVGElement, null != a.__h ? [u] : null, i, null == u ? l(a) : u, a.__h), w(i, a), a.__e != u && f(a)), H.length > t && H.sort(B));
        d.__r = 0
    }

    function h(e, t, r, n, i, o, u, s, f, p) {
        var d, h, y, g, _, O, j, P = n && n.__k || V,
            w = P.length;
        for (r.__k = [], d = 0; d < t.length; d++)
            if (null != (g = r.__k[d] = null == (g = t[d]) || "boolean" == typeof g || "function" == typeof g ? null : "string" == typeof g || "number" == typeof g || "bigint" == typeof g ? a(null, g, null, null, g) : $(g) ? a(c, {
                    children: g
                }, null, null, null) : g.__b > 0 ? a(g.type, g.props, g.key, g.ref ? g.ref : null, g.__v) : g)) {
                if (g.__ = r, g.__b = r.__b + 1, null === (y = P[d]) || y && g.key == y.key && g.type === y.type) P[d] = void 0;
                else
                    for (h = 0; h < w; h++) {
                        if ((y = P[h]) && g.key == y.key && g.type === y.type) {
                            P[h] = void 0;
                            break
                        }
                        y = null
                    }
                S(e, g, y = y || W, i, o, u, s, f, p), _ = g.__e, (h = g.ref) && y.ref != h && (j || (j = []), y.ref && j.push(y.ref, null, g), j.push(h, g.__c || _, g)), null != _ ? (null == O && (O = _), "function" == typeof g.type && g.__k === y.__k ? g.__d = f = m(g, f, e) : f = b(e, g, y, P, _, f), "function" == typeof r.type && (r.__d = f)) : f && y.__e == f && f.parentNode != e && (f = l(y))
            }
        for (r.__e = O, d = w; d--;) null != P[d] && ("function" == typeof r.type && null != P[d].__e && P[d].__e == r.__d && (r.__d = v(n).nextSibling), x(P[d], P[d]));
        if (j)
            for (d = 0; d < j.length; d++) R(j[d], j[++d], j[++d])
    }

    function m(e, t, r) {
        for (var n, i = e.__k, o = 0; i && o < i.length; o++)(n = i[o]) && (n.__ = e, t = "function" == typeof n.type ? m(n, t, r) : b(r, n, n, i, n.__e, t));
        return t
    }

    function y(e, t) {
        return t = t || [], null == e || "boolean" == typeof e || ($(e) ? e.some(function(e) {
            y(e, t)
        }) : t.push(e)), t
    }

    function b(e, t, r, n, i, o) {
        var a, u, c;
        if (void 0 !== t.__d) a = t.__d, t.__d = void 0;
        else if (null == r || i != o || null == i.parentNode) e: if (null == o || o.parentNode !== e) e.appendChild(i), a = null;
            else {
                for (u = o, c = 0;
                    (u = u.nextSibling) && c < n.length; c += 1)
                    if (u == i) break e;
                e.insertBefore(i, o), a = o
            }
        return void 0 !== a ? a : i.nextSibling
    }

    function v(e) {
        var t, r, n;
        if (null == e.type || "string" == typeof e.type) return e.__e;
        if (e.__k)
            for (t = e.__k.length - 1; t >= 0; t--)
                if ((r = e.__k[t]) && (n = v(r))) return n;
        return null
    }

    function g(e, t, r, n, i) {
        var o;
        for (o in r) "children" === o || "key" === o || o in t || O(e, o, null, r[o], n);
        for (o in t) i && "function" != typeof t[o] || "children" === o || "key" === o || "value" === o || "checked" === o || r[o] === t[o] || O(e, o, t[o], r[o], n)
    }

    function _(e, t, r) {
        "-" === t[0] ? e.setProperty(t, null == r ? "" : r) : e[t] = null == r ? "" : "number" != typeof r || Q.test(t) ? r : r + "px"
    }

    function O(e, t, r, n, i) {
        var o;
        e: if ("style" === t)
            if ("string" == typeof r) e.style.cssText = r;
            else {
                if ("string" == typeof n && (e.style.cssText = n = ""), n)
                    for (t in n) r && t in r || _(e.style, t, "");
                if (r)
                    for (t in r) n && r[t] === n[t] || _(e.style, t, r[t])
            }
        else if ("o" === t[0] && "n" === t[1]) o = t !== (t = t.replace(/Capture$/, "")), t = t.toLowerCase() in e ? t.toLowerCase().slice(2) : t.slice(2), e.l || (e.l = {}), e.l[t + o] = r, r ? n || e.addEventListener(t, o ? P : j, o) : e.removeEventListener(t, o ? P : j, o);
        else if ("dangerouslySetInnerHTML" !== t) {
            if (i) t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
            else if ("width" !== t && "height" !== t && "href" !== t && "list" !== t && "form" !== t && "tabIndex" !== t && "download" !== t && "rowSpan" !== t && "colSpan" !== t && t in e) try {
                e[t] = null == r ? "" : r;
                break e
            } catch (e) {}
            "function" == typeof r || (null == r || !1 === r && "-" !== t[4] ? e.removeAttribute(t) : e.setAttribute(t, r))
        }
    }

    function j(e) {
        return this.l[e.type + !1](T.event ? T.event(e) : e)
    }

    function P(e) {
        return this.l[e.type + !0](T.event ? T.event(e) : e)
    }

    function S(e, t, r, i, o, a, u, l, f) {
        var p, d, m, y, b, v, g, _, O, j, P, S, w, R, x, k = t.type;
        if (void 0 !== t.constructor) return null;
        null != r.__h && (f = r.__h, l = t.__e = r.__e, t.__h = null, a = [l]), (p = T.__b) && p(t);
        try {
            e: if ("function" == typeof k) {
                if (_ = t.props, O = (p = k.contextType) && i[p.__c], j = p ? O ? O.props.value : p.__ : i, r.__c ? g = (d = t.__c = r.__c).__ = d.__E : ("prototype" in k && k.prototype.render ? t.__c = d = new k(_, j) : (t.__c = d = new s(_, j), d.constructor = k, d.render = I), O && O.sub(d), d.props = _, d.state || (d.state = {}), d.context = j, d.__n = i, m = d.__d = !0, d.__h = [], d._sb = []), null == d.__s && (d.__s = d.state), null != k.getDerivedStateFromProps && (d.__s == d.state && (d.__s = n({}, d.__s)), n(d.__s, k.getDerivedStateFromProps(_, d.__s))), y = d.props, b = d.state, d.__v = t, m) null == k.getDerivedStateFromProps && null != d.componentWillMount && d.componentWillMount(), null != d.componentDidMount && d.__h.push(d.componentDidMount);
                else {
                    if (null == k.getDerivedStateFromProps && _ !== y && null != d.componentWillReceiveProps && d.componentWillReceiveProps(_, j), !d.__e && null != d.shouldComponentUpdate && !1 === d.shouldComponentUpdate(_, d.__s, j) || t.__v === r.__v) {
                        for (t.__v !== r.__v && (d.props = _, d.state = d.__s, d.__d = !1), d.__e = !1, t.__e = r.__e, t.__k = r.__k, t.__k.forEach(function(e) {
                                e && (e.__ = t)
                            }), P = 0; P < d._sb.length; P++) d.__h.push(d._sb[P]);
                        d._sb = [], d.__h.length && u.push(d);
                        break e
                    }
                    null != d.componentWillUpdate && d.componentWillUpdate(_, d.__s, j), null != d.componentDidUpdate && d.__h.push(function() {
                        d.componentDidUpdate(y, b, v)
                    })
                }
                if (d.context = j, d.props = _, d.__P = e, S = T.__r, w = 0, "prototype" in k && k.prototype.render) {
                    for (d.state = d.__s, d.__d = !1, S && S(t), p = d.render(d.props, d.state, d.context), R = 0; R < d._sb.length; R++) d.__h.push(d._sb[R]);
                    d._sb = []
                } else
                    do {
                        d.__d = !1, S && S(t), p = d.render(d.props, d.state, d.context), d.state = d.__s
                    } while (d.__d && ++w < 25);
                d.state = d.__s, null != d.getChildContext && (i = n(n({}, i), d.getChildContext())), m || null == d.getSnapshotBeforeUpdate || (v = d.getSnapshotBeforeUpdate(y, b)), h(e, $(x = null != p && p.type === c && null == p.key ? p.props.children : p) ? x : [x], t, r, i, o, a, u, l, f), d.base = t.__e, t.__h = null, d.__h.length && u.push(d), g && (d.__E = d.__ = null), d.__e = !1
            } else null == a && t.__v === r.__v ? (t.__k = r.__k, t.__e = r.__e) : t.__e = E(r.__e, t, r, i, o, a, u, f);
            (p = T.diffed) && p(t)
        }
        catch (e) {
            t.__v = null, (f || null != a) && (t.__e = l, t.__h = !!f, a[a.indexOf(l)] = null), T.__e(e, t, r)
        }
    }

    function w(e, t) {
        T.__c && T.__c(t, e), e.some(function(t) {
            try {
                e = t.__h, t.__h = [], e.some(function(e) {
                    e.call(t)
                })
            } catch (e) {
                T.__e(e, t.__v)
            }
        })
    }

    function E(e, t, r, n, o, a, u, c) {
        var s, f, p, d = r.props,
            m = t.props,
            y = t.type,
            b = 0;
        if ("svg" === y && (o = !0), null != a)
            for (; b < a.length; b++)
                if ((s = a[b]) && "setAttribute" in s == !!y && (y ? s.localName === y : 3 === s.nodeType)) {
                    e = s, a[b] = null;
                    break
                }
        if (null == e) {
            if (null === y) return document.createTextNode(m);
            e = o ? document.createElementNS("http://www.w3.org/2000/svg", y) : document.createElement(y, m.is && m), a = null, c = !1
        }
        if (null === y) d === m || c && e.data === m || (e.data = m);
        else {
            if (a = a && C.call(e.childNodes), f = (d = r.props || W).dangerouslySetInnerHTML, p = m.dangerouslySetInnerHTML, !c) {
                if (null != a)
                    for (d = {}, b = 0; b < e.attributes.length; b++) d[e.attributes[b].name] = e.attributes[b].value;
                (p || f) && (p && (f && p.__html == f.__html || p.__html === e.innerHTML) || (e.innerHTML = p && p.__html || ""))
            }
            if (g(e, m, d, o, c), p) t.__k = [];
            else if (h(e, $(b = t.props.children) ? b : [b], t, r, n, o && "foreignObject" !== y, a, u, a ? a[0] : r.__k && l(r, 0), c), null != a)
                for (b = a.length; b--;) null != a[b] && i(a[b]);
            c || ("value" in m && void 0 !== (b = m.value) && (b !== e.value || "progress" === y && !b || "option" === y && b !== d.value) && O(e, "value", b, d.value, !1), "checked" in m && void 0 !== (b = m.checked) && b !== e.checked && O(e, "checked", b, d.checked, !1))
        }
        return e
    }

    function R(e, t, r) {
        try {
            "function" == typeof e ? e(t) : e.current = t
        } catch (e) {
            T.__e(e, r)
        }
    }

    function x(e, t, r) {
        var n, o;
        if (T.unmount && T.unmount(e), (n = e.ref) && (n.current && n.current !== e.__e || R(n, null, t)), null != (n = e.__c)) {
            if (n.componentWillUnmount) try {
                n.componentWillUnmount()
            } catch (e) {
                T.__e(e, t)
            }
            n.base = n.__P = null, e.__c = void 0
        }
        if (n = e.__k)
            for (o = 0; o < n.length; o++) n[o] && x(n[o], t, r || "function" != typeof e.type);
        r || null == e.__e || i(e.__e), e.__ = e.__e = e.__d = void 0
    }

    function I(e, t, r) {
        return this.constructor(e, r)
    }

    function k(e, t, r) {
        var n, i, a;
        T.__ && T.__(e, t), i = (n = "function" == typeof r) ? null : r && r.__k || t.__k, a = [], S(t, e = (!n && r || t).__k = o(c, null, [e]), i || W, W, void 0 !== t.ownerSVGElement, !n && r ? [r] : i ? null : t.firstChild ? C.call(t.childNodes) : null, a, !n && r ? r : i ? i.__e : t.firstChild, n), w(a, e)
    }

    function M(e, t) {
        k(e, t, M)
    }

    function A(e, t, r) {
        var i, o, u, c, s = n({}, e.props);
        for (u in e.type && e.type.defaultProps && (c = e.type.defaultProps), t) "key" == u ? i = t[u] : "ref" == u ? o = t[u] : s[u] = void 0 === t[u] && void 0 !== c ? c[u] : t[u];
        return arguments.length > 2 && (s.children = arguments.length > 3 ? C.call(arguments, 2) : r), a(e.type, s, i || e.key, o || e.ref, null)
    }

    function N(e, t) {
        var r = {
            __c: t = "__cC" + U++,
            __: e,
            Consumer: function(e, t) {
                return e.children(t)
            },
            Provider: function(e) {
                var r, n;
                return this.getChildContext || (r = [], (n = {})[t] = this, this.getChildContext = function() {
                    return n
                }, this.shouldComponentUpdate = function(e) {
                    this.props.value !== e.value && r.some(function(e) {
                        e.__e = !0, p(e)
                    })
                }, this.sub = function(e) {
                    r.push(e);
                    var t = e.componentWillUnmount;
                    e.componentWillUnmount = function() {
                        r.splice(r.indexOf(e), 1), t && t.call(e)
                    }
                }), e.children
            }
        };
        return r.Provider.__ = r.Consumer.contextType = r
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.Component = s, t.Fragment = c, t.cloneElement = A, t.createContext = N, t.h = t.createElement = o, t.createRef = u, t.hydrate = M, t.options = t.isValidElement = void 0, t.render = k, t.toChildArray = y;
    var C, T, F, D, H, L, q, B, U, W = {},
        V = [],
        Q = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i,
        $ = Array.isArray;
    t.isValidElement = D, t.options = T, C = V.slice, t.options = T = {
        __e: function(e, t, r, n) {
            for (var i, o, a; t = t.__;)
                if ((i = t.__c) && !i.__) try {
                    if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(e)), a = i.__d), null != i.componentDidCatch && (i.componentDidCatch(e, n || {}), a = i.__d), a) return i.__E = i
                } catch (t) {
                    e = t
                }
            throw e
        }
    }, F = 0, t.isValidElement = D = function(e) {
        return null != e && void 0 === e.constructor
    }, s.prototype.setState = function(e, t) {
        var r;
        r = null != this.__s && this.__s !== this.state ? this.__s : this.__s = n({}, this.state), "function" == typeof e && (e = e(n({}, r), this.props)), e && n(r, e), null != e && this.__v && (t && this._sb.push(t), p(this))
    }, s.prototype.forceUpdate = function(e) {
        this.__v && (this.__e = !0, e && this.__h.push(e), p(this))
    }, s.prototype.render = c, H = [], q = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, B = function(e, t) {
        return e.__v.__b - t.__v.__b
    }, d.__r = 0, U = 0
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = r(276);
    Object.keys(n).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === n[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return n[e]
            }
        }))
    });
    var i = r(277);
    Object.keys(i).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === i[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return i[e]
            }
        }))
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = r(164);
    Object.keys(n).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === n[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return n[e]
            }
        }))
    });
    var i = r(165);
    Object.keys(i).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === i[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return i[e]
            }
        }))
    });
    var o = r(166);
    Object.keys(o).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === o[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return o[e]
            }
        }))
    });
    var a = r(167);
    Object.keys(a).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === a[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return a[e]
            }
        }))
    });
    var u = r(168);
    Object.keys(u).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === u[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return u[e]
            }
        }))
    });
    var c = r(169);
    Object.keys(c).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === c[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return c[e]
            }
        }))
    });
    var s = r(170);
    Object.keys(s).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === s[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return s[e]
            }
        }))
    });
    var l = r(171);
    Object.keys(l).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === l[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return l[e]
            }
        }))
    });
    var f = r(172);
    Object.keys(f).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === f[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return f[e]
            }
        }))
    });
    var p = r(173);
    Object.keys(p).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === p[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return p[e]
            }
        }))
    });
    var d = r(174);
    Object.keys(d).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === d[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return d[e]
            }
        }))
    });
    var h = r(175);
    Object.keys(h).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === h[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return h[e]
            }
        }))
    });
    var m = r(176);
    Object.keys(m).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === m[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return m[e]
            }
        }))
    });
    var y = r(177);
    Object.keys(y).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === y[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return y[e]
            }
        }))
    });
    var b = r(53);
    Object.keys(b).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === b[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return b[e]
            }
        }))
    });
    var v = r(178);
    Object.keys(v).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === v[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return v[e]
            }
        }))
    });
    var g = r(54);
    Object.keys(g).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === g[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return g[e]
            }
        }))
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.component = void 0;
    var n = function(e) {
        return function() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                r = t.descendantName,
                n = t.modifierName,
                i = r ? "-".concat(r) : "",
                o = n ? "--".concat(n) : "";
            return "".concat("ais", "-").concat(e).concat(i).concat(o)
        }
    };
    t.component = n
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = r(198);
    Object.keys(n).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === n[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return n[e]
            }
        }))
    });
    var i = r(199);
    Object.keys(i).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === i[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return i[e]
            }
        }))
    });
    var o = r(200);
    Object.keys(o).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === o[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return o[e]
            }
        }))
    });
    var a = r(201);
    Object.keys(a).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === a[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return a[e]
            }
        }))
    });
    var u = r(202);
    Object.keys(u).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === u[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return u[e]
            }
        }))
    });
    var c = r(203);
    Object.keys(c).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === c[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return c[e]
            }
        }))
    });
    var s = r(204);
    Object.keys(s).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === s[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return s[e]
            }
        }))
    });
    var l = r(205);
    Object.keys(l).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === l[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return l[e]
            }
        }))
    });
    var f = r(206);
    Object.keys(f).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === f[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return f[e]
            }
        }))
    })
}, function(e, t, r) {
    "use strict";

    function n() {
        return n = Object.assign ? Object.assign.bind() : function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = arguments[t];
                for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
            }
            return e
        }, n.apply(this, arguments)
    }

    function i(e) {
        "@babel/helpers - typeof";
        return (i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function o(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
    }

    function a(e, t) {
        for (var r = 0; r < t.length; r++) {
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, m(n.key), n)
        }
    }

    function u(e, t, r) {
        return t && a(e.prototype, t), r && a(e, r), Object.defineProperty(e, "prototype", {
            writable: !1
        }), e
    }

    function c(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
            constructor: {
                value: e,
                writable: !0,
                configurable: !0
            }
        }), Object.defineProperty(e, "prototype", {
            writable: !1
        }), t && s(e, t)
    }

    function s(e, t) {
        return (s = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
            return e.__proto__ = t, e
        })(e, t)
    }

    function l(e) {
        var t = d();
        return function() {
            var r, n = h(e);
            if (t) {
                var i = h(this).constructor;
                r = Reflect.construct(n, arguments, i)
            } else r = n.apply(this, arguments);
            return f(this, r)
        }
    }

    function f(e, t) {
        if (t && ("object" === i(t) || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return p(e)
    }

    function p(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e
    }

    function d() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0
        } catch (e) {
            return !1
        }
    }

    function h(e) {
        return (h = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e)
        })(e)
    }

    function m(e) {
        var t = y(e, "string");
        return "symbol" === i(t) ? t : String(t)
    }

    function y(e, t) {
        if ("object" !== i(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" !== i(n)) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var b = r(2),
        v = r(10),
        g = r(0),
        _ = {
            data: {},
            rootTagName: "div",
            useCustomCompileOptions: {},
            templates: {},
            templatesConfig: {}
        },
        O = function(e) {
            function t() {
                return o(this, t), r.apply(this, arguments)
            }
            c(t, e);
            var r = l(t);
            return u(t, [{
                key: "shouldComponentUpdate",
                value: function(e) {
                    return !(0, g.isEqual)(this.props.data, e.data) || this.props.templateKey !== e.templateKey || !(0, g.isEqual)(this.props.rootProps, e.rootProps)
                }
            }, {
                key: "render",
                value: function() {
                    var e = this.props.rootTagName,
                        t = this.props.useCustomCompileOptions[this.props.templateKey],
                        r = t ? this.props.templatesConfig.compileOptions : {},
                        o = (0, v.renderTemplate)({
                            templates: this.props.templates,
                            templateKey: this.props.templateKey,
                            compileOptions: r,
                            helpers: this.props.templatesConfig.helpers,
                            data: this.props.data,
                            bindEvent: this.props.bindEvent,
                            sendEvent: this.props.sendEvent
                        });
                    return null === o ? null : "object" === i(o) ? (0, b.h)(e, this.props.rootProps, o) : (0, b.h)(e, n({}, this.props.rootProps, {
                        dangerouslySetInnerHTML: {
                            __html: o
                        }
                    }))
                }
            }]), t
        }(b.Component);
    ! function(e, t, r) {
        t = m(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r
    }(O, "defaultProps", _);
    var j = O;
    t.default = j
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return t.default = n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        }, n(e)
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = n
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = r(234);
    Object.keys(n).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === n[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return n[e]
            }
        }))
    });
    var i = r(235);
    Object.keys(i).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === i[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return i[e]
            }
        }))
    });
    var o = r(236);
    Object.keys(o).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === o[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return o[e]
            }
        }))
    });
    var a = r(237);
    Object.keys(a).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === a[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return a[e]
            }
        }))
    });
    var u = r(238);
    Object.keys(u).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === u[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return u[e]
            }
        }))
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = r(283);
    Object.keys(n).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === n[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return n[e]
            }
        }))
    });
    var i = r(284);
    Object.keys(i).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === i[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return i[e]
            }
        }))
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = r(247);
    Object.keys(n).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === n[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return n[e]
            }
        }))
    });
    var i = r(253);
    Object.keys(i).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === i[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return i[e]
            }
        }))
    });
    var o = r(65);
    Object.keys(o).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === o[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return o[e]
            }
        }))
    });
    var a = r(259);
    Object.keys(a).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === a[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return a[e]
            }
        }))
    })
}, function(e, t, r) {
    "use strict";

    function n(e) {
        return "object" === (0, c.default)(e) && null !== e ? o(Array.isArray(e) ? [] : {}, e) : e
    }

    function i(e) {
        return "function" == typeof e || Array.isArray(e) || "[object Object]" === Object.prototype.toString.call(e)
    }

    function o(e, t) {
        if (e === t) return e;
        for (var r in t)
            if (Object.prototype.hasOwnProperty.call(t, r) && "__proto__" !== r && "constructor" !== r) {
                var a = t[r],
                    u = e[r];
                void 0 !== u && void 0 === a || (i(u) && i(a) ? e[r] = o(u, a) : e[r] = n(a))
            }
        return e
    }

    function a(e) {
        i(e) || (e = {});
        for (var t = 1, r = arguments.length; t < r; t++) {
            var n = arguments[t];
            i(n) && o(e, n)
        }
        return e
    }
    var u = r(1),
        c = u(r(8));
    e.exports = a
}, function(e, t, r) {
    "use strict";
    e.exports = function(e, t) {
        if (Array.isArray(e))
            for (var r = 0; r < e.length; r++)
                if (t(e[r])) return e[r]
    }
}, function(e, t, r) {
    "use strict";

    function n(e, t) {
        return e.toLocaleString(t)
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.formatNumber = n
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.InternalHighlight = void 0;
    var n = r(291),
        i = r(2),
        o = (0, n.createHighlightComponent)({
            createElement: i.createElement,
            Fragment: i.Fragment
        });
    t.InternalHighlight = o
}, function(e, t, r) {
    "use strict";

    function n(e) {
        if ("function" != typeof WeakMap) return null;
        var t = new WeakMap,
            r = new WeakMap;
        return (n = function(e) {
            return e ? r : t
        })(e)
    }

    function i(e, t) {
        if (!t && e && e.__esModule) return e;
        if (null === e || "object" !== a(e) && "function" != typeof e) return {
            default: e
        };
        var r = n(t);
        if (r && r.has(e)) return r.get(e);
        var i = {},
            o = Object.defineProperty && Object.getOwnPropertyDescriptor;
        for (var u in e)
            if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
                var c = o ? Object.getOwnPropertyDescriptor(e, u) : null;
                c && (c.get || c.set) ? Object.defineProperty(i, u, c) : i[u] = e[u]
            }
        return i.default = e, r && r.set(e, i), i
    }
    var o = r(1),
        a = r(29);
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var u = {
        highlight: !0,
        reverseHighlight: !0,
        snippet: !0,
        reverseSnippet: !0,
        insights: !0,
        getInsightsAnonymousUserToken: !0,
        getInsightsAnonymousUserTokenInternal: !0
    };
    Object.defineProperty(t, "getInsightsAnonymousUserToken", {
        enumerable: !0,
        get: function() {
            return d.default
        }
    }), Object.defineProperty(t, "getInsightsAnonymousUserTokenInternal", {
        enumerable: !0,
        get: function() {
            return d.getInsightsAnonymousUserTokenInternal
        }
    }), Object.defineProperty(t, "highlight", {
        enumerable: !0,
        get: function() {
            return c.default
        }
    }), Object.defineProperty(t, "insights", {
        enumerable: !0,
        get: function() {
            return p.default
        }
    }), Object.defineProperty(t, "reverseHighlight", {
        enumerable: !0,
        get: function() {
            return s.default
        }
    }), Object.defineProperty(t, "reverseSnippet", {
        enumerable: !0,
        get: function() {
            return f.default
        }
    }), Object.defineProperty(t, "snippet", {
        enumerable: !0,
        get: function() {
            return l.default
        }
    });
    var c = i(r(77));
    Object.keys(c).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (Object.prototype.hasOwnProperty.call(u, e) || e in t && t[e] === c[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return c[e]
            }
        }))
    });
    var s = i(r(110));
    Object.keys(s).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (Object.prototype.hasOwnProperty.call(u, e) || e in t && t[e] === s[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return s[e]
            }
        }))
    });
    var l = i(r(111));
    Object.keys(l).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (Object.prototype.hasOwnProperty.call(u, e) || e in t && t[e] === l[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return l[e]
            }
        }))
    });
    var f = i(r(112));
    Object.keys(f).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (Object.prototype.hasOwnProperty.call(u, e) || e in t && t[e] === f[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return f[e]
            }
        }))
    });
    var p = o(r(43)),
        d = i(r(113))
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e) {
        if (null == e) throw new TypeError("Cannot destructure " + e)
    }

    function o() {
        return o = Object.assign ? Object.assign.bind() : function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = arguments[t];
                for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
            }
            return e
        }, o.apply(this, arguments)
    }

    function a(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function u(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? a(Object(r), !0).forEach(function(t) {
                c(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : a(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function c(e, t, r) {
        return t = s(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function s(e) {
        var t = l(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function l(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function f(e) {
        return (0, m.escape)(e).replace(new RegExp(b.highlightPreTag, "g"), v.highlightPreTag).replace(new RegExp(b.highlightPostTag, "g"), v.highlightPostTag)
    }

    function p(e) {
        return (0, y.isPlainObject)(e) && "string" != typeof e.value ? Object.keys(e).reduce(function(t, r) {
            return u(u({}, t), {}, c({}, r, p(e[r])))
        }, {}) : Array.isArray(e) ? e.map(p) : u(u({}, e), {}, {
            value: f(e.value)
        })
    }

    function d(e) {
        return void 0 === e.__escaped && (e = e.map(function(e) {
            var t = o({}, (i(e), e));
            return t._highlightResult && (t._highlightResult = p(t._highlightResult)), t._snippetResult && (t._snippetResult = p(t._snippetResult)), t
        }), e.__escaped = !0), e
    }

    function h(e) {
        return e.map(function(e) {
            return u(u({}, e), {}, {
                highlighted: f(e.highlighted)
            })
        })
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.TAG_REPLACEMENT = t.TAG_PLACEHOLDER = void 0, t.escapeFacets = h, t.escapeHits = d;
    var m = r(18),
        y = r(35),
        b = {
            highlightPreTag: "__ais-highlight__",
            highlightPostTag: "__/ais-highlight__"
        };
    t.TAG_PLACEHOLDER = b;
    var v = {
        highlightPreTag: "<mark>",
        highlightPostTag: "</mark>"
    };
    t.TAG_REPLACEMENT = v
}, function(e, t, r) {
    "use strict";

    function n(e) {
        return e && u.test(e) ? e.replace(a, function(e) {
            return o[e]
        }) : e
    }

    function i(e) {
        return e && l.test(e) ? e.replace(s, function(e) {
            return c[e]
        }) : e
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.escape = n, t.unescape = i;
    var o = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;"
        },
        a = /[&<>"']/g,
        u = RegExp(a.source),
        c = {
            "&amp;": "&",
            "&lt;": "<",
            "&gt;": ">",
            "&quot;": '"',
            "&#39;": "'"
        },
        s = /&(amp|quot|lt|gt|#39);/g,
        l = RegExp(s.source)
}, function(e, t, r) {
    "use strict";

    function n(e) {
        return "ais.index" === e.$$type
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.isIndexWidget = n
}, function(e, t, r) {
    "use strict";

    function n(e) {
        return e.filter(function(e, t, r) {
            return r.indexOf(e) === t
        })
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.uniq = n
}, function(e, t, r) {
    "use strict";

    function n() {
        this._events = this._events || {}, this._maxListeners = this._maxListeners || void 0
    }

    function i(e) {
        return "function" == typeof e
    }

    function o(e) {
        return "number" == typeof e
    }

    function a(e) {
        return "object" === (0, s.default)(e) && null !== e
    }

    function u(e) {
        return void 0 === e
    }
    var c = r(1),
        s = c(r(8));
    e.exports = n, n.prototype._events = void 0, n.prototype._maxListeners = void 0, n.defaultMaxListeners = 10, n.prototype.setMaxListeners = function(e) {
        if (!o(e) || e < 0 || isNaN(e)) throw TypeError("n must be a positive number");
        return this._maxListeners = e, this
    }, n.prototype.emit = function(e) {
        var t, r, n, o, c, s;
        if (this._events || (this._events = {}), "error" === e && (!this._events.error || a(this._events.error) && !this._events.error.length)) {
            if ((t = arguments[1]) instanceof Error) throw t;
            var l = new Error('Uncaught, unspecified "error" event. (' + t + ")");
            throw l.context = t, l
        }
        if (r = this._events[e], u(r)) return !1;
        if (i(r)) switch (arguments.length) {
            case 1:
                r.call(this);
                break;
            case 2:
                r.call(this, arguments[1]);
                break;
            case 3:
                r.call(this, arguments[1], arguments[2]);
                break;
            default:
                o = Array.prototype.slice.call(arguments, 1), r.apply(this, o)
        } else if (a(r))
            for (o = Array.prototype.slice.call(arguments, 1), s = r.slice(), n = s.length, c = 0; c < n; c++) s[c].apply(this, o);
        return !0
    }, n.prototype.addListener = function(e, t) {
        var r;
        if (!i(t)) throw TypeError("listener must be a function");
        return this._events || (this._events = {}), this._events.newListener && this.emit("newListener", e, i(t.listener) ? t.listener : t), this._events[e] ? a(this._events[e]) ? this._events[e].push(t) : this._events[e] = [this._events[e], t] : this._events[e] = t, a(this._events[e]) && !this._events[e].warned && (r = u(this._maxListeners) ? n.defaultMaxListeners : this._maxListeners) && r > 0 && this._events[e].length > r && (this._events[e].warned = !0, console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[e].length), "function" == typeof console.trace && console.trace()), this
    }, n.prototype.on = n.prototype.addListener, n.prototype.once = function(e, t) {
        function r() {
            this.removeListener(e, r), n || (n = !0, t.apply(this, arguments))
        }
        if (!i(t)) throw TypeError("listener must be a function");
        var n = !1;
        return r.listener = t, this.on(e, r), this
    }, n.prototype.removeListener = function(e, t) {
        var r, n, o, u;
        if (!i(t)) throw TypeError("listener must be a function");
        if (!this._events || !this._events[e]) return this;
        if (r = this._events[e], o = r.length, n = -1, r === t || i(r.listener) && r.listener === t) delete this._events[e], this._events.removeListener && this.emit("removeListener", e, t);
        else if (a(r)) {
            for (u = o; u-- > 0;)
                if (r[u] === t || r[u].listener && r[u].listener === t) {
                    n = u;
                    break
                }
            if (n < 0) return this;
            1 === r.length ? (r.length = 0, delete this._events[e]) : r.splice(n, 1), this._events.removeListener && this.emit("removeListener", e, t)
        }
        return this
    }, n.prototype.removeAllListeners = function(e) {
        var t, r;
        if (!this._events) return this;
        if (!this._events.removeListener) return 0 === arguments.length ? this._events = {} : this._events[e] && delete this._events[e], this;
        if (0 === arguments.length) {
            for (t in this._events) "removeListener" !== t && this.removeAllListeners(t);
            return this.removeAllListeners("removeListener"), this._events = {}, this
        }
        if (r = this._events[e], i(r)) this.removeListener(e, r);
        else if (r)
            for (; r.length;) this.removeListener(e, r[r.length - 1]);
        return delete this._events[e], this
    }, n.prototype.listeners = function(e) {
        return this._events && this._events[e] ? i(this._events[e]) ? [this._events[e]] : this._events[e].slice() : []
    }, n.prototype.listenerCount = function(e) {
        if (this._events) {
            var t = this._events[e];
            if (i(t)) return 1;
            if (t) return t.length
        }
        return 0
    }, n.listenerCount = function(e, t) {
        return e.listenerCount(t)
    }
}, function(e, t, r) {
    "use strict";

    function n(e, t, r) {
        return new i(e, t, r)
    }
    var i = r(117),
        o = r(44),
        a = r(45);
    n.version = r(49), n.AlgoliaSearchHelper = i, n.SearchParameters = o, n.SearchResults = a, e.exports = n
}, function(e, t, r) {
    "use strict";
    e.exports = function() {
        return Array.prototype.slice.call(arguments).reduceRight(function(e, t) {
            return Object.keys(Object(t)).forEach(function(r) {
                void 0 !== t[r] && (void 0 !== e[r] && delete e[r], e[r] = t[r])
            }), e
        }, {})
    }
}, function(e, t, r) {
    "use strict";

    function n(e, t) {
        if (null === e) return {};
        var r, n, i = {},
            o = Object.keys(e);
        for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || (i[r] = e[r]);
        return i
    }
    e.exports = n
}, function(e, t, r) {
    "use strict";

    function n(e) {
        return e && Object.keys(e).length > 0
    }
    e.exports = n
}, function(e, t, r) {
    "use strict";

    function n(e) {
        return "string" != typeof e ? e : String(e).replace(/^-/, "\\-")
    }

    function i(e) {
        return "string" != typeof e ? e : e.replace(/^\\-/, "-")
    }
    e.exports = {
        escapeFacetValue: n,
        unescapeFacetValue: i
    }
}, function(e, t, r) {
    "use strict";
    var n = String.prototype.replace,
        i = /%20/g,
        o = {
            RFC1738: "RFC1738",
            RFC3986: "RFC3986"
        };
    e.exports = {
        default: o.RFC3986,
        formatters: {
            RFC1738: function(e) {
                return n.call(e, i, "+")
            },
            RFC3986: function(e) {
                return String(e)
            }
        },
        RFC1738: o.RFC1738,
        RFC3986: o.RFC3986
    }
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function s(e, t) {
        if (null == e) return {};
        var r, n, i = l(e, t);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
        }
        return i
    }

    function l(e, t) {
        if (null == e) return {};
        var r, n, i = {},
            o = Object.keys(e);
        for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || (i[r] = e[r]);
        return i
    }

    function f(e) {
        var t = e.event,
            r = e.nextState,
            n = void 0 === r ? {} : r,
            i = e.props,
            a = e.query,
            u = e.refresh,
            c = e.store,
            l = s(e, m);
        y && i.environment.clearTimeout(y);
        var f = l.setCollections,
            v = l.setIsOpen,
            g = l.setQuery,
            _ = l.setActiveItemId,
            O = l.setStatus;
        if (g(a), _(i.defaultActiveItemId), !a && !1 === i.openOnFocus) {
            var j, P = c.getState().collections.map(function(e) {
                return o(o({}, e), {}, {
                    items: []
                })
            });
            O("idle"), f(P), v(null !== (j = n.isOpen) && void 0 !== j ? j : i.shouldPanelOpen({
                state: c.getState()
            }));
            var S = (0, h.cancelable)(b(P).then(function() {
                return Promise.resolve()
            }));
            return c.pendingRequests.add(S)
        }
        O("loading"), y = i.environment.setTimeout(function() {
            O("stalled")
        }, i.stallThreshold);
        var w = (0, h.cancelable)(b(i.getSources(o({
            query: a,
            refresh: u,
            state: c.getState()
        }, l)).then(function(e) {
            return Promise.all(e.map(function(e) {
                return Promise.resolve(e.getItems(o({
                    query: a,
                    refresh: u,
                    state: c.getState()
                }, l))).then(function(t) {
                    return (0, d.preResolve)(t, e.sourceId, c.getState())
                })
            })).then(d.resolve).then(function(t) {
                return (0, d.postResolve)(t, e, c)
            }).then(function(e) {
                return (0, p.reshape)({
                    collections: e,
                    props: i,
                    state: c.getState()
                })
            })
        }))).then(function(e) {
            var r;
            O("idle"), f(e);
            var s = i.shouldPanelOpen({
                state: c.getState()
            });
            v(null !== (r = n.isOpen) && void 0 !== r ? r : i.openOnFocus && !a && s || s);
            var p = (0, h.getActiveItem)(c.getState());
            if (null !== c.getState().activeItemId && p) {
                var d = p.item,
                    m = p.itemInputValue,
                    y = p.itemUrl,
                    b = p.source;
                b.onActive(o({
                    event: t,
                    item: d,
                    itemInputValue: m,
                    itemUrl: y,
                    refresh: u,
                    source: b,
                    state: c.getState()
                }, l))
            }
        }).finally(function() {
            O("idle"), y && i.environment.clearTimeout(y)
        });
        return c.pendingRequests.add(w)
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.onInput = f;
    var p = r(209),
        d = r(210),
        h = r(6),
        m = ["event", "nextState", "props", "query", "refresh", "store"],
        y = null,
        b = (0, h.createConcurrentSafePromise)()
}, function(e, t, r) {
    "use strict";

    function n(t) {
        "@babel/helpers - typeof";
        return e.exports = n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        }, e.exports.__esModule = !0, e.exports.default = e.exports, n(t)
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports
}, function(e, t, r) {
    "use strict";

    function n(e) {
        return e.toString().charAt(0).toUpperCase() + e.toString().slice(1)
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.capitalize = n
}, function(e, t, r) {
    "use strict";

    function n(e) {
        var t = e.index,
            r = e.indexUiState,
            n = t.getWidgets().map(function(e) {
                return e.$$type
            }).filter(Boolean);
        (0, i.keys)(r).reduce(function(e, t) {
            var r = o[t];
            if (!r) return e;
            var i = r.widgets;
            return i && !i.some(function(e) {
                return n.includes(e)
            }) && e.push([t, {
                connectors: r.connectors,
                widgets: r.widgets.map(function(e) {
                    return e.split("ais.")[1]
                })
            }]), e
        }, [])
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.checkIndexUiState = n;
    var i = (r(30), r(32), r(78)),
        o = {
            query: {
                connectors: ["connectSearchBox"],
                widgets: ["ais.searchBox", "ais.autocomplete", "ais.voiceSearch"]
            },
            refinementList: {
                connectors: ["connectRefinementList"],
                widgets: ["ais.refinementList"]
            },
            menu: {
                connectors: ["connectMenu"],
                widgets: ["ais.menu"]
            },
            hierarchicalMenu: {
                connectors: ["connectHierarchicalMenu"],
                widgets: ["ais.hierarchicalMenu"]
            },
            numericMenu: {
                connectors: ["connectNumericMenu"],
                widgets: ["ais.numericMenu"]
            },
            ratingMenu: {
                connectors: ["connectRatingMenu"],
                widgets: ["ais.ratingMenu"]
            },
            range: {
                connectors: ["connectRange"],
                widgets: ["ais.rangeInput", "ais.rangeSlider", "ais.range"]
            },
            toggle: {
                connectors: ["connectToggleRefinement"],
                widgets: ["ais.toggleRefinement"]
            },
            geoSearch: {
                connectors: ["connectGeoSearch"],
                widgets: ["ais.geoSearch"]
            },
            sortBy: {
                connectors: ["connectSortBy"],
                widgets: ["ais.sortBy"]
            },
            page: {
                connectors: ["connectPagination"],
                widgets: ["ais.pagination", "ais.infiniteHits"]
            },
            hitsPerPage: {
                connectors: ["connectHitsPerPage"],
                widgets: ["ais.hitsPerPage"]
            },
            configure: {
                connectors: ["connectConfigure"],
                widgets: ["ais.configure"]
            },
            places: {
                connectors: [],
                widgets: ["ais.places"]
            }
        }
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.warning = t.warn = t.deprecate = void 0;
    var n = r(33),
        i = function(e, t) {
            return e
        };
    t.deprecate = i;
    var o = n.noop;
    t.warn = o;
    var a = n.noop;
    t.warning = a
}, function(e, t, r) {
    "use strict";

    function n() {}
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.noop = n
}, function(e, t, r) {
    "use strict";

    function n(e) {
        return Object.prototype.toString.call(e).slice(8, -1)
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.getObjectType = n
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e) {
        return null === e ? void 0 === e ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(e)
    }

    function o(e) {
        return "object" === n(e) && null !== e
    }

    function a(e) {
        if (!o(e) || "[object Object]" !== i(e)) return !1;
        if (null === Object.getPrototypeOf(e)) return !0;
        for (var t = e; null !== Object.getPrototypeOf(t);) t = Object.getPrototypeOf(t);
        return Object.getPrototypeOf(e) === t
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.isPlainObject = a
}, function(e, t, r) {
    "use strict";

    function n(e, t, r) {
        return e.state.isHierarchicalFacet(t) ? e.state.isHierarchicalFacetRefined(t, r) : e.state.isConjunctiveFacet(t) ? e.state.isFacetRefined(t, r) : e.state.isDisjunctiveFacetRefined(t, r)
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.isFacetRefined = n
}, function(e, t, r) {
    "use strict";

    function n(e) {
        return btoa(encodeURIComponent(JSON.stringify(e)))
    }

    function i(e) {
        return JSON.parse(decodeURIComponent(atob(e)))
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.deserializePayload = i, t.serializePayload = n
}, function(e, t, r) {
    "use strict";

    function n(e) {
        return "string" == typeof e ? e.replace(/^\\-/, "-") : e
    }

    function i(e) {
        return "number" == typeof e && e < 0 || "string" == typeof e ? String(e).replace(/^-/, "\\-") : e
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.escapeFacetValue = i, t.unescapeFacetValue = n
}, function(e, t, r) {
    "use strict";

    function n(e, t) {
        for (var r, n = 0; n < e.length; n++)
            if (r = e[n], t(r, n, e)) return r
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.find = n
}, function(e, t, r) {
    "use strict";

    function n(e, t) {
        if (!Array.isArray(e)) return -1;
        for (var r = 0; r < e.length; r++)
            if (t(e[r])) return r;
        return -1
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.findIndex = n
}, function(e, t, r) {
    "use strict";

    function n(e) {
        return e instanceof HTMLElement || Boolean(e) && e.nodeType > 0
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.isDomElement = n
}, function(e, t, r) {
    "use strict";

    function n(e, t) {
        var r, n, a = e[t],
            u = (null === (r = e[t + 1]) || void 0 === r ? void 0 : r.isHighlighted) || !0,
            c = (null === (n = e[t - 1]) || void 0 === n ? void 0 : n.isHighlighted) || !0;
        return o.test((0, i.unescape)(a.value)) || c !== u ? a.isHighlighted : c
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.getHighlightFromSiblings = n;
    var i = r(18),
        o = new RegExp(/\w/i)
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e) {
        var t = e.getAttribute("data-insights-method"),
            r = e.getAttribute("data-insights-payload");
        if ("string" != typeof r) throw new Error("The insights helper expects `data-insights-payload` to be a base64-encoded JSON string.");
        try {
            return {
                method: t,
                payload: (0, u.deserializePayload)(r)
            }
        } catch (e) {
            throw new Error("The insights helper was unable to parse `data-insights-payload`.")
        }
    }

    function o(e) {
        var t = e.method,
            r = e.payload;
        if ("object" !== n(r)) throw new Error("The insights helper expects the payload to be an object.");
        var i;
        try {
            i = (0, u.serializePayload)(r)
        } catch (e) {
            throw new Error("Could not JSON serialize the payload object.")
        }
        return 'data-insights-method="'.concat(t, '" data-insights-payload="').concat(i, '"')
    }

    function a(e, t) {
        return o({
            method: e,
            payload: t
        })
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = a, t.readDataAttributes = i, t.writeDataAttributes = o;
    var u = r(0)
}, function(e, t, r) {
    "use strict";

    function n(e, t) {
        return Array.isArray(e) && Array.isArray(t) ? e.length === t.length && e.every(function(e, r) {
            return n(t[r], e)
        }) : e === t
    }

    function i(e, t) {
        return s(e, function(e) {
            return n(e, t)
        })
    }

    function o(e) {
        var t = e ? o._parseNumbers(e) : {};
        void 0 === t.userToken || d(t.userToken) || console.warn("[algoliasearch-helper] The `userToken` parameter is invalid. This can lead to wrong analytics.\n  - Format: [a-zA-Z0-9_-]{1,64}"), this.facets = t.facets || [], this.disjunctiveFacets = t.disjunctiveFacets || [], this.hierarchicalFacets = t.hierarchicalFacets || [], this.facetsRefinements = t.facetsRefinements || {}, this.facetsExcludes = t.facetsExcludes || {}, this.disjunctiveFacetsRefinements = t.disjunctiveFacetsRefinements || {}, this.numericRefinements = t.numericRefinements || {}, this.tagRefinements = t.tagRefinements || [], this.hierarchicalFacetsRefinements = t.hierarchicalFacetsRefinements || {};
        var r = this;
        Object.keys(t).forEach(function(e) {
            var n = -1 !== o.PARAMETERS.indexOf(e),
                i = void 0 !== t[e];
            !n && i && (r[e] = t[e])
        })
    }
    var a = r(12),
        u = r(23),
        c = r(118),
        s = r(13),
        l = r(119),
        f = r(24),
        p = r(25),
        d = r(120),
        h = r(121);
    o.PARAMETERS = Object.keys(new o), o._parseNumbers = function(e) {
        if (e instanceof o) return e;
        var t = {};
        if (["aroundPrecision", "aroundRadius", "getRankingInfo", "minWordSizefor2Typos", "minWordSizefor1Typo", "page", "maxValuesPerFacet", "distinct", "minimumAroundRadius", "hitsPerPage", "minProximity"].forEach(function(r) {
                var n = e[r];
                if ("string" == typeof n) {
                    var i = parseFloat(n);
                    t[r] = isNaN(i) ? n : i
                }
            }), Array.isArray(e.insideBoundingBox) && (t.insideBoundingBox = e.insideBoundingBox.map(function(e) {
                return Array.isArray(e) ? e.map(function(e) {
                    return parseFloat(e)
                }) : e
            })), e.numericRefinements) {
            var r = {};
            Object.keys(e.numericRefinements).forEach(function(t) {
                var n = e.numericRefinements[t] || {};
                r[t] = {}, Object.keys(n).forEach(function(e) {
                    var i = n[e],
                        o = i.map(function(e) {
                            return Array.isArray(e) ? e.map(function(e) {
                                return "string" == typeof e ? parseFloat(e) : e
                            }) : "string" == typeof e ? parseFloat(e) : e
                        });
                    r[t][e] = o
                })
            }), t.numericRefinements = r
        }
        return a({}, e, t)
    }, o.make = function(e) {
        var t = new o(e);
        return (e.hierarchicalFacets || []).forEach(function(e) {
            if (e.rootPath) {
                var r = t.getHierarchicalRefinement(e.name);
                r.length > 0 && 0 !== r[0].indexOf(e.rootPath) && (t = t.clearRefinements(e.name)), r = t.getHierarchicalRefinement(e.name), 0 === r.length && (t = t.toggleHierarchicalFacetRefinement(e.name, e.rootPath))
            }
        }), t
    }, o.validate = function(e, t) {
        var r = t || {};
        return e.tagFilters && r.tagRefinements && r.tagRefinements.length > 0 ? new Error("[Tags] Cannot switch from the managed tag API to the advanced API. It is probably an error, if it is really what you want, you should first clear the tags with clearTags method.") : e.tagRefinements.length > 0 && r.tagFilters ? new Error("[Tags] Cannot switch from the advanced tag API to the managed API. It is probably an error, if it is not, you should first clear the tags with clearTags method.") : e.numericFilters && r.numericRefinements && p(r.numericRefinements) ? new Error("[Numeric filters] Can't switch from the advanced to the managed API. It is probably an error, if this is really what you want, you have to first clear the numeric filters.") : p(e.numericRefinements) && r.numericFilters ? new Error("[Numeric filters] Can't switch from the managed API to the advanced. It is probably an error, if this is really what you want, you have to first clear the numeric filters.") : null
    }, o.prototype = {
        constructor: o,
        clearRefinements: function(e) {
            var t = {
                numericRefinements: this._clearNumericRefinements(e),
                facetsRefinements: h.clearRefinement(this.facetsRefinements, e, "conjunctiveFacet"),
                facetsExcludes: h.clearRefinement(this.facetsExcludes, e, "exclude"),
                disjunctiveFacetsRefinements: h.clearRefinement(this.disjunctiveFacetsRefinements, e, "disjunctiveFacet"),
                hierarchicalFacetsRefinements: h.clearRefinement(this.hierarchicalFacetsRefinements, e, "hierarchicalFacet")
            };
            return t.numericRefinements === this.numericRefinements && t.facetsRefinements === this.facetsRefinements && t.facetsExcludes === this.facetsExcludes && t.disjunctiveFacetsRefinements === this.disjunctiveFacetsRefinements && t.hierarchicalFacetsRefinements === this.hierarchicalFacetsRefinements ? this : this.setQueryParameters(t)
        },
        clearTags: function() {
            return void 0 === this.tagFilters && 0 === this.tagRefinements.length ? this : this.setQueryParameters({
                tagFilters: void 0,
                tagRefinements: []
            })
        },
        setIndex: function(e) {
            return e === this.index ? this : this.setQueryParameters({
                index: e
            })
        },
        setQuery: function(e) {
            return e === this.query ? this : this.setQueryParameters({
                query: e
            })
        },
        setPage: function(e) {
            return e === this.page ? this : this.setQueryParameters({
                page: e
            })
        },
        setFacets: function(e) {
            return this.setQueryParameters({
                facets: e
            })
        },
        setDisjunctiveFacets: function(e) {
            return this.setQueryParameters({
                disjunctiveFacets: e
            })
        },
        setHitsPerPage: function(e) {
            return this.hitsPerPage === e ? this : this.setQueryParameters({
                hitsPerPage: e
            })
        },
        setTypoTolerance: function(e) {
            return this.typoTolerance === e ? this : this.setQueryParameters({
                typoTolerance: e
            })
        },
        addNumericRefinement: function(e, t, r) {
            var n = l(r);
            if (this.isNumericRefined(e, t, n)) return this;
            var i = a({}, this.numericRefinements);
            return i[e] = a({}, i[e]), i[e][t] ? (i[e][t] = i[e][t].slice(), i[e][t].push(n)) : i[e][t] = [n], this.setQueryParameters({
                numericRefinements: i
            })
        },
        getConjunctiveRefinements: function(e) {
            return this.isConjunctiveFacet(e) ? this.facetsRefinements[e] || [] : []
        },
        getDisjunctiveRefinements: function(e) {
            return this.isDisjunctiveFacet(e) ? this.disjunctiveFacetsRefinements[e] || [] : []
        },
        getHierarchicalRefinement: function(e) {
            return this.hierarchicalFacetsRefinements[e] || []
        },
        getExcludeRefinements: function(e) {
            return this.isConjunctiveFacet(e) ? this.facetsExcludes[e] || [] : []
        },
        removeNumericRefinement: function(e, t, r) {
            return void 0 !== r ? this.isNumericRefined(e, t, r) ? this.setQueryParameters({
                numericRefinements: this._clearNumericRefinements(function(i, o) {
                    return o === e && i.op === t && n(i.val, l(r))
                })
            }) : this : void 0 !== t ? this.isNumericRefined(e, t) ? this.setQueryParameters({
                numericRefinements: this._clearNumericRefinements(function(r, n) {
                    return n === e && r.op === t
                })
            }) : this : this.isNumericRefined(e) ? this.setQueryParameters({
                numericRefinements: this._clearNumericRefinements(function(t, r) {
                    return r === e
                })
            }) : this
        },
        getNumericRefinements: function(e) {
            return this.numericRefinements[e] || {}
        },
        getNumericRefinement: function(e, t) {
            return this.numericRefinements[e] && this.numericRefinements[e][t]
        },
        _clearNumericRefinements: function(e) {
            if (void 0 === e) return p(this.numericRefinements) ? {} : this.numericRefinements;
            if ("string" == typeof e) return f(this.numericRefinements, [e]);
            if ("function" == typeof e) {
                var t = !1,
                    r = this.numericRefinements,
                    n = Object.keys(r).reduce(function(n, i) {
                        var o = r[i],
                            a = {};
                        return o = o || {}, Object.keys(o).forEach(function(r) {
                            var n = o[r] || [],
                                u = [];
                            n.forEach(function(t) {
                                e({
                                    val: t,
                                    op: r
                                }, i, "numeric") || u.push(t)
                            }), u.length !== n.length && (t = !0), a[r] = u
                        }), n[i] = a, n
                    }, {});
                return t ? n : this.numericRefinements
            }
        },
        addFacet: function(e) {
            return this.isConjunctiveFacet(e) ? this : this.setQueryParameters({
                facets: this.facets.concat([e])
            })
        },
        addDisjunctiveFacet: function(e) {
            return this.isDisjunctiveFacet(e) ? this : this.setQueryParameters({
                disjunctiveFacets: this.disjunctiveFacets.concat([e])
            })
        },
        addHierarchicalFacet: function(e) {
            if (this.isHierarchicalFacet(e.name)) throw new Error("Cannot declare two hierarchical facets with the same name: `" + e.name + "`");
            return this.setQueryParameters({
                hierarchicalFacets: this.hierarchicalFacets.concat([e])
            })
        },
        addFacetRefinement: function(e, t) {
            if (!this.isConjunctiveFacet(e)) throw new Error(e + " is not defined in the facets attribute of the helper configuration");
            return h.isRefined(this.facetsRefinements, e, t) ? this : this.setQueryParameters({
                facetsRefinements: h.addRefinement(this.facetsRefinements, e, t)
            })
        },
        addExcludeRefinement: function(e, t) {
            if (!this.isConjunctiveFacet(e)) throw new Error(e + " is not defined in the facets attribute of the helper configuration");
            return h.isRefined(this.facetsExcludes, e, t) ? this : this.setQueryParameters({
                facetsExcludes: h.addRefinement(this.facetsExcludes, e, t)
            })
        },
        addDisjunctiveFacetRefinement: function(e, t) {
            if (!this.isDisjunctiveFacet(e)) throw new Error(e + " is not defined in the disjunctiveFacets attribute of the helper configuration");
            return h.isRefined(this.disjunctiveFacetsRefinements, e, t) ? this : this.setQueryParameters({
                disjunctiveFacetsRefinements: h.addRefinement(this.disjunctiveFacetsRefinements, e, t)
            })
        },
        addTagRefinement: function(e) {
            if (this.isTagRefined(e)) return this;
            var t = {
                tagRefinements: this.tagRefinements.concat(e)
            };
            return this.setQueryParameters(t)
        },
        removeFacet: function(e) {
            return this.isConjunctiveFacet(e) ? this.clearRefinements(e).setQueryParameters({
                facets: this.facets.filter(function(t) {
                    return t !== e
                })
            }) : this
        },
        removeDisjunctiveFacet: function(e) {
            return this.isDisjunctiveFacet(e) ? this.clearRefinements(e).setQueryParameters({
                disjunctiveFacets: this.disjunctiveFacets.filter(function(t) {
                    return t !== e
                })
            }) : this
        },
        removeHierarchicalFacet: function(e) {
            return this.isHierarchicalFacet(e) ? this.clearRefinements(e).setQueryParameters({
                hierarchicalFacets: this.hierarchicalFacets.filter(function(t) {
                    return t.name !== e
                })
            }) : this
        },
        removeFacetRefinement: function(e, t) {
            if (!this.isConjunctiveFacet(e)) throw new Error(e + " is not defined in the facets attribute of the helper configuration");
            return h.isRefined(this.facetsRefinements, e, t) ? this.setQueryParameters({
                facetsRefinements: h.removeRefinement(this.facetsRefinements, e, t)
            }) : this
        },
        removeExcludeRefinement: function(e, t) {
            if (!this.isConjunctiveFacet(e)) throw new Error(e + " is not defined in the facets attribute of the helper configuration");
            return h.isRefined(this.facetsExcludes, e, t) ? this.setQueryParameters({
                facetsExcludes: h.removeRefinement(this.facetsExcludes, e, t)
            }) : this
        },
        removeDisjunctiveFacetRefinement: function(e, t) {
            if (!this.isDisjunctiveFacet(e)) throw new Error(e + " is not defined in the disjunctiveFacets attribute of the helper configuration");
            return h.isRefined(this.disjunctiveFacetsRefinements, e, t) ? this.setQueryParameters({
                disjunctiveFacetsRefinements: h.removeRefinement(this.disjunctiveFacetsRefinements, e, t)
            }) : this
        },
        removeTagRefinement: function(e) {
            if (!this.isTagRefined(e)) return this;
            var t = {
                tagRefinements: this.tagRefinements.filter(function(t) {
                    return t !== e
                })
            };
            return this.setQueryParameters(t)
        },
        toggleRefinement: function(e, t) {
            return this.toggleFacetRefinement(e, t)
        },
        toggleFacetRefinement: function(e, t) {
            if (this.isHierarchicalFacet(e)) return this.toggleHierarchicalFacetRefinement(e, t);
            if (this.isConjunctiveFacet(e)) return this.toggleConjunctiveFacetRefinement(e, t);
            if (this.isDisjunctiveFacet(e)) return this.toggleDisjunctiveFacetRefinement(e, t);
            throw new Error("Cannot refine the undeclared facet " + e + "; it should be added to the helper options facets, disjunctiveFacets or hierarchicalFacets")
        },
        toggleConjunctiveFacetRefinement: function(e, t) {
            if (!this.isConjunctiveFacet(e)) throw new Error(e + " is not defined in the facets attribute of the helper configuration");
            return this.setQueryParameters({
                facetsRefinements: h.toggleRefinement(this.facetsRefinements, e, t)
            })
        },
        toggleExcludeFacetRefinement: function(e, t) {
            if (!this.isConjunctiveFacet(e)) throw new Error(e + " is not defined in the facets attribute of the helper configuration");
            return this.setQueryParameters({
                facetsExcludes: h.toggleRefinement(this.facetsExcludes, e, t)
            })
        },
        toggleDisjunctiveFacetRefinement: function(e, t) {
            if (!this.isDisjunctiveFacet(e)) throw new Error(e + " is not defined in the disjunctiveFacets attribute of the helper configuration");
            return this.setQueryParameters({
                disjunctiveFacetsRefinements: h.toggleRefinement(this.disjunctiveFacetsRefinements, e, t)
            })
        },
        toggleHierarchicalFacetRefinement: function(e, t) {
            if (!this.isHierarchicalFacet(e)) throw new Error(e + " is not defined in the hierarchicalFacets attribute of the helper configuration");
            var r = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(e)),
                n = {};
            return void 0 !== this.hierarchicalFacetsRefinements[e] && this.hierarchicalFacetsRefinements[e].length > 0 && (this.hierarchicalFacetsRefinements[e][0] === t || 0 === this.hierarchicalFacetsRefinements[e][0].indexOf(t + r)) ? -1 === t.indexOf(r) ? n[e] = [] : n[e] = [t.slice(0, t.lastIndexOf(r))] : n[e] = [t], this.setQueryParameters({
                hierarchicalFacetsRefinements: u({}, n, this.hierarchicalFacetsRefinements)
            })
        },
        addHierarchicalFacetRefinement: function(e, t) {
            if (this.isHierarchicalFacetRefined(e)) throw new Error(e + " is already refined.");
            if (!this.isHierarchicalFacet(e)) throw new Error(e + " is not defined in the hierarchicalFacets attribute of the helper configuration.");
            var r = {};
            return r[e] = [t], this.setQueryParameters({
                hierarchicalFacetsRefinements: u({}, r, this.hierarchicalFacetsRefinements)
            })
        },
        removeHierarchicalFacetRefinement: function(e) {
            if (!this.isHierarchicalFacetRefined(e)) return this;
            var t = {};
            return t[e] = [], this.setQueryParameters({
                hierarchicalFacetsRefinements: u({}, t, this.hierarchicalFacetsRefinements)
            })
        },
        toggleTagRefinement: function(e) {
            return this.isTagRefined(e) ? this.removeTagRefinement(e) : this.addTagRefinement(e)
        },
        isDisjunctiveFacet: function(e) {
            return this.disjunctiveFacets.indexOf(e) > -1
        },
        isHierarchicalFacet: function(e) {
            return void 0 !== this.getHierarchicalFacetByName(e)
        },
        isConjunctiveFacet: function(e) {
            return this.facets.indexOf(e) > -1
        },
        isFacetRefined: function(e, t) {
            return !!this.isConjunctiveFacet(e) && h.isRefined(this.facetsRefinements, e, t)
        },
        isExcludeRefined: function(e, t) {
            return !!this.isConjunctiveFacet(e) && h.isRefined(this.facetsExcludes, e, t)
        },
        isDisjunctiveFacetRefined: function(e, t) {
            return !!this.isDisjunctiveFacet(e) && h.isRefined(this.disjunctiveFacetsRefinements, e, t)
        },
        isHierarchicalFacetRefined: function(e, t) {
            if (!this.isHierarchicalFacet(e)) return !1;
            var r = this.getHierarchicalRefinement(e);
            return t ? -1 !== r.indexOf(t) : r.length > 0
        },
        isNumericRefined: function(e, t, r) {
            if (void 0 === r && void 0 === t) return !!this.numericRefinements[e];
            var n = this.numericRefinements[e] && void 0 !== this.numericRefinements[e][t];
            if (void 0 === r || !n) return n;
            var o = l(r),
                a = void 0 !== i(this.numericRefinements[e][t], o);
            return n && a
        },
        isTagRefined: function(e) {
            return -1 !== this.tagRefinements.indexOf(e)
        },
        getRefinedDisjunctiveFacets: function() {
            var e = this,
                t = c(Object.keys(this.numericRefinements).filter(function(t) {
                    return Object.keys(e.numericRefinements[t]).length > 0
                }), this.disjunctiveFacets);
            return Object.keys(this.disjunctiveFacetsRefinements).filter(function(t) {
                return e.disjunctiveFacetsRefinements[t].length > 0
            }).concat(t).concat(this.getRefinedHierarchicalFacets())
        },
        getRefinedHierarchicalFacets: function() {
            var e = this;
            return c(this.hierarchicalFacets.map(function(e) {
                return e.name
            }), Object.keys(this.hierarchicalFacetsRefinements).filter(function(t) {
                return e.hierarchicalFacetsRefinements[t].length > 0
            }))
        },
        getUnrefinedDisjunctiveFacets: function() {
            var e = this.getRefinedDisjunctiveFacets();
            return this.disjunctiveFacets.filter(function(t) {
                return -1 === e.indexOf(t)
            })
        },
        managedParameters: ["index", "facets", "disjunctiveFacets", "facetsRefinements", "hierarchicalFacets", "facetsExcludes", "disjunctiveFacetsRefinements", "numericRefinements", "tagRefinements", "hierarchicalFacetsRefinements"],
        getQueryParams: function() {
            var e = this.managedParameters,
                t = {},
                r = this;
            return Object.keys(this).forEach(function(n) {
                var i = r[n]; - 1 === e.indexOf(n) && void 0 !== i && (t[n] = i)
            }), t
        },
        setQueryParameter: function(e, t) {
            if (this[e] === t) return this;
            var r = {};
            return r[e] = t, this.setQueryParameters(r)
        },
        setQueryParameters: function(e) {
            if (!e) return this;
            var t = o.validate(this, e);
            if (t) throw t;
            var r = this,
                n = o._parseNumbers(e),
                i = Object.keys(this).reduce(function(e, t) {
                    return e[t] = r[t], e
                }, {}),
                a = Object.keys(n).reduce(function(e, t) {
                    var r = void 0 !== e[t],
                        i = void 0 !== n[t];
                    return r && !i ? f(e, [t]) : (i && (e[t] = n[t]), e)
                }, i);
            return new this.constructor(a)
        },
        resetPage: function() {
            return void 0 === this.page ? this : this.setPage(0)
        },
        _getHierarchicalFacetSortBy: function(e) {
            return e.sortBy || ["isRefined:desc", "name:asc"]
        },
        _getHierarchicalFacetSeparator: function(e) {
            return e.separator || " > "
        },
        _getHierarchicalRootPath: function(e) {
            return e.rootPath || null
        },
        _getHierarchicalShowParentLevel: function(e) {
            return "boolean" != typeof e.showParentLevel || e.showParentLevel
        },
        getHierarchicalFacetByName: function(e) {
            return s(this.hierarchicalFacets, function(t) {
                return t.name === e
            })
        },
        getHierarchicalFacetBreadcrumb: function(e) {
            if (!this.isHierarchicalFacet(e)) return [];
            var t = this.getHierarchicalRefinement(e)[0];
            if (!t) return [];
            var r = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(e));
            return t.split(r).map(function(e) {
                return e.trim()
            })
        },
        toString: function() {
            return JSON.stringify(this, null, 2)
        }
    }, e.exports = o
}, function(e, t, r) {
    "use strict";

    function n(e) {
        var t = {};
        return e.forEach(function(e, r) {
            t[e] = r
        }), t
    }

    function i(e, t, r) {
        t && t[r] && (e.stats = t[r])
    }

    function o(e, t) {
        return _(e, function(e) {
            return (e.attributes || []).indexOf(t) > -1
        })
    }

    function a(e, t, r) {
        var a = t[0];
        this._rawResults = t;
        var u = this;
        Object.keys(a).forEach(function(e) {
            u[e] = a[e]
        }), Object.keys(r || {}).forEach(function(e) {
            u[e] = r[e]
        }), this.processingTimeMS = t.reduce(function(e, t) {
            return void 0 === t.processingTimeMS ? e : e + t.processingTimeMS
        }, 0), this.disjunctiveFacets = [], this.hierarchicalFacets = e.hierarchicalFacets.map(function() {
            return []
        }), this.facets = [];
        var c = e.getRefinedDisjunctiveFacets(),
            s = n(e.facets),
            l = n(e.disjunctiveFacets),
            f = 1,
            p = a.facets || {};
        Object.keys(p).forEach(function(t) {
            var r = p[t],
                n = o(e.hierarchicalFacets, t);
            if (n) {
                var c = n.attributes.indexOf(t),
                    f = O(e.hierarchicalFacets, function(e) {
                        return e.name === n.name
                    });
                u.hierarchicalFacets[f][c] = {
                    attribute: t,
                    data: r,
                    exhaustive: a.exhaustiveFacetsCount
                }
            } else {
                var d, h = -1 !== e.disjunctiveFacets.indexOf(t),
                    m = -1 !== e.facets.indexOf(t);
                h && (d = l[t], u.disjunctiveFacets[d] = {
                    name: t,
                    data: r,
                    exhaustive: a.exhaustiveFacetsCount
                }, i(u.disjunctiveFacets[d], a.facets_stats, t)), m && (d = s[t], u.facets[d] = {
                    name: t,
                    data: r,
                    exhaustive: a.exhaustiveFacetsCount
                }, i(u.facets[d], a.facets_stats, t))
            }
        }), this.hierarchicalFacets = g(this.hierarchicalFacets), c.forEach(function(r) {
            var n = t[f],
                o = n && n.facets ? n.facets : {},
                c = e.getHierarchicalFacetByName(r);
            Object.keys(o).forEach(function(t) {
                var r, s = o[t];
                if (c) {
                    r = O(e.hierarchicalFacets, function(e) {
                        return e.name === c.name
                    });
                    var f = O(u.hierarchicalFacets[r], function(e) {
                        return e.attribute === t
                    });
                    if (-1 === f) return;
                    u.hierarchicalFacets[r][f].data = y({}, u.hierarchicalFacets[r][f].data, s)
                } else {
                    r = l[t];
                    var p = a.facets && a.facets[t] || {};
                    u.disjunctiveFacets[r] = {
                        name: t,
                        data: b({}, s, p),
                        exhaustive: n.exhaustiveFacetsCount
                    }, i(u.disjunctiveFacets[r], n.facets_stats, t), e.disjunctiveFacetsRefinements[t] && e.disjunctiveFacetsRefinements[t].forEach(function(n) {
                        !u.disjunctiveFacets[r].data[n] && e.disjunctiveFacetsRefinements[t].indexOf(w(n)) > -1 && (u.disjunctiveFacets[r].data[n] = 0)
                    })
                }
            }), f++
        }), e.getRefinedHierarchicalFacets().forEach(function(r) {
            var n = e.getHierarchicalFacetByName(r),
                i = e._getHierarchicalFacetSeparator(n),
                o = e.getHierarchicalRefinement(r);
            0 === o.length || o[0].split(i).length < 2 || t.slice(f).forEach(function(t) {
                var r = t && t.facets ? t.facets : {};
                Object.keys(r).forEach(function(t) {
                    var a = r[t],
                        c = O(e.hierarchicalFacets, function(e) {
                            return e.name === n.name
                        }),
                        s = O(u.hierarchicalFacets[c], function(e) {
                            return e.attribute === t
                        });
                    if (-1 !== s) {
                        var l = {};
                        if (o.length > 0) {
                            var f = o[0].split(i)[0];
                            l[f] = u.hierarchicalFacets[c][s].data[f]
                        }
                        u.hierarchicalFacets[c][s].data = b(l, a, u.hierarchicalFacets[c][s].data)
                    }
                }), f++
            })
        }), Object.keys(e.facetsExcludes).forEach(function(t) {
            var r = e.facetsExcludes[t],
                n = s[t];
            u.facets[n] = {
                name: t,
                data: a.facets[t],
                exhaustive: a.exhaustiveFacetsCount
            }, r.forEach(function(e) {
                u.facets[n] = u.facets[n] || {
                    name: t
                }, u.facets[n].data = u.facets[n].data || {}, u.facets[n].data[e] = 0
            })
        }), this.hierarchicalFacets = this.hierarchicalFacets.map(E(e)), this.facets = g(this.facets), this.disjunctiveFacets = g(this.disjunctiveFacets), this._state = e
    }

    function u(e, t) {
        function r(e) {
            return e.name === t
        }
        if (e._state.isConjunctiveFacet(t)) {
            var n = _(e.facets, r);
            return n ? Object.keys(n.data).map(function(r) {
                var i = S(r);
                return {
                    name: r,
                    escapedValue: i,
                    count: n.data[r],
                    isRefined: e._state.isFacetRefined(t, i),
                    isExcluded: e._state.isExcludeRefined(t, r)
                }
            }) : []
        }
        if (e._state.isDisjunctiveFacet(t)) {
            var i = _(e.disjunctiveFacets, r);
            return i ? Object.keys(i.data).map(function(r) {
                var n = S(r);
                return {
                    name: r,
                    escapedValue: n,
                    count: i.data[r],
                    isRefined: e._state.isDisjunctiveFacetRefined(t, n)
                }
            }) : []
        }
        if (e._state.isHierarchicalFacet(t)) {
            var o = _(e.hierarchicalFacets, r);
            if (!o) return o;
            var a = e._state.getHierarchicalFacetByName(t),
                u = w(e._state.getHierarchicalRefinement(t)[0] || "").split(e._state._getHierarchicalFacetSeparator(a));
            return u.unshift(t), c(o, u, 0), o
        }
    }

    function c(e, t, r) {
        e.isRefined = e.name === t[r], e.data && e.data.forEach(function(e) {
            c(e, t, r + 1)
        })
    }

    function s(e, t, r, n) {
        if (n = n || 0, Array.isArray(t)) return e(t, r[n]);
        if (!t.data || 0 === t.data.length) return t;
        var i = t.data.map(function(t) {
                return s(e, t, r, n + 1)
            }),
            o = e(i, r[n]);
        return b({
            data: o
        }, t)
    }

    function l(e, t) {
        return t.sort(e)
    }

    function f(e, t) {
        var r = [],
            n = [],
            i = t.order || [],
            o = i.reduce(function(e, t, r) {
                return e[t] = r, e
            }, {});
        e.forEach(function(e) {
            var t = e.path || e.name;
            void 0 !== o[t] ? r[o[t]] = e : n.push(e)
        }), r = r.filter(function(e) {
            return e
        });
        var a, u = t.sortRemainingBy;
        return "hidden" === u ? r : (a = "alpha" === u ? [
            ["path", "name"],
            ["asc", "asc"]
        ] : [
            ["count"],
            ["desc"]
        ], r.concat(v(n, a[0], a[1])))
    }

    function p(e, t) {
        return e.renderingContent && e.renderingContent.facetOrdering && e.renderingContent.facetOrdering.values && e.renderingContent.facetOrdering.values[t]
    }

    function d(e, t) {
        var r = _(e, function(e) {
            return e.name === t
        });
        return r && r.stats
    }

    function h(e, t, r, n, i) {
        var o = _(i, function(e) {
                return e.name === r
            }),
            a = o && o.data && o.data[n] ? o.data[n] : 0,
            u = o && o.exhaustive || !1;
        return {
            type: t,
            attributeName: r,
            name: n,
            count: a,
            exhaustive: u
        }
    }

    function m(e, t, r, n) {
        var i = e.getHierarchicalFacetByName(t),
            o = e._getHierarchicalFacetSeparator(i),
            a = r.split(o),
            u = _(n, function(e) {
                return e.name === t
            }),
            c = a.reduce(function(e, t) {
                var r = e && _(e.data, function(e) {
                    return e.name === t
                });
                return void 0 !== r ? r : e
            }, u),
            s = c && c.count || 0,
            l = c && c.exhaustive || !1,
            f = c && c.path || "";
        return {
            type: "hierarchical",
            attributeName: t,
            name: f,
            count: s,
            exhaustive: l
        }
    }
    var y = r(12),
        b = r(23),
        v = r(46),
        g = r(122),
        _ = r(13),
        O = r(123),
        j = r(47),
        P = r(26),
        S = P.escapeFacetValue,
        w = P.unescapeFacetValue,
        E = r(124);
    a.prototype.getFacetByName = function(e) {
        function t(t) {
            return t.name === e
        }
        return _(this.facets, t) || _(this.disjunctiveFacets, t) || _(this.hierarchicalFacets, t)
    }, a.DEFAULT_SORT = ["isRefined:desc", "count:desc", "name:asc"], a.prototype.getFacetValues = function(e, t) {
        var r = u(this, e);
        if (r) {
            var n, i = b({}, t, {
                    sortBy: a.DEFAULT_SORT,
                    facetOrdering: !(t && t.sortBy)
                }),
                o = this;
            return n = Array.isArray(r) ? [e] : o._state.getHierarchicalFacetByName(r.name).attributes, s(function(e, t) {
                if (i.facetOrdering) {
                    var r = p(o, t);
                    if (Boolean(r)) return f(e, r)
                }
                if (Array.isArray(i.sortBy)) {
                    var n = j(i.sortBy, a.DEFAULT_SORT);
                    return v(e, n[0], n[1])
                }
                if ("function" == typeof i.sortBy) return l(i.sortBy, e);
                throw new Error("options.sortBy is optional but if defined it must be either an array of string (predicates) or a sorting function")
            }, r, n)
        }
    }, a.prototype.getFacetStats = function(e) {
        return this._state.isConjunctiveFacet(e) ? d(this.facets, e) : this._state.isDisjunctiveFacet(e) ? d(this.disjunctiveFacets, e) : void 0
    }, a.prototype.getRefinements = function() {
        var e = this._state,
            t = this,
            r = [];
        return Object.keys(e.facetsRefinements).forEach(function(n) {
            e.facetsRefinements[n].forEach(function(i) {
                r.push(h(e, "facet", n, i, t.facets))
            })
        }), Object.keys(e.facetsExcludes).forEach(function(n) {
            e.facetsExcludes[n].forEach(function(i) {
                r.push(h(e, "exclude", n, i, t.facets))
            })
        }), Object.keys(e.disjunctiveFacetsRefinements).forEach(function(n) {
            e.disjunctiveFacetsRefinements[n].forEach(function(i) {
                r.push(h(e, "disjunctive", n, i, t.disjunctiveFacets))
            })
        }), Object.keys(e.hierarchicalFacetsRefinements).forEach(function(n) {
            e.hierarchicalFacetsRefinements[n].forEach(function(i) {
                r.push(m(e, n, i, t.hierarchicalFacets))
            })
        }), Object.keys(e.numericRefinements).forEach(function(t) {
            var n = e.numericRefinements[t];
            Object.keys(n).forEach(function(e) {
                n[e].forEach(function(n) {
                    r.push({
                        type: "numeric",
                        attributeName: t,
                        name: n,
                        numericValue: n,
                        operator: e
                    })
                })
            })
        }), e.tagRefinements.forEach(function(e) {
            r.push({
                type: "tag",
                attributeName: "_tags",
                name: e
            })
        }), r
    }, e.exports = a
}, function(e, t, r) {
    "use strict";

    function n(e, t) {
        if (e !== t) {
            var r = void 0 !== e,
                n = null === e,
                i = void 0 !== t,
                o = null === t;
            if (!o && e > t || n && i || !r) return 1;
            if (!n && e < t || o && r || !i) return -1
        }
        return 0
    }

    function i(e, t, r) {
        if (!Array.isArray(e)) return [];
        Array.isArray(r) || (r = []);
        var i = e.map(function(e, r) {
            return {
                criteria: t.map(function(t) {
                    return e[t]
                }),
                index: r,
                value: e
            }
        });
        return i.sort(function(e, t) {
            for (var i = -1; ++i < e.criteria.length;) {
                var o = n(e.criteria[i], t.criteria[i]);
                if (o) return i >= r.length ? o : "desc" === r[i] ? -o : o
            }
            return e.index - t.index
        }), i.map(function(e) {
            return e.value
        })
    }
    e.exports = i
}, function(e, t, r) {
    "use strict";
    var n = r(13);
    e.exports = function(e, t) {
        var r = (t || []).map(function(e) {
            return e.split(":")
        });
        return e.reduce(function(e, t) {
            var i = t.split(":"),
                o = n(r, function(e) {
                    return e[0] === i[0]
                });
            return i.length > 1 || !o ? (e[0].push(i[0]), e[1].push(i[1]), e) : (e[0].push(o[0]), e[1].push(o[1]), e)
        }, [
            [],
            []
        ])
    }
}, function(e, t, r) {
    "use strict";

    function n(e, t) {
        e.prototype = Object.create(t.prototype, {
            constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        })
    }
    e.exports = n
}, function(e, t, r) {
    "use strict";
    e.exports = "3.13.0"
}, function(e, t, r) {
    "use strict";
    var n = r(1),
        i = n(r(8)),
        o = r(27),
        a = Object.prototype.hasOwnProperty,
        u = Array.isArray,
        c = function() {
            for (var e = [], t = 0; t < 256; ++t) e.push("%" + ((t < 16 ? "0" : "") + t.toString(16)).toUpperCase());
            return e
        }(),
        s = function(e) {
            for (; e.length > 1;) {
                var t = e.pop(),
                    r = t.obj[t.prop];
                if (u(r)) {
                    for (var n = [], i = 0; i < r.length; ++i) void 0 !== r[i] && n.push(r[i]);
                    t.obj[t.prop] = n
                }
            }
        },
        l = function(e, t) {
            for (var r = t && t.plainObjects ? Object.create(null) : {}, n = 0; n < e.length; ++n) void 0 !== e[n] && (r[n] = e[n]);
            return r
        },
        f = function e(t, r, n) {
            if (!r) return t;
            if ("object" !== (0, i.default)(r)) {
                if (u(t)) t.push(r);
                else {
                    if (!t || "object" !== (0, i.default)(t)) return [t, r];
                    (n && (n.plainObjects || n.allowPrototypes) || !a.call(Object.prototype, r)) && (t[r] = !0)
                }
                return t
            }
            if (!t || "object" !== (0, i.default)(t)) return [t].concat(r);
            var o = t;
            return u(t) && !u(r) && (o = l(t, n)), u(t) && u(r) ? (r.forEach(function(r, o) {
                if (a.call(t, o)) {
                    var u = t[o];
                    u && "object" === (0, i.default)(u) && r && "object" === (0, i.default)(r) ? t[o] = e(u, r, n) : t.push(r)
                } else t[o] = r
            }), t) : Object.keys(r).reduce(function(t, i) {
                var o = r[i];
                return a.call(t, i) ? t[i] = e(t[i], o, n) : t[i] = o, t
            }, o)
        },
        p = function(e, t) {
            return Object.keys(t).reduce(function(e, r) {
                return e[r] = t[r], e
            }, e)
        },
        d = function(e, t, r) {
            var n = e.replace(/\+/g, " ");
            if ("iso-8859-1" === r) return n.replace(/%[0-9a-f]{2}/gi, unescape);
            try {
                return decodeURIComponent(n)
            } catch (e) {
                return n
            }
        },
        h = function(e, t, r, n, a) {
            if (0 === e.length) return e;
            var u = e;
            if ("symbol" === (0, i.default)(e) ? u = Symbol.prototype.toString.call(e) : "string" != typeof e && (u = String(e)), "iso-8859-1" === r) return escape(u).replace(/%u[0-9a-f]{4}/gi, function(e) {
                return "%26%23" + parseInt(e.slice(2), 16) + "%3B"
            });
            for (var s = "", l = 0; l < u.length; ++l) {
                var f = u.charCodeAt(l);
                45 === f || 46 === f || 95 === f || 126 === f || f >= 48 && f <= 57 || f >= 65 && f <= 90 || f >= 97 && f <= 122 || a === o.RFC1738 && (40 === f || 41 === f) ? s += u.charAt(l) : f < 128 ? s += c[f] : f < 2048 ? s += c[192 | f >> 6] + c[128 | 63 & f] : f < 55296 || f >= 57344 ? s += c[224 | f >> 12] + c[128 | f >> 6 & 63] + c[128 | 63 & f] : (l += 1, f = 65536 + ((1023 & f) << 10 | 1023 & u.charCodeAt(l)), s += c[240 | f >> 18] + c[128 | f >> 12 & 63] + c[128 | f >> 6 & 63] + c[128 | 63 & f])
            }
            return s
        },
        m = function(e) {
            for (var t = [{
                    obj: {
                        o: e
                    },
                    prop: "o"
                }], r = [], n = 0; n < t.length; ++n)
                for (var o = t[n], a = o.obj[o.prop], u = Object.keys(a), c = 0; c < u.length; ++c) {
                    var l = u[c],
                        f = a[l];
                    "object" === (0, i.default)(f) && null !== f && -1 === r.indexOf(f) && (t.push({
                        obj: a,
                        prop: l
                    }), r.push(f))
                }
            return s(t), e
        },
        y = function(e) {
            return "[object RegExp]" === Object.prototype.toString.call(e)
        },
        b = function(e) {
            return !(!e || "object" !== (0, i.default)(e) || !(e.constructor && e.constructor.isBuffer && e.constructor.isBuffer(e)))
        },
        v = function(e, t) {
            return [].concat(e, t)
        },
        g = function(e, t) {
            if (u(e)) {
                for (var r = [], n = 0; n < e.length; n += 1) r.push(t(e[n]));
                return r
            }
            return t(e)
        };
    e.exports = {
        arrayToObject: l,
        assign: p,
        combine: v,
        compact: m,
        decode: d,
        encode: h,
        isBuffer: b,
        isRegExp: y,
        maybeMap: g,
        merge: f
    }
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0, t.default = "4.56.0"
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = r(154);
    Object.keys(n).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === n[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return n[e]
            }
        }))
    });
    var i = r(267);
    Object.keys(i).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === i[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return i[e]
            }
        }))
    });
    var o = r(270);
    Object.keys(o).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === o[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return o[e]
            }
        }))
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.version = void 0, t.version = "1.9.4"
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = r(179);
    Object.keys(n).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === n[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return n[e]
            }
        }))
    });
    var i = r(180);
    Object.keys(i).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === i[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return i[e]
            }
        }))
    });
    var o = r(181);
    Object.keys(o).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === o[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return o[e]
            }
        }))
    });
    var a = r(182);
    Object.keys(a).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === a[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return a[e]
            }
        }))
    });
    var u = r(183);
    Object.keys(u).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === u[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return u[e]
            }
        }))
    });
    var c = r(184);
    Object.keys(c).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === c[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return c[e]
            }
        }))
    });
    var s = r(185);
    Object.keys(s).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === s[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return s[e]
            }
        }))
    });
    var l = r(186);
    Object.keys(l).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === l[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return l[e]
            }
        }))
    });
    var f = r(187);
    Object.keys(f).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === f[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return f[e]
            }
        }))
    });
    var p = r(188);
    Object.keys(p).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === p[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return p[e]
            }
        }))
    });
    var d = r(189);
    Object.keys(d).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === d[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return d[e]
            }
        }))
    });
    var h = r(190);
    Object.keys(h).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === h[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return h[e]
            }
        }))
    })
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e) {
        return c(e) || u(e) || a(e) || o()
    }

    function o() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
    }

    function a(e, t) {
        if (e) {
            if ("string" == typeof e) return s(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? s(e, t) : void 0
        }
    }

    function u(e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e)
    }

    function c(e) {
        if (Array.isArray(e)) return s(e)
    }

    function s(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
        return n
    }

    function l(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function f(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? l(Object(r), !0).forEach(function(t) {
                p(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : l(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function p(e, t, r) {
        return t = d(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function d(e) {
        var t = h(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function h(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function m(e, t) {
        var r, n = "undefined" != typeof window ? window : {},
            o = e.plugins || [];
        return f(f({
            debug: !1,
            openOnFocus: !1,
            placeholder: "",
            autoFocus: !1,
            defaultActiveItemId: null,
            stallThreshold: 300,
            insights: !1,
            environment: n,
            shouldPanelOpen: function(e) {
                var t = e.state;
                return (0, y.getItemsCount)(t) > 0
            },
            reshape: function(e) {
                return e.sources
            }
        }, e), {}, {
            id: null !== (r = e.id) && void 0 !== r ? r : (0, y.generateAutocompleteId)(),
            plugins: o,
            initialState: f({
                activeItemId: null,
                query: "",
                completion: null,
                collections: [],
                isOpen: !1,
                status: "idle",
                context: {}
            }, e.initialState),
            onStateChange: function(t) {
                var r;
                null === (r = e.onStateChange) || void 0 === r || r.call(e, t), o.forEach(function(e) {
                    var r;
                    return null === (r = e.onStateChange) || void 0 === r ? void 0 : r.call(e, t)
                })
            },
            onSubmit: function(t) {
                var r;
                null === (r = e.onSubmit) || void 0 === r || r.call(e, t), o.forEach(function(e) {
                    var r;
                    return null === (r = e.onSubmit) || void 0 === r ? void 0 : r.call(e, t)
                })
            },
            onReset: function(t) {
                var r;
                null === (r = e.onReset) || void 0 === r || r.call(e, t), o.forEach(function(e) {
                    var r;
                    return null === (r = e.onReset) || void 0 === r ? void 0 : r.call(e, t)
                })
            },
            getSources: function(r) {
                return Promise.all([].concat(i(o.map(function(e) {
                    return e.getSources
                })), [e.getSources]).filter(Boolean).map(function(e) {
                    return (0, b.getNormalizedSources)(e, r)
                })).then(function(e) {
                    return (0, y.flatten)(e)
                }).then(function(e) {
                    return e.map(function(e) {
                        return f(f({}, e), {}, {
                            onSelect: function(r) {
                                e.onSelect(r), t.forEach(function(e) {
                                    var t;
                                    return null === (t = e.onSelect) || void 0 === t ? void 0 : t.call(e, r)
                                })
                            },
                            onActive: function(r) {
                                e.onActive(r), t.forEach(function(e) {
                                    var t;
                                    return null === (t = e.onActive) || void 0 === t ? void 0 : t.call(e, r)
                                })
                            },
                            onResolve: function(r) {
                                e.onResolve(r), t.forEach(function(e) {
                                    var t;
                                    return null === (t = e.onResolve) || void 0 === t ? void 0 : t.call(e, r)
                                })
                            }
                        })
                    })
                })
            },
            navigator: f({
                navigate: function(e) {
                    var t = e.itemUrl;
                    n.location.assign(t)
                },
                navigateNewTab: function(e) {
                    var t = e.itemUrl,
                        r = n.open(t, "_blank", "noopener");
                    null === r || void 0 === r || r.focus()
                },
                navigateNewWindow: function(e) {
                    var t = e.itemUrl;
                    n.open(t, "_blank", "noopener")
                }
            }, e.navigator)
        })
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.getDefaultProps = m;
    var y = r(4),
        b = r(6)
}, function(e, t, r) {
    "use strict";

    function n(e) {
        var t = o.get(this);
        return t || (t = new Map, o.set(this, t)), (t = i(this, t.get(e) || (t.set(e, t = function(e) {
            for (var t, r, n = 1, i = "", o = "", a = [0], u = function(e) {
                    1 === n && (e || (i = i.replace(/^\s*\n\s*|\s*\n\s*$/g, ""))) ? a.push(0, e, i) : 3 === n && (e || i) ? (a.push(3, e, i), n = 2) : 2 === n && "..." === i && e ? a.push(4, e, 0) : 2 === n && i && !e ? a.push(5, 0, !0, i) : n >= 5 && ((i || !e && 5 === n) && (a.push(n, 0, i, r), n = 6), e && (a.push(n, e, 0, r), n = 6)), i = ""
                }, c = 0; c < e.length; c++) {
                c && (1 === n && u(), u(c));
                for (var s = 0; s < e[c].length; s++) t = e[c][s], 1 === n ? "<" === t ? (u(), a = [a], n = 3) : i += t : 4 === n ? "--" === i && ">" === t ? (n = 1, i = "") : i = t + i[0] : o ? t === o ? o = "" : i += t : '"' === t || "'" === t ? o = t : ">" === t ? (u(), n = 1) : n && ("=" === t ? (n = 5, r = i, i = "") : "/" === t && (n < 5 || ">" === e[c][s + 1]) ? (u(), 3 === n && (a = a[0]), n = a, (a = a[0]).push(2, 0, n), n = 0) : " " === t || "\t" === t || "\n" === t || "\r" === t ? (u(), n = 2) : i += t), 3 === n && "!--" === i && (n = 4, a = a[0])
            }
            return u(), a
        }(e)), t), arguments, [])).length > 1 ? t : t[0]
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = n;
    var i = function e(t, r, n, i) {
            var o;
            r[0] = 0;
            for (var a = 1; a < r.length; a++) {
                var u = r[a++],
                    c = r[a] ? (r[0] |= u ? 1 : 2, n[r[a++]]) : r[++a];
                3 === u ? i[0] = c : 4 === u ? i[1] = Object.assign(i[1] || {}, c) : 5 === u ? (i[1] = i[1] || {})[r[++a]] = c : 6 === u ? i[1][r[++a]] += c + "" : u ? (o = t.apply(c, e(t, c, n, ["", null])), i.push(o), c[0] ? r[0] |= 2 : (r[a - 2] = 0, r[a] = o)) : i.push(c)
            }
            return i
        },
        o = new Map
}, function(e, t, r) {
    "use strict";

    function n(e) {
        return u(e) || a(e) || o(e) || i()
    }

    function i() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
    }

    function o(e, t) {
        if (e) {
            if ("string" == typeof e) return c(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? c(e, t) : void 0
        }
    }

    function a(e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e)
    }

    function u(e) {
        if (Array.isArray(e)) return c(e)
    }

    function c(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
        return n
    }

    function s(e, t) {
        if (null == e) return {};
        var r, n, i = l(e, t);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
        }
        return i
    }

    function l(e, t) {
        if (null == e) return {};
        var r, n, i = {},
            o = Object.keys(e);
        for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || (i[r] = e[r]);
        return i
    }

    function f(e) {
        return function(t, r) {
            var i = r.children,
                o = void 0 === i ? [] : i,
                a = s(r, d),
                u = e.document.createElement(t);
            return (0, p.setProperties)(u, a), u.append.apply(u, n(o)), u
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.getCreateDomElement = f;
    var p = r(9),
        d = ["children"]
}, function(e, t, r) {
    "use strict";

    function n(e) {
        return u(e) || a(e) || o(e) || i()
    }

    function i() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
    }

    function o(e, t) {
        if (e) {
            if ("string" == typeof e) return c(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? c(e, t) : void 0
        }
    }

    function a(e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e)
    }

    function u(e) {
        if (Array.isArray(e)) return c(e)
    }

    function c(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
        return n
    }

    function s(e) {
        var t = e.hit,
            r = e.attribute,
            i = Array.isArray(r) ? r : [r],
            o = (0, l.getAttributeValueByPath)(t, ["_highlightResult"].concat(n(i), ["value"]));
        return "string" != typeof o && (o = (0, l.getAttributeValueByPath)(t, i) || ""), (0, f.parseAttribute)({
            highlightedValue: o
        })
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.parseAlgoliaHitHighlight = s;
    var l = r(4),
        f = r(59)
}, function(e, t, r) {
    "use strict";

    function n() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
            t = e;
        return {
            get: function() {
                return t
            },
            add: function(e) {
                var r = t[t.length - 1];
                (null === r || void 0 === r ? void 0 : r.isHighlighted) === e.isHighlighted ? t[t.length - 1] = {
                    value: r.value + e.value,
                    isHighlighted: r.isHighlighted
                } : t.push(e)
            }
        }
    }

    function i(e) {
        var t = e.highlightedValue,
            r = t.split(o.HIGHLIGHT_PRE_TAG),
            i = r.shift(),
            a = n(i ? [{
                value: i,
                isHighlighted: !1
            }] : []);
        return r.forEach(function(e) {
            var t = e.split(o.HIGHLIGHT_POST_TAG);
            a.add({
                value: t[0],
                isHighlighted: !0
            }), "" !== t[1] && a.add({
                value: t[1],
                isHighlighted: !1
            })
        }), a.get()
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.parseAttribute = i;
    var o = r(60)
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.HIGHLIGHT_PRE_TAG = t.HIGHLIGHT_POST_TAG = void 0, t.HIGHLIGHT_PRE_TAG = "__aa-highlight__", t.HIGHLIGHT_POST_TAG = "__/aa-highlight__"
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function s(e) {
        return e.some(function(e) {
            return e.isHighlighted
        }) ? e.map(function(t, r) {
            return o(o({}, t), {}, {
                isHighlighted: !(0, l.isPartHighlighted)(e, r)
            })
        }) : e.map(function(e) {
            return o(o({}, e), {}, {
                isHighlighted: !1
            })
        })
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.reverseHighlightedParts = s;
    var l = r(250)
}, function(e, t, r) {
    "use strict";

    function n(e) {
        return u(e) || a(e) || o(e) || i()
    }

    function i() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
    }

    function o(e, t) {
        if (e) {
            if ("string" == typeof e) return c(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? c(e, t) : void 0
        }
    }

    function a(e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e)
    }

    function u(e) {
        if (Array.isArray(e)) return c(e)
    }

    function c(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
        return n
    }

    function s(e) {
        var t = e.hit,
            r = e.attribute,
            i = Array.isArray(r) ? r : [r],
            o = (0, l.getAttributeValueByPath)(t, ["_snippetResult"].concat(n(i), ["value"]));
        return "string" != typeof o && (o = (0, l.getAttributeValueByPath)(t, i) || ""), (0, f.parseAttribute)({
            highlightedValue: o
        })
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.parseAlgoliaHitSnippet = s;
    var l = r(4),
        f = r(59)
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function s(e, t) {
        function r(t) {
            return e({
                searchClient: t.searchClient,
                queries: t.requests.map(function(e) {
                    return e.query
                })
            }).then(function(e) {
                return e.map(function(e, r) {
                    var n = t.requests[r];
                    return {
                        items: e,
                        sourceId: n.sourceId,
                        transformResponse: n.transformResponse
                    }
                })
            })
        }
        return function(e) {
            return function(n) {
                return o(o({
                    requesterId: t,
                    execute: r
                }, e), n)
            }
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.createRequester = s
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.createAlgoliaRequester = void 0;
    var n = r(65),
        i = r(63),
        o = (0, i.createRequester)(n.fetchAlgoliaResults, "algolia");
    t.createAlgoliaRequester = o
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = r(255);
    Object.keys(n).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === n[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return n[e]
            }
        }))
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.userAgents = void 0;
    var n = r(4),
        i = [{
            segment: "autocomplete-js",
            version: n.version
        }];
    t.userAgents = i
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.createAlgoliaRequester = void 0;
    var s = r(11),
        l = r(66),
        f = (0, s.createRequester)(function(e) {
            return (0, s.fetchAlgoliaResults)(o(o({}, e), {}, {
                userAgents: l.userAgents
            }))
        }, "algolia");
    t.createAlgoliaRequester = f
}, function(e, t, r) {
    "use strict";

    function n(e) {
        var t = e.onTapAhead;
        return {
            item: function(e) {
                var r = e.item,
                    n = e.createElement,
                    i = e.components;
                return r.__autocomplete_qsCategory ? n("div", {
                    className: "aa-ItemWrapper"
                }, n("div", {
                    className: "aa-ItemContent aa-ItemContent--indented"
                }, n("div", {
                    className: "aa-ItemContentSubtitle aa-ItemContentSubtitle--standalone"
                }, n("span", {
                    className: "aa-ItemContentSubtitleIcon"
                }), n("span", null, "in", " ", n("span", {
                    className: "aa-ItemContentSubtitleCategory"
                }, r.__autocomplete_qsCategory))))) : n("div", {
                    className: "aa-ItemWrapper"
                }, n("div", {
                    className: "aa-ItemContent"
                }, n("div", {
                    className: "aa-ItemIcon aa-ItemIcon--noBorder"
                }, n("svg", {
                    viewBox: "0 0 24 24",
                    fill: "currentColor"
                }, n("path", {
                    d: "M16.041 15.856c-0.034 0.026-0.067 0.055-0.099 0.087s-0.060 0.064-0.087 0.099c-1.258 1.213-2.969 1.958-4.855 1.958-1.933 0-3.682-0.782-4.95-2.050s-2.050-3.017-2.050-4.95 0.782-3.682 2.050-4.95 3.017-2.050 4.95-2.050 3.682 0.782 4.95 2.050 2.050 3.017 2.050 4.95c0 1.886-0.745 3.597-1.959 4.856zM21.707 20.293l-3.675-3.675c1.231-1.54 1.968-3.493 1.968-5.618 0-2.485-1.008-4.736-2.636-6.364s-3.879-2.636-6.364-2.636-4.736 1.008-6.364 2.636-2.636 3.879-2.636 6.364 1.008 4.736 2.636 6.364 3.879 2.636 6.364 2.636c2.125 0 4.078-0.737 5.618-1.968l3.675 3.675c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414z"
                }))), n("div", {
                    className: "aa-ItemContentBody"
                }, n("div", {
                    className: "aa-ItemContentTitle"
                }, n(i.ReverseHighlight, {
                    hit: r,
                    attribute: "query"
                })))), n("div", {
                    className: "aa-ItemActions"
                }, n("button", {
                    className: "aa-ItemActionButton",
                    title: 'Fill query with "'.concat(r.query, '"'),
                    onClick: function(e) {
                        e.preventDefault(), e.stopPropagation(), t(r)
                    }
                }, n("svg", {
                    viewBox: "0 0 24 24",
                    fill: "currentColor"
                }, n("path", {
                    d: "M8 17v-7.586l8.293 8.293c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414l-8.293-8.293h7.586c0.552 0 1-0.448 1-1s-0.448-1-1-1h-10c-0.552 0-1 0.448-1 1v10c0 0.552 0.448 1 1 1s1-0.448 1-1z"
                })))))
            }
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.getTemplates = n
}, function(e, t, r) {
    "use strict";

    function n(e, t) {
        for (var r in t) e[r] = t[r];
        return e
    }

    function i(e) {
        var t = e.parentNode;
        t && t.removeChild(e)
    }

    function o(e, t, r) {
        var n, i, o, u = {};
        for (o in t) "key" == o ? n = t[o] : "ref" == o ? i = t[o] : u[o] = t[o];
        if (arguments.length > 2 && (u.children = arguments.length > 3 ? C.call(arguments, 2) : r), "function" == typeof e && null != e.defaultProps)
            for (o in e.defaultProps) void 0 === u[o] && (u[o] = e.defaultProps[o]);
        return a(e, u, n, i, null)
    }

    function a(e, t, r, n, i) {
        var o = {
            type: e,
            props: t,
            key: r,
            ref: n,
            __k: null,
            __: null,
            __b: 0,
            __e: null,
            __d: void 0,
            __c: null,
            __h: null,
            constructor: void 0,
            __v: null == i ? ++F : i
        };
        return null == i && null != T.vnode && T.vnode(o), o
    }

    function u() {
        return {
            current: null
        }
    }

    function c(e) {
        return e.children
    }

    function s(e, t) {
        this.props = e, this.context = t
    }

    function l(e, t) {
        if (null == t) return e.__ ? l(e.__, e.__.__k.indexOf(e) + 1) : null;
        for (var r; t < e.__k.length; t++)
            if (null != (r = e.__k[t]) && null != r.__e) return r.__e;
        return "function" == typeof e.type ? l(e) : null
    }

    function f(e) {
        var t, r;
        if (null != (e = e.__) && null != e.__c) {
            for (e.__e = e.__c.base = null, t = 0; t < e.__k.length; t++)
                if (null != (r = e.__k[t]) && null != r.__e) {
                    e.__e = e.__c.base = r.__e;
                    break
                }
            return f(e)
        }
    }

    function p(e) {
        (!e.__d && (e.__d = !0) && H.push(e) && !d.__r++ || L !== T.debounceRendering) && ((L = T.debounceRendering) || q)(d)
    }

    function d() {
        var e, t, r, i, o, a, u, c;
        for (H.sort(B); e = H.shift();) e.__d && (t = H.length, i = void 0, o = void 0, u = (a = (r = e).__v).__e, (c = r.__P) && (i = [], (o = n({}, a)).__v = a.__v + 1, S(c, a, o, r.__n, void 0 !== c.ownerSVGElement, null != a.__h ? [u] : null, i, null == u ? l(a) : u, a.__h), w(i, a), a.__e != u && f(a)), H.length > t && H.sort(B));
        d.__r = 0
    }

    function h(e, t, r, n, i, o, u, s, f, p) {
        var d, h, y, g, _, O, j, P = n && n.__k || V,
            w = P.length;
        for (r.__k = [], d = 0; d < t.length; d++)
            if (null != (g = r.__k[d] = null == (g = t[d]) || "boolean" == typeof g || "function" == typeof g ? null : "string" == typeof g || "number" == typeof g || "bigint" == typeof g ? a(null, g, null, null, g) : Array.isArray(g) ? a(c, {
                    children: g
                }, null, null, null) : g.__b > 0 ? a(g.type, g.props, g.key, g.ref ? g.ref : null, g.__v) : g)) {
                if (g.__ = r, g.__b = r.__b + 1, null === (y = P[d]) || y && g.key == y.key && g.type === y.type) P[d] = void 0;
                else
                    for (h = 0; h < w; h++) {
                        if ((y = P[h]) && g.key == y.key && g.type === y.type) {
                            P[h] = void 0;
                            break
                        }
                        y = null
                    }
                S(e, g, y = y || W, i, o, u, s, f, p), _ = g.__e, (h = g.ref) && y.ref != h && (j || (j = []), y.ref && j.push(y.ref, null, g), j.push(h, g.__c || _, g)), null != _ ? (null == O && (O = _), "function" == typeof g.type && g.__k === y.__k ? g.__d = f = m(g, f, e) : f = b(e, g, y, P, _, f), "function" == typeof r.type && (r.__d = f)) : f && y.__e == f && f.parentNode != e && (f = l(y))
            }
        for (r.__e = O, d = w; d--;) null != P[d] && ("function" == typeof r.type && null != P[d].__e && P[d].__e == r.__d && (r.__d = v(n).nextSibling), x(P[d], P[d]));
        if (j)
            for (d = 0; d < j.length; d++) R(j[d], j[++d], j[++d])
    }

    function m(e, t, r) {
        for (var n, i = e.__k, o = 0; i && o < i.length; o++)(n = i[o]) && (n.__ = e, t = "function" == typeof n.type ? m(n, t, r) : b(r, n, n, i, n.__e, t));
        return t
    }

    function y(e, t) {
        return t = t || [], null == e || "boolean" == typeof e || (Array.isArray(e) ? e.some(function(e) {
            y(e, t)
        }) : t.push(e)), t
    }

    function b(e, t, r, n, i, o) {
        var a, u, c;
        if (void 0 !== t.__d) a = t.__d, t.__d = void 0;
        else if (null == r || i != o || null == i.parentNode) e: if (null == o || o.parentNode !== e) e.appendChild(i), a = null;
            else {
                for (u = o, c = 0;
                    (u = u.nextSibling) && c < n.length; c += 1)
                    if (u == i) break e;
                e.insertBefore(i, o), a = o
            }
        return void 0 !== a ? a : i.nextSibling
    }

    function v(e) {
        var t, r, n;
        if (null == e.type || "string" == typeof e.type) return e.__e;
        if (e.__k)
            for (t = e.__k.length - 1; t >= 0; t--)
                if ((r = e.__k[t]) && (n = v(r))) return n;
        return null
    }

    function g(e, t, r, n, i) {
        var o;
        for (o in r) "children" === o || "key" === o || o in t || O(e, o, null, r[o], n);
        for (o in t) i && "function" != typeof t[o] || "children" === o || "key" === o || "value" === o || "checked" === o || r[o] === t[o] || O(e, o, t[o], r[o], n)
    }

    function _(e, t, r) {
        "-" === t[0] ? e.setProperty(t, null == r ? "" : r) : e[t] = null == r ? "" : "number" != typeof r || Q.test(t) ? r : r + "px"
    }

    function O(e, t, r, n, i) {
        var o;
        e: if ("style" === t)
            if ("string" == typeof r) e.style.cssText = r;
            else {
                if ("string" == typeof n && (e.style.cssText = n = ""), n)
                    for (t in n) r && t in r || _(e.style, t, "");
                if (r)
                    for (t in r) n && r[t] === n[t] || _(e.style, t, r[t])
            }
        else if ("o" === t[0] && "n" === t[1]) o = t !== (t = t.replace(/Capture$/, "")), t = t.toLowerCase() in e ? t.toLowerCase().slice(2) : t.slice(2), e.l || (e.l = {}), e.l[t + o] = r, r ? n || e.addEventListener(t, o ? P : j, o) : e.removeEventListener(t, o ? P : j, o);
        else if ("dangerouslySetInnerHTML" !== t) {
            if (i) t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
            else if ("width" !== t && "height" !== t && "href" !== t && "list" !== t && "form" !== t && "tabIndex" !== t && "download" !== t && t in e) try {
                e[t] = null == r ? "" : r;
                break e
            } catch (e) {}
            "function" == typeof r || (null == r || !1 === r && "-" !== t[4] ? e.removeAttribute(t) : e.setAttribute(t, r))
        }
    }

    function j(e) {
        return this.l[e.type + !1](T.event ? T.event(e) : e)
    }

    function P(e) {
        return this.l[e.type + !0](T.event ? T.event(e) : e)
    }

    function S(e, t, r, i, o, a, u, l, f) {
        var p, d, m, y, b, v, g, _, O, j, P, S, w, R, x, k = t.type;
        if (void 0 !== t.constructor) return null;
        null != r.__h && (f = r.__h, l = t.__e = r.__e, t.__h = null, a = [l]), (p = T.__b) && p(t);
        try {
            e: if ("function" == typeof k) {
                if (_ = t.props, O = (p = k.contextType) && i[p.__c], j = p ? O ? O.props.value : p.__ : i, r.__c ? g = (d = t.__c = r.__c).__ = d.__E : ("prototype" in k && k.prototype.render ? t.__c = d = new k(_, j) : (t.__c = d = new s(_, j), d.constructor = k, d.render = I), O && O.sub(d), d.props = _, d.state || (d.state = {}), d.context = j, d.__n = i, m = d.__d = !0, d.__h = [], d._sb = []), null == d.__s && (d.__s = d.state), null != k.getDerivedStateFromProps && (d.__s == d.state && (d.__s = n({}, d.__s)), n(d.__s, k.getDerivedStateFromProps(_, d.__s))), y = d.props, b = d.state, d.__v = t, m) null == k.getDerivedStateFromProps && null != d.componentWillMount && d.componentWillMount(), null != d.componentDidMount && d.__h.push(d.componentDidMount);
                else {
                    if (null == k.getDerivedStateFromProps && _ !== y && null != d.componentWillReceiveProps && d.componentWillReceiveProps(_, j), !d.__e && null != d.shouldComponentUpdate && !1 === d.shouldComponentUpdate(_, d.__s, j) || t.__v === r.__v) {
                        for (t.__v !== r.__v && (d.props = _, d.state = d.__s, d.__d = !1), d.__e = !1, t.__e = r.__e, t.__k = r.__k, t.__k.forEach(function(e) {
                                e && (e.__ = t)
                            }), P = 0; P < d._sb.length; P++) d.__h.push(d._sb[P]);
                        d._sb = [], d.__h.length && u.push(d);
                        break e
                    }
                    null != d.componentWillUpdate && d.componentWillUpdate(_, d.__s, j), null != d.componentDidUpdate && d.__h.push(function() {
                        d.componentDidUpdate(y, b, v)
                    })
                }
                if (d.context = j, d.props = _, d.__P = e, S = T.__r, w = 0, "prototype" in k && k.prototype.render) {
                    for (d.state = d.__s, d.__d = !1, S && S(t), p = d.render(d.props, d.state, d.context), R = 0; R < d._sb.length; R++) d.__h.push(d._sb[R]);
                    d._sb = []
                } else
                    do {
                        d.__d = !1, S && S(t), p = d.render(d.props, d.state, d.context), d.state = d.__s
                    } while (d.__d && ++w < 25);
                d.state = d.__s, null != d.getChildContext && (i = n(n({}, i), d.getChildContext())), m || null == d.getSnapshotBeforeUpdate || (v = d.getSnapshotBeforeUpdate(y, b)), x = null != p && p.type === c && null == p.key ? p.props.children : p, h(e, Array.isArray(x) ? x : [x], t, r, i, o, a, u, l, f), d.base = t.__e, t.__h = null, d.__h.length && u.push(d), g && (d.__E = d.__ = null), d.__e = !1
            } else null == a && t.__v === r.__v ? (t.__k = r.__k, t.__e = r.__e) : t.__e = E(r.__e, t, r, i, o, a, u, f);
            (p = T.diffed) && p(t)
        }
        catch (e) {
            t.__v = null, (f || null != a) && (t.__e = l, t.__h = !!f, a[a.indexOf(l)] = null), T.__e(e, t, r)
        }
    }

    function w(e, t) {
        T.__c && T.__c(t, e), e.some(function(t) {
            try {
                e = t.__h, t.__h = [], e.some(function(e) {
                    e.call(t)
                })
            } catch (e) {
                T.__e(e, t.__v)
            }
        })
    }

    function E(e, t, r, n, o, a, u, c) {
        var s, f, p, d = r.props,
            m = t.props,
            y = t.type,
            b = 0;
        if ("svg" === y && (o = !0), null != a)
            for (; b < a.length; b++)
                if ((s = a[b]) && "setAttribute" in s == !!y && (y ? s.localName === y : 3 === s.nodeType)) {
                    e = s, a[b] = null;
                    break
                }
        if (null == e) {
            if (null === y) return document.createTextNode(m);
            e = o ? document.createElementNS("http://www.w3.org/2000/svg", y) : document.createElement(y, m.is && m), a = null, c = !1
        }
        if (null === y) d === m || c && e.data === m || (e.data = m);
        else {
            if (a = a && C.call(e.childNodes), f = (d = r.props || W).dangerouslySetInnerHTML, p = m.dangerouslySetInnerHTML, !c) {
                if (null != a)
                    for (d = {}, b = 0; b < e.attributes.length; b++) d[e.attributes[b].name] = e.attributes[b].value;
                (p || f) && (p && (f && p.__html == f.__html || p.__html === e.innerHTML) || (e.innerHTML = p && p.__html || ""))
            }
            if (g(e, m, d, o, c), p) t.__k = [];
            else if (b = t.props.children, h(e, Array.isArray(b) ? b : [b], t, r, n, o && "foreignObject" !== y, a, u, a ? a[0] : r.__k && l(r, 0), c), null != a)
                for (b = a.length; b--;) null != a[b] && i(a[b]);
            c || ("value" in m && void 0 !== (b = m.value) && (b !== e.value || "progress" === y && !b || "option" === y && b !== d.value) && O(e, "value", b, d.value, !1), "checked" in m && void 0 !== (b = m.checked) && b !== e.checked && O(e, "checked", b, d.checked, !1))
        }
        return e
    }

    function R(e, t, r) {
        try {
            "function" == typeof e ? e(t) : e.current = t
        } catch (e) {
            T.__e(e, r)
        }
    }

    function x(e, t, r) {
        var n, o;
        if (T.unmount && T.unmount(e), (n = e.ref) && (n.current && n.current !== e.__e || R(n, null, t)), null != (n = e.__c)) {
            if (n.componentWillUnmount) try {
                n.componentWillUnmount()
            } catch (e) {
                T.__e(e, t)
            }
            n.base = n.__P = null, e.__c = void 0
        }
        if (n = e.__k)
            for (o = 0; o < n.length; o++) n[o] && x(n[o], t, r || "function" != typeof e.type);
        r || null == e.__e || i(e.__e), e.__ = e.__e = e.__d = void 0
    }

    function I(e, t, r) {
        return this.constructor(e, r)
    }

    function k(e, t, r) {
        var n, i, a;
        T.__ && T.__(e, t), i = (n = "function" == typeof r) ? null : r && r.__k || t.__k, a = [], S(t, e = (!n && r || t).__k = o(c, null, [e]), i || W, W, void 0 !== t.ownerSVGElement, !n && r ? [r] : i ? null : t.firstChild ? C.call(t.childNodes) : null, a, !n && r ? r : i ? i.__e : t.firstChild, n), w(a, e)
    }

    function M(e, t) {
        k(e, t, M)
    }

    function A(e, t, r) {
        var i, o, u, c = n({}, e.props);
        for (u in t) "key" == u ? i = t[u] : "ref" == u ? o = t[u] : c[u] = t[u];
        return arguments.length > 2 && (c.children = arguments.length > 3 ? C.call(arguments, 2) : r), a(e.type, c, i || e.key, o || e.ref, null)
    }

    function N(e, t) {
        var r = {
            __c: t = "__cC" + U++,
            __: e,
            Consumer: function(e, t) {
                return e.children(t)
            },
            Provider: function(e) {
                var r, n;
                return this.getChildContext || (r = [], (n = {})[t] = this, this.getChildContext = function() {
                    return n
                }, this.shouldComponentUpdate = function(e) {
                    this.props.value !== e.value && r.some(function(e) {
                        e.__e = !0, p(e)
                    })
                }, this.sub = function(e) {
                    r.push(e);
                    var t = e.componentWillUnmount;
                    e.componentWillUnmount = function() {
                        r.splice(r.indexOf(e), 1), t && t.call(e)
                    }
                }), e.children
            }
        };
        return r.Provider.__ = r.Consumer.contextType = r
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.Component = s, t.Fragment = c, t.cloneElement = A, t.createContext = N, t.h = t.createElement = o, t.createRef = u, t.hydrate = M, t.options = t.isValidElement = void 0, t.render = k, t.toChildArray = y;
    var C, T, F, D, H, L, q, B, U, W = {},
        V = [],
        Q = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
    t.isValidElement = D, t.options = T, C = V.slice, t.options = T = {
        __e: function(e, t, r, n) {
            for (var i, o, a; t = t.__;)
                if ((i = t.__c) && !i.__) try {
                    if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(e)), a = i.__d), null != i.componentDidCatch && (i.componentDidCatch(e, n || {}), a = i.__d), a) return i.__E = i
                } catch (t) {
                    e = t
                }
            throw e
        }
    }, F = 0, t.isValidElement = D = function(e) {
        return null != e && void 0 === e.constructor
    }, s.prototype.setState = function(e, t) {
        var r;
        r = null != this.__s && this.__s !== this.state ? this.__s : this.__s = n({}, this.state), "function" == typeof e && (e = e(n({}, r), this.props)), e && n(r, e), null != e && this.__v && (t && this._sb.push(t), p(this))
    }, s.prototype.forceUpdate = function(e) {
        this.__v && (this.__e = !0, e && this.__h.push(e), p(this))
    }, s.prototype.render = c, H = [], q = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, B = function(e, t) {
        return e.__v.__b - t.__v.__b
    }, d.__r = 0, U = 0
}, function(e, t, r) {
    "use strict";
    var n = r(1);
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), Object.defineProperty(t, "Component", {
        enumerable: !0,
        get: function() {
            return i.Component
        }
    }), Object.defineProperty(t, "h", {
        enumerable: !0,
        get: function() {
            return i.h
        }
    }), t.html = void 0, Object.defineProperty(t, "render", {
        enumerable: !0,
        get: function() {
            return i.render
        }
    });
    var i = r(69),
        o = n(r(56)),
        a = o.default.bind(i.h);
    t.html = a
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                g(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a() {
        return a = Object.assign ? Object.assign.bind() : function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = arguments[t];
                for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
            }
            return e
        }, a.apply(this, arguments)
    }

    function u(e, t) {
        if (null == e) return {};
        var r, n, i = c(e, t);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
        }
        return i
    }

    function c(e, t) {
        if (null == e) return {};
        var r, n, i = {},
            o = Object.keys(e);
        for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || (i[r] = e[r]);
        return i
    }

    function s(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
    }

    function l(e, t) {
        for (var r = 0; r < t.length; r++) {
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, _(n.key), n)
        }
    }

    function f(e, t, r) {
        return t && l(e.prototype, t), r && l(e, r), Object.defineProperty(e, "prototype", {
            writable: !1
        }), e
    }

    function p(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
            constructor: {
                value: e,
                writable: !0,
                configurable: !0
            }
        }), Object.defineProperty(e, "prototype", {
            writable: !1
        }), t && d(e, t)
    }

    function d(e, t) {
        return (d = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
            return e.__proto__ = t, e
        })(e, t)
    }

    function h(e) {
        var t = b();
        return function() {
            var r, n = v(e);
            if (t) {
                var i = v(this).constructor;
                r = Reflect.construct(n, arguments, i)
            } else r = n.apply(this, arguments);
            return m(this, r)
        }
    }

    function m(e, t) {
        if (t && ("object" === n(t) || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return y(e)
    }

    function y(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e
    }

    function b() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0
        } catch (e) {
            return !1
        }
    }

    function v(e) {
        return (v = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e)
        })(e)
    }

    function g(e, t, r) {
        return t = _(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function _(e) {
        var t = O(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function O(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function j(e) {
        return void 0 !== e.data
    }
    var P = r(1);
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var S = r(3),
        w = r(2),
        E = r(0),
        R = P(r(72)),
        x = P(r(7)),
        I = P(r(302)),
        k = ["root"],
        M = {
            cssClasses: {},
            depth: 0
        },
        A = function(e) {
            function t() {
                var e;
                s(this, t);
                for (var n = arguments.length, i = new Array(n), c = 0; c < n; c++) i[c] = arguments[c];
                return e = r.call.apply(r, [this].concat(i)), g(y(e), "searchBox", (0, w.createRef)()), g(y(e), "_generateFacetItem", function(r) {
                    var n;
                    if (j(r) && Array.isArray(r.data) && r.data.length > 0) {
                        var i = e.props.cssClasses,
                            c = (i.root, u(i, k));
                        n = (0, w.h)(t, a({}, e.props, {
                            cssClasses: c,
                            depth: e.props.depth + 1,
                            facetValues: r.data,
                            showMore: !1,
                            className: e.props.cssClasses.childList
                        }))
                    }
                    var s = e.props.createURL(r.value),
                        l = o(o({}, r), {}, {
                            url: s,
                            attribute: e.props.attribute,
                            cssClasses: e.props.cssClasses,
                            isFromSearch: e.props.isFromSearch
                        }),
                        f = r.value;
                    void 0 !== r.isRefined && (f += "/".concat(r.isRefined)), void 0 !== r.count && (f += "/".concat(r.count));
                    var p = (0, S.cx)(e.props.cssClasses.item, r.isRefined && e.props.cssClasses.selectedItem, !r.count && e.props.cssClasses.disabledItem, Boolean(j(r) && Array.isArray(r.data) && r.data.length > 0) && e.props.cssClasses.parentItem);
                    return (0, w.h)(I.default, {
                        templateKey: "item",
                        key: f,
                        facetValueToRefine: r.value,
                        handleClick: e.handleItemClick,
                        isRefined: r.isRefined,
                        className: p,
                        subItems: n,
                        templateData: l,
                        templateProps: e.props.templateProps
                    })
                }), g(y(e), "handleItemClick", function(t) {
                    var r = t.facetValueToRefine,
                        n = t.isRefined,
                        i = t.originalEvent;
                    if (!(0, E.isSpecialClick)(i) && i.target instanceof HTMLElement && i.target.parentNode instanceof HTMLElement && (!n || !i.target.parentNode.querySelector('input[type="radio"]:checked'))) {
                        if ("INPUT" === i.target.tagName) return void e.refine(r);
                        for (var o = i.target; o !== i.currentTarget;) {
                            if ("LABEL" === o.tagName && (o.querySelector('input[type="checkbox"]') || o.querySelector('input[type="radio"]'))) return;
                            "A" === o.tagName && o.href && i.preventDefault(), o = o.parentNode
                        }
                        i.stopPropagation(), e.refine(r)
                    }
                }), e
            }
            p(t, e);
            var r = h(t);
            return f(t, [{
                key: "shouldComponentUpdate",
                value: function(e) {
                    return !(0, E.isEqual)(this.props.facetValues, e.facetValues)
                }
            }, {
                key: "refine",
                value: function(e) {
                    this.props.toggleRefinement(e)
                }
            }, {
                key: "componentWillReceiveProps",
                value: function(e) {
                    this.searchBox.current && !e.isFromSearch && this.searchBox.current.resetInput()
                }
            }, {
                key: "refineFirstValue",
                value: function() {
                    var e = this.props.facetValues && this.props.facetValues[0];
                    if (e) {
                        var t = e.value;
                        this.props.toggleRefinement(t)
                    }
                }
            }, {
                key: "render",
                value: function() {
                    var e = this,
                        t = (0, S.cx)(this.props.cssClasses.showMore, !(!0 === this.props.showMore && this.props.canToggleShowMore) && this.props.cssClasses.disabledShowMore),
                        r = !0 === this.props.showMore && (0, w.h)(x.default, a({}, this.props.templateProps, {
                            templateKey: "showMoreText",
                            rootTagName: "button",
                            rootProps: {
                                className: t,
                                disabled: !this.props.canToggleShowMore,
                                onClick: this.props.toggleShowMore
                            },
                            data: {
                                isShowingMore: this.props.isShowingMore
                            }
                        })),
                        n = !0 !== this.props.searchIsAlwaysActive && !(this.props.isFromSearch || !this.props.hasExhaustiveItems),
                        i = this.props.searchFacetValues && (0, w.h)("div", {
                            className: this.props.cssClasses.searchBox
                        }, (0, w.h)(R.default, {
                            ref: this.searchBox,
                            placeholder: this.props.searchPlaceholder,
                            disabled: n,
                            cssClasses: this.props.cssClasses.searchable,
                            templates: this.props.searchBoxTemplateProps.templates,
                            onChange: function(t) {
                                return e.props.searchFacetValues(t.target.value)
                            },
                            onReset: function() {
                                return e.props.searchFacetValues("")
                            },
                            onSubmit: function() {
                                return e.refineFirstValue()
                            },
                            searchAsYouType: !1
                        })),
                        o = this.props.facetValues && this.props.facetValues.length > 0 && (0, w.h)("ul", {
                            className: this.props.cssClasses.list
                        }, this.props.facetValues.map(this._generateFacetItem, this)),
                        u = this.props.searchFacetValues && this.props.isFromSearch && (!this.props.facetValues || 0 === this.props.facetValues.length) && (0, w.h)(x.default, a({}, this.props.templateProps, {
                            templateKey: "searchableNoResults",
                            rootProps: {
                                className: this.props.cssClasses.noResults
                            }
                        })),
                        c = (0, S.cx)(this.props.cssClasses.root, (!this.props.facetValues || 0 === this.props.facetValues.length) && this.props.cssClasses.noRefinementRoot, this.props.className);
                    return (0, w.h)("div", {
                        className: c
                    }, this.props.children, i, o, u, r)
                }
            }]), t
        }(w.Component);
    g(A, "defaultProps", M);
    var N = A;
    t.default = N
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
    }

    function o(e, t) {
        for (var r = 0; r < t.length; r++) {
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, m(n.key), n)
        }
    }

    function a(e, t, r) {
        return t && o(e.prototype, t), r && o(e, r), Object.defineProperty(e, "prototype", {
            writable: !1
        }), e
    }

    function u(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
            constructor: {
                value: e,
                writable: !0,
                configurable: !0
            }
        }), Object.defineProperty(e, "prototype", {
            writable: !1
        }), t && c(e, t)
    }

    function c(e, t) {
        return (c = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
            return e.__proto__ = t, e
        })(e, t)
    }

    function s(e) {
        var t = p();
        return function() {
            var r, n = d(e);
            if (t) {
                var i = d(this).constructor;
                r = Reflect.construct(n, arguments, i)
            } else r = n.apply(this, arguments);
            return l(this, r)
        }
    }

    function l(e, t) {
        if (t && ("object" === n(t) || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return f(e)
    }

    function f(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e
    }

    function p() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0
        } catch (e) {
            return !1
        }
    }

    function d(e) {
        return (d = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e)
        })(e)
    }

    function h(e, t, r) {
        return t = m(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function m(e) {
        var t = y(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function y(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }
    var b = r(1);
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var v = r(2),
        g = r(0),
        _ = b(r(7)),
        O = {
            query: "",
            showSubmit: !0,
            showReset: !0,
            showLoadingIndicator: !0,
            autofocus: !1,
            searchAsYouType: !0,
            isSearchStalled: !1,
            disabled: !1,
            onChange: g.noop,
            onSubmit: g.noop,
            onReset: g.noop,
            refine: g.noop
        },
        j = function(e) {
            function t() {
                var e;
                i(this, t);
                for (var n = arguments.length, o = new Array(n), a = 0; a < n; a++) o[a] = arguments[a];
                return e = r.call.apply(r, [this].concat(o)), h(f(e), "state", {
                    query: e.props.query,
                    focused: !1
                }), h(f(e), "input", (0, v.createRef)()), h(f(e), "onInput", function(t) {
                    var r = e.props,
                        n = r.searchAsYouType,
                        i = r.refine,
                        o = r.onChange,
                        a = t.target.value;
                    n && i(a), e.setState({
                        query: a
                    }), o(t)
                }), h(f(e), "onSubmit", function(t) {
                    var r = e.props,
                        n = r.searchAsYouType,
                        i = r.refine,
                        o = r.onSubmit;
                    return t.preventDefault(), t.stopPropagation(), e.input.current && e.input.current.blur(), n || i(e.state.query), o(t), !1
                }), h(f(e), "onReset", function(t) {
                    var r = e.props,
                        n = r.refine,
                        i = r.onReset;
                    e.input.current && e.input.current.focus(), n(""), e.setState({
                        query: ""
                    }), i(t)
                }), h(f(e), "onBlur", function() {
                    e.setState({
                        focused: !1
                    })
                }), h(f(e), "onFocus", function() {
                    e.setState({
                        focused: !0
                    })
                }), e
            }
            u(t, e);
            var r = s(t);
            return a(t, [{
                key: "resetInput",
                value: function() {
                    this.setState({
                        query: ""
                    })
                }
            }, {
                key: "componentWillReceiveProps",
                value: function(e) {
                    this.state.focused || e.query === this.state.query || this.setState({
                        query: e.query
                    })
                }
            }, {
                key: "render",
                value: function() {
                    var e = this.props,
                        t = e.cssClasses,
                        r = e.placeholder,
                        n = e.autofocus,
                        i = e.showSubmit,
                        o = e.showReset,
                        a = e.showLoadingIndicator,
                        u = e.templates,
                        c = e.isSearchStalled;
                    return (0, v.h)("div", {
                        className: t.root
                    }, (0, v.h)("form", {
                        action: "",
                        role: "search",
                        className: t.form,
                        noValidate: !0,
                        onSubmit: this.onSubmit,
                        onReset: this.onReset
                    }, (0, v.h)("input", {
                        ref: this.input,
                        value: this.state.query,
                        disabled: this.props.disabled,
                        className: t.input,
                        type: "search",
                        placeholder: r,
                        autoFocus: n,
                        autoComplete: "off",
                        autoCorrect: "off",
                        autoCapitalize: "off",
                        spellCheck: "false",
                        maxLength: 512,
                        onInput: this.onInput,
                        onBlur: this.onBlur,
                        onFocus: this.onFocus
                    }), (0, v.h)(_.default, {
                        templateKey: "submit",
                        rootTagName: "button",
                        rootProps: {
                            className: t.submit,
                            type: "submit",
                            title: "Submit the search query.",
                            hidden: !i
                        },
                        templates: u,
                        data: {
                            cssClasses: t
                        }
                    }), (0, v.h)(_.default, {
                        templateKey: "reset",
                        rootTagName: "button",
                        rootProps: {
                            className: t.reset,
                            type: "reset",
                            title: "Clear the search query.",
                            hidden: !(o && this.state.query.trim() && !c)
                        },
                        templates: u,
                        data: {
                            cssClasses: t
                        }
                    }), a && (0, v.h)(_.default, {
                        templateKey: "loadingIndicator",
                        rootTagName: "span",
                        rootProps: {
                            className: t.loadingIndicator,
                            hidden: !c
                        },
                        templates: u,
                        data: {
                            cssClasses: t
                        }
                    })))
                }
            }]), t
        }(v.Component);
    h(j, "defaultProps", O);
    var P = j;
    t.default = P
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var n = r(2),
        i = (0, n.h)("path", {
            d: "M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z"
        }),
        o = (0, n.h)("path", {
            d: "M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z"
        }),
        a = (0, n.h)("g", {
            fill: "none",
            fillRule: "evenodd"
        }, (0, n.h)("g", {
            transform: "translate(1 1)",
            strokeWidth: "2"
        }, (0, n.h)("circle", {
            strokeOpacity: ".5",
            cx: "18",
            cy: "18",
            r: "18"
        }), (0, n.h)("path", {
            d: "M36 18c0-9.94-8.06-18-18-18"
        }, (0, n.h)("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 18 18",
            to: "360 18 18",
            dur: "1s",
            repeatCount: "indefinite"
        })))),
        u = {
            reset: function(e) {
                var t = e.cssClasses;
                return (0, n.h)("svg", {
                    className: t.resetIcon,
                    viewBox: "0 0 20 20",
                    width: "10",
                    height: "10",
                    "aria-hidden": "true"
                }, i)
            },
            submit: function(e) {
                var t = e.cssClasses;
                return (0, n.h)("svg", {
                    className: t.submitIcon,
                    width: "10",
                    height: "10",
                    viewBox: "0 0 40 40",
                    "aria-hidden": "true"
                }, o)
            },
            loadingIndicator: function(e) {
                var t = e.cssClasses;
                return (0, n.h)("svg", {
                    className: t.loadingIcon,
                    width: "16",
                    height: "16",
                    viewBox: "0 0 38 38",
                    stroke: "#444",
                    "aria-hidden": "true"
                }, a)
            }
        },
        c = u;
    t.default = c
}, function(e, t, r) {
    "use strict";

    function n(e, t, r) {
        for (var n = e; n && !r(n);) {
            if (n === t) return null;
            n = n.parentElement
        }
        return n
    }

    function i(e) {
        var t = e.getAttribute("data-insights-event");
        if ("string" != typeof t) throw new Error("The insights middleware expects `data-insights-event` to be a base64-encoded JSON string.");
        try {
            return (0, c.deserializePayload)(t)
        } catch (e) {
            throw new Error("The insights middleware was unable to parse `data-insights-event`.")
        }
    }

    function o(e) {
        return function(t) {
            var r = s(t);
            return (0, a.h)("div", {
                onClick: r
            }, (0, a.h)(e, t))
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.createInsightsEventHandler = void 0, t.default = o;
    var a = r(2),
        u = r(43),
        c = r(0),
        s = function(e) {
            var t = e.insights,
                r = e.sendEvent;
            return function(e) {
                var o = n(e.target, e.currentTarget, function(e) {
                    return e.hasAttribute("data-insights-event")
                });
                o && i(o).forEach(function(e) {
                    return r(e)
                });
                var a = n(e.target, e.currentTarget, function(e) {
                    return e.hasAttribute("data-insights-method") && e.hasAttribute("data-insights-payload")
                });
                if (a) {
                    var c = (0, u.readDataAttributes)(a),
                        s = c.method,
                        l = c.payload;
                    t(s, l)
                }
            }
        };
    t.createInsightsEventHandler = s
}, function(e, t, r) {
    "use strict";
    var n = r(1);
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), Object.defineProperty(t, "algoliasearch", {
        enumerable: !0,
        get: function() {
            return o.default
        }
    }), Object.defineProperty(t, "autocomplete", {
        enumerable: !0,
        get: function() {
            return a.autocomplete
        }
    }), t.connectors = void 0, Object.defineProperty(t, "createQuerySuggestionsPlugin", {
        enumerable: !0,
        get: function() {
            return u.createQuerySuggestionsPlugin
        }
    }), Object.defineProperty(t, "getAlgoliaResults", {
        enumerable: !0,
        get: function() {
            return a.getAlgoliaResults
        }
    }), Object.defineProperty(t, "html", {
        enumerable: !0,
        get: function() {
            return s.html
        }
    }), Object.defineProperty(t, "instantsearch", {
        enumerable: !0,
        get: function() {
            return i.default
        }
    }), Object.defineProperty(t, "render", {
        enumerable: !0,
        get: function() {
            return c.render
        }
    }), t.widgets = void 0;
    var i = n(r(76)),
        o = n(r(153)),
        a = r(52),
        u = r(273),
        c = r(69),
        s = r(70),
        l = n(r(275)),
        f = n(r(282)),
        p = n(r(305)),
        d = n(r(308)),
        h = n(r(310)),
        m = n(r(313)),
        y = n(r(316)),
        b = n(r(320)),
        v = n(r(323)),
        g = n(r(329)),
        _ = n(r(333)),
        O = n(r(335)),
        j = {
            rangeSlider: l.default,
            menu: f.default,
            refinementList: p.default,
            searchBox: d.default,
            stats: h.default,
            sortBy: m.default,
            clearRefinements: y.default,
            panel: b.default,
            hits: v.default,
            pagination: g.default,
            configure: _.default
        };
    t.widgets = j;
    var P = {
        connectCurrentRefinements: O.default
    };
    t.connectors = P
}, function(e, t, r) {
    "use strict";
    var n = r(1);
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var i = {};
    t.default = void 0;
    var o = r(16),
        a = r(114),
        u = n(r(116)),
        c = r(0),
        s = n(r(51)),
        l = r(137);
    Object.keys(l).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (Object.prototype.hasOwnProperty.call(i, e) || e in t && t[e] === l[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return l[e]
            }
        }))
    });
    var f = function(e) {
        return new u.default(e)
    };
    f.version = s.default, f.createInfiniteHitsSessionStorageCache = (0, c.deprecate)(a.createInfiniteHitsSessionStorageCache, "import { createInfiniteHitsSessionStorageCache } from 'instantsearch.js/es/lib/infiniteHitsCache'"), f.highlight = (0, c.deprecate)(o.highlight, "import { highlight } from 'instantsearch.js/es/helpers'"), f.reverseHighlight = (0, c.deprecate)(o.reverseHighlight, "import { reverseHighlight } from 'instantsearch.js/es/helpers'"), f.snippet = (0, c.deprecate)(o.snippet, "import { snippet } from 'instantsearch.js/es/helpers'"), f.reverseSnippet = (0, c.deprecate)(o.reverseSnippet, "import { reverseSnippet } from 'instantsearch.js/es/helpers'"), f.insights = o.insights, f.getInsightsAnonymousUserToken = o.getInsightsAnonymousUserToken, Object.defineProperty(f, "widgets", {
        get: function() {
            throw new ReferenceError("\"instantsearch.widgets\" are not available from the ES build.\n\nTo import the widgets:\n\nimport { searchBox } from 'instantsearch.js/es/widgets'")
        }
    }), Object.defineProperty(f, "connectors", {
        get: function() {
            throw new ReferenceError("\"instantsearch.connectors\" are not available from the ES build.\n\nTo import the connectors:\n\nimport { connectSearchBox } from 'instantsearch.js/es/connectors'")
        }
    });
    var p = f;
    t.default = p
}, function(e, t, r) {
    "use strict";

    function n(e) {
        var t = e.attribute,
            r = e.highlightedTagName,
            n = void 0 === r ? "mark" : r,
            i = e.hit,
            u = e.cssClasses,
            c = void 0 === u ? {} : u,
            s = (0, o.getPropertyByPath)(i._highlightResult, t),
            l = s || {},
            f = l.value,
            p = void 0 === f ? "" : f,
            d = a({
                descendantName: "highlighted"
            }) + (c.highlighted ? " ".concat(c.highlighted) : "");
        return p.replace(new RegExp(o.TAG_REPLACEMENT.highlightPreTag, "g"), "<".concat(n, ' class="').concat(d, '">')).replace(new RegExp(o.TAG_REPLACEMENT.highlightPostTag, "g"), "</".concat(n, ">"))
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = n;
    var i = r(5),
        o = r(0),
        a = (0, i.component)("Highlight")
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.keys = void 0;
    var n = Object.keys;
    t.keys = n
}, function(e, t, r) {
    "use strict";

    function n(e, t) {
        if (void 0 === e || "function" != typeof e) throw new Error("The render function is not valid (received type ".concat((0, i.getObjectType)(e), ").\n\n").concat(t))
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.checkRendering = n;
    var i = r(34)
}, function(e, t, r) {
    "use strict";

    function n(e) {
        var t = e.helper,
            r = e.attributesToClear,
            n = void 0 === r ? [] : r,
            i = t.state.setPage(0);
        return i = n.reduce(function(e, t) {
            return i.isNumericRefined(t) ? e.removeNumericRefinement(t) : i.isHierarchicalFacet(t) ? e.removeHierarchicalFacetRefinement(t) : i.isDisjunctiveFacet(t) ? e.removeDisjunctiveFacetRefinement(t) : i.isConjunctiveFacet(t) ? e.removeFacetRefinement(t) : e
        }, i), -1 !== n.indexOf("query") && (i = i.setQuery("")), i
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.clearRefinements = n
}, function(e, t, r) {
    "use strict";

    function n(e) {
        var t = i.TAG_REPLACEMENT.highlightPreTag,
            r = i.TAG_REPLACEMENT.highlightPostTag;
        return e.map(function(e) {
            return e.isHighlighted ? t + e.value + r : e.value
        }).join("")
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.concatHighlightedParts = n;
    var i = r(17)
}, function(e, t, r) {
    "use strict";

    function n() {
        var e = -1,
            t = -1,
            r = void 0;
        return function(n) {
            var i = ++e;
            return Promise.resolve(n).then(function(e) {
                return r && i < t ? r : (t = i, r = e, e)
            })
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.createConcurrentSafePromise = n
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        return s(e) || c(e, t) || a(e, t) || o()
    }

    function o() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
    }

    function a(e, t) {
        if (e) {
            if ("string" == typeof e) return u(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? u(e, t) : void 0
        }
    }

    function u(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
        return n
    }

    function c(e, t) {
        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (null != r) {
            var n, i, o, a, u = [],
                c = !0,
                s = !1;
            try {
                if (o = (r = r.call(e)).next, 0 === t) {
                    if (Object(r) !== r) return;
                    c = !1
                } else
                    for (; !(c = (n = o.call(r)).done) && (u.push(n.value), u.length !== t); c = !0);
            } catch (e) {
                s = !0, i = e
            } finally {
                try {
                    if (!c && null != r.return && (a = r.return(), Object(a) !== a)) return
                } finally {
                    if (s) throw i
                }
            }
            return u
        }
    }

    function s(e) {
        if (Array.isArray(e)) return e
    }

    function l(e) {
        var t = e.instantSearchInstance,
            r = e.helper,
            o = e.attribute,
            a = e.widgetType;
        return function() {
            for (var e = arguments.length, u = new Array(e), c = 0; c < e; c++) u[c] = arguments[c];
            var s = u[1],
                l = u[2],
                p = void 0 === l ? "Filter Applied" : l,
                d = u[0].split(":"),
                h = i(d, 2),
                m = h[0],
                y = h[1],
                b = "string" == typeof o ? o : o(s);
            1 === u.length && "object" === n(u[0]) ? t.sendEventToInsights(u[0]) : "click" !== m || 2 !== u.length && 3 !== u.length || (0, f.isFacetRefined)(r, b, s) || t.sendEventToInsights({
                insightsMethod: "clickedFilters",
                widgetType: a,
                eventType: m,
                eventModifier: y,
                payload: {
                    eventName: p,
                    index: r.getIndex(),
                    filters: ["".concat(b, ":").concat(s)]
                },
                attribute: b
            })
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.createSendEventForFacet = l;
    var f = r(36)
}, function(e, t, r) {
    "use strict";

    function n(e, t) {
        return c(e) || u(e, t) || o(e, t) || i()
    }

    function i() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
    }

    function o(e, t) {
        if (e) {
            if ("string" == typeof e) return a(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? a(e, t) : void 0
        }
    }

    function a(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
        return n
    }

    function u(e, t) {
        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (null != r) {
            var n, i, o, a, u = [],
                c = !0,
                s = !1;
            try {
                if (o = (r = r.call(e)).next, 0 === t) {
                    if (Object(r) !== r) return;
                    c = !1
                } else
                    for (; !(c = (n = o.call(r)).done) && (u.push(n.value), u.length !== t); c = !0);
            } catch (e) {
                s = !0, i = e
            } finally {
                try {
                    if (!c && null != r.return && (a = r.return(), Object(a) !== a)) return
                } finally {
                    if (s) throw i
                }
            }
            return u
        }
    }

    function c(e) {
        if (Array.isArray(e)) return e
    }

    function s(e) {
        "@babel/helpers - typeof";
        return (s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function l(e) {
        for (var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 20, r = [], n = 0; n < Math.ceil(e.length / t); n++) r.push(e.slice(n * t, (n + 1) * t));
        return r
    }

    function f(e) {
        var t = e.index,
            r = e.widgetType,
            i = (e.methodName, e.args),
            o = e.instantSearchInstance;
        if (1 === i.length && "object" === s(i[0])) return [i[0]];
        var a = i[0].split(":"),
            u = n(a, 2),
            c = u[0],
            f = u[1],
            p = i[1],
            d = i[2];
        if (!p) return [];
        if (("click" === c || "conversion" === c) && !d) return [];
        var h = Array.isArray(p) ? p : [p];
        if (0 === h.length) return [];
        var m = h[0].__queryID,
            y = l(h),
            b = y.map(function(e) {
                return e.map(function(e) {
                    return e.objectID
                })
            }),
            v = y.map(function(e) {
                return e.map(function(e) {
                    return e.__position
                })
            });
        return "view" === c ? "idle" !== o.status ? [] : y.map(function(e, n) {
            return {
                insightsMethod: "viewedObjectIDs",
                widgetType: r,
                eventType: c,
                payload: {
                    eventName: d || "Hits Viewed",
                    index: t,
                    objectIDs: b[n]
                },
                hits: e,
                eventModifier: f
            }
        }) : "click" === c ? y.map(function(e, n) {
            return {
                insightsMethod: "clickedObjectIDsAfterSearch",
                widgetType: r,
                eventType: c,
                payload: {
                    eventName: d || "Hit Clicked",
                    index: t,
                    queryID: m,
                    objectIDs: b[n],
                    positions: v[n]
                },
                hits: e,
                eventModifier: f
            }
        }) : "conversion" === c ? y.map(function(e, n) {
            return {
                insightsMethod: "convertedObjectIDsAfterSearch",
                widgetType: r,
                eventType: c,
                payload: {
                    eventName: d || "Hit Converted",
                    index: t,
                    queryID: m,
                    objectIDs: b[n]
                },
                hits: e,
                eventModifier: f
            }
        }) : []
    }

    function p(e) {
        var t = e.instantSearchInstance,
            r = e.index,
            n = e.widgetType,
            i = {},
            o = void 0;
        return function() {
            for (var e = arguments.length, a = new Array(e), u = 0; u < e; u++) a[u] = arguments[u];
            f({
                widgetType: n,
                index: r,
                methodName: "sendEvent",
                args: a,
                instantSearchInstance: t
            }).forEach(function(e) {
                "click" === e.eventType && "internal" === e.eventModifier && i[e.eventType] || (i[e.eventType] = !0, t.sendEventToInsights(e))
            }), clearTimeout(o), o = setTimeout(function() {
                i = {}
            }, 0)
        }
    }

    function d(e) {
        var t = e.index,
            r = e.widgetType,
            n = e.instantSearchInstance;
        return function() {
            for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++) i[o] = arguments[o];
            var a = f({
                widgetType: r,
                index: t,
                methodName: "bindEvent",
                args: i,
                instantSearchInstance: n
            });
            return a.length ? "data-insights-event=".concat((0, h.serializePayload)(a)) : ""
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t._buildEventPayloadsForHits = f, t.createBindEventForHits = d, t.createSendEventForHits = p;
    var h = r(37)
}, function(e, t, r) {
    "use strict";

    function n(e, t) {
        var r = e[t.getIndexId()] || {};
        t.getHelper().setState(t.getWidgetSearchParameters(t.getHelper().state, {
            uiState: r
        })), t.getWidgets().filter(i.isIndexWidget).forEach(function(t) {
            return n(e, t)
        })
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.setIndexHelperState = n;
    var i = (r(31), r(19))
}, function(e, t, r) {
    "use strict";

    function n(e, t) {
        var r = null;
        return function() {
            for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++) i[o] = arguments[o];
            return new Promise(function(n, o) {
                r && clearTimeout(r), r = setTimeout(function() {
                    r = null, Promise.resolve(e.apply(void 0, i)).then(n).catch(o)
                }, t)
            })
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.debounce = n
}, function(e, t, r) {
    "use strict";

    function n(e) {
        var t = null,
            r = !1,
            n = function() {
                for (var n = arguments.length, o = new Array(n), a = 0; a < n; a++) o[a] = arguments[a];
                null === t && (t = i.then(function() {
                    if (t = null, r) return void(r = !1);
                    e.apply(void 0, o)
                }))
            };
        return n.wait = function() {
            if (null === t) throw new Error("The deferred function should be called before calling `wait()`");
            return t
        }, n.cancel = function() {
            null !== t && (r = !0)
        }, n
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.defer = n;
    var i = Promise.resolve()
}, function(e, t, r) {
    "use strict";

    function n(e) {
        var t = e.name,
            r = e.connector;
        return ["https://www.algolia.com/doc/api-reference/widgets/", t, "/js/", void 0 !== r && r ? "#connector" : ""].join("")
    }

    function i() {
        for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
        var i = t.map(function(e) {
            return n(e)
        }).join(", ");
        return function(e) {
            return [e, "See documentation: ".concat(i)].filter(Boolean).join("\n\n")
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.createDocumentationLink = n, t.createDocumentationMessageGenerator = i
}, function(e, t, r) {
    "use strict";

    function n(e, t) {
        return c(e) || u(e, t) || o(e, t) || i()
    }

    function i() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
    }

    function o(e, t) {
        if (e) {
            if ("string" == typeof e) return a(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? a(e, t) : void 0
        }
    }

    function a(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
        return n
    }

    function u(e, t) {
        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (null != r) {
            var n, i, o, a, u = [],
                c = !0,
                s = !1;
            try {
                if (o = (r = r.call(e)).next, 0 === t) {
                    if (Object(r) !== r) return;
                    c = !1
                } else
                    for (; !(c = (n = o.call(r)).done) && (u.push(n.value), u.length !== t); c = !0);
            } catch (e) {
                s = !0, i = e
            } finally {
                try {
                    if (!c && null != r.return && (a = r.return(), Object(a) !== a)) return
                } finally {
                    if (s) throw i
                }
            }
            return u
        }
    }

    function c(e) {
        if (Array.isArray(e)) return e
    }

    function s(e) {
        var t = e.match(d);
        if (!t) throw new Error('Invalid value for "aroundLatLng" parameter: "'.concat(e, '"'));
        return {
            lat: parseFloat(t[1]),
            lng: parseFloat(t[2])
        }
    }

    function l(e) {
        var t = n(e, 1),
            r = t[0],
            i = void 0 === r ? [void 0, void 0, void 0, void 0] : r,
            o = n(i, 4),
            a = o[0],
            u = o[1],
            c = o[2],
            s = o[3];
        if (!(a && u && c && s)) throw new Error('Invalid value for "insideBoundingBox" parameter: ['.concat(e, "]"));
        return {
            northEast: {
                lat: a,
                lng: u
            },
            southWest: {
                lat: c,
                lng: s
            }
        }
    }

    function f(e) {
        var t = e.split(",").map(parseFloat),
            r = n(t, 4),
            i = r[0],
            o = r[1],
            a = r[2],
            u = r[3];
        if (!(i && o && a && u)) throw new Error('Invalid value for "insideBoundingBox" parameter: "'.concat(e, '"'));
        return {
            northEast: {
                lat: i,
                lng: o
            },
            southWest: {
                lat: a,
                lng: u
            }
        }
    }

    function p(e) {
        return Array.isArray(e) ? l(e) : f(e)
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.aroundLatLngToPosition = s, t.insideBoundingBoxToBoundingBox = p;
    var d = /^(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)$/
}, function(e, t, r) {
    "use strict";

    function n(e) {
        if (e.transporter) {
            var t = e.transporter,
                r = t.headers,
                n = t.queryParameters,
                i = "x-algolia-application-id";
            return [r[i] || n[i], r["x-algolia-api-key"] || n["x-algolia-api-key"]]
        }
        return [e.applicationID, e.apiKey]
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.getAppIdAndApiKey = n
}, function(e, t, r) {
    "use strict";

    function n(e) {
        var t = "string" == typeof e,
            r = t ? document.querySelector(e) : e;
        if (!(0, i.isDomElement)(r)) {
            var n = "Container must be `string` or `HTMLElement`.";
            throw t && (n += " Unable to find ".concat(e)), new Error(n)
        }
        return r
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.getContainerNode = n;
    var i = r(41)
}, function(e, t, r) {
    "use strict";

    function n(e) {
        var t = i.TAG_REPLACEMENT.highlightPostTag,
            r = i.TAG_REPLACEMENT.highlightPreTag,
            n = e.split(r),
            o = n.shift(),
            a = o ? [{
                value: o,
                isHighlighted: !1
            }] : [];
        return n.forEach(function(e) {
            var r = e.split(t);
            a.push({
                value: r[0],
                isHighlighted: !0
            }), "" !== r[1] && a.push({
                value: r[1],
                isHighlighted: !1
            })
        }), a
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.getHighlightedParts = n;
    var i = r(17)
}, function(e, t, r) {
    "use strict";

    function n(e, t) {
        return (Array.isArray(t) ? t : t.split(".")).reduce(function(e, t) {
            return e && e[t]
        }, e)
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.getPropertyByPath = n
}, function(e, t, r) {
    "use strict";

    function n(e, t, r, n) {
        var i, u = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : [],
            c = {
                type: t,
                attribute: r,
                name: n,
                escapedValue: (0, o.escapeFacetValue)(n)
            },
            s = (0, a.find)(u, function(e) {
                return e.name === r
            });
        if ("hierarchical" === t) {
            for (var l = e.getHierarchicalFacetByName(r), f = n.split(l.separator), p = function(e) {
                    return function(t) {
                        return e[t]
                    }
                }, d = 0; void 0 !== s && d < f.length; ++d) ! function(e) {
                s = s && s.data && (0, a.find)(Object.keys(s.data).map(p(s.data)), function(t) {
                    return t.name === f[e]
                })
            }(d);
            i = s && s.count
        } else i = s && s.data && s.data[c.name];
        return void 0 !== i && (c.count = i), s && void 0 !== s.exhaustive && (c.exhaustive = s.exhaustive), c
    }

    function i(e, t) {
        var r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
            i = [],
            a = t.facetsRefinements,
            u = void 0 === a ? {} : a,
            c = t.facetsExcludes,
            s = void 0 === c ? {} : c,
            l = t.disjunctiveFacetsRefinements,
            f = void 0 === l ? {} : l,
            p = t.hierarchicalFacetsRefinements,
            d = void 0 === p ? {} : p,
            h = t.numericRefinements,
            m = void 0 === h ? {} : h,
            y = t.tagRefinements,
            b = void 0 === y ? [] : y;
        return Object.keys(u).forEach(function(r) {
            u[r].forEach(function(o) {
                i.push(n(t, "facet", r, o, e.facets))
            })
        }), Object.keys(s).forEach(function(e) {
            s[e].forEach(function(t) {
                i.push({
                    type: "exclude",
                    attribute: e,
                    name: t,
                    exclude: !0
                })
            })
        }), Object.keys(f).forEach(function(r) {
            f[r].forEach(function(a) {
                i.push(n(t, "disjunctive", r, (0, o.unescapeFacetValue)(a), e.disjunctiveFacets))
            })
        }), Object.keys(d).forEach(function(r) {
            d[r].forEach(function(o) {
                i.push(n(t, "hierarchical", r, o, e.hierarchicalFacets))
            })
        }), Object.keys(m).forEach(function(e) {
            var t = m[e];
            Object.keys(t).forEach(function(r) {
                var n = r,
                    o = t[n];
                (Array.isArray(o) ? o : [o]).forEach(function(t) {
                    i.push({
                        type: "numeric",
                        attribute: e,
                        name: "".concat(t),
                        numericValue: t,
                        operator: n
                    })
                })
            })
        }), b.forEach(function(e) {
            i.push({
                type: "tag",
                attribute: "_tags",
                name: e
            })
        }), r && t.query && t.query.trim() && i.push({
            attribute: "query",
            type: "query",
            name: t.query,
            query: t.query
        }), i
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.getRefinements = i;
    var o = r(38),
        a = r(39)
}, function(e, t, r) {
    "use strict";

    function n(e, t) {
        var r, n = null === (r = e.getWidgetRenderState) || void 0 === r ? void 0 : r.call(e, t),
            i = null;
        if (n && n.widgetParams) {
            var o = n.widgetParams;
            o.attribute ? i = o.attribute : Array.isArray(o.attributes) && (i = o.attributes[0])
        }
        if ("string" != typeof i) throw new Error("Could not find the attribute of the widget:\n\n".concat(JSON.stringify(e), "\n\nPlease check whether the widget's getWidgetRenderState returns widgetParams.attribute correctly."));
        return i
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.getWidgetAttribute = n
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function s(e, t, r) {
        return e.map(function(e, n) {
            return o(o({}, e), {}, {
                __position: r * t + n + 1
            })
        })
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.addAbsolutePosition = s
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function s(e, t) {
        return t ? e.map(function(e) {
            return o(o({}, e), {}, {
                __queryID: t
            })
        }) : e
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.addQueryID = s
}, function(e, t, r) {
    "use strict";

    function n(e) {
        return e !== Object(e)
    }

    function i(e, t) {
        if (e === t) return !0;
        if (n(e) || n(t) || "function" == typeof e || "function" == typeof t) return e === t;
        if (Object.keys(e).length !== Object.keys(t).length) return !1;
        for (var r = 0, o = Object.keys(e); r < o.length; r++) {
            var a = o[r];
            if (!(a in t)) return !1;
            if (!i(e[a], t[a])) return !1
        }
        return !0
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.isEqual = i
}, function(e, t, r) {
    "use strict";

    function n(e) {
        return "number" == typeof e && isFinite(e)
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.isFiniteNumber = n
}, function(e, t, r) {
    "use strict";

    function n(e) {
        return 1 === e.button || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.isSpecialClick = n
}, function(e, t, r) {
    "use strict";

    function n(e, t) {
        t(e), e.getWidgets().forEach(function(e) {
            (0, i.isIndexWidget)(e) && n(e, t)
        })
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.walkIndex = n;
    var i = r(19)
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function s(e, t) {
        if (null == e) return {};
        var r, n, i = l(e, t);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
        }
        return i
    }

    function l(e, t) {
        if (null == e) return {};
        var r, n, i = {},
            o = Object.keys(e);
        for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || (i[r] = e[r]);
        return i
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.mergeSearchParameters = void 0;
    var f = r(40),
        p = r(20),
        d = ["facets", "disjunctiveFacets", "facetsRefinements", "facetsExcludes", "disjunctiveFacetsRefinements", "numericRefinements", "tagRefinements", "hierarchicalFacets", "hierarchicalFacetsRefinements", "ruleContexts"],
        h = function(e, t) {
            var r = (t.facets, t.disjunctiveFacets, t.facetsRefinements, t.facetsExcludes, t.disjunctiveFacetsRefinements, t.numericRefinements, t.tagRefinements, t.hierarchicalFacets, t.hierarchicalFacetsRefinements, t.ruleContexts, s(t, d));
            return e.setQueryParameters(r)
        },
        m = function(e, t) {
            return t.facets.reduce(function(e, t) {
                return e.addFacet(t)
            }, e)
        },
        y = function(e, t) {
            return t.disjunctiveFacets.reduce(function(e, t) {
                return e.addDisjunctiveFacet(t)
            }, e)
        },
        b = function(e, t) {
            return e.setQueryParameters({
                hierarchicalFacets: t.hierarchicalFacets.reduce(function(e, t) {
                    var r = (0, f.findIndex)(e, function(e) {
                        return e.name === t.name
                    });
                    if (-1 === r) return e.concat(t);
                    var n = e.slice();
                    return n.splice(r, 1, t), n
                }, e.hierarchicalFacets)
            })
        },
        v = function(e, t) {
            return t.tagRefinements.reduce(function(e, t) {
                return e.addTagRefinement(t)
            }, e)
        },
        g = function(e, t) {
            return e.setQueryParameters({
                facetsRefinements: o(o({}, e.facetsRefinements), t.facetsRefinements)
            })
        },
        _ = function(e, t) {
            return e.setQueryParameters({
                facetsExcludes: o(o({}, e.facetsExcludes), t.facetsExcludes)
            })
        },
        O = function(e, t) {
            return e.setQueryParameters({
                disjunctiveFacetsRefinements: o(o({}, e.disjunctiveFacetsRefinements), t.disjunctiveFacetsRefinements)
            })
        },
        j = function(e, t) {
            return e.setQueryParameters({
                numericRefinements: o(o({}, e.numericRefinements), t.numericRefinements)
            })
        },
        P = function(e, t) {
            return e.setQueryParameters({
                hierarchicalFacetsRefinements: o(o({}, e.hierarchicalFacetsRefinements), t.hierarchicalFacetsRefinements)
            })
        },
        S = function(e, t) {
            var r = (0, p.uniq)([].concat(e.ruleContexts).concat(t.ruleContexts).filter(Boolean));
            return r.length > 0 ? e.setQueryParameters({
                ruleContexts: r
            }) : e
        },
        w = function() {
            for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
            return t.reduce(function(e, t) {
                var r = P(e, t),
                    n = b(r, t),
                    i = v(n, t),
                    o = j(i, t),
                    a = O(o, t),
                    u = _(a, t),
                    c = g(u, t),
                    s = y(c, t),
                    l = S(s, t),
                    f = m(l, t);
                return h(f, t)
            })
        };
    t.mergeSearchParameters = w
}, function(e, t, r) {
    "use strict";

    function n(e, t) {
        return null === e || void 0 === e ? e : Object.keys(e).reduce(function(r, n) {
            if (t.indexOf(n) >= 0) return r;
            var i = n;
            return r[i] = e[i], r
        }, {})
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.omit = n
}, function(e, t, r) {
    "use strict";

    function n(e) {
        return u(e) || a(e) || o(e) || i()
    }

    function i() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
    }

    function o(e, t) {
        if (e) {
            if ("string" == typeof e) return c(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? c(e, t) : void 0
        }
    }

    function a(e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e)
    }

    function u(e) {
        if (Array.isArray(e)) return c(e)
    }

    function c(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
        return n
    }

    function s(e) {
        var t = e.start,
            r = void 0 === t ? 0 : t,
            i = e.end,
            o = e.step,
            a = void 0 === o ? 1 : o,
            u = 0 === a ? 1 : a,
            c = Math.round((i - r) / u);
        return n(Array(c)).map(function(e, t) {
            return r + t * u
        })
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.range = s
}, function(e, t, r) {
    "use strict";

    function n(e, t, r) {
        var n = t.getHelper();
        return {
            uiState: r,
            helper: n,
            parent: t,
            instantSearchInstance: e,
            state: n.state,
            renderState: e.renderState,
            templatesConfig: e.templatesConfig,
            createURL: t.createURL,
            scopedResults: [],
            searchMetadata: {
                isSearchStalled: "stalled" === e.status
            },
            status: e.status,
            error: e.error
        }
    }

    function i(e, t) {
        var r = t.getResults(),
            n = t.getHelper();
        return {
            helper: n,
            parent: t,
            instantSearchInstance: e,
            results: r,
            scopedResults: t.getScopedResults(),
            state: r ? r._state : n.state,
            renderState: e.renderState,
            templatesConfig: e.templatesConfig,
            createURL: t.createURL,
            searchMetadata: {
                isSearchStalled: "stalled" === e.status
            },
            status: e.status,
            error: e.error
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.createInitArgs = n, t.createRenderArgs = i
}, function(e, t, r) {
    "use strict";

    function n(e) {
        for (var t = e.getParent(), r = [e.getHelper().state]; null !== t;) r = [t.getHelper().state].concat(r), t = t.getParent();
        return r
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.resolveSearchParameters = n
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function s(e) {
        return e.some(function(e) {
            return e.isHighlighted
        }) ? e.map(function(t, r) {
            return o(o({}, t), {}, {
                isHighlighted: !(0, l.getHighlightFromSiblings)(e, r)
            })
        }) : e.map(function(e) {
            return o(o({}, e), {}, {
                isHighlighted: !1
            })
        })
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.reverseHighlightedParts = s;
    var l = r(42)
}, function(e, t, r) {
    "use strict";

    function n(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
                fallback: function() {}
            },
            r = t.fallback;
        return "undefined" == typeof window ? r() : e({
            window: window
        })
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.safelyRunOnBrowser = n
}, function(e, t, r) {
    "use strict";

    function n(e) {
        return Array.isArray(e) ? e : [e]
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.toArray = n
}, function(e, t, r) {
    "use strict";

    function n(e) {
        var t = e.attribute,
            r = e.highlightedTagName,
            n = void 0 === r ? "mark" : r,
            i = e.hit,
            u = e.cssClasses,
            c = void 0 === u ? {} : u,
            s = (0, o.getPropertyByPath)(i._highlightResult, t),
            l = s || {},
            f = l.value,
            p = void 0 === f ? "" : f,
            d = a({
                descendantName: "highlighted"
            }) + (c.highlighted ? " ".concat(c.highlighted) : "");
        return (0, o.concatHighlightedParts)((0, o.reverseHighlightedParts)((0, o.getHighlightedParts)(p))).replace(new RegExp(o.TAG_REPLACEMENT.highlightPreTag, "g"), "<".concat(n, ' class="').concat(d, '">')).replace(new RegExp(o.TAG_REPLACEMENT.highlightPostTag, "g"), "</".concat(n, ">"))
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = n;
    var i = r(5),
        o = r(0),
        a = (0, i.component)("ReverseHighlight")
}, function(e, t, r) {
    "use strict";

    function n(e) {
        var t = e.attribute,
            r = e.highlightedTagName,
            n = void 0 === r ? "mark" : r,
            i = e.hit,
            u = e.cssClasses,
            c = void 0 === u ? {} : u,
            s = (0, o.getPropertyByPath)(i._snippetResult, t),
            l = s || {},
            f = l.value,
            p = void 0 === f ? "" : f,
            d = a({
                descendantName: "highlighted"
            }) + (c.highlighted ? " ".concat(c.highlighted) : "");
        return p.replace(new RegExp(o.TAG_REPLACEMENT.highlightPreTag, "g"), "<".concat(n, ' class="').concat(d, '">')).replace(new RegExp(o.TAG_REPLACEMENT.highlightPostTag, "g"), "</".concat(n, ">"))
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = n;
    var i = r(5),
        o = r(0),
        a = (0, i.component)("Snippet")
}, function(e, t, r) {
    "use strict";

    function n(e) {
        var t = e.attribute,
            r = e.highlightedTagName,
            n = void 0 === r ? "mark" : r,
            i = e.hit,
            u = e.cssClasses,
            c = void 0 === u ? {} : u,
            s = (0, o.getPropertyByPath)(i._snippetResult, t),
            l = s || {},
            f = l.value,
            p = void 0 === f ? "" : f,
            d = a({
                descendantName: "highlighted"
            }) + (c.highlighted ? " ".concat(c.highlighted) : "");
        return (0, o.concatHighlightedParts)((0, o.reverseHighlightedParts)((0, o.getHighlightedParts)(p))).replace(new RegExp(o.TAG_REPLACEMENT.highlightPreTag, "g"), "<".concat(n, ' class="').concat(d, '">')).replace(new RegExp(o.TAG_REPLACEMENT.highlightPostTag, "g"), "</".concat(n, ">"))
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = n;
    var i = r(5),
        o = r(0),
        a = (0, i.component)("ReverseSnippet")
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e) {
        if ("object" === ("undefined" == typeof document ? "undefined" : n(document)) && "string" == typeof document.cookie)
            for (var t = "".concat(e, "="), r = document.cookie.split(";"), i = 0; i < r.length; i++) {
                for (var o = r[i];
                    " " === o.charAt(0);) o = o.substring(1);
                if (0 === o.indexOf(t)) return o.substring(t.length, o.length)
            }
    }

    function o() {
        return i(u)
    }

    function a() {
        return o()
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.ANONYMOUS_TOKEN_COOKIE_KEY = void 0, t.default = a, t.getInsightsAnonymousUserTokenInternal = o;
    var u = (r(0), "_ALGOLIA");
    t.ANONYMOUS_TOKEN_COOKIE_KEY = u
}, function(e, t, r) {
    "use strict";
    var n = r(1);
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), Object.defineProperty(t, "createInfiniteHitsSessionStorageCache", {
        enumerable: !0,
        get: function() {
            return i.default
        }
    });
    var i = n(r(115))
}, function(e, t, r) {
    "use strict";

    function n(e, t) {
        if (null == e) return {};
        var r, n, o = i(e, t);
        if (Object.getOwnPropertySymbols) {
            var a = Object.getOwnPropertySymbols(e);
            for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r])
        }
        return o
    }

    function i(e, t) {
        if (null == e) return {};
        var r, n, i = {},
            o = Object.keys(e);
        for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || (i[r] = e[r]);
        return i
    }

    function o(e) {
        return n(e || {}, c)
    }

    function a() {
        return {
            read: function(e) {
                var t = e.state,
                    r = (0, u.safelyRunOnBrowser)(function(e) {
                        return e.window.sessionStorage
                    });
                if (!r) return null;
                try {
                    var n = JSON.parse(r.getItem(s));
                    return n && (0, u.isEqual)(n.state, o(t)) ? n.hits : null
                } catch (e) {
                    if (e instanceof SyntaxError) try {
                        r.removeItem(s)
                    } catch (e) {}
                    return null
                }
            },
            write: function(e) {
                var t = e.state,
                    r = e.hits,
                    n = (0, u.safelyRunOnBrowser)(function(e) {
                        return e.window.sessionStorage
                    });
                if (n) try {
                    n.setItem(s, JSON.stringify({
                        state: o(t),
                        hits: r
                    }))
                } catch (e) {}
            }
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = a;
    var u = r(0),
        c = ["page"],
        s = "ais.infiniteHits"
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                y(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
    }

    function u(e, t) {
        for (var r = 0; r < t.length; r++) {
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, b(n.key), n)
        }
    }

    function c(e, t, r) {
        return t && u(e.prototype, t), r && u(e, r), Object.defineProperty(e, "prototype", {
            writable: !1
        }), e
    }

    function s(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
            constructor: {
                value: e,
                writable: !0,
                configurable: !0
            }
        }), Object.defineProperty(e, "prototype", {
            writable: !1
        }), t && l(e, t)
    }

    function l(e, t) {
        return (l = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
            return e.__proto__ = t, e
        })(e, t)
    }

    function f(e) {
        var t = h();
        return function() {
            var r, n = m(e);
            if (t) {
                var i = m(this).constructor;
                r = Reflect.construct(n, arguments, i)
            } else r = n.apply(this, arguments);
            return p(this, r)
        }
    }

    function p(e, t) {
        if (t && ("object" === n(t) || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return d(e)
    }

    function d(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e
    }

    function h() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0
        } catch (e) {
            return !1
        }
    }

    function m(e) {
        return (m = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e)
        })(e)
    }

    function y(e, t, r) {
        return t = b(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function b(e) {
        var t = v(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function v(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function g() {
        return "#"
    }
    var _ = r(1);
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var O = _(r(21)),
        j = _(r(22)),
        P = r(127),
        S = r(128),
        w = r(129),
        E = _(r(135)),
        R = _(r(136)),
        x = r(0),
        I = _(r(51)),
        k = (0, x.createDocumentationMessageGenerator)({
            name: "instantsearch"
        }),
        M = function(e) {
            function t(e) {
                var n;
                a(this, t), n = r.call(this), y(d(n), "client", void 0), y(d(n), "indexName", void 0), y(d(n), "insightsClient", void 0), y(d(n), "onStateChange", null), y(d(n), "helper", void 0), y(d(n), "mainHelper", void 0), y(d(n), "mainIndex", void 0), y(d(n), "started", void 0), y(d(n), "templatesConfig", void 0), y(d(n), "renderState", {}), y(d(n), "_stalledSearchDelay", void 0), y(d(n), "_searchStalledTimer", void 0), y(d(n), "_initialUiState", void 0), y(d(n), "_initialResults", void 0), y(d(n), "_createURL", void 0), y(d(n), "_searchFunction", void 0), y(d(n), "_mainHelperSearch", void 0), y(d(n), "middleware", []), y(d(n), "sendEventToInsights", void 0), y(d(n), "status", "idle"), y(d(n), "error", void 0), y(d(n), "scheduleSearch", (0, x.defer)(function() {
                    n.started && n.mainHelper.search()
                })), y(d(n), "scheduleRender", (0, x.defer)(function() {
                    var e, t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                    null !== (e = n.mainHelper) && void 0 !== e && e.hasPendingRequests() || (clearTimeout(n._searchStalledTimer), n._searchStalledTimer = null, t && (n.status = "idle", n.error = void 0)), n.mainIndex.render({
                        instantSearchInstance: d(n)
                    }), n.emit("render")
                })), y(d(n), "onInternalStateChange", (0, x.defer)(function() {
                    var e = n.mainIndex.getWidgetUiState({});
                    n.middleware.forEach(function(t) {
                        t.instance.onStateChange({
                            uiState: e
                        })
                    })
                })), n.setMaxListeners(100);
                var i = e.indexName,
                    o = void 0 === i ? "" : i,
                    u = e.numberLocale,
                    c = e.initialUiState,
                    s = void 0 === c ? {} : c,
                    l = e.routing,
                    f = void 0 === l ? null : l,
                    p = e.insights,
                    h = void 0 !== p && p,
                    m = e.searchFunction,
                    b = e.stalledSearchDelay,
                    v = void 0 === b ? 200 : b,
                    _ = e.searchClient,
                    O = void 0 === _ ? null : _,
                    j = e.insightsClient,
                    M = void 0 === j ? null : j,
                    A = e.onStateChange,
                    N = void 0 === A ? null : A;
                if (null === O) throw new Error(k("The `searchClient` option is required."));
                if ("function" != typeof O.search) throw new Error("The `searchClient` must implement a `search` method.\n\nSee: https://www.algolia.com/doc/guides/building-search-ui/going-further/backend-search/in-depth/backend-instantsearch/js/");
                if ("function" == typeof O.addAlgoliaAgent && O.addAlgoliaAgent("instantsearch.js (".concat(I.default, ")")), M && "function" != typeof M) throw new Error(k("The `insightsClient` option should be a function."));
                if (n.client = O, n.insightsClient = M, n.indexName = o, n.helper = null, n.mainHelper = null, n.mainIndex = (0, E.default)({
                        indexName: o
                    }), n.onStateChange = N, n.started = !1, n.templatesConfig = {
                        helpers: (0, R.default)({
                            numberLocale: u
                        }),
                        compileOptions: {}
                    }, n._stalledSearchDelay = v, n._searchStalledTimer = null, n._createURL = g, n._initialUiState = s, n._initialResults = null, m && (n._searchFunction = m), n.sendEventToInsights = x.noop, f) {
                    var C = "boolean" == typeof f ? {} : f;
                    C.$$internal = !0, n.use((0, w.createRouterMiddleware)(C))
                }
                if (h) {
                    var T = "boolean" == typeof h ? {} : h;
                    T.$$internal = !0, n.use((0, P.createInsightsMiddleware)(T))
                }
                return (0, S.isMetadataEnabled)() && n.use((0, S.createMetadataMiddleware)({
                    $$internal: !0
                })), n
            }
            s(t, e);
            var r = f(t);
            return c(t, [{
                key: "_isSearchStalled",
                get: function() {
                    return "stalled" === this.status
                }
            }, {
                key: "use",
                value: function() {
                    for (var e = this, t = arguments.length, r = new Array(t), n = 0; n < t; n++) r[n] = arguments[n];
                    var i = r.map(function(t) {
                        var r = o({
                            $$type: "__unknown__",
                            $$internal: !1,
                            subscribe: x.noop,
                            started: x.noop,
                            unsubscribe: x.noop,
                            onStateChange: x.noop
                        }, t({
                            instantSearchInstance: e
                        }));
                        return e.middleware.push({
                            creator: t,
                            instance: r
                        }), r
                    });
                    return this.started && i.forEach(function(e) {
                        e.subscribe(), e.started()
                    }), this
                }
            }, {
                key: "unuse",
                value: function() {
                    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
                    return this.middleware.filter(function(e) {
                        return t.includes(e.creator)
                    }).forEach(function(e) {
                        return e.instance.unsubscribe()
                    }), this.middleware = this.middleware.filter(function(e) {
                        return !t.includes(e.creator)
                    }), this
                }
            }, {
                key: "EXPERIMENTAL_use",
                value: function() {
                    return this.use.apply(this, arguments)
                }
            }, {
                key: "addWidget",
                value: function(e) {
                    return this.addWidgets([e])
                }
            }, {
                key: "addWidgets",
                value: function(e) {
                    if (!Array.isArray(e)) throw new Error(k("The `addWidgets` method expects an array of widgets. Please use `addWidget`."));
                    if (e.some(function(e) {
                            return "function" != typeof e.init && "function" != typeof e.render
                        })) throw new Error(k("The widget definition expects a `render` and/or an `init` method."));
                    return this.mainIndex.addWidgets(e), this
                }
            }, {
                key: "removeWidget",
                value: function(e) {
                    return this.removeWidgets([e])
                }
            }, {
                key: "removeWidgets",
                value: function(e) {
                    if (!Array.isArray(e)) throw new Error(k("The `removeWidgets` method expects an array of widgets. Please use `removeWidget`."));
                    if (e.some(function(e) {
                            return "function" != typeof e.dispose
                        })) throw new Error(k("The widget definition expects a `dispose` method."));
                    return this.mainIndex.removeWidgets(e), this
                }
            }, {
                key: "start",
                value: function() {
                    var e = this;
                    if (this.started) throw new Error(k("The `start` method has already been called once."));
                    var t = this.mainHelper || (0, j.default)(this.client, this.indexName);
                    if (t.search = function() {
                            return e.status = "loading", e.scheduleRender(!1), t.searchOnlyWithDerivedHelpers()
                        }, this._searchFunction) {
                        var r = {
                            search: function() {
                                return new Promise(x.noop)
                            }
                        };
                        this._mainHelperSearch = t.search.bind(t), t.search = function() {
                            var n = e.mainIndex.getHelper(),
                                i = (0, j.default)(r, n.state.index, n.state);
                            return i.once("search", function(t) {
                                var r = t.state;
                                n.overrideStateWithoutTriggeringChangeEvent(r), e._mainHelperSearch()
                            }), i.on("change", function(e) {
                                var t = e.state;
                                n.setState(t)
                            }), e._searchFunction(i), t
                        }
                    }
                    if (t.on("error", function(t) {
                            var r = t.error;
                            if (!(r instanceof Error)) {
                                var n = r;
                                r = Object.keys(n).reduce(function(e, t) {
                                    return e[t] = n[t], e
                                }, new Error(n.message))
                            }
                            r.error = r, e.error = r, e.status = "error", e.scheduleRender(!1), e.emit("error", r)
                        }), this.mainHelper = t, this.middleware.forEach(function(e) {
                            e.instance.subscribe()
                        }), this.mainIndex.init({
                            instantSearchInstance: this,
                            parent: null,
                            uiState: this._initialUiState
                        }), this._initialResults) {
                        var n = this.scheduleSearch;
                        this.scheduleSearch = (0, x.defer)(x.noop), (0, x.defer)(function() {
                            e.scheduleSearch = n
                        })()
                    } else this.mainIndex.getWidgets().length > 0 && this.scheduleSearch();
                    this.helper = this.mainIndex.getHelper(), this.started = !0, this.middleware.forEach(function(e) {
                        e.instance.started()
                    })
                }
            }, {
                key: "dispose",
                value: function() {
                    var e;
                    this.scheduleSearch.cancel(), this.scheduleRender.cancel(), clearTimeout(this._searchStalledTimer), this.removeWidgets(this.mainIndex.getWidgets()), this.mainIndex.dispose(), this.started = !1, this.removeAllListeners(), null === (e = this.mainHelper) || void 0 === e || e.removeAllListeners(), this.mainHelper = null, this.helper = null, this.middleware.forEach(function(e) {
                        e.instance.unsubscribe()
                    })
                }
            }, {
                key: "scheduleStalledRender",
                value: function() {
                    var e = this;
                    this._searchStalledTimer || (this._searchStalledTimer = setTimeout(function() {
                        e.status = "stalled", e.scheduleRender()
                    }, this._stalledSearchDelay))
                }
            }, {
                key: "setUiState",
                value: function(e) {
                    var t = this,
                        r = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                    if (!this.mainHelper) throw new Error(k("The `start` method needs to be called before `setUiState`."));
                    this.mainIndex.refreshUiState();
                    var n = "function" == typeof e ? e(this.mainIndex.getWidgetUiState({})) : e;
                    this.onStateChange && r ? this.onStateChange({
                        uiState: n,
                        setUiState: function(e) {
                            (0, x.setIndexHelperState)("function" == typeof e ? e(n) : e, t.mainIndex), t.scheduleSearch(), t.onInternalStateChange()
                        }
                    }) : ((0, x.setIndexHelperState)(n, this.mainIndex), this.scheduleSearch(), this.onInternalStateChange())
                }
            }, {
                key: "getUiState",
                value: function() {
                    return this.started && this.mainIndex.refreshUiState(), this.mainIndex.getWidgetUiState({})
                }
            }, {
                key: "createURL",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    if (!this.started) throw new Error(k("The `start` method needs to be called before `createURL`."));
                    return this._createURL(e)
                }
            }, {
                key: "refresh",
                value: function() {
                    if (!this.mainHelper) throw new Error(k("The `start` method needs to be called before `refresh`."));
                    this.mainHelper.clearCache().search()
                }
            }]), t
        }(O.default),
        A = M;
    t.default = A
}, function(e, t, r) {
    "use strict";

    function n(e, t, r) {
        "function" == typeof e.addAlgoliaAgent && e.addAlgoliaAgent("JS Helper (" + m + ")"), this.setClient(e);
        var n = r || {};
        n.index = t, this.state = a.make(n), this.lastResults = null, this._queryId = 0, this._lastQueryIdReceived = -1, this.derivedHelpers = [], this._currentNbQueries = 0
    }

    function i(e) {
        if (e < 0) throw new Error("Page requested below 0.");
        return this._change({
            state: this.state.setPage(e),
            isPageReset: !1
        }), this
    }

    function o() {
        return this.state.page
    }
    var a = r(44),
        u = r(45),
        c = r(125),
        s = r(126),
        l = r(21),
        f = r(48),
        p = r(25),
        d = r(24),
        h = r(12),
        m = r(49),
        y = r(26).escapeFacetValue;
    f(n, l), n.prototype.search = function() {
        return this._search({
            onlyWithDerivedHelpers: !1
        }), this
    }, n.prototype.searchOnlyWithDerivedHelpers = function() {
        return this._search({
            onlyWithDerivedHelpers: !0
        }), this
    }, n.prototype.getQuery = function() {
        var e = this.state;
        return s._getHitsSearchParams(e)
    }, n.prototype.searchOnce = function(e, t) {
        var r = e ? this.state.setQueryParameters(e) : this.state,
            n = s._getQueries(r.index, r),
            i = this;
        return this._currentNbQueries++, this.emit("searchOnce", {
            state: r
        }), t ? void this.client.search(n).then(function(e) {
            i._currentNbQueries--, 0 === i._currentNbQueries && i.emit("searchQueueEmpty"), t(null, new u(r, e.results), r)
        }).catch(function(e) {
            i._currentNbQueries--, 0 === i._currentNbQueries && i.emit("searchQueueEmpty"), t(e, null, r)
        }) : this.client.search(n).then(function(e) {
            return i._currentNbQueries--, 0 === i._currentNbQueries && i.emit("searchQueueEmpty"), {
                content: new u(r, e.results),
                state: r,
                _originalResponse: e
            }
        }, function(e) {
            throw i._currentNbQueries--, 0 === i._currentNbQueries && i.emit("searchQueueEmpty"), e
        })
    }, n.prototype.findAnswers = function(e) {
        console.warn("[algoliasearch-helper] answers is no longer supported");
        var t = this.state,
            r = this.derivedHelpers[0];
        if (!r) return Promise.resolve([]);
        var n = r.getModifiedState(t),
            i = h({
                attributesForPrediction: e.attributesForPrediction,
                nbHits: e.nbHits
            }, {
                params: d(s._getHitsSearchParams(n), ["attributesToSnippet", "hitsPerPage", "restrictSearchableAttributes", "snippetEllipsisText"])
            }),
            o = "search for answers was called, but this client does not have a function client.initIndex(index).findAnswers";
        if ("function" != typeof this.client.initIndex) throw new Error(o);
        var a = this.client.initIndex(n.index);
        if ("function" != typeof a.findAnswers) throw new Error(o);
        return a.findAnswers(n.query, e.queryLanguages, i)
    }, n.prototype.searchForFacetValues = function(e, t, r, n) {
        var i = "function" == typeof this.client.searchForFacetValues,
            o = "function" == typeof this.client.initIndex;
        if (!i && !o && "function" != typeof this.client.search) throw new Error("search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues or client.initIndex(index).searchForFacetValues");
        var a = this.state.setQueryParameters(n || {}),
            u = a.isDisjunctiveFacet(e),
            c = s.getSearchForFacetQuery(e, t, r, a);
        this._currentNbQueries++;
        var l, f = this;
        return i ? l = this.client.searchForFacetValues([{
            indexName: a.index,
            params: c
        }]) : o ? l = this.client.initIndex(a.index).searchForFacetValues(c) : (delete c.facetName, l = this.client.search([{
            type: "facet",
            facet: e,
            indexName: a.index,
            params: c
        }]).then(function(e) {
            return e.results[0]
        })), this.emit("searchForFacetValues", {
            state: a,
            facet: e,
            query: t
        }), l.then(function(t) {
            return f._currentNbQueries--, 0 === f._currentNbQueries && f.emit("searchQueueEmpty"), t = Array.isArray(t) ? t[0] : t, t.facetHits.forEach(function(t) {
                t.escapedValue = y(t.value), t.isRefined = u ? a.isDisjunctiveFacetRefined(e, t.escapedValue) : a.isFacetRefined(e, t.escapedValue)
            }), t
        }, function(e) {
            throw f._currentNbQueries--, 0 === f._currentNbQueries && f.emit("searchQueueEmpty"), e
        })
    }, n.prototype.setQuery = function(e) {
        return this._change({
            state: this.state.resetPage().setQuery(e),
            isPageReset: !0
        }), this
    }, n.prototype.clearRefinements = function(e) {
        return this._change({
            state: this.state.resetPage().clearRefinements(e),
            isPageReset: !0
        }), this
    }, n.prototype.clearTags = function() {
        return this._change({
            state: this.state.resetPage().clearTags(),
            isPageReset: !0
        }), this
    }, n.prototype.addDisjunctiveFacetRefinement = function(e, t) {
        return this._change({
            state: this.state.resetPage().addDisjunctiveFacetRefinement(e, t),
            isPageReset: !0
        }), this
    }, n.prototype.addDisjunctiveRefine = function() {
        return this.addDisjunctiveFacetRefinement.apply(this, arguments)
    }, n.prototype.addHierarchicalFacetRefinement = function(e, t) {
        return this._change({
            state: this.state.resetPage().addHierarchicalFacetRefinement(e, t),
            isPageReset: !0
        }), this
    }, n.prototype.addNumericRefinement = function(e, t, r) {
        return this._change({
            state: this.state.resetPage().addNumericRefinement(e, t, r),
            isPageReset: !0
        }), this
    }, n.prototype.addFacetRefinement = function(e, t) {
        return this._change({
            state: this.state.resetPage().addFacetRefinement(e, t),
            isPageReset: !0
        }), this
    }, n.prototype.addRefine = function() {
        return this.addFacetRefinement.apply(this, arguments)
    }, n.prototype.addFacetExclusion = function(e, t) {
        return this._change({
            state: this.state.resetPage().addExcludeRefinement(e, t),
            isPageReset: !0
        }), this
    }, n.prototype.addExclude = function() {
        return this.addFacetExclusion.apply(this, arguments)
    }, n.prototype.addTag = function(e) {
        return this._change({
            state: this.state.resetPage().addTagRefinement(e),
            isPageReset: !0
        }), this
    }, n.prototype.removeNumericRefinement = function(e, t, r) {
        return this._change({
            state: this.state.resetPage().removeNumericRefinement(e, t, r),
            isPageReset: !0
        }), this
    }, n.prototype.removeDisjunctiveFacetRefinement = function(e, t) {
        return this._change({
            state: this.state.resetPage().removeDisjunctiveFacetRefinement(e, t),
            isPageReset: !0
        }), this
    }, n.prototype.removeDisjunctiveRefine = function() {
        return this.removeDisjunctiveFacetRefinement.apply(this, arguments)
    }, n.prototype.removeHierarchicalFacetRefinement = function(e) {
        return this._change({
            state: this.state.resetPage().removeHierarchicalFacetRefinement(e),
            isPageReset: !0
        }), this
    }, n.prototype.removeFacetRefinement = function(e, t) {
        return this._change({
            state: this.state.resetPage().removeFacetRefinement(e, t),
            isPageReset: !0
        }), this
    }, n.prototype.removeRefine = function() {
        return this.removeFacetRefinement.apply(this, arguments)
    }, n.prototype.removeFacetExclusion = function(e, t) {
        return this._change({
            state: this.state.resetPage().removeExcludeRefinement(e, t),
            isPageReset: !0
        }), this
    }, n.prototype.removeExclude = function() {
        return this.removeFacetExclusion.apply(this, arguments)
    }, n.prototype.removeTag = function(e) {
        return this._change({
            state: this.state.resetPage().removeTagRefinement(e),
            isPageReset: !0
        }), this
    }, n.prototype.toggleFacetExclusion = function(e, t) {
        return this._change({
            state: this.state.resetPage().toggleExcludeFacetRefinement(e, t),
            isPageReset: !0
        }), this
    }, n.prototype.toggleExclude = function() {
        return this.toggleFacetExclusion.apply(this, arguments)
    }, n.prototype.toggleRefinement = function(e, t) {
        return this.toggleFacetRefinement(e, t)
    }, n.prototype.toggleFacetRefinement = function(e, t) {
        return this._change({
            state: this.state.resetPage().toggleFacetRefinement(e, t),
            isPageReset: !0
        }), this
    }, n.prototype.toggleRefine = function() {
        return this.toggleFacetRefinement.apply(this, arguments)
    }, n.prototype.toggleTag = function(e) {
        return this._change({
            state: this.state.resetPage().toggleTagRefinement(e),
            isPageReset: !0
        }), this
    }, n.prototype.nextPage = function() {
        var e = this.state.page || 0;
        return this.setPage(e + 1)
    }, n.prototype.previousPage = function() {
        var e = this.state.page || 0;
        return this.setPage(e - 1)
    }, n.prototype.setCurrentPage = i, n.prototype.setPage = i, n.prototype.setIndex = function(e) {
        return this._change({
            state: this.state.resetPage().setIndex(e),
            isPageReset: !0
        }), this
    }, n.prototype.setQueryParameter = function(e, t) {
        return this._change({
            state: this.state.resetPage().setQueryParameter(e, t),
            isPageReset: !0
        }), this
    }, n.prototype.setState = function(e) {
        return this._change({
            state: a.make(e),
            isPageReset: !1
        }), this
    }, n.prototype.overrideStateWithoutTriggeringChangeEvent = function(e) {
        return this.state = new a(e), this
    }, n.prototype.hasRefinements = function(e) {
        return !!p(this.state.getNumericRefinements(e)) || (this.state.isConjunctiveFacet(e) ? this.state.isFacetRefined(e) : this.state.isDisjunctiveFacet(e) ? this.state.isDisjunctiveFacetRefined(e) : !!this.state.isHierarchicalFacet(e) && this.state.isHierarchicalFacetRefined(e))
    }, n.prototype.isExcluded = function(e, t) {
        return this.state.isExcludeRefined(e, t)
    }, n.prototype.isDisjunctiveRefined = function(e, t) {
        return this.state.isDisjunctiveFacetRefined(e, t)
    }, n.prototype.hasTag = function(e) {
        return this.state.isTagRefined(e)
    }, n.prototype.isTagRefined = function() {
        return this.hasTagRefinements.apply(this, arguments)
    }, n.prototype.getIndex = function() {
        return this.state.index
    }, n.prototype.getCurrentPage = o, n.prototype.getPage = o, n.prototype.getTags = function() {
        return this.state.tagRefinements
    }, n.prototype.getRefinements = function(e) {
        var t = [];
        if (this.state.isConjunctiveFacet(e)) this.state.getConjunctiveRefinements(e).forEach(function(e) {
            t.push({
                value: e,
                type: "conjunctive"
            })
        }), this.state.getExcludeRefinements(e).forEach(function(e) {
            t.push({
                value: e,
                type: "exclude"
            })
        });
        else if (this.state.isDisjunctiveFacet(e)) {
            var r = this.state.getDisjunctiveRefinements(e);
            r.forEach(function(e) {
                t.push({
                    value: e,
                    type: "disjunctive"
                })
            })
        }
        var n = this.state.getNumericRefinements(e);
        return Object.keys(n).forEach(function(e) {
            var r = n[e];
            t.push({
                value: r,
                operator: e,
                type: "numeric"
            })
        }), t
    }, n.prototype.getNumericRefinement = function(e, t) {
        return this.state.getNumericRefinement(e, t)
    }, n.prototype.getHierarchicalFacetBreadcrumb = function(e) {
        return this.state.getHierarchicalFacetBreadcrumb(e)
    }, n.prototype._search = function(e) {
        var t = this.state,
            r = [],
            n = [];
        e.onlyWithDerivedHelpers || (n = s._getQueries(t.index, t), r.push({
            state: t,
            queriesCount: n.length,
            helper: this
        }), this.emit("search", {
            state: t,
            results: this.lastResults
        }));
        var i = this.derivedHelpers.map(function(e) {
                var n = e.getModifiedState(t),
                    i = n.index ? s._getQueries(n.index, n) : [];
                return r.push({
                    state: n,
                    queriesCount: i.length,
                    helper: e
                }), e.emit("search", {
                    state: n,
                    results: e.lastResults
                }), i
            }),
            o = Array.prototype.concat.apply(n, i),
            a = this._queryId++;
        if (this._currentNbQueries++, !o.length) return Promise.resolve({
            results: []
        }).then(this._dispatchAlgoliaResponse.bind(this, r, a));
        try {
            this.client.search(o).then(this._dispatchAlgoliaResponse.bind(this, r, a)).catch(this._dispatchAlgoliaError.bind(this, a))
        } catch (e) {
            this.emit("error", {
                error: e
            })
        }
    }, n.prototype._dispatchAlgoliaResponse = function(e, t, r) {
        if (!(t < this._lastQueryIdReceived)) {
            this._currentNbQueries -= t - this._lastQueryIdReceived, this._lastQueryIdReceived = t, 0 === this._currentNbQueries && this.emit("searchQueueEmpty");
            var n = r.results.slice();
            e.forEach(function(e) {
                var t = e.state,
                    r = e.queriesCount,
                    i = e.helper,
                    o = n.splice(0, r);
                if (!t.index) return void i.emit("result", {
                    results: null,
                    state: t
                });
                var a = i.lastResults = new u(t, o);
                i.emit("result", {
                    results: a,
                    state: t
                })
            })
        }
    }, n.prototype._dispatchAlgoliaError = function(e, t) {
        e < this._lastQueryIdReceived || (this._currentNbQueries -= e - this._lastQueryIdReceived, this._lastQueryIdReceived = e, this.emit("error", {
            error: t
        }), 0 === this._currentNbQueries && this.emit("searchQueueEmpty"))
    }, n.prototype.containsRefinement = function(e, t, r, n) {
        return e || 0 !== t.length || 0 !== r.length || 0 !== n.length
    }, n.prototype._hasDisjunctiveRefinements = function(e) {
        return this.state.disjunctiveRefinements[e] && this.state.disjunctiveRefinements[e].length > 0
    }, n.prototype._change = function(e) {
        var t = e.state,
            r = e.isPageReset;
        t !== this.state && (this.state = t, this.emit("change", {
            state: this.state,
            results: this.lastResults,
            isPageReset: r
        }))
    }, n.prototype.clearCache = function() {
        return this.client.clearCache && this.client.clearCache(), this
    }, n.prototype.setClient = function(e) {
        return this.client === e ? this : ("function" == typeof e.addAlgoliaAgent && e.addAlgoliaAgent("JS Helper (" + m + ")"), this.client = e, this)
    }, n.prototype.getClient = function() {
        return this.client
    }, n.prototype.derive = function(e) {
        var t = new c(this, e);
        return this.derivedHelpers.push(t), t
    }, n.prototype.detachDerivedHelper = function(e) {
        var t = this.derivedHelpers.indexOf(e);
        if (-1 === t) throw new Error("Derived helper already detached");
        this.derivedHelpers.splice(t, 1)
    }, n.prototype.hasPendingRequests = function() {
        return this._currentNbQueries > 0
    }, e.exports = n
}, function(e, t, r) {
    "use strict";

    function n(e, t) {
        return e.filter(function(r, n) {
            return t.indexOf(r) > -1 && e.indexOf(r) === n
        })
    }
    e.exports = n
}, function(e, t, r) {
    "use strict";

    function n(e) {
        if ("number" == typeof e) return e;
        if ("string" == typeof e) return parseFloat(e);
        if (Array.isArray(e)) return e.map(n);
        throw new Error("The value should be a number, a parsable string or an array of those.")
    }
    e.exports = n
}, function(e, t, r) {
    "use strict";
    e.exports = function(e) {
        return null !== e && /^[a-zA-Z0-9_-]{1,64}$/.test(e)
    }
}, function(e, t, r) {
    "use strict";
    var n = r(23),
        i = r(24),
        o = r(25),
        a = {
            addRefinement: function(e, t, r) {
                if (a.isRefined(e, t, r)) return e;
                var i = "" + r,
                    o = e[t] ? e[t].concat(i) : [i],
                    u = {};
                return u[t] = o, n({}, u, e)
            },
            removeRefinement: function(e, t, r) {
                if (void 0 === r) return a.clearRefinement(e, function(e, r) {
                    return t === r
                });
                var n = "" + r;
                return a.clearRefinement(e, function(e, r) {
                    return t === r && n === e
                })
            },
            toggleRefinement: function(e, t, r) {
                if (void 0 === r) throw new Error("toggleRefinement should be used with a value");
                return a.isRefined(e, t, r) ? a.removeRefinement(e, t, r) : a.addRefinement(e, t, r)
            },
            clearRefinement: function(e, t, r) {
                if (void 0 === t) return o(e) ? {} : e;
                if ("string" == typeof t) return i(e, [t]);
                if ("function" == typeof t) {
                    var n = !1,
                        a = Object.keys(e).reduce(function(i, o) {
                            var a = e[o] || [],
                                u = a.filter(function(e) {
                                    return !t(e, o, r)
                                });
                            return u.length !== a.length && (n = !0), i[o] = u, i
                        }, {});
                    return n ? a : e
                }
            },
            isRefined: function(e, t, r) {
                var n = !!e[t] && e[t].length > 0;
                if (void 0 === r || !n) return n;
                var i = "" + r;
                return -1 !== e[t].indexOf(i)
            }
        };
    e.exports = a
}, function(e, t, r) {
    "use strict";
    e.exports = function(e) {
        return Array.isArray(e) ? e.filter(Boolean) : []
    }
}, function(e, t, r) {
    "use strict";
    e.exports = function(e, t) {
        if (!Array.isArray(e)) return -1;
        for (var r = 0; r < e.length; r++)
            if (t(e[r])) return r;
        return -1
    }
}, function(e, t, r) {
    "use strict";

    function n(e) {
        return function(t, r) {
            var n = e.hierarchicalFacets[r],
                o = e.hierarchicalFacetsRefinements[n.name] && e.hierarchicalFacetsRefinements[n.name][0] || "",
                a = e._getHierarchicalFacetSeparator(n),
                u = e._getHierarchicalRootPath(n),
                c = e._getHierarchicalShowParentLevel(n),
                l = s(e._getHierarchicalFacetSortBy(n)),
                f = t.every(function(e) {
                    return e.exhaustive
                }),
                p = i(l, a, u, c, o),
                d = t;
            return u && (d = t.slice(u.split(a).length)), d.reduce(p, {
                name: e.hierarchicalFacets[r].name,
                count: null,
                isRefined: !0,
                path: null,
                escapedValue: null,
                exhaustive: f,
                data: null
            })
        }
    }

    function i(e, t, r, n, i) {
        return function(s, l, f) {
            var d = s;
            if (f > 0) {
                var h = 0;
                for (d = s; h < f;) {
                    var m = d && Array.isArray(d.data) ? d.data : [];
                    d = c(m, function(e) {
                        return e.isRefined
                    }), h++
                }
            }
            if (d) {
                var y = Object.keys(l.data).map(function(e) {
                    return [e, l.data[e]]
                }).filter(function(e) {
                    return o(e[0], d.path || r, i, t, r, n)
                });
                d.data = u(y.map(function(e) {
                    var r = e[0];
                    return a(e[1], r, t, p(i), l.exhaustive)
                }), e[0], e[1])
            }
            return s
        }
    }

    function o(e, t, r, n, i, o) {
        return (!i || 0 === e.indexOf(i) && i !== e) && (!i && -1 === e.indexOf(n) || i && e.split(n).length - i.split(n).length == 1 || -1 === e.indexOf(n) && -1 === r.indexOf(n) || 0 === r.indexOf(e) || 0 === e.indexOf(t + n) && (o || 0 === e.indexOf(r)))
    }

    function a(e, t, r, n, i) {
        var o = t.split(r);
        return {
            name: o[o.length - 1].trim(),
            path: t,
            escapedValue: f(t),
            count: e,
            isRefined: n === t || 0 === n.indexOf(t + r),
            exhaustive: i,
            data: null
        }
    }
    e.exports = n;
    var u = r(46),
        c = r(13),
        s = r(47),
        l = r(26),
        f = l.escapeFacetValue,
        p = l.unescapeFacetValue
}, function(e, t, r) {
    "use strict";

    function n(e, t) {
        this.main = e, this.fn = t, this.lastResults = null
    }
    var i = r(21);
    r(48)(n, i), n.prototype.detach = function() {
        this.removeAllListeners(), this.main.detachDerivedHelper(this)
    }, n.prototype.getModifiedState = function(e) {
        return this.fn(e)
    }, e.exports = n
}, function(e, t, r) {
    "use strict";

    function n(e) {
        return Object.keys(e).sort(function(e, t) {
            return e.localeCompare(t)
        }).reduce(function(t, r) {
            return t[r] = e[r], t
        }, {})
    }
    var i = r(12),
        o = {
            _getQueries: function(e, t) {
                var r = [];
                return r.push({
                    indexName: e,
                    params: o._getHitsSearchParams(t)
                }), t.getRefinedDisjunctiveFacets().forEach(function(n) {
                    r.push({
                        indexName: e,
                        params: o._getDisjunctiveFacetSearchParams(t, n)
                    })
                }), t.getRefinedHierarchicalFacets().forEach(function(n) {
                    var i = t.getHierarchicalFacetByName(n),
                        a = t.getHierarchicalRefinement(n),
                        u = t._getHierarchicalFacetSeparator(i);
                    if (a.length > 0 && a[0].split(u).length > 1) {
                        var c = a[0].split(u).slice(0, -1).reduce(function(e, t, r) {
                            return e.concat({
                                attribute: i.attributes[r],
                                value: 0 === r ? t : [e[e.length - 1].value, t].join(u)
                            })
                        }, []);
                        c.forEach(function(n, a) {
                            function u(e) {
                                return i.attributes.some(function(t) {
                                    return t === e.split(":")[0]
                                })
                            }
                            var s = o._getDisjunctiveFacetSearchParams(t, n.attribute, 0 === a),
                                l = (s.facetFilters || []).reduce(function(e, t) {
                                    if (Array.isArray(t)) {
                                        var r = t.filter(function(e) {
                                            return !u(e)
                                        });
                                        r.length > 0 && e.push(r)
                                    }
                                    return "string" != typeof t || u(t) || e.push(t), e
                                }, []),
                                f = c[a - 1];
                            s.facetFilters = a > 0 ? l.concat(f.attribute + ":" + f.value) : l.length > 0 ? l : void 0, r.push({
                                indexName: e,
                                params: s
                            })
                        })
                    }
                }), r
            },
            _getHitsSearchParams: function(e) {
                var t = e.facets.concat(e.disjunctiveFacets).concat(o._getHitsHierarchicalFacetsAttributes(e)),
                    r = o._getFacetFilters(e),
                    a = o._getNumericFilters(e),
                    u = o._getTagFilters(e),
                    c = {
                        facets: t.indexOf("*") > -1 ? ["*"] : t,
                        tagFilters: u
                    };
                return r.length > 0 && (c.facetFilters = r), a.length > 0 && (c.numericFilters = a), n(i({}, e.getQueryParams(), c))
            },
            _getDisjunctiveFacetSearchParams: function(e, t, r) {
                var a = o._getFacetFilters(e, t, r),
                    u = o._getNumericFilters(e, t),
                    c = o._getTagFilters(e),
                    s = {
                        hitsPerPage: 0,
                        page: 0,
                        analytics: !1,
                        clickAnalytics: !1
                    };
                c.length > 0 && (s.tagFilters = c);
                var l = e.getHierarchicalFacetByName(t);
                return s.facets = l ? o._getDisjunctiveHierarchicalFacetAttribute(e, l, r) : t, u.length > 0 && (s.numericFilters = u), a.length > 0 && (s.facetFilters = a), n(i({}, e.getQueryParams(), s))
            },
            _getNumericFilters: function(e, t) {
                if (e.numericFilters) return e.numericFilters;
                var r = [];
                return Object.keys(e.numericRefinements).forEach(function(n) {
                    var i = e.numericRefinements[n] || {};
                    Object.keys(i).forEach(function(e) {
                        var o = i[e] || [];
                        t !== n && o.forEach(function(t) {
                            if (Array.isArray(t)) {
                                var i = t.map(function(t) {
                                    return n + e + t
                                });
                                r.push(i)
                            } else r.push(n + e + t)
                        })
                    })
                }), r
            },
            _getTagFilters: function(e) {
                return e.tagFilters ? e.tagFilters : e.tagRefinements.join(",")
            },
            _getFacetFilters: function(e, t, r) {
                var n = [],
                    i = e.facetsRefinements || {};
                Object.keys(i).forEach(function(e) {
                    (i[e] || []).forEach(function(t) {
                        n.push(e + ":" + t)
                    })
                });
                var o = e.facetsExcludes || {};
                Object.keys(o).forEach(function(e) {
                    (o[e] || []).forEach(function(t) {
                        n.push(e + ":-" + t)
                    })
                });
                var a = e.disjunctiveFacetsRefinements || {};
                Object.keys(a).forEach(function(e) {
                    var r = a[e] || [];
                    if (e !== t && r && 0 !== r.length) {
                        var i = [];
                        r.forEach(function(t) {
                            i.push(e + ":" + t)
                        }), n.push(i)
                    }
                });
                var u = e.hierarchicalFacetsRefinements || {};
                return Object.keys(u).forEach(function(i) {
                    var o = u[i] || [],
                        a = o[0];
                    if (void 0 !== a) {
                        var c, s, l = e.getHierarchicalFacetByName(i),
                            f = e._getHierarchicalFacetSeparator(l),
                            p = e._getHierarchicalRootPath(l);
                        if (t === i) {
                            if (-1 === a.indexOf(f) || !p && !0 === r || p && p.split(f).length === a.split(f).length) return;
                            p ? (s = p.split(f).length - 1, a = p) : (s = a.split(f).length - 2, a = a.slice(0, a.lastIndexOf(f))), c = l.attributes[s]
                        } else s = a.split(f).length - 1, c = l.attributes[s];
                        c && n.push([c + ":" + a])
                    }
                }), n
            },
            _getHitsHierarchicalFacetsAttributes: function(e) {
                var t = [];
                return e.hierarchicalFacets.reduce(function(t, r) {
                    var n = e.getHierarchicalRefinement(r.name)[0];
                    if (!n) return t.push(r.attributes[0]), t;
                    var i = e._getHierarchicalFacetSeparator(r),
                        o = n.split(i).length,
                        a = r.attributes.slice(0, o + 1);
                    return t.concat(a)
                }, t)
            },
            _getDisjunctiveHierarchicalFacetAttribute: function(e, t, r) {
                var n = e._getHierarchicalFacetSeparator(t);
                if (!0 === r) {
                    var i = e._getHierarchicalRootPath(t),
                        o = 0;
                    return i && (o = i.split(n).length), [t.attributes[o]]
                }
                var a = e.getHierarchicalRefinement(t.name)[0] || "",
                    u = a.split(n).length - 1;
                return t.attributes.slice(0, u + 1)
            },
            getSearchForFacetQuery: function(e, t, r, a) {
                var u = a.isDisjunctiveFacet(e) ? a.clearRefinements(e) : a,
                    c = {
                        facetQuery: t,
                        facetName: e
                    };
                return "number" == typeof r && (c.maxFacetHits = r), n(i({}, o._getHitsSearchParams(u), c))
            }
        };
    e.exports = o
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function s(e, t) {
        return p(e) || f(e, t) || m(e, t) || l()
    }

    function l() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
    }

    function f(e, t) {
        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (null != r) {
            var n, i, o, a, u = [],
                c = !0,
                s = !1;
            try {
                if (o = (r = r.call(e)).next, 0 === t) {
                    if (Object(r) !== r) return;
                    c = !1
                } else
                    for (; !(c = (n = o.call(r)).done) && (u.push(n.value), u.length !== t); c = !0);
            } catch (e) {
                s = !0, i = e
            } finally {
                try {
                    if (!c && null != r.return && (a = r.return(), Object(a) !== a)) return
                } finally {
                    if (s) throw i
                }
            }
            return u
        }
    }

    function p(e) {
        if (Array.isArray(e)) return e
    }

    function d(e) {
        return b(e) || y(e) || m(e) || h()
    }

    function h() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
    }

    function m(e, t) {
        if (e) {
            if ("string" == typeof e) return v(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? v(e, t) : void 0
        }
    }

    function y(e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e)
    }

    function b(e) {
        if (Array.isArray(e)) return v(e)
    }

    function v(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
        return n
    }

    function g() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = e.insightsClient,
            r = e.insightsInitParams,
            n = e.onEvent,
            i = e.$$internal,
            a = void 0 !== i && i,
            u = t;
        t || null === t || (0, j.safelyRunOnBrowser)(function(e) {
            var t = e.window,
                r = t.AlgoliaAnalyticsObject || "aa";
            "string" == typeof r && (u = t[r]), u || (t.AlgoliaAnalyticsObject = r, t[r] || (t[r] = function() {
                t[r].queue || (t[r].queue = []);
                for (var e = arguments.length, n = new Array(e), i = 0; i < e; i++) n[i] = arguments[i];
                t[r].queue.push(n)
            }, t[r].version = P, t[r].shouldAddScript = !0), u = t[r])
        });
        var c = u || j.noop;
        return function(e) {
            var t = e.instantSearchInstance,
                i = t.middleware.filter(function(e) {
                    return "ais.insights" === e.instance.$$type && e.instance.$$internal
                }).map(function(e) {
                    return e.creator
                });
            t.unuse.apply(t, d(i));
            var u = (0, j.getAppIdAndApiKey)(t.client),
                l = s(u, 2),
                f = l[0],
                p = l[1],
                h = void 0,
                m = void 0;
            if (Array.isArray(c.queue)) {
                var y = (0, j.find)(c.queue.slice().reverse(), function(e) {
                        return "setUserToken" === s(e, 1)[0]
                    }) || [],
                    b = s(y, 2);
                h = b[1]
            }
            c("getUserToken", null, function(e, t) {
                m = t
            }), !r && _(c) || c("init", o({
                appId: f,
                apiKey: p,
                partial: !0
            }, r));
            var v, g;
            return {
                $$type: "ais.insights",
                $$internal: a,
                onStateChange: function() {},
                subscribe: function() {
                    if (c.shouldAddScript) {
                        var e = "[insights middleware]: could not load search-insights.js. Please load it manually following https://alg.li/insights-init";
                        try {
                            var r = document.createElement("script");
                            r.async = !0, r.src = S, r.onerror = function() {
                                t.emit("error", new Error(e))
                            }, document.body.appendChild(r), c.shouldAddScript = !1
                        } catch (r) {
                            c.shouldAddScript = !1, t.emit("error", new Error(e))
                        }
                    }
                },
                started: function() {
                    c("addAlgoliaAgent", "insights-middleware"), g = t.helper, v = {
                        userToken: g.state.userToken,
                        clickAnalytics: g.state.clickAnalytics
                    }, g.overrideStateWithoutTriggeringChangeEvent(o(o({}, g.state), {}, {
                        clickAnalytics: !0
                    })), a || t.scheduleSearch();
                    var e = function(e) {
                            if (e) {
                                var r = g.state.userToken;
                                g.overrideStateWithoutTriggeringChangeEvent(o(o({}, g.state), {}, {
                                    userToken: e
                                })), r && r !== e && t.scheduleSearch()
                            }
                        },
                        r = (0, O.getInsightsAnonymousUserTokenInternal)();
                    r && e(r), m ? (e(m), c("setUserToken", m)) : h && (e(h), c("setUserToken", h)), c("onUserTokenChange", e, {
                        immediate: !0
                    });
                    var i = c;
                    _(c) && (i = function(e, t) {
                        return c(e, t, {
                            headers: {
                                "X-Algolia-Application-Id": f,
                                "X-Algolia-API-Key": p
                            }
                        })
                    }), t.sendEventToInsights = function(e) {
                        n ? n(e, i) : e.insightsMethod && (e.payload.algoliaSource = ["instantsearch"], "internal" === e.eventModifier && e.payload.algoliaSource.push("instantsearch-internal"), i(e.insightsMethod, e.payload))
                    }
                },
                unsubscribe: function() {
                    c("onUserTokenChange", void 0), t.sendEventToInsights = j.noop, g && v && (g.overrideStateWithoutTriggeringChangeEvent(o(o({}, g.state), v)), t.scheduleSearch())
                }
            }
        }
    }

    function _(e) {
        var t = (e.version || "").split(".").map(Number),
            r = s(t, 2),
            n = r[0],
            i = r[1],
            o = n >= 3,
            a = 2 === n && i >= 6,
            u = 1 === n && i >= 10;
        return o || a || u
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.createInsightsMiddleware = g;
    var O = r(16),
        j = r(0),
        P = "2.6.0",
        S = "https://cdn.jsdelivr.net/npm/search-insights@".concat(P, "/dist/search-insights.min.js")
}, function(e, t, r) {
    "use strict";

    function n(e, t, r) {
        var i = (0, a.createInitArgs)(t, t.mainIndex, t._initialUiState);
        e.forEach(function(e) {
            var o = {};
            if (e.getWidgetRenderState) {
                var a = e.getWidgetRenderState(i);
                a && a.widgetParams && (o = a.widgetParams)
            }
            var u = Object.keys(o).filter(function(e) {
                return void 0 !== o[e]
            });
            r.widgets.push({
                type: e.$$type,
                widgetType: e.$$widgetType,
                params: u
            }), "ais.index" === e.$$type && n(e.getWidgets(), t, r)
        })
    }

    function i() {
        return (0, a.safelyRunOnBrowser)(function(e) {
            var t, r;
            return (null === (t = e.window.navigator) || void 0 === t ? void 0 : null === (r = t.userAgent) || void 0 === r ? void 0 : r.indexOf("Algolia Crawler")) > -1
        }, {
            fallback: function() {
                return !1
            }
        })
    }

    function o() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = e.$$internal,
            r = void 0 !== t && t;
        return function(e) {
            var t = e.instantSearchInstance,
                i = {
                    widgets: []
                },
                o = document.createElement("meta"),
                a = document.querySelector("head");
            return o.name = "instantsearch:widgets", {
                $$type: "ais.metadata",
                $$internal: r,
                onStateChange: function() {},
                subscribe: function() {
                    setTimeout(function() {
                        var e = t.client;
                        i.ua = e.transporter && e.transporter.userAgent ? e.transporter.userAgent.value : e._ua, n(t.mainIndex.getWidgets(), t, i), t.middleware.forEach(function(e) {
                            return i.widgets.push({
                                middleware: !0,
                                type: e.instance.$$type,
                                internal: e.instance.$$internal
                            })
                        }), o.content = JSON.stringify(i), a.appendChild(o)
                    }, 0)
                },
                started: function() {},
                unsubscribe: function() {
                    o.remove()
                }
            }
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.createMetadataMiddleware = o, t.isMetadataEnabled = i;
    var a = r(0)
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }
    var s = r(1);
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.createRouterMiddleware = void 0;
    var l = s(r(130)),
        f = s(r(134)),
        p = r(0),
        d = function() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                t = e.router,
                r = void 0 === t ? (0, l.default)() : t,
                n = e.stateMapping,
                i = void 0 === n ? (0, f.default)() : n,
                u = e.$$internal,
                c = void 0 !== u && u;
            return function(e) {
                function t(e) {
                    var t = Object.keys(e).reduce(function(t, r) {
                            return o(o({}, t), {}, a({}, r, e[r]))
                        }, n.mainIndex.getWidgetUiState({})),
                        u = i.stateToRoute(t);
                    return r.createURL(u)
                }
                var n = e.instantSearchInstance;
                n._createURL = t;
                var u = void 0,
                    s = n._initialUiState;
                return {
                    $$type: "ais.router({router:".concat(r.$$type || "__unknown__", ", stateMapping:").concat(i.$$type || "__unknown__", "})"),
                    $$internal: c,
                    onStateChange: function(e) {
                        var t = e.uiState,
                            n = i.stateToRoute(t);
                        void 0 !== u && (0, p.isEqual)(u, n) || (r.write(n), u = n)
                    },
                    subscribe: function() {
                        n._initialUiState = o(o({}, s), i.routeToState(r.read())), r.onUpdate(function(e) {
                            n.setUiState(i.routeToState(e))
                        })
                    },
                    started: function() {
                        var e;
                        null === (e = r.start) || void 0 === e || e.call(r)
                    },
                    unsubscribe: function() {
                        r.dispose()
                    }
                }
            }
        };
    t.createRouterMiddleware = d
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
    }

    function o(e, t) {
        for (var r = 0; r < t.length; r++) {
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, c(n.key), n)
        }
    }

    function a(e, t, r) {
        return t && o(e.prototype, t), r && o(e, r), Object.defineProperty(e, "prototype", {
            writable: !1
        }), e
    }

    function u(e, t, r) {
        return t = c(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function c(e) {
        var t = s(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function s(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function l() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = e.createURL,
            r = void 0 === t ? function(e) {
                var t = e.qsModule,
                    r = e.routeState,
                    n = e.location,
                    i = n.protocol,
                    o = n.hostname,
                    a = n.port,
                    u = void 0 === a ? "" : a,
                    c = n.pathname,
                    s = n.hash,
                    l = t.stringify(r),
                    f = "" === u ? "" : ":".concat(u);
                return l ? "".concat(i, "//").concat(o).concat(f).concat(c, "?").concat(l).concat(s) : "".concat(i, "//").concat(o).concat(f).concat(c).concat(s)
            } : t,
            n = e.parseURL,
            i = void 0 === n ? function(e) {
                var t = e.qsModule,
                    r = e.location;
                return t.parse(r.search.slice(1), {
                    arrayLimit: 99
                })
            } : n,
            o = e.writeDelay,
            a = void 0 === o ? 400 : o,
            u = e.windowTitle,
            c = e.getLocation,
            s = void 0 === c ? function() {
                return (0, d.safelyRunOnBrowser)(function(e) {
                    return e.window.location
                }, {
                    fallback: function() {
                        throw new Error("You need to provide `getLocation` to the `history` router in environments where `window` does not exist.")
                    }
                })
            } : c,
            l = e.start,
            f = e.dispose,
            p = e.push;
        return new m({
            createURL: r,
            parseURL: i,
            writeDelay: a,
            windowTitle: u,
            getLocation: s,
            start: l,
            dispose: f,
            push: p
        })
    }
    var f = r(1);
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = l;
    var p = f(r(131)),
        d = r(0),
        h = function(e) {
            e && (window.document.title = e)
        },
        m = function() {
            function e(t) {
                var r = this,
                    n = t.windowTitle,
                    o = t.writeDelay,
                    a = void 0 === o ? 400 : o,
                    c = t.createURL,
                    s = t.parseURL,
                    l = t.getLocation,
                    f = t.start,
                    p = t.dispose,
                    m = t.push;
                i(this, e), u(this, "$$type", "ais.browser"), u(this, "windowTitle", void 0), u(this, "writeDelay", void 0), u(this, "_createURL", void 0), u(this, "parseURL", void 0), u(this, "getLocation", void 0), u(this, "writeTimer", void 0), u(this, "_onPopState", void 0), u(this, "inPopState", !1), u(this, "isDisposed", !1), u(this, "latestAcknowledgedHistory", 0), u(this, "_start", void 0), u(this, "_dispose", void 0), u(this, "_push", void 0), this.windowTitle = n, this.writeTimer = void 0, this.writeDelay = a, this._createURL = c, this.parseURL = s, this.getLocation = l, this._start = f, this._dispose = p, this._push = m, (0, d.safelyRunOnBrowser)(function(e) {
                    var t = e.window,
                        n = r.windowTitle && r.windowTitle(r.read());
                    h(n), r.latestAcknowledgedHistory = t.history.length
                })
            }
            return a(e, [{
                key: "read",
                value: function() {
                    return this.parseURL({
                        qsModule: p.default,
                        location: this.getLocation()
                    })
                }
            }, {
                key: "write",
                value: function(e) {
                    var t = this;
                    (0, d.safelyRunOnBrowser)(function(r) {
                        var n = r.window,
                            i = t.createURL(e),
                            o = t.windowTitle && t.windowTitle(e);
                        t.writeTimer && clearTimeout(t.writeTimer), t.writeTimer = setTimeout(function() {
                            h(o), t.shouldWrite(i) && (t._push ? t._push(i) : n.history.pushState(e, o || "", i), t.latestAcknowledgedHistory = n.history.length), t.inPopState = !1, t.writeTimer = void 0
                        }, t.writeDelay)
                    })
                }
            }, {
                key: "onUpdate",
                value: function(e) {
                    var t = this;
                    this._start && this._start(function() {
                        e(t.read())
                    }), this._onPopState = function() {
                        t.writeTimer && (clearTimeout(t.writeTimer), t.writeTimer = void 0), t.inPopState = !0, e(t.read())
                    }, (0, d.safelyRunOnBrowser)(function(e) {
                        e.window.addEventListener("popstate", t._onPopState)
                    })
                }
            }, {
                key: "createURL",
                value: function(e) {
                    return this._createURL({
                        qsModule: p.default,
                        routeState: e,
                        location: this.getLocation()
                    })
                }
            }, {
                key: "dispose",
                value: function() {
                    var e = this;
                    this._dispose && this._dispose(), this.isDisposed = !0, (0, d.safelyRunOnBrowser)(function(t) {
                        var r = t.window;
                        e._onPopState && r.removeEventListener("popstate", e._onPopState)
                    }), this.writeTimer && clearTimeout(this.writeTimer), this.write({})
                }
            }, {
                key: "start",
                value: function() {
                    this.isDisposed = !1
                }
            }, {
                key: "shouldWrite",
                value: function(e) {
                    var t = this;
                    return (0, d.safelyRunOnBrowser)(function(r) {
                        var n = r.window,
                            i = !(t.isDisposed && t.latestAcknowledgedHistory !== n.history.length);
                        return !t.inPopState && i && e !== n.location.href
                    })
                }
            }]), e
        }()
}, function(e, t, r) {
    "use strict";
    var n = r(132),
        i = r(133),
        o = r(27);
    e.exports = {
        formats: o,
        parse: i,
        stringify: n
    }
}, function(e, t, r) {
    "use strict";
    var n = r(1),
        i = n(r(8)),
        o = r(50),
        a = r(27),
        u = Object.prototype.hasOwnProperty,
        c = {
            brackets: function(e) {
                return e + "[]"
            },
            comma: "comma",
            indices: function(e, t) {
                return e + "[" + t + "]"
            },
            repeat: function(e) {
                return e
            }
        },
        s = Array.isArray,
        l = String.prototype.split,
        f = Array.prototype.push,
        p = function(e, t) {
            f.apply(e, s(t) ? t : [t])
        },
        d = Date.prototype.toISOString,
        h = a.default,
        m = {
            addQueryPrefix: !1,
            allowDots: !1,
            charset: "utf-8",
            charsetSentinel: !1,
            delimiter: "&",
            encode: !0,
            encoder: o.encode,
            encodeValuesOnly: !1,
            format: h,
            formatter: a.formatters[h],
            indices: !1,
            serializeDate: function(e) {
                return d.call(e)
            },
            skipNulls: !1,
            strictNullHandling: !1
        },
        y = function(e) {
            return "string" == typeof e || "number" == typeof e || "boolean" == typeof e || "symbol" === (0, i.default)(e) || "bigint" == typeof e
        },
        b = function e(t, r, n, a, u, c, f, d, h, b, v, g, _, O) {
            var j = t;
            if ("function" == typeof f ? j = f(r, j) : j instanceof Date ? j = b(j) : "comma" === n && s(j) && (j = o.maybeMap(j, function(e) {
                    return e instanceof Date ? b(e) : e
                })), null === j) {
                if (a) return c && !_ ? c(r, m.encoder, O, "key", v) : r;
                j = ""
            }
            if (y(j) || o.isBuffer(j)) {
                if (c) {
                    var P = _ ? r : c(r, m.encoder, O, "key", v);
                    if ("comma" === n && _) {
                        for (var S = l.call(String(j), ","), w = "", E = 0; E < S.length; ++E) w += (0 === E ? "" : ",") + g(c(S[E], m.encoder, O, "value", v));
                        return [g(P) + "=" + w]
                    }
                    return [g(P) + "=" + g(c(j, m.encoder, O, "value", v))]
                }
                return [g(r) + "=" + g(String(j))]
            }
            var R = [];
            if (void 0 === j) return R;
            var x;
            if ("comma" === n && s(j)) x = [{
                value: j.length > 0 ? j.join(",") || null : void 0
            }];
            else if (s(f)) x = f;
            else {
                var I = Object.keys(j);
                x = d ? I.sort(d) : I
            }
            for (var k = 0; k < x.length; ++k) {
                var M = x[k],
                    A = "object" === (0, i.default)(M) && void 0 !== M.value ? M.value : j[M];
                if (!u || null !== A) {
                    var N = s(j) ? "function" == typeof n ? n(r, M) : r : r + (h ? "." + M : "[" + M + "]");
                    p(R, e(A, N, n, a, u, c, f, d, h, b, v, g, _, O))
                }
            }
            return R
        },
        v = function(e) {
            if (!e) return m;
            if (null !== e.encoder && void 0 !== e.encoder && "function" != typeof e.encoder) throw new TypeError("Encoder has to be a function.");
            var t = e.charset || m.charset;
            if (void 0 !== e.charset && "utf-8" !== e.charset && "iso-8859-1" !== e.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
            var r = a.default;
            if (void 0 !== e.format) {
                if (!u.call(a.formatters, e.format)) throw new TypeError("Unknown format option provided.");
                r = e.format
            }
            var n = a.formatters[r],
                i = m.filter;
            return ("function" == typeof e.filter || s(e.filter)) && (i = e.filter), {
                addQueryPrefix: "boolean" == typeof e.addQueryPrefix ? e.addQueryPrefix : m.addQueryPrefix,
                allowDots: void 0 === e.allowDots ? m.allowDots : !!e.allowDots,
                charset: t,
                charsetSentinel: "boolean" == typeof e.charsetSentinel ? e.charsetSentinel : m.charsetSentinel,
                delimiter: void 0 === e.delimiter ? m.delimiter : e.delimiter,
                encode: "boolean" == typeof e.encode ? e.encode : m.encode,
                encoder: "function" == typeof e.encoder ? e.encoder : m.encoder,
                encodeValuesOnly: "boolean" == typeof e.encodeValuesOnly ? e.encodeValuesOnly : m.encodeValuesOnly,
                filter: i,
                format: r,
                formatter: n,
                serializeDate: "function" == typeof e.serializeDate ? e.serializeDate : m.serializeDate,
                skipNulls: "boolean" == typeof e.skipNulls ? e.skipNulls : m.skipNulls,
                sort: "function" == typeof e.sort ? e.sort : null,
                strictNullHandling: "boolean" == typeof e.strictNullHandling ? e.strictNullHandling : m.strictNullHandling
            }
        };
    e.exports = function(e, t) {
        var r, n, o = e,
            a = v(t);
        "function" == typeof a.filter ? (n = a.filter, o = n("", o)) : s(a.filter) && (n = a.filter, r = n);
        var u = [];
        if ("object" !== (0, i.default)(o) || null === o) return "";
        var l;
        l = t && t.arrayFormat in c ? t.arrayFormat : t && "indices" in t ? t.indices ? "indices" : "repeat" : "indices";
        var f = c[l];
        r || (r = Object.keys(o)), a.sort && r.sort(a.sort);
        for (var d = 0; d < r.length; ++d) {
            var h = r[d];
            a.skipNulls && null === o[h] || p(u, b(o[h], h, f, a.strictNullHandling, a.skipNulls, a.encode ? a.encoder : null, a.filter, a.sort, a.allowDots, a.serializeDate, a.format, a.formatter, a.encodeValuesOnly, a.charset))
        }
        var m = u.join(a.delimiter),
            y = !0 === a.addQueryPrefix ? "?" : "";
        return a.charsetSentinel && ("iso-8859-1" === a.charset ? y += "utf8=%26%2310003%3B&" : y += "utf8=%E2%9C%93&"), m.length > 0 ? y + m : ""
    }
}, function(e, t, r) {
    "use strict";
    var n = r(50),
        i = Object.prototype.hasOwnProperty,
        o = Array.isArray,
        a = {
            allowDots: !1,
            allowPrototypes: !1,
            arrayLimit: 20,
            charset: "utf-8",
            charsetSentinel: !1,
            comma: !1,
            decoder: n.decode,
            delimiter: "&",
            depth: 5,
            ignoreQueryPrefix: !1,
            interpretNumericEntities: !1,
            parameterLimit: 1e3,
            parseArrays: !0,
            plainObjects: !1,
            strictNullHandling: !1
        },
        u = function(e) {
            return e.replace(/&#(\d+);/g, function(e, t) {
                return String.fromCharCode(parseInt(t, 10))
            })
        },
        c = function(e, t) {
            return e && "string" == typeof e && t.comma && e.indexOf(",") > -1 ? e.split(",") : e
        },
        s = function(e, t) {
            var r, s = {},
                l = t.ignoreQueryPrefix ? e.replace(/^\?/, "") : e,
                f = t.parameterLimit === 1 / 0 ? void 0 : t.parameterLimit,
                p = l.split(t.delimiter, f),
                d = -1,
                h = t.charset;
            if (t.charsetSentinel)
                for (r = 0; r < p.length; ++r) 0 === p[r].indexOf("utf8=") && ("utf8=%E2%9C%93" === p[r] ? h = "utf-8" : "utf8=%26%2310003%3B" === p[r] && (h = "iso-8859-1"), d = r, r = p.length);
            for (r = 0; r < p.length; ++r)
                if (r !== d) {
                    var m, y, b = p[r],
                        v = b.indexOf("]="),
                        g = -1 === v ? b.indexOf("=") : v + 1; - 1 === g ? (m = t.decoder(b, a.decoder, h, "key"), y = t.strictNullHandling ? null : "") : (m = t.decoder(b.slice(0, g), a.decoder, h, "key"), y = n.maybeMap(c(b.slice(g + 1), t), function(e) {
                        return t.decoder(e, a.decoder, h, "value")
                    })), y && t.interpretNumericEntities && "iso-8859-1" === h && (y = u(y)), b.indexOf("[]=") > -1 && (y = o(y) ? [y] : y), i.call(s, m) ? s[m] = n.combine(s[m], y) : s[m] = y
                }
            return s
        },
        l = function(e, t, r, n) {
            for (var i = n ? t : c(t, r), o = e.length - 1; o >= 0; --o) {
                var a, u = e[o];
                if ("[]" === u && r.parseArrays) a = [].concat(i);
                else {
                    a = r.plainObjects ? Object.create(null) : {};
                    var s = "[" === u.charAt(0) && "]" === u.charAt(u.length - 1) ? u.slice(1, -1) : u,
                        l = parseInt(s, 10);
                    r.parseArrays || "" !== s ? !isNaN(l) && u !== s && String(l) === s && l >= 0 && r.parseArrays && l <= r.arrayLimit ? (a = [], a[l] = i) : "__proto__" !== s && (a[s] = i) : a = {
                        0: i
                    }
                }
                i = a
            }
            return i
        },
        f = function(e, t, r, n) {
            if (e) {
                var o = r.allowDots ? e.replace(/\.([^.[]+)/g, "[$1]") : e,
                    a = /(\[[^[\]]*])/,
                    u = /(\[[^[\]]*])/g,
                    c = r.depth > 0 && a.exec(o),
                    s = c ? o.slice(0, c.index) : o,
                    f = [];
                if (s) {
                    if (!r.plainObjects && i.call(Object.prototype, s) && !r.allowPrototypes) return;
                    f.push(s)
                }
                for (var p = 0; r.depth > 0 && null !== (c = u.exec(o)) && p < r.depth;) {
                    if (p += 1, !r.plainObjects && i.call(Object.prototype, c[1].slice(1, -1)) && !r.allowPrototypes) return;
                    f.push(c[1])
                }
                return c && f.push("[" + o.slice(c.index) + "]"), l(f, t, r, n)
            }
        },
        p = function(e) {
            if (!e) return a;
            if (null !== e.decoder && void 0 !== e.decoder && "function" != typeof e.decoder) throw new TypeError("Decoder has to be a function.");
            if (void 0 !== e.charset && "utf-8" !== e.charset && "iso-8859-1" !== e.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
            var t = void 0 === e.charset ? a.charset : e.charset;
            return {
                allowDots: void 0 === e.allowDots ? a.allowDots : !!e.allowDots,
                allowPrototypes: "boolean" == typeof e.allowPrototypes ? e.allowPrototypes : a.allowPrototypes,
                arrayLimit: "number" == typeof e.arrayLimit ? e.arrayLimit : a.arrayLimit,
                charset: t,
                charsetSentinel: "boolean" == typeof e.charsetSentinel ? e.charsetSentinel : a.charsetSentinel,
                comma: "boolean" == typeof e.comma ? e.comma : a.comma,
                decoder: "function" == typeof e.decoder ? e.decoder : a.decoder,
                delimiter: "string" == typeof e.delimiter || n.isRegExp(e.delimiter) ? e.delimiter : a.delimiter,
                depth: "number" == typeof e.depth || !1 === e.depth ? +e.depth : a.depth,
                ignoreQueryPrefix: !0 === e.ignoreQueryPrefix,
                interpretNumericEntities: "boolean" == typeof e.interpretNumericEntities ? e.interpretNumericEntities : a.interpretNumericEntities,
                parameterLimit: "number" == typeof e.parameterLimit ? e.parameterLimit : a.parameterLimit,
                parseArrays: !1 !== e.parseArrays,
                plainObjects: "boolean" == typeof e.plainObjects ? e.plainObjects : a.plainObjects,
                strictNullHandling: "boolean" == typeof e.strictNullHandling ? e.strictNullHandling : a.strictNullHandling
            }
        };
    e.exports = function(e, t) {
        var r = p(t);
        if ("" === e || null === e || void 0 === e) return r.plainObjects ? Object.create(null) : {};
        for (var i = "string" == typeof e ? s(e, r) : e, o = r.plainObjects ? Object.create(null) : {}, a = Object.keys(i), u = 0; u < a.length; ++u) {
            var c = a[u],
                l = f(c, i[c], r, "string" == typeof e);
            o = n.merge(o, l, r)
        }
        return n.compact(o)
    }
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function s(e, t) {
        if (null == e) return {};
        var r, n, i = l(e, t);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
        }
        return i
    }

    function l(e, t) {
        if (null == e) return {};
        var r, n, i = {},
            o = Object.keys(e);
        for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || (i[r] = e[r]);
        return i
    }

    function f(e) {
        return e.configure, s(e, d)
    }

    function p() {
        return {
            $$type: "ais.simple",
            stateToRoute: function(e) {
                return Object.keys(e).reduce(function(t, r) {
                    return o(o({}, t), {}, a({}, r, f(e[r])))
                }, {})
            },
            routeToState: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                return Object.keys(e).reduce(function(t, r) {
                    return o(o({}, t), {}, a({}, r, f(e[r])))
                }, {})
            }
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = p;
    var d = ["configure"]
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function s(e) {
        return d(e) || p(e) || f(e) || l()
    }

    function l() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
    }

    function f(e, t) {
        if (e) {
            if ("string" == typeof e) return h(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? h(e, t) : void 0
        }
    }

    function p(e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e)
    }

    function d(e) {
        if (Array.isArray(e)) return h(e)
    }

    function h(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
        return n
    }

    function m(e, t) {
        if (null == e) return {};
        var r, n, i = y(e, t);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
        }
        return i
    }

    function y(e, t) {
        if (null == e) return {};
        var r, n, i = {},
            o = Object.keys(e);
        for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || (i[r] = e[r]);
        return i
    }

    function b(e, t) {
        var r = t.state,
            n = t.isPageReset,
            i = t._uiState;
        r !== e.state && (e.state = r, e.emit("change", {
            state: e.state,
            results: e.lastResults,
            isPageReset: n,
            _uiState: i
        }))
    }

    function v(e, t) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        return e.reduce(function(e, r) {
            return (0, w.isIndexWidget)(r) ? e : r.getWidgetUiState || r.getWidgetState ? r.getWidgetUiState ? r.getWidgetUiState(e, t) : r.getWidgetState(e, t) : e
        }, r)
    }

    function g(e, t) {
        var r = t.initialSearchParameters,
            n = m(t, E);
        return e.filter(function(e) {
            return !(0, w.isIndexWidget)(e)
        }).reduce(function(e, t) {
            return t.getWidgetSearchParameters ? t.getWidgetSearchParameters(e, n) : e
        }, r)
    }

    function _(e) {
        var t = e.filter(w.isIndexWidget);
        0 !== t.length && t.forEach(function(e) {
            var t = e.getHelper();
            b(t, {
                state: t.state.resetPage(),
                isPageReset: !0
            }), _(e.getWidgets())
        })
    }

    function O(e) {
        return e.filter(w.isIndexWidget).reduce(function(e, t) {
            return e.concat.apply(e, [{
                indexId: t.getIndexId(),
                results: t.getResults(),
                helper: t.getHelper()
            }].concat(s(O(t.getWidgets()))))
        }, [])
    }

    function j(e) {
        var t = e.renderState,
            r = e.instantSearchInstance,
            n = e.parent,
            i = n ? n.getIndexId() : r.mainIndex.getIndexId();
        r.renderState = o(o({}, r.renderState), {}, a({}, i, o(o({}, r.renderState[i]), t)))
    }
    var P = r(1);
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var S = P(r(22)),
        w = r(0),
        E = ["initialSearchParameters"],
        R = (0, w.createDocumentationMessageGenerator)({
            name: "index-widget"
        }),
        x = function(e) {
            if (void 0 === e || void 0 === e.indexName) throw new Error(R("The `indexName` option is required."));
            var t = e.indexName,
                r = e.indexId,
                n = void 0 === r ? t : r,
                i = [],
                u = {},
                c = null,
                l = null,
                f = null,
                p = null,
                d = null;
            return {
                $$type: "ais.index",
                $$widgetType: "ais.index",
                getIndexName: function() {
                    return t
                },
                getIndexId: function() {
                    return n
                },
                getHelper: function() {
                    return f
                },
                getResults: function() {
                    var e;
                    return null !== (e = p) && void 0 !== e && e.lastResults ? (p.lastResults._state = f.state, p.lastResults) : null
                },
                getPreviousState: function() {
                    return d
                },
                getScopedResults: function() {
                    var e = this.getParent();
                    return O(e ? e.getWidgets() : [this])
                },
                getParent: function() {
                    return l
                },
                createURL: function(e) {
                    return c._createURL(a({}, n, v(i, {
                        searchParameters: e,
                        helper: f
                    })))
                },
                getWidgets: function() {
                    return i
                },
                addWidgets: function(e) {
                    var t = this;
                    if (!Array.isArray(e)) throw new Error(R("The `addWidgets` method expects an array of widgets."));
                    if (e.some(function(e) {
                            return "function" != typeof e.init && "function" != typeof e.render
                        })) throw new Error(R("The widget definition expects a `render` and/or an `init` method."));
                    return i = i.concat(e), c && Boolean(e.length) && (b(f, {
                        state: g(i, {
                            uiState: u,
                            initialSearchParameters: f.state
                        }),
                        _uiState: u
                    }), e.forEach(function(e) {
                        e.getRenderState && j({
                            renderState: e.getRenderState(c.renderState[t.getIndexId()] || {}, (0, w.createInitArgs)(c, t, c._initialUiState)),
                            instantSearchInstance: c,
                            parent: t
                        })
                    }), e.forEach(function(e) {
                        e.init && e.init((0, w.createInitArgs)(c, t, c._initialUiState))
                    }), c.scheduleSearch()), this
                },
                removeWidgets: function(e) {
                    var t = this;
                    if (!Array.isArray(e)) throw new Error(R("The `removeWidgets` method expects an array of widgets."));
                    if (e.some(function(e) {
                            return "function" != typeof e.dispose
                        })) throw new Error(R("The widget definition expects a `dispose` method."));
                    if (i = i.filter(function(t) {
                            return -1 === e.indexOf(t)
                        }), c && Boolean(e.length)) {
                        var r = e.reduce(function(e, r) {
                            return r.dispose({
                                helper: f,
                                state: e,
                                parent: t
                            }) || e
                        }, f.state);
                        u = v(i, {
                            searchParameters: r,
                            helper: f
                        }), f.setState(g(i, {
                            uiState: u,
                            initialSearchParameters: r
                        })), i.length && c.scheduleSearch()
                    }
                    return this
                },
                init: function(e) {
                    var r, o = this,
                        a = e.instantSearchInstance,
                        h = e.parent,
                        m = e.uiState;
                    if (null === f) {
                        c = a, l = h, u = m[n] || {};
                        var y = a.mainHelper,
                            b = g(i, {
                                uiState: u,
                                initialSearchParameters: new S.default.SearchParameters({
                                    index: t
                                })
                            });
                        f = (0, S.default)({}, b.index, b), f.search = function() {
                            return a.onStateChange ? (a.onStateChange({
                                uiState: a.mainIndex.getWidgetUiState({}),
                                setUiState: function(e) {
                                    return a.setUiState(e, !1)
                                }
                            }), y) : y.search()
                        }, f.searchWithoutTriggeringOnStateChange = function() {
                            return y.search()
                        }, f.searchForFacetValues = function(e, t, r, n) {
                            var i = f.state.setQueryParameters(n);
                            return y.searchForFacetValues(e, t, r, i)
                        }, p = y.derive(function() {
                            return w.mergeSearchParameters.apply(void 0, s((0, w.resolveSearchParameters)(o)))
                        });
                        var O = null === (r = a._initialResults) || void 0 === r ? void 0 : r[this.getIndexId()];
                        if (O) {
                            var P = new S.default.SearchResults(new S.default.SearchParameters(O.state), O.results);
                            p.lastResults = P, f.lastResults = P
                        }
                        f.on("change", function(e) {
                            e.isPageReset && _(i)
                        }), p.on("search", function() {
                            a.scheduleStalledRender()
                        }), p.on("result", function(e) {
                            var t = e.results;
                            a.scheduleRender(), f.lastResults = t, d = null === t || void 0 === t ? void 0 : t._state
                        }), i.forEach(function(e) {
                            e.getRenderState && j({
                                renderState: e.getRenderState(a.renderState[o.getIndexId()] || {}, (0, w.createInitArgs)(a, o, m)),
                                instantSearchInstance: a,
                                parent: o
                            })
                        }), i.forEach(function(e) {
                            e.init && e.init((0, w.createInitArgs)(a, o, m))
                        }), f.on("change", function(e) {
                            var t = e.state,
                                r = e._uiState;
                            u = v(i, {
                                searchParameters: t,
                                helper: f
                            }, r || {}), a.onStateChange || a.onInternalStateChange()
                        }), O && a.scheduleRender()
                    }
                },
                render: function(e) {
                    var t = this,
                        r = e.instantSearchInstance;
                    "error" === r.status && !r.mainHelper.hasPendingRequests() && d && f.setState(d);
                    var n = this.getResults() ? i : i.filter(w.isIndexWidget);
                    n.forEach(function(e) {
                        e.getRenderState && j({
                            renderState: e.getRenderState(r.renderState[t.getIndexId()] || {}, (0, w.createRenderArgs)(r, t)),
                            instantSearchInstance: r,
                            parent: t
                        })
                    }), n.forEach(function(e) {
                        e.render && e.render((0, w.createRenderArgs)(r, t))
                    })
                },
                dispose: function() {
                    var e, t, r = this;
                    i.forEach(function(e) {
                        e.dispose && e.dispose({
                            helper: f,
                            state: f.state,
                            parent: r
                        })
                    }), c = null, l = null, null === (e = f) || void 0 === e || e.removeAllListeners(), f = null, null === (t = p) || void 0 === t || t.detach(), p = null
                },
                getWidgetUiState: function(e) {
                    return i.filter(w.isIndexWidget).reduce(function(e, t) {
                        return t.getWidgetUiState(e)
                    }, o(o({}, e), {}, a({}, n, o(o({}, e[n]), u))))
                },
                getWidgetState: function(e) {
                    return this.getWidgetUiState(e)
                },
                getWidgetSearchParameters: function(e, t) {
                    var r = t.uiState;
                    return g(i, {
                        uiState: r,
                        initialSearchParameters: e
                    })
                },
                refreshUiState: function() {
                    u = v(i, {
                        searchParameters: this.getHelper().state,
                        helper: this.getHelper()
                    }, u)
                },
                setIndexUiState: function(e) {
                    var t = "function" == typeof e ? e(u) : e;
                    c.setUiState(function(e) {
                        return o(o({}, e), {}, a({}, n, t))
                    })
                }
            }
        },
        I = x;
    t.default = I
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function s(e) {
        var t = e.numberLocale;
        return {
            formatNumber: function(e, r) {
                return (0, f.formatNumber)(Number(r(e)), t)
            },
            highlight: function(e, t) {
                try {
                    var r = JSON.parse(e);
                    return t((0, l.highlight)(o(o({}, r), {}, {
                        hit: this
                    })))
                } catch (e) {
                    throw new Error('\nThe highlight helper expects a JSON object of the format:\n{ "attribute": "name", "highlightedTagName": "mark" }')
                }
            },
            reverseHighlight: function(e, t) {
                try {
                    var r = JSON.parse(e);
                    return t((0, l.reverseHighlight)(o(o({}, r), {}, {
                        hit: this
                    })))
                } catch (e) {
                    throw new Error('\n  The reverseHighlight helper expects a JSON object of the format:\n  { "attribute": "name", "highlightedTagName": "mark" }')
                }
            },
            snippet: function(e, t) {
                try {
                    var r = JSON.parse(e);
                    return t((0, l.snippet)(o(o({}, r), {}, {
                        hit: this
                    })))
                } catch (e) {
                    throw new Error('\nThe snippet helper expects a JSON object of the format:\n{ "attribute": "name", "highlightedTagName": "mark" }')
                }
            },
            reverseSnippet: function(e, t) {
                try {
                    var r = JSON.parse(e);
                    return t((0, l.reverseSnippet)(o(o({}, r), {}, {
                        hit: this
                    })))
                } catch (e) {
                    throw new Error('\n  The reverseSnippet helper expects a JSON object of the format:\n  { "attribute": "name", "highlightedTagName": "mark" }')
                }
            },
            insights: function(e, t) {
                try {
                    var r = JSON.parse(e),
                        n = r.method,
                        i = r.payload;
                    return t((0, l.insights)(n, o({
                        objectIDs: [this.objectID]
                    }, i)))
                } catch (e) {
                    throw new Error('\nThe insights helper expects a JSON object of the format:\n{ "method": "method-name", "payload": { "eventName": "name of the event" } }')
                }
            }
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = s;
    var l = r(16),
        f = r(14)
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = r(138);
    Object.keys(n).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === n[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return n[e]
            }
        }))
    });
    var i = r(139);
    Object.keys(i).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === i[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return i[e]
            }
        }))
    });
    var o = r(141);
    Object.keys(o).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === o[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return o[e]
            }
        }))
    });
    var a = r(142);
    Object.keys(a).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === a[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return a[e]
            }
        }))
    });
    var u = r(143);
    Object.keys(u).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === u[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return u[e]
            }
        }))
    });
    var c = r(144);
    Object.keys(c).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === c[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return c[e]
            }
        }))
    });
    var s = r(145);
    Object.keys(s).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === s[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return s[e]
            }
        }))
    });
    var l = r(146);
    Object.keys(l).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === l[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return l[e]
            }
        }))
    });
    var f = r(147);
    Object.keys(f).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === f[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return f[e]
            }
        }))
    });
    var p = r(148);
    Object.keys(p).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === p[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return p[e]
            }
        }))
    });
    var d = r(149);
    Object.keys(d).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === d[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return d[e]
            }
        }))
    });
    var h = r(150);
    Object.keys(h).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === h[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return h[e]
            }
        }))
    });
    var m = r(151);
    Object.keys(m).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === m[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return m[e]
            }
        }))
    });
    var y = r(152);
    Object.keys(y).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === y[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return y[e]
            }
        }))
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = r(140);
    Object.keys(n).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === n[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return n[e]
            }
        }))
    })
}, function(e, t, r) {
    "use strict"
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    var n, i, o = r(1),
        a = o(r(8));
    ! function(o, u) {
        "object" == (0, a.default)(t) && void 0 !== e ? e.exports = u() : (n = u, void 0 !== (i = "function" == typeof n ? n.call(t, r, t, e) : n) && (e.exports = i))
    }(0, function() {
        function e(e, t, r) {
            return t in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r, e
        }

        function t(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                t && (n = n.filter(function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                })), r.push.apply(r, n)
            }
            return r
        }

        function r(r) {
            for (var n = 1; n < arguments.length; n++) {
                var i = null != arguments[n] ? arguments[n] : {};
                n % 2 ? t(Object(i), !0).forEach(function(t) {
                    e(r, t, i[t])
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(i)) : t(Object(i)).forEach(function(e) {
                    Object.defineProperty(r, e, Object.getOwnPropertyDescriptor(i, e))
                })
            }
            return r
        }

        function n(e, t) {
            if (null == e) return {};
            var r, n, i = function(e, t) {
                if (null == e) return {};
                var r, n, i = {},
                    o = Object.keys(e);
                for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || (i[r] = e[r]);
                return i
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
            }
            return i
        }

        function i(e, t) {
            return function(e) {
                if (Array.isArray(e)) return e
            }(e) || function(e, t) {
                if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) {
                    var r = [],
                        n = !0,
                        i = !1,
                        o = void 0;
                    try {
                        for (var a, u = e[Symbol.iterator](); !(n = (a = u.next()).done) && (r.push(a.value), !t || r.length !== t); n = !0);
                    } catch (e) {
                        i = !0, o = e
                    } finally {
                        try {
                            n || null == u.return || u.return()
                        } finally {
                            if (i) throw o
                        }
                    }
                    return r
                }
            }(e, t) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance")
            }()
        }

        function o(e) {
            return function(e) {
                if (Array.isArray(e)) {
                    for (var t = 0, r = new Array(e.length); t < e.length; t++) r[t] = e[t];
                    return r
                }
            }(e) || function(e) {
                if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e)
            }(e) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance")
            }()
        }

        function a(e) {
            var t, r = "algoliasearch-client-js-".concat(e.key),
                n = function() {
                    return void 0 === t && (t = e.localStorage || window.localStorage), t
                },
                o = function() {
                    return JSON.parse(n().getItem(r) || "{}")
                };
            return {
                get: function(e, t) {
                    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                        miss: function() {
                            return Promise.resolve()
                        }
                    };
                    return Promise.resolve().then(function() {
                        var r = JSON.stringify(e),
                            n = o()[r];
                        return Promise.all([n || t(), void 0 !== n])
                    }).then(function(e) {
                        var t = i(e, 2),
                            n = t[0],
                            o = t[1];
                        return Promise.all([n, o || r.miss(n)])
                    }).then(function(e) {
                        return i(e, 1)[0]
                    })
                },
                set: function(e, t) {
                    return Promise.resolve().then(function() {
                        var i = o();
                        return i[JSON.stringify(e)] = t, n().setItem(r, JSON.stringify(i)), t
                    })
                },
                delete: function(e) {
                    return Promise.resolve().then(function() {
                        var t = o();
                        delete t[JSON.stringify(e)], n().setItem(r, JSON.stringify(t))
                    })
                },
                clear: function() {
                    return Promise.resolve().then(function() {
                        n().removeItem(r)
                    })
                }
            }
        }

        function u(e) {
            var t = o(e.caches),
                r = t.shift();
            return void 0 === r ? {
                get: function(e, t) {
                    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                        miss: function() {
                            return Promise.resolve()
                        }
                    };
                    return t().then(function(e) {
                        return Promise.all([e, r.miss(e)])
                    }).then(function(e) {
                        return i(e, 1)[0]
                    })
                },
                set: function(e, t) {
                    return Promise.resolve(t)
                },
                delete: function(e) {
                    return Promise.resolve()
                },
                clear: function() {
                    return Promise.resolve()
                }
            } : {
                get: function(e, n) {
                    var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                        miss: function() {
                            return Promise.resolve()
                        }
                    };
                    return r.get(e, n, i).catch(function() {
                        return u({
                            caches: t
                        }).get(e, n, i)
                    })
                },
                set: function(e, n) {
                    return r.set(e, n).catch(function() {
                        return u({
                            caches: t
                        }).set(e, n)
                    })
                },
                delete: function(e) {
                    return r.delete(e).catch(function() {
                        return u({
                            caches: t
                        }).delete(e)
                    })
                },
                clear: function() {
                    return r.clear().catch(function() {
                        return u({
                            caches: t
                        }).clear()
                    })
                }
            }
        }

        function c() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
                    serializable: !0
                },
                t = {};
            return {
                get: function(r, n) {
                    var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                            miss: function() {
                                return Promise.resolve()
                            }
                        },
                        o = JSON.stringify(r);
                    if (o in t) return Promise.resolve(e.serializable ? JSON.parse(t[o]) : t[o]);
                    var a = n(),
                        u = i && i.miss || function() {
                            return Promise.resolve()
                        };
                    return a.then(function(e) {
                        return u(e)
                    }).then(function() {
                        return a
                    })
                },
                set: function(r, n) {
                    return t[JSON.stringify(r)] = e.serializable ? JSON.stringify(n) : n, Promise.resolve(n)
                },
                delete: function(e) {
                    return delete t[JSON.stringify(e)], Promise.resolve()
                },
                clear: function() {
                    return t = {}, Promise.resolve()
                }
            }
        }

        function s(e) {
            for (var t = e.length - 1; t > 0; t--) {
                var r = Math.floor(Math.random() * (t + 1)),
                    n = e[t];
                e[t] = e[r], e[r] = n
            }
            return e
        }

        function l(e, t) {
            return t ? (Object.keys(t).forEach(function(r) {
                e[r] = t[r](e)
            }), e) : e
        }

        function f(e) {
            for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) r[n - 1] = arguments[n];
            var i = 0;
            return e.replace(/%s/g, function() {
                return encodeURIComponent(r[i++])
            })
        }

        function p(e, t) {
            var r = e || {},
                n = r.data || {};
            return Object.keys(r).forEach(function(e) {
                -1 === ["timeout", "headers", "queryParameters", "data", "cacheable"].indexOf(e) && (n[e] = r[e])
            }), {
                data: Object.entries(n).length > 0 ? n : void 0,
                timeout: r.timeout || t,
                headers: r.headers || {},
                queryParameters: r.queryParameters || {},
                cacheable: r.cacheable
            }
        }

        function d(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : w;
            return r(r({}, e), {}, {
                status: t,
                lastUpdate: Date.now()
            })
        }

        function h(e) {
            return "string" == typeof e ? {
                protocol: "https",
                url: e,
                accept: S.Any
            } : {
                protocol: e.protocol || "https",
                url: e.url,
                accept: e.accept || S.Any
            }
        }

        function m(e, t) {
            return Promise.all(t.map(function(t) {
                return e.get(t, function() {
                    return Promise.resolve(d(t))
                })
            })).then(function(e) {
                var r = e.filter(function(e) {
                        return function(e) {
                            return e.status === w || Date.now() - e.lastUpdate > 12e4
                        }(e)
                    }),
                    n = e.filter(function(e) {
                        return function(e) {
                            return e.status === R && Date.now() - e.lastUpdate <= 12e4
                        }(e)
                    }),
                    i = [].concat(o(r), o(n));
                return {
                    getTimeout: function(e, t) {
                        return (0 === n.length && 0 === e ? 1 : n.length + 3 + e) * t
                    },
                    statelessHosts: i.length > 0 ? i.map(function(e) {
                        return h(e)
                    }) : t
                }
            })
        }

        function y(e, t, n, i) {
            var a = [],
                u = function(e, t) {
                    if (e.method !== x && (void 0 !== e.data || void 0 !== t.data)) {
                        var n = Array.isArray(e.data) ? e.data : r(r({}, e.data), t.data);
                        return JSON.stringify(n)
                    }
                }(n, i),
                c = function(e, t) {
                    var n = r(r({}, e.headers), t.headers),
                        i = {};
                    return Object.keys(n).forEach(function(e) {
                        var t = n[e];
                        i[e.toLowerCase()] = t
                    }), i
                }(e, i),
                s = n.method,
                l = n.method !== x ? {} : r(r({}, n.data), i.data),
                f = r(r(r({
                    "x-algolia-agent": e.userAgent.value
                }, e.queryParameters), l), i.queryParameters),
                p = 0,
                h = function t(r, o) {
                    var l = r.pop();
                    if (void 0 === l) throw {
                        name: "RetryError",
                        message: "Unreachable hosts - your application id may be incorrect. If the error persists, contact support@algolia.com.",
                        transporterStackTrace: _(a)
                    };
                    var h = {
                            data: u,
                            headers: c,
                            method: s,
                            url: v(l, n.path, f),
                            connectTimeout: o(p, e.timeouts.connect),
                            responseTimeout: o(p, i.timeout)
                        },
                        m = function(e) {
                            var t = {
                                request: h,
                                response: e,
                                host: l,
                                triesLeft: r.length
                            };
                            return a.push(t), t
                        },
                        y = {
                            onSuccess: function(e) {
                                return function(e) {
                                    try {
                                        return JSON.parse(e.content)
                                    } catch (t) {
                                        throw function(e, t) {
                                            return {
                                                name: "DeserializationError",
                                                message: e,
                                                response: t
                                            }
                                        }(t.message, e)
                                    }
                                }(e)
                            },
                            onRetry: function(n) {
                                var i = m(n);
                                return n.isTimedOut && p++, Promise.all([e.logger.info("Retryable failure", O(i)), e.hostsCache.set(l, d(l, n.isTimedOut ? R : E))]).then(function() {
                                    return t(r, o)
                                })
                            },
                            onFail: function(e) {
                                throw m(e),
                                    function(e, t) {
                                        var r = e.content,
                                            n = e.status,
                                            i = r;
                                        try {
                                            i = JSON.parse(r).message
                                        } catch (e) {}
                                        return function(e, t, r) {
                                            return {
                                                name: "ApiError",
                                                message: e,
                                                status: t,
                                                transporterStackTrace: r
                                            }
                                        }(i, n, t)
                                    }(e, _(a))
                            }
                        };
                    return e.requester.send(h).then(function(e) {
                        return function(e, t) {
                            return function(e) {
                                var t = e.status;
                                return e.isTimedOut || function(e) {
                                    var t = e.isTimedOut,
                                        r = e.status;
                                    return !t && 0 == ~~r
                                }(e) || 2 != ~~(t / 100) && 4 != ~~(t / 100)
                            }(e) ? t.onRetry(e) : 2 == ~~(e.status / 100) ? t.onSuccess(e) : t.onFail(e)
                        }(e, y)
                    })
                };
            return m(e.hostsCache, t).then(function(e) {
                return h(o(e.statelessHosts).reverse(), e.getTimeout)
            })
        }

        function b(e) {
            var t = {
                value: "Algolia for JavaScript (".concat(e, ")"),
                add: function(e) {
                    var r = "; ".concat(e.segment).concat(void 0 !== e.version ? " (".concat(e.version, ")") : "");
                    return -1 === t.value.indexOf(r) && (t.value = "".concat(t.value).concat(r)), t
                }
            };
            return t
        }

        function v(e, t, r) {
            var n = g(r),
                i = "".concat(e.protocol, "://").concat(e.url, "/").concat("/" === t.charAt(0) ? t.substr(1) : t);
            return n.length && (i += "?".concat(n)), i
        }

        function g(e) {
            return Object.keys(e).map(function(t) {
                return f("%s=%s", t, (r = e[t], "[object Object]" === Object.prototype.toString.call(r) || "[object Array]" === Object.prototype.toString.call(r) ? JSON.stringify(e[t]) : e[t]));
                var r
            }).join("&")
        }

        function _(e) {
            return e.map(function(e) {
                return O(e)
            })
        }

        function O(e) {
            var t = e.request.headers["x-algolia-api-key"] ? {
                "x-algolia-api-key": "*****"
            } : {};
            return r(r({}, e), {}, {
                request: r(r({}, e.request), {}, {
                    headers: r(r({}, e.request.headers), t)
                })
            })
        }

        function j(e, t, n) {
            var i, o = {
                appId: e,
                apiKey: t,
                timeouts: {
                    connect: 1,
                    read: 2,
                    write: 30
                },
                requester: {
                    send: function(e) {
                        return new Promise(function(t) {
                            var r = new XMLHttpRequest;
                            r.open(e.method, e.url, !0), Object.keys(e.headers).forEach(function(t) {
                                return r.setRequestHeader(t, e.headers[t])
                            });
                            var n, i = function(e, n) {
                                    return setTimeout(function() {
                                        r.abort(), t({
                                            status: 0,
                                            content: n,
                                            isTimedOut: !0
                                        })
                                    }, 1e3 * e)
                                },
                                o = i(e.connectTimeout, "Connection timeout");
                            r.onreadystatechange = function() {
                                r.readyState > r.OPENED && void 0 === n && (clearTimeout(o), n = i(e.responseTimeout, "Socket timeout"))
                            }, r.onerror = function() {
                                0 === r.status && (clearTimeout(o), clearTimeout(n), t({
                                    content: r.responseText || "Network request failed",
                                    status: r.status,
                                    isTimedOut: !1
                                }))
                            }, r.onload = function() {
                                clearTimeout(o), clearTimeout(n), t({
                                    content: r.responseText,
                                    status: r.status,
                                    isTimedOut: !1
                                })
                            }, r.send(e.data)
                        })
                    }
                },
                logger: (i = q, {
                    debug: function(e, t) {
                        return H >= i && console.debug(e, t), Promise.resolve()
                    },
                    info: function(e, t) {
                        return L >= i && console.info(e, t), Promise.resolve()
                    },
                    error: function(e, t) {
                        return console.error(e, t), Promise.resolve()
                    }
                }),
                responsesCache: c(),
                requestsCache: c({
                    serializable: !1
                }),
                hostsCache: u({
                    caches: [a({
                        key: "".concat("4.17.0", "-").concat(e)
                    }), c()]
                }),
                userAgent: b("4.17.0").add({
                    segment: "Browser",
                    version: "lite"
                }),
                authMode: P.WithinQueryParameters
            };
            return k(r(r(r({}, o), n), {}, {
                methods: {
                    search: N,
                    searchForFacetValues: C,
                    multipleQueries: N,
                    multipleSearchForFacetValues: C,
                    customRequest: M,
                    initIndex: function(e) {
                        return function(t) {
                            return A(e)(t, {
                                methods: {
                                    search: F,
                                    searchForFacetValues: D,
                                    findAnswers: T
                                }
                            })
                        }
                    }
                }
            }))
        }
        var P = {
                WithinQueryParameters: 0,
                WithinHeaders: 1
            },
            S = {
                Read: 1,
                Write: 2,
                Any: 3
            },
            w = 1,
            E = 2,
            R = 3,
            x = "GET",
            I = "POST",
            k = function(e) {
                var t = e.appId,
                    n = function(e, t, r) {
                        var n = {
                            "x-algolia-api-key": r,
                            "x-algolia-application-id": t
                        };
                        return {
                            headers: function() {
                                return e === P.WithinHeaders ? n : {}
                            },
                            queryParameters: function() {
                                return e === P.WithinQueryParameters ? n : {}
                            }
                        }
                    }(void 0 !== e.authMode ? e.authMode : P.WithinHeaders, t, e.apiKey),
                    o = function(e) {
                        var t = e.hostsCache,
                            r = e.logger,
                            n = e.requester,
                            o = e.requestsCache,
                            a = e.responsesCache,
                            u = e.timeouts,
                            c = e.userAgent,
                            s = e.hosts,
                            l = e.queryParameters,
                            f = {
                                hostsCache: t,
                                logger: r,
                                requester: n,
                                requestsCache: o,
                                responsesCache: a,
                                timeouts: u,
                                userAgent: c,
                                headers: e.headers,
                                queryParameters: l,
                                hosts: s.map(function(e) {
                                    return h(e)
                                }),
                                read: function(e, t) {
                                    var r = p(t, f.timeouts.read),
                                        n = function() {
                                            return y(f, f.hosts.filter(function(e) {
                                                return 0 != (e.accept & S.Read)
                                            }), e, r)
                                        };
                                    if (!0 !== (void 0 !== r.cacheable ? r.cacheable : e.cacheable)) return n();
                                    var o = {
                                        request: e,
                                        mappedRequestOptions: r,
                                        transporter: {
                                            queryParameters: f.queryParameters,
                                            headers: f.headers
                                        }
                                    };
                                    return f.responsesCache.get(o, function() {
                                        return f.requestsCache.get(o, function() {
                                            return f.requestsCache.set(o, n()).then(function(e) {
                                                return Promise.all([f.requestsCache.delete(o), e])
                                            }, function(e) {
                                                return Promise.all([f.requestsCache.delete(o), Promise.reject(e)])
                                            }).then(function(e) {
                                                var t = i(e, 2);
                                                return t[0], t[1]
                                            })
                                        })
                                    }, {
                                        miss: function(e) {
                                            return f.responsesCache.set(o, e)
                                        }
                                    })
                                },
                                write: function(e, t) {
                                    return y(f, f.hosts.filter(function(e) {
                                        return 0 != (e.accept & S.Write)
                                    }), e, p(t, f.timeouts.write))
                                }
                            };
                        return f
                    }(r(r({
                        hosts: [{
                            url: "".concat(t, "-dsn.algolia.net"),
                            accept: S.Read
                        }, {
                            url: "".concat(t, ".algolia.net"),
                            accept: S.Write
                        }].concat(s([{
                            url: "".concat(t, "-1.algolianet.com")
                        }, {
                            url: "".concat(t, "-2.algolianet.com")
                        }, {
                            url: "".concat(t, "-3.algolianet.com")
                        }]))
                    }, e), {}, {
                        headers: r(r(r({}, n.headers()), {
                            "content-type": "application/x-www-form-urlencoded"
                        }), e.headers),
                        queryParameters: r(r({}, n.queryParameters()), e.queryParameters)
                    }));
                return l({
                    transporter: o,
                    appId: t,
                    addAlgoliaAgent: function(e, t) {
                        o.userAgent.add({
                            segment: e,
                            version: t
                        })
                    },
                    clearCache: function() {
                        return Promise.all([o.requestsCache.clear(), o.responsesCache.clear()]).then(function() {})
                    }
                }, e.methods)
            },
            M = function(e) {
                return function(t, r) {
                    return t.method === x ? e.transporter.read(t, r) : e.transporter.write(t, r)
                }
            },
            A = function(e) {
                return function(t) {
                    var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    return l({
                        transporter: e.transporter,
                        appId: e.appId,
                        indexName: t
                    }, r.methods)
                }
            },
            N = function(e) {
                return function(t, n) {
                    var i = t.map(function(e) {
                        return r(r({}, e), {}, {
                            params: g(e.params || {})
                        })
                    });
                    return e.transporter.read({
                        method: I,
                        path: "1/indexes/*/queries",
                        data: {
                            requests: i
                        },
                        cacheable: !0
                    }, n)
                }
            },
            C = function(e) {
                return function(t, i) {
                    return Promise.all(t.map(function(t) {
                        var o = t.params,
                            a = o.facetName,
                            u = o.facetQuery,
                            c = n(o, ["facetName", "facetQuery"]);
                        return A(e)(t.indexName, {
                            methods: {
                                searchForFacetValues: D
                            }
                        }).searchForFacetValues(a, u, r(r({}, i), c))
                    }))
                }
            },
            T = function(e) {
                return function(t, r, n) {
                    return e.transporter.read({
                        method: I,
                        path: f("1/answers/%s/prediction", e.indexName),
                        data: {
                            query: t,
                            queryLanguages: r
                        },
                        cacheable: !0
                    }, n)
                }
            },
            F = function(e) {
                return function(t, r) {
                    return e.transporter.read({
                        method: I,
                        path: f("1/indexes/%s/query", e.indexName),
                        data: {
                            query: t
                        },
                        cacheable: !0
                    }, r)
                }
            },
            D = function(e) {
                return function(t, r, n) {
                    return e.transporter.read({
                        method: I,
                        path: f("1/indexes/%s/facets/%s/query", e.indexName, t),
                        data: {
                            facetQuery: r
                        },
                        cacheable: !0
                    }, n)
                }
            },
            H = 1,
            L = 2,
            q = 3;
        return j.version = "4.17.0", j
    })
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        if (null == e) return {};
        var r, n, i = o(e, t);
        if (Object.getOwnPropertySymbols) {
            var a = Object.getOwnPropertySymbols(e);
            for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
        }
        return i
    }

    function o(e, t) {
        if (null == e) return {};
        var r, n, i = {},
            o = Object.keys(e);
        for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || (i[r] = e[r]);
        return i
    }

    function a(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function u(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? a(Object(r), !0).forEach(function(t) {
                c(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : a(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function c(e, t, r) {
        return t = s(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function s(e) {
        var t = l(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function l(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function f(e) {
        function t() {
            (0, P.setProperties)(L.value.panel, {
                style: N.value ? {} : (0, _.getPanelPlacementStyle)({
                    panelPlacement: A.value.renderer.panelPlacement,
                    container: L.value.root,
                    form: L.value.form,
                    environment: A.value.core.environment
                })
            })
        }

        function r(e) {
            T.current = e;
            var t = {
                    autocomplete: C.value,
                    autocompleteScopeApi: D,
                    classNames: A.value.renderer.classNames,
                    components: A.value.renderer.components,
                    container: A.value.renderer.container,
                    html: H.value,
                    dom: L.value,
                    panelContainer: N.value ? L.value.detachedContainer : A.value.renderer.panelContainer,
                    propGetters: F,
                    state: T.current,
                    renderer: A.value.renderer.renderer
                },
                r = !(0, h.getItemsCount)(e) && !I.current && A.value.renderer.renderNoResults || A.value.renderer.render;
            (0, O.renderSearchBox)(t), (0, O.renderPanel)(r, t)
        }

        function n() {
            w--, f()
        }

        function o() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            f();
            var t = A.value.renderer,
                n = t.components,
                o = i(t, S);
            k.current = (0, P.mergeDeep)(o, A.value.core, {
                components: (0, P.pickBy)(n, function(e) {
                    return !e.value.hasOwnProperty("__autocomplete_componentName")
                }),
                initialState: T.current
            }, e), x(), p(), C.value.refresh().then(function() {
                r(T.current)
            })
        }

        function a(e) {
            requestAnimationFrame(function() {
                var t = A.value.core.environment.document.body.contains(L.value.detachedOverlay);
                e !== t && (e ? (A.value.core.environment.document.body.appendChild(L.value.detachedOverlay), A.value.core.environment.document.body.classList.add("aa-Detached"), L.value.input.focus()) : (A.value.core.environment.document.body.removeChild(L.value.detachedOverlay), A.value.core.environment.document.body.classList.remove("aa-Detached")))
            })
        }
        var s = (0, b.createEffectWrapper)(),
            l = s.runEffect,
            f = s.cleanupEffects,
            p = s.runEffects,
            E = (0, v.createReactiveWrapper)(),
            R = E.reactive,
            x = E.runReactives,
            I = (0, h.createRef)(!1),
            k = (0, h.createRef)(e),
            M = (0, h.createRef)(void 0),
            A = R(function() {
                return (0, g.getDefaultOptions)(k.current)
            }),
            N = R(function() {
                return A.value.core.environment.matchMedia(A.value.renderer.detachedMediaQuery).matches
            }),
            C = R(function() {
                return (0, d.createAutocomplete)(u(u({}, A.value.core), {}, {
                    onStateChange: function(e) {
                        var t, r, n;
                        I.current = e.state.collections.some(function(e) {
                            return e.source.templates.noResults
                        }), null === (t = M.current) || void 0 === t || t.call(M, e), null === (r = (n = A.value.core).onStateChange) || void 0 === r || r.call(n, e)
                    },
                    shouldPanelOpen: k.current.shouldPanelOpen || function(e) {
                        var t = e.state;
                        if (N.value) return !0;
                        var r = (0, h.getItemsCount)(t) > 0;
                        if (!A.value.core.openOnFocus && !t.query) return r;
                        var n = Boolean(I.current || A.value.renderer.renderNoResults);
                        return !r && n || r
                    },
                    __autocomplete_metadata: {
                        userAgents: j.userAgents,
                        options: e
                    }
                }))
            }),
            T = (0, h.createRef)(u({
                collections: [],
                completion: null,
                context: {},
                isOpen: !1,
                query: "",
                activeItemId: null,
                status: "idle"
            }, A.value.core.initialState)),
            F = {
                getEnvironmentProps: A.value.renderer.getEnvironmentProps,
                getFormProps: A.value.renderer.getFormProps,
                getInputProps: A.value.renderer.getInputProps,
                getItemProps: A.value.renderer.getItemProps,
                getLabelProps: A.value.renderer.getLabelProps,
                getListProps: A.value.renderer.getListProps,
                getPanelProps: A.value.renderer.getPanelProps,
                getRootProps: A.value.renderer.getRootProps
            },
            D = {
                setActiveItemId: C.value.setActiveItemId,
                setQuery: C.value.setQuery,
                setCollections: C.value.setCollections,
                setIsOpen: C.value.setIsOpen,
                setStatus: C.value.setStatus,
                setContext: C.value.setContext,
                refresh: C.value.refresh,
                navigator: C.value.navigator
            },
            H = R(function() {
                return m.default.bind(A.value.renderer.renderer.createElement)
            }),
            L = R(function() {
                return (0, y.createAutocompleteDom)({
                    autocomplete: C.value,
                    autocompleteScopeApi: D,
                    classNames: A.value.renderer.classNames,
                    environment: A.value.core.environment,
                    isDetached: N.value,
                    placeholder: A.value.core.placeholder,
                    propGetters: F,
                    setIsModalOpen: a,
                    state: T.current,
                    translations: A.value.renderer.translations
                })
            });
        return l(function() {
            var e = C.value.getEnvironmentProps({
                formElement: L.value.form,
                panelElement: L.value.panel,
                inputElement: L.value.input
            });
            return (0, P.setProperties)(A.value.core.environment, e),
                function() {
                    (0, P.setProperties)(A.value.core.environment, Object.keys(e).reduce(function(e, t) {
                        return u(u({}, e), {}, c({}, t, void 0))
                    }, {}))
                }
        }), l(function() {
            var e = N.value ? A.value.core.environment.document.body : A.value.renderer.panelContainer,
                t = N.value ? L.value.detachedOverlay : L.value.panel;
            return N.value && T.current.isOpen && a(!0), r(T.current),
                function() {
                    e.contains(t) && e.removeChild(t)
                }
        }), l(function() {
            var e = A.value.renderer.container;
            return e.appendChild(L.value.root),
                function() {
                    e.removeChild(L.value.root)
                }
        }), l(function() {
            var e = (0, h.debounce)(function(e) {
                r(e.state)
            }, 0);
            return M.current = function(r) {
                    var n = r.state,
                        i = r.prevState;
                    N.value && i.isOpen !== n.isOpen && a(n.isOpen), N.value || !n.isOpen || i.isOpen || t(), n.query !== i.query && A.value.core.environment.document.querySelectorAll(".aa-Panel--scrollable").forEach(function(e) {
                        0 !== e.scrollTop && (e.scrollTop = 0)
                    }), e({
                        state: n
                    })
                },
                function() {
                    M.current = void 0
                }
        }), l(function() {
            var e = (0, h.debounce)(function() {
                var e = N.value;
                N.value = A.value.core.environment.matchMedia(A.value.renderer.detachedMediaQuery).matches, e !== N.value ? o({}) : requestAnimationFrame(t)
            }, 20);
            return A.value.core.environment.addEventListener("resize", e),
                function() {
                    A.value.core.environment.removeEventListener("resize", e)
                }
        }), l(function() {
            function e(e) {
                L.value.detachedContainer.classList.toggle("aa-DetachedContainer--modal", e)
            }

            function t(t) {
                e(t.matches)
            }
            if (!N.value) return function() {};
            var r = A.value.core.environment.matchMedia(getComputedStyle(A.value.core.environment.document.documentElement).getPropertyValue("--aa-detached-modal-media-query"));
            e(r.matches);
            var n = Boolean(r.addEventListener);
            return n ? r.addEventListener("change", t) : r.addListener(t),
                function() {
                    n ? r.removeEventListener("change", t) : r.removeListener(t)
                }
        }), l(function() {
            return requestAnimationFrame(t),
                function() {}
        }), w++, u(u({}, D), {}, {
            update: o,
            destroy: n
        })
    }
    var p = r(1);
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.autocomplete = f;
    var d = r(155),
        h = r(4),
        m = p(r(56)),
        y = r(230),
        b = r(241),
        v = r(242),
        g = r(243),
        _ = r(265),
        O = r(266),
        j = r(66),
        P = r(9),
        S = ["components"],
        w = 0
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = r(156);
    Object.keys(n).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === n[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return n[e]
            }
        }))
    });
    var i = r(55);
    Object.keys(i).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === i[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return i[e]
            }
        }))
    });
    var o = r(215);
    Object.keys(o).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === o[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return o[e]
            }
        }))
    })
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function s(e) {
        function t(e) {
            var t = e.prevState,
                n = e.state;
            i.onStateChange(o({
                prevState: t,
                state: n,
                refresh: r,
                navigator: i.navigator
            }, u))
        }

        function r() {
            return (0, b.onInput)(o({
                event: new Event("input"),
                nextState: {
                    isOpen: a.getState().isOpen
                },
                props: i,
                navigator: i.navigator,
                query: a.getState().query,
                refresh: r,
                store: a
            }, u))
        }(0, f.checkOptions)(e);
        var n = [],
            i = (0, h.getDefaultProps)(e, n),
            a = (0, p.createStore)(v.stateReducer, i, t),
            u = (0, d.getAutocompleteSetters)({
                store: a
            }),
            c = (0, m.getPropGetters)(o({
                props: i,
                refresh: r,
                store: a,
                navigator: i.navigator
            }, u));
        if (e.insights && !i.plugins.some(function(e) {
                return "aa.algoliaInsightsPlugin" === e.name
            })) {
            var s = "boolean" == typeof e.insights ? {} : e.insights;
            i.plugins.push((0, l.createAlgoliaInsightsPlugin)(s))
        }
        return i.plugins.forEach(function(e) {
            var t;
            return null === (t = e.subscribe) || void 0 === t ? void 0 : t.call(e, o(o({}, u), {}, {
                navigator: i.navigator,
                refresh: r,
                onSelect: function(e) {
                    n.push({
                        onSelect: e
                    })
                },
                onActive: function(e) {
                    n.push({
                        onActive: e
                    })
                },
                onResolve: function(e) {
                    n.push({
                        onResolve: e
                    })
                }
            }))
        }), (0, y.injectMetadata)({
            metadata: (0, y.getMetadata)({
                plugins: i.plugins,
                options: e
            }),
            environment: i.environment
        }), o(o({
            refresh: r,
            navigator: i.navigator
        }, c), u)
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.createAutocomplete = s;
    var l = r(157),
        f = r(196),
        p = r(197),
        d = r(207),
        h = r(55),
        m = r(208),
        y = r(212),
        b = r(28),
        v = r(213)
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = r(158);
    Object.keys(n).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === n[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return n[e]
            }
        }))
    });
    var i = r(163);
    Object.keys(i).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === i[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return i[e]
            }
        }))
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = r(159);
    Object.keys(n).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === n[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return n[e]
            }
        }))
    });
    var i = r(160);
    Object.keys(i).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === i[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return i[e]
            }
        }))
    });
    var o = r(161);
    Object.keys(o).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === o[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return o[e]
            }
        }))
    });
    var a = r(162);
    Object.keys(a).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === a[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return a[e]
            }
        }))
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e) {
        return c(e) || u(e) || a(e) || o()
    }

    function o() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
    }

    function a(e, t) {
        if (e) {
            if ("string" == typeof e) return s(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? s(e, t) : void 0
        }
    }

    function u(e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e)
    }

    function c(e) {
        if (Array.isArray(e)) return s(e)
    }

    function s(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
        return n
    }

    function l(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function f(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? l(Object(r), !0).forEach(function(t) {
                p(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : l(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function p(e, t, r) {
        return t = d(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function d(e) {
        var t = h(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function h(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function m(e) {
        var t = y(e),
            r = t.insightsClient,
            n = t.onItemsChange,
            o = t.onSelect,
            a = t.onActive,
            u = r;
        r || (0, v.safelyRunOnBrowser)(function(e) {
            var t = e.window,
                r = t.AlgoliaAnalyticsObject || "aa";
            "string" == typeof r && (u = t[r]), u || (t.AlgoliaAnalyticsObject = r, t[r] || (t[r] = function() {
                t[r].queue || (t[r].queue = []);
                for (var e = arguments.length, n = new Array(e), i = 0; i < e; i++) n[i] = arguments[i];
                t[r].queue.push(n)
            }), t[r].version = P, u = t[r], b(t))
        });
        var c = (0, _.createSearchInsightsApi)(u),
            s = (0, v.createRef)([]),
            l = (0, v.debounce)(function(e) {
                var t = e.state;
                if (t.isOpen) {
                    var r = t.collections.reduce(function(e, t) {
                        return [].concat(i(e), i(t.items))
                    }, []).filter(j.isAlgoliaInsightsHit);
                    (0, v.isEqual)(s.current.map(function(e) {
                        return e.objectID
                    }), r.map(function(e) {
                        return e.objectID
                    })) || (s.current = r, r.length > 0 && w({
                        onItemsChange: n,
                        items: r,
                        insights: c,
                        state: t
                    }))
                }
            }, 0);
        return {
            name: "aa.algoliaInsightsPlugin",
            subscribe: function(e) {
                var t = e.setContext,
                    r = e.onSelect,
                    n = e.onActive;
                u("addAlgoliaAgent", "insights-plugin"), t({
                    algoliaInsightsPlugin: {
                        __algoliaSearchParameters: {
                            clickAnalytics: !0
                        },
                        insights: c
                    }
                }), r(function(e) {
                    var t = e.item,
                        r = e.state,
                        n = e.event,
                        i = e.source;
                    (0, j.isAlgoliaInsightsHit)(t) && o({
                        state: r,
                        event: n,
                        insights: c,
                        item: t,
                        insightsEvents: [f({
                            eventName: "Item Selected"
                        }, (0, g.createClickedEvent)({
                            item: t,
                            items: i.getItems().filter(j.isAlgoliaInsightsHit)
                        }))]
                    })
                }), n(function(e) {
                    var t = e.item,
                        r = e.source,
                        n = e.state,
                        i = e.event;
                    (0, j.isAlgoliaInsightsHit)(t) && a({
                        state: n,
                        event: i,
                        insights: c,
                        item: t,
                        insightsEvents: [f({
                            eventName: "Item Active"
                        }, (0, g.createClickedEvent)({
                            item: t,
                            items: r.getItems().filter(j.isAlgoliaInsightsHit)
                        }))]
                    })
                })
            },
            onStateChange: function(e) {
                var t = e.state;
                l({
                    state: t
                })
            },
            __autocomplete_pluginOptions: e
        }
    }

    function y(e) {
        return f({
            onItemsChange: function(e) {
                var t = e.insights,
                    r = e.insightsEvents;
                t.viewedObjectIDs.apply(t, i(r.map(function(e) {
                    return f(f({}, e), {}, {
                        algoliaSource: [].concat(i(e.algoliaSource || []), ["autocomplete-internal"])
                    })
                })))
            },
            onSelect: function(e) {
                var t = e.insights,
                    r = e.insightsEvents;
                t.clickedObjectIDsAfterSearch.apply(t, i(r.map(function(e) {
                    return f(f({}, e), {}, {
                        algoliaSource: [].concat(i(e.algoliaSource || []), ["autocomplete-internal"])
                    })
                })))
            },
            onActive: v.noop
        }, e)
    }

    function b(e) {
        var t = "[Autocomplete]: Could not load search-insights.js. Please load it manually following https://alg.li/insights-autocomplete";
        try {
            var r = e.document.createElement("script");
            r.async = !0, r.src = S, r.onerror = function() {
                console.error(t)
            }, document.body.appendChild(r)
        } catch (e) {
            console.error(t)
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.createAlgoliaInsightsPlugin = m;
    var v = r(4),
        g = r(191),
        _ = r(192),
        O = r(194),
        j = r(195),
        P = "2.6.0",
        S = "https://cdn.jsdelivr.net/npm/search-insights@".concat(P, "/dist/search-insights.min.js"),
        w = (0, v.debounce)(function(e) {
            var t = e.onItemsChange,
                r = e.items,
                n = e.insights,
                i = e.state;
            t({
                insights: n,
                insightsEvents: (0, O.createViewedEvents)({
                    items: r
                }).map(function(e) {
                    return f({
                        eventName: "Items Viewed"
                    }, e)
                }),
                state: i
            })
        }, 400)
}, function(e, t, r) {
    "use strict";

    function n(e) {
        return {
            current: e
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.createRef = n
}, function(e, t, r) {
    "use strict";

    function n(e, t) {
        var r = void 0;
        return function() {
            for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++) i[o] = arguments[o];
            r && clearTimeout(r), r = setTimeout(function() {
                return e.apply(void 0, i)
            }, t)
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.debounce = n
}, function(e, t, r) {
    "use strict";

    function n(e) {
        return arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Set, e
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.decycle = n
}, function(e, t, r) {
    "use strict";

    function n(e) {
        return e.reduce(function(e, t) {
            return e.concat(t)
        }, [])
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.flatten = n
}, function(e, t, r) {
    "use strict";

    function n() {
        return "autocomplete-".concat(i++)
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.generateAutocompleteId = n;
    var i = 0
}, function(e, t, r) {
    "use strict";

    function n(e, t) {
        return t.reduce(function(e, t) {
            return e && e[t]
        }, e)
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.getAttributeValueByPath = n
}, function(e, t, r) {
    "use strict";

    function n(e) {
        return 0 === e.collections.length ? 0 : e.collections.reduce(function(e, t) {
            return e + t.items.length
        }, 0)
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.getItemsCount = n
}, function(e, t, r) {
    "use strict";

    function n(e, t) {}
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.invariant = n
}, function(e, t, r) {
    "use strict";

    function n(e) {
        return e !== Object(e)
    }

    function i(e, t) {
        if (e === t) return !0;
        if (n(e) || n(t) || "function" == typeof e || "function" == typeof t) return e === t;
        if (Object.keys(e).length !== Object.keys(t).length) return !1;
        for (var r = 0, o = Object.keys(e); r < o.length; r++) {
            var a = o[r];
            if (!(a in t)) return !1;
            if (!i(e[a], t[a])) return !1
        }
        return !0
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.isEqual = i
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.noop = void 0;
    var n = function() {};
    t.noop = n
}, function(e, t, r) {
    "use strict";

    function n(e) {
        if ("undefined" != typeof window) return e({
            window: window
        })
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.safelyRunOnBrowser = n
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.userAgents = void 0;
    var n = r(53),
        i = [{
            segment: "autocomplete-core",
            version: n.version
        }];
    t.userAgents = i
}, function(e, t, r) {
    "use strict";

    function n(e, t) {}
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.warn = n, t.warnCache = void 0;
    var i = {
        current: {}
    };
    t.warnCache = i
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";

    function n(e) {
        var t = e.item,
            r = e.items,
            n = void 0 === r ? [] : r;
        return {
            index: t.__autocomplete_indexName,
            items: [t],
            positions: [1 + n.findIndex(function(e) {
                return e.objectID === t.objectID
            })],
            queryID: t.__autocomplete_queryID,
            algoliaSource: ["autocomplete"]
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.createClickedEvent = n
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e) {
        return c(e) || u(e) || a(e) || o()
    }

    function o() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
    }

    function a(e, t) {
        if (e) {
            if ("string" == typeof e) return s(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? s(e, t) : void 0
        }
    }

    function u(e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e)
    }

    function c(e) {
        if (Array.isArray(e)) return s(e)
    }

    function s(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
        return n
    }

    function l(e, t) {
        if (null == e) return {};
        var r, n, i = f(e, t);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
        }
        return i
    }

    function f(e, t) {
        if (null == e) return {};
        var r, n, i = {},
            o = Object.keys(e);
        for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || (i[r] = e[r]);
        return i
    }

    function p(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function d(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? p(Object(r), !0).forEach(function(t) {
                h(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : p(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function h(e, t, r) {
        return t = m(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function m(e) {
        var t = y(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function y(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function b(e) {
        for (var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 20, r = [], n = 0; n < e.objectIDs.length; n += t) r.push(d(d({}, e), {}, {
            objectIDs: e.objectIDs.slice(n, n + t)
        }));
        return r
    }

    function v(e) {
        return e.map(function(e) {
            var t = e.items,
                r = l(e, O);
            return d(d({}, r), {}, {
                objectIDs: (null === t || void 0 === t ? void 0 : t.map(function(e) {
                    return e.objectID
                })) || r.objectIDs
            })
        })
    }

    function g(e) {
        function t(t, n, o) {
            if (r && void 0 !== o) {
                var a = o[0].__autocomplete_algoliaCredentials,
                    u = a.appId,
                    c = a.apiKey,
                    s = {
                        "X-Algolia-Application-Id": u,
                        "X-Algolia-API-Key": c
                    };
                e.apply(void 0, [t].concat(i(n), [{
                    headers: s
                }]))
            } else e.apply(void 0, [t].concat(i(n)))
        }
        var r = (0, _.isModernInsightsClient)(e);
        return {
            init: function(t, r) {
                e("init", {
                    appId: t,
                    apiKey: r
                })
            },
            setUserToken: function(t) {
                e("setUserToken", t)
            },
            clickedObjectIDsAfterSearch: function() {
                for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++) r[n] = arguments[n];
                r.length > 0 && t("clickedObjectIDsAfterSearch", v(r), r[0].items)
            },
            clickedObjectIDs: function() {
                for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++) r[n] = arguments[n];
                r.length > 0 && t("clickedObjectIDs", v(r), r[0].items)
            },
            clickedFilters: function() {
                for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) r[n] = arguments[n];
                r.length > 0 && e.apply(void 0, ["clickedFilters"].concat(r))
            },
            convertedObjectIDsAfterSearch: function() {
                for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++) r[n] = arguments[n];
                r.length > 0 && t("convertedObjectIDsAfterSearch", v(r), r[0].items)
            },
            convertedObjectIDs: function() {
                for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++) r[n] = arguments[n];
                r.length > 0 && t("convertedObjectIDs", v(r), r[0].items)
            },
            convertedFilters: function() {
                for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) r[n] = arguments[n];
                r.length > 0 && e.apply(void 0, ["convertedFilters"].concat(r))
            },
            viewedObjectIDs: function() {
                for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++) r[n] = arguments[n];
                r.length > 0 && r.reduce(function(e, t) {
                    var r = t.items,
                        n = l(t, j);
                    return [].concat(i(e), i(b(d(d({}, n), {}, {
                        objectIDs: (null === r || void 0 === r ? void 0 : r.map(function(e) {
                            return e.objectID
                        })) || n.objectIDs
                    })).map(function(e) {
                        return {
                            items: r,
                            payload: e
                        }
                    })))
                }, []).forEach(function(e) {
                    var r = e.items;
                    return t("viewedObjectIDs", [e.payload], r)
                })
            },
            viewedFilters: function() {
                for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) r[n] = arguments[n];
                r.length > 0 && e.apply(void 0, ["viewedFilters"].concat(r))
            }
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.createSearchInsightsApi = g;
    var _ = r(193),
        O = ["items"],
        j = ["items"]
}, function(e, t, r) {
    "use strict";

    function n(e, t) {
        return c(e) || u(e, t) || o(e, t) || i()
    }

    function i() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
    }

    function o(e, t) {
        if (e) {
            if ("string" == typeof e) return a(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? a(e, t) : void 0
        }
    }

    function a(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
        return n
    }

    function u(e, t) {
        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (null != r) {
            var n, i, o, a, u = [],
                c = !0,
                s = !1;
            try {
                if (o = (r = r.call(e)).next, 0 === t) {
                    if (Object(r) !== r) return;
                    c = !1
                } else
                    for (; !(c = (n = o.call(r)).done) && (u.push(n.value), u.length !== t); c = !0);
            } catch (e) {
                s = !0, i = e
            } finally {
                try {
                    if (!c && null != r.return && (a = r.return(), Object(a) !== a)) return
                } finally {
                    if (s) throw i
                }
            }
            return u
        }
    }

    function c(e) {
        if (Array.isArray(e)) return e
    }

    function s(e) {
        var t = (e.version || "").split(".").map(Number),
            r = n(t, 2),
            i = r[0],
            o = r[1],
            a = i >= 3,
            u = 2 === i && o >= 4,
            c = 1 === i && o >= 10;
        return a || u || c
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.isModernInsightsClient = s
}, function(e, t, r) {
    "use strict";

    function n(e) {
        var t = e.items,
            r = t.reduce(function(e, t) {
                var r;
                return e[t.__autocomplete_indexName] = (null !== (r = e[t.__autocomplete_indexName]) && void 0 !== r ? r : []).concat(t), e
            }, {});
        return Object.keys(r).map(function(e) {
            return {
                index: e,
                items: r[e],
                algoliaSource: ["autocomplete"]
            }
        })
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.createViewedEvents = n
}, function(e, t, r) {
    "use strict";

    function n(e) {
        return e.objectID && e.__autocomplete_indexName && e.__autocomplete_queryID
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.isAlgoliaInsightsHit = n
}, function(e, t, r) {
    "use strict";

    function n(e) {}
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.checkOptions = n, r(4)
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function s(e, t, r) {
        var n = t.initialState;
        return {
            getState: function() {
                return n
            },
            dispatch: function(i, a) {
                var u = o({}, n);
                n = e(n, {
                    type: i,
                    props: t,
                    payload: a
                }), r({
                    state: n,
                    prevState: u
                })
            },
            pendingRequests: (0, l.createCancelablePromiseList)()
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.createStore = s;
    var l = r(6)
}, function(e, t, r) {
    "use strict";

    function n(e, t) {
        var r = t;
        return {
            then: function(t, i) {
                return n(e.then(a(t, r, e), a(i, r, e)), r)
            },
            catch: function(t) {
                return n(e.catch(a(t, r, e)), r)
            },
            finally: function(t) {
                return t && r.onCancelList.push(t), n(e.finally(a(t && function() {
                    return r.onCancelList = [], t()
                }, r, e)), r)
            },
            cancel: function() {
                r.isCanceled = !0;
                var e = r.onCancelList;
                r.onCancelList = [], e.forEach(function(e) {
                    e()
                })
            },
            isCanceled: function() {
                return !0 === r.isCanceled
            }
        }
    }

    function i(e) {
        return n(new Promise(function(t, r) {
            return e(t, r)
        }), {
            isCanceled: !1,
            onCancelList: []
        })
    }

    function o(e) {
        return n(e, {
            isCanceled: !1,
            onCancelList: []
        })
    }

    function a(e, t, r) {
        return e ? function(r) {
            return t.isCanceled ? r : e(r)
        } : r
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.cancelable = o, t.createCancelablePromise = i, i.resolve = function(e) {
        return o(Promise.resolve(e))
    }, i.reject = function(e) {
        return o(Promise.reject(e))
    }
}, function(e, t, r) {
    "use strict";

    function n() {
        var e = [];
        return {
            add: function(t) {
                return e.push(t), t.finally(function() {
                    e = e.filter(function(e) {
                        return e !== t
                    })
                })
            },
            cancelAll: function() {
                e.forEach(function(e) {
                    return e.cancel()
                })
            },
            isEmpty: function() {
                return 0 === e.length
            }
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.createCancelablePromiseList = n
}, function(e, t, r) {
    "use strict";

    function n() {
        var e = -1,
            t = -1,
            r = void 0;
        return function(n) {
            e++;
            var i = e;
            return Promise.resolve(n).then(function(e) {
                return r && i < t ? r : (t = i, r = e, e)
            })
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.createConcurrentSafePromise = n
}, function(e, t, r) {
    "use strict";

    function n(e, t, r, n) {
        if (!r) return null;
        if (e < 0 && (null === t || null !== n && 0 === t)) return r + e;
        var i = (null === t ? -1 : t) + e;
        return i <= -1 || i >= r ? null === n ? null : 0 : i
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.getNextActiveItemId = n
}, function(e, t, r) {
    "use strict";

    function n(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function i(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? n(Object(r), !0).forEach(function(t) {
                o(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : n(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function o(e, t, r) {
        return t = a(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function a(e) {
        var t = u(e, "string");
        return "symbol" === c(t) ? t : String(t)
    }

    function u(e, t) {
        if ("object" !== c(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" !== c(n)) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function c(e) {
        "@babel/helpers - typeof";
        return (c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function s(e, t) {
        var r = [];
        return Promise.resolve(e(t)).then(function(e) {
            return (0, l.invariant)(Array.isArray(e), function() {
                return "The `getSources` function must return an array of sources but returned type ".concat(JSON.stringify(c(e)), ":\n\n").concat(JSON.stringify((0, l.decycle)(e), null, 2))
            }), Promise.all(e.filter(function(e) {
                return Boolean(e)
            }).map(function(e) {
                if ((0, l.invariant)("string" == typeof e.sourceId, "A source must provide a `sourceId` string."), r.includes(e.sourceId)) throw new Error("[Autocomplete] The `sourceId` ".concat(JSON.stringify(e.sourceId), " is not unique."));
                r.push(e.sourceId);
                var t = {
                    getItemInputValue: function(e) {
                        return e.state.query
                    },
                    getItemUrl: function() {},
                    onSelect: function(e) {
                        (0, e.setIsOpen)(!1)
                    },
                    onActive: l.noop,
                    onResolve: l.noop
                };
                Object.keys(t).forEach(function(e) {
                    t[e].__default = !0
                });
                var n = i(i({}, t), e);
                return Promise.resolve(n)
            }))
        })
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.getNormalizedSources = s;
    var l = r(4)
}, function(e, t, r) {
    "use strict";

    function n(e) {
        var t = e.collections.map(function(e) {
                return e.items.length
            }).reduce(function(e, t, r) {
                var n = e[r - 1] || 0,
                    i = n + t;
                return e.push(i), e
            }, []),
            r = t.reduce(function(t, r) {
                return r <= e.activeItemId ? t + 1 : t
            }, 0);
        return e.collections[r]
    }

    function i(e) {
        for (var t = e.state, r = e.collection, n = !1, i = 0, o = 0; !1 === n;) {
            var a = t.collections[i];
            if (a === r) {
                n = !0;
                break
            }
            o += a.items.length, i++
        }
        return t.activeItemId - o
    }

    function o(e) {
        var t = n(e);
        if (!t) return null;
        var r = t.items[i({
                state: e,
                collection: t
            })],
            o = t.source;
        return {
            item: r,
            itemInputValue: o.getItemInputValue({
                item: r,
                state: e
            }),
            itemUrl: o.getItemUrl({
                item: r,
                state: e
            }),
            source: o
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.getActiveItem = o
}, function(e, t, r) {
    "use strict";

    function n(e, t) {
        return e === t || e.contains(t)
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.isOrContainsNode = n
}, function(e, t, r) {
    "use strict";

    function n(e) {
        return Boolean(e && e.match(i))
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.isSamsung = n;
    var i = /((gt|sm)-|galaxy nexus)|samsung[- ]|samsungbrowser/i
}, function(e, t, r) {
    "use strict";

    function n(e) {
        return {
            results: e,
            hits: e.map(function(e) {
                return e.hits
            }).filter(Boolean),
            facetHits: e.map(function(e) {
                var t;
                return null === (t = e.facetHits) || void 0 === t ? void 0 : t.map(function(e) {
                    return {
                        label: e.value,
                        count: e.count,
                        _highlightResult: {
                            label: {
                                value: e.highlighted
                            }
                        }
                    }
                })
            }).filter(Boolean)
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.mapToAlgoliaResponse = n
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function s(e) {
        var t = e.store;
        return {
            setActiveItemId: function(e) {
                t.dispatch("setActiveItemId", e)
            },
            setQuery: function(e) {
                t.dispatch("setQuery", e)
            },
            setCollections: function(e) {
                var r = 0,
                    n = e.map(function(e) {
                        return o(o({}, e), {}, {
                            items: (0, l.flatten)(e.items).map(function(e) {
                                return o(o({}, e), {}, {
                                    __autocomplete_id: r++
                                })
                            })
                        })
                    });
                t.dispatch("setCollections", n)
            },
            setIsOpen: function(e) {
                t.dispatch("setIsOpen", e)
            },
            setStatus: function(e) {
                t.dispatch("setStatus", e)
            },
            setContext: function(e) {
                t.dispatch("setContext", e)
            }
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.getAutocompleteSetters = s;
    var l = r(4)
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function s(e, t) {
        if (null == e) return {};
        var r, n, i = l(e, t);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
        }
        return i
    }

    function l(e, t) {
        if (null == e) return {};
        var r, n, i = {},
            o = Object.keys(e);
        for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || (i[r] = e[r]);
        return i
    }

    function f(e) {
        var t = e.props,
            r = e.refresh,
            n = e.store,
            i = s(e, y),
            a = function(e) {
                function r(e) {
                    !n.getState().isOpen && n.pendingRequests.isEmpty() || e.target === i || !1 === [a, u].some(function(t) {
                        return (0, m.isOrContainsNode)(t, e.target)
                    }) && (n.dispatch("blur", null), t.debug || n.pendingRequests.cancelAll())
                }
                var i = e.inputElement,
                    a = e.formElement,
                    u = e.panelElement,
                    c = s(e, b);
                return o({
                    onTouchStart: r,
                    onMouseDown: r,
                    onTouchMove: function(e) {
                        !1 !== n.getState().isOpen && i === t.environment.document.activeElement && e.target !== i && i.blur()
                    }
                }, c)
            },
            u = function(e) {
                return o({
                    role: "combobox",
                    "aria-expanded": n.getState().isOpen,
                    "aria-haspopup": "listbox",
                    "aria-owns": n.getState().isOpen ? "".concat(t.id, "-list") : void 0,
                    "aria-labelledby": "".concat(t.id, "-label")
                }, e)
            },
            c = function(e) {
                var a = (e.inputElement, s(e, v));
                return o({
                    action: "",
                    noValidate: !0,
                    role: "search",
                    onSubmit: function(a) {
                        var u;
                        a.preventDefault(), t.onSubmit(o({
                            event: a,
                            refresh: r,
                            state: n.getState()
                        }, i)), n.dispatch("submit", null), null === (u = e.inputElement) || void 0 === u || u.blur()
                    },
                    onReset: function(a) {
                        var u;
                        a.preventDefault(), t.onReset(o({
                            event: a,
                            refresh: r,
                            state: n.getState()
                        }, i)), n.dispatch("reset", null), null === (u = e.inputElement) || void 0 === u || u.focus()
                    }
                }, a)
            },
            l = function(e) {
                function a(e) {
                    (t.openOnFocus || Boolean(n.getState().query)) && (0, d.onInput)(o({
                        event: e,
                        props: t,
                        query: n.getState().completion || n.getState().query,
                        refresh: r,
                        store: n
                    }, i)), n.dispatch("focus", null)
                }
                var u, c = e || {},
                    l = c.maxLength,
                    f = void 0 === l ? 512 : l,
                    y = s(c, g),
                    b = (0, m.getActiveItem)(n.getState()),
                    v = (null === (u = t.environment.navigator) || void 0 === u ? void 0 : u.userAgent) || "",
                    _ = (0, m.isSamsung)(v),
                    O = null !== b && void 0 !== b && b.itemUrl && !_ ? "go" : "search";
                return o({
                    "aria-autocomplete": "both",
                    "aria-activedescendant": n.getState().isOpen && null !== n.getState().activeItemId ? "".concat(t.id, "-item-").concat(n.getState().activeItemId) : void 0,
                    "aria-controls": n.getState().isOpen ? "".concat(t.id, "-list") : void 0,
                    "aria-labelledby": "".concat(t.id, "-label"),
                    value: n.getState().completion || n.getState().query,
                    id: "".concat(t.id, "-input"),
                    autoComplete: "off",
                    autoCorrect: "off",
                    autoCapitalize: "off",
                    enterKeyHint: O,
                    spellCheck: "false",
                    autoFocus: t.autoFocus,
                    placeholder: t.placeholder,
                    maxLength: f,
                    type: "search",
                    onChange: function(e) {
                        (0, d.onInput)(o({
                            event: e,
                            props: t,
                            query: e.currentTarget.value.slice(0, f),
                            refresh: r,
                            store: n
                        }, i))
                    },
                    onKeyDown: function(e) {
                        (0, h.onKeyDown)(o({
                            event: e,
                            props: t,
                            refresh: r,
                            store: n
                        }, i))
                    },
                    onFocus: a,
                    onBlur: p.noop,
                    onClick: function(r) {
                        e.inputElement !== t.environment.document.activeElement || n.getState().isOpen || a(r)
                    }
                }, y)
            },
            f = function(e, t) {
                return void 0 !== t ? "".concat(e, "-").concat(t) : e
            },
            P = function(e) {
                var r = e || {},
                    n = r.sourceIndex,
                    i = s(r, _);
                return o({
                    htmlFor: "".concat(f(t.id, n), "-input"),
                    id: "".concat(f(t.id, n), "-label")
                }, i)
            },
            S = function(e) {
                var r = e || {},
                    n = r.sourceIndex,
                    i = s(r, O);
                return o({
                    role: "listbox",
                    "aria-labelledby": "".concat(f(t.id, n), "-label"),
                    id: "".concat(f(t.id, n), "-list")
                }, i)
            };
        return {
            getEnvironmentProps: a,
            getRootProps: u,
            getFormProps: c,
            getLabelProps: P,
            getInputProps: l,
            getPanelProps: function(e) {
                return o({
                    onMouseDown: function(e) {
                        e.preventDefault()
                    },
                    onMouseLeave: function() {
                        //n.dispatch("mouseleave", null)
                    }
                }, e)
            },
            getListProps: S,
            getItemProps: function(e) {
                var a = e.item,
                    u = e.source,
                    c = e.sourceIndex,
                    l = s(e, j);
                return o({
                    id: "".concat(f(t.id, c), "-item-").concat(a.__autocomplete_id),
                    role: "option",
                    "aria-selected": n.getState().activeItemId === a.__autocomplete_id,
                    onMouseMove: function(e) {
                        if (a.__autocomplete_id !== n.getState().activeItemId && false) {
                            n.dispatch("mousemove", a.__autocomplete_id);
                            var t = (0, m.getActiveItem)(n.getState());
                            if (null !== n.getState().activeItemId && t) {
                                var u = t.item,
                                    c = t.itemInputValue,
                                    s = t.itemUrl,
                                    l = t.source;
                                l.onActive(o({
                                    event: e,
                                    item: u,
                                    itemInputValue: c,
                                    itemUrl: s,
                                    refresh: r,
                                    source: l,
                                    state: n.getState()
                                }, i))
                            }
                        }
                    },
                    onMouseDown: function(e) {
                        e.preventDefault()
                    },
                    onClick: function(e) {
                        var c = u.getItemInputValue({
                                item: a,
                                state: n.getState()
                            }),
                            s = u.getItemUrl({
                                item: a,
                                state: n.getState()
                            });
                        (s ? Promise.resolve() : (0, d.onInput)(o({
                            event: e,
                            nextState: {
                                isOpen: !1
                            },
                            props: t,
                            query: c,
                            refresh: r,
                            store: n
                        }, i))).then(function() {
                            u.onSelect(o({
                                event: e,
                                item: a,
                                itemInputValue: c,
                                itemUrl: s,
                                refresh: r,
                                source: u,
                                state: n.getState()
                            }, i))
                        })
                    }
                }, l)
            }
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.getPropGetters = f;
    var p = r(4),
        d = r(28),
        h = r(211),
        m = r(6),
        y = ["props", "refresh", "store"],
        b = ["inputElement", "formElement", "panelElement"],
        v = ["inputElement"],
        g = ["inputElement", "maxLength"],
        _ = ["sourceIndex"],
        O = ["sourceIndex"],
        j = ["item", "source", "sourceIndex"]
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function s(e) {
        var t = e.collections,
            r = e.props,
            n = e.state,
            i = t.reduce(function(e, t) {
                return o(o({}, e), {}, a({}, t.source.sourceId, o(o({}, t.source), {}, {
                    getItems: function() {
                        return (0, l.flatten)(t.items)
                    }
                })))
            }, {}),
            u = r.plugins.reduce(function(e, t) {
                return t.reshape ? t.reshape(e) : e
            }, {
                sourcesBySourceId: i,
                state: n
            }),
            c = u.sourcesBySourceId,
            s = r.reshape({
                sourcesBySourceId: c,
                sources: Object.values(c),
                state: n
            });
        return (0, l.flatten)(s).filter(Boolean).map(function(e) {
            return {
                source: e,
                items: e.getItems()
            }
        })
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.reshape = s;
    var l = r(4)
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function s(e) {
        return d(e) || p(e) || f(e) || l()
    }

    function l() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
    }

    function f(e, t) {
        if (e) {
            if ("string" == typeof e) return h(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? h(e, t) : void 0
        }
    }

    function p(e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e)
    }

    function d(e) {
        if (Array.isArray(e)) return h(e)
    }

    function h(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
        return n
    }

    function m(e) {
        return Boolean(e.execute)
    }

    function y(e) {
        return Boolean(null === e || void 0 === e ? void 0 : e.execute)
    }

    function b(e, t, r) {
        if (y(e)) {
            var n = "algolia" === e.requesterId ? Object.assign.apply(Object, [{}].concat(s(Object.keys(r.context).map(function(e) {
                var t;
                return null === (t = r.context[e]) || void 0 === t ? void 0 : t.__algoliaSearchParameters
            })))) : {};
            return o(o({}, e), {}, {
                requests: e.queries.map(function(r) {
                    return {
                        query: "algolia" === e.requesterId ? o(o({}, r), {}, {
                            params: o(o({}, n), r.params)
                        }) : r,
                        sourceId: t,
                        transformResponse: e.transformResponse
                    }
                })
            })
        }
        return {
            items: e,
            sourceId: t
        }
    }

    function v(e) {
        var t = e.reduce(function(e, t) {
                if (!m(t)) return e.push(t), e;
                var r = t.searchClient,
                    n = t.execute,
                    i = t.requesterId,
                    o = t.requests,
                    a = e.find(function(e) {
                        return m(t) && m(e) && e.searchClient === r && Boolean(i) && e.requesterId === i
                    });
                if (a) {
                    var u;
                    (u = a.items).push.apply(u, s(o))
                } else {
                    var c = {
                        execute: n,
                        requesterId: i,
                        items: o,
                        searchClient: r
                    };
                    e.push(c)
                }
                return e
            }, []),
            r = t.map(function(e) {
                if (!m(e)) return Promise.resolve(e);
                var t = e,
                    r = t.execute,
                    n = t.items;
                return r({
                    searchClient: t.searchClient,
                    requests: n
                })
            });
        return Promise.all(r).then(function(e) {
            return (0, _.flatten)(e)
        })
    }

    function g(e, t, r) {
        return t.map(function(t) {
            var i = e.filter(function(e) {
                    return e.sourceId === t.sourceId
                }),
                o = i.map(function(e) {
                    return e.items
                }),
                a = i[0].transformResponse,
                u = a ? a((0, O.mapToAlgoliaResponse)(o)) : o;
            return t.onResolve({
                source: t,
                results: o,
                items: u,
                state: r.getState()
            }), (0, _.invariant)(Array.isArray(u), function() {
                return 'The `getItems` function from source "'.concat(t.sourceId, '" must return an array of items but returned type ').concat(JSON.stringify(n(u)), ":\n\n").concat(JSON.stringify((0, _.decycle)(u), null, 2), ".\n\nSee: https://www.algolia.com/doc/ui-libraries/autocomplete/core-concepts/sources/#param-getitems")
            }), (0, _.invariant)(u.every(Boolean), 'The `getItems` function from source "'.concat(t.sourceId, '" must return an array of items but returned ').concat(JSON.stringify(void 0), ".\n\nDid you forget to return items?\n\nSee: https://www.algolia.com/doc/ui-libraries/autocomplete/core-concepts/sources/#param-getitems")), {
                source: t,
                items: u
            }
        })
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.postResolve = g, t.preResolve = b, t.resolve = v;
    var _ = r(4),
        O = r(6)
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function s(e, t) {
        if (null == e) return {};
        var r, n, i = l(e, t);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
        }
        return i
    }

    function l(e, t) {
        if (null == e) return {};
        var r, n, i = {},
            o = Object.keys(e);
        for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || (i[r] = e[r]);
        return i
    }

    function f(e) {
        var t = e.event,
            r = e.props,
            n = e.refresh,
            i = e.store,
            a = s(e, h);
        if ("ArrowUp" === t.key || "ArrowDown" === t.key) {
            var u = function() {
                    var e = r.environment.document.getElementById("".concat(r.id, "-item-").concat(i.getState().activeItemId));
                    e && (e.scrollIntoViewIfNeeded ? e.scrollIntoViewIfNeeded(!1) : e.scrollIntoView(!1))
                },
                c = function() {
                    var e = (0, d.getActiveItem)(i.getState());
                    if (null !== i.getState().activeItemId && e) {
                        var r = e.item,
                            u = e.itemInputValue,
                            c = e.itemUrl,
                            s = e.source;
                        s.onActive(o({
                            event: t,
                            item: r,
                            itemInputValue: u,
                            itemUrl: c,
                            refresh: n,
                            source: s,
                            state: i.getState()
                        }, a))
                    }
                };
            t.preventDefault(), !1 === i.getState().isOpen && (r.openOnFocus || Boolean(i.getState().query)) ? (0, p.onInput)(o({
                event: t,
                props: r,
                query: i.getState().query,
                refresh: n,
                store: i
            }, a)).then(function() {
                i.dispatch(t.key, {
                    nextActiveItemId: r.defaultActiveItemId
                }), c(), setTimeout(u, 0)
            }) : (i.dispatch(t.key, {}), c(), u())
        } else if ("Escape" === t.key) t.preventDefault(), i.dispatch(t.key, null), i.pendingRequests.cancelAll();
        else if ("Tab" === t.key) i.dispatch("blur", null), i.pendingRequests.cancelAll();
        else if ("Enter" === t.key) {
            if (null === i.getState().activeItemId || i.getState().collections.every(function(e) {
                    return 0 === e.items.length
                })) return void(r.debug || i.pendingRequests.cancelAll());
            t.preventDefault();
            var l = (0, d.getActiveItem)(i.getState()),
                f = l.item,
                m = l.itemInputValue,
                y = l.itemUrl,
                b = l.source;
            if (t.metaKey || t.ctrlKey) void 0 !== y && (b.onSelect(o({
                event: t,
                item: f,
                itemInputValue: m,
                itemUrl: y,
                refresh: n,
                source: b,
                state: i.getState()
            }, a)), r.navigator.navigateNewTab({
                itemUrl: y,
                item: f,
                state: i.getState()
            }));
            else if (t.shiftKey) void 0 !== y && (b.onSelect(o({
                event: t,
                item: f,
                itemInputValue: m,
                itemUrl: y,
                refresh: n,
                source: b,
                state: i.getState()
            }, a)), r.navigator.navigateNewWindow({
                itemUrl: y,
                item: f,
                state: i.getState()
            }));
            else if (t.altKey);
            else {
                if (void 0 !== y) return b.onSelect(o({
                    event: t,
                    item: f,
                    itemInputValue: m,
                    itemUrl: y,
                    refresh: n,
                    source: b,
                    state: i.getState()
                }, a)), void r.navigator.navigate({
                    itemUrl: y,
                    item: f,
                    state: i.getState()
                });
                (0, p.onInput)(o({
                    event: t,
                    nextState: {
                        isOpen: !1
                    },
                    props: r,
                    query: m,
                    refresh: n,
                    store: i
                }, a)).then(function() {
                    b.onSelect(o({
                        event: t,
                        item: f,
                        itemInputValue: m,
                        itemUrl: y,
                        refresh: n,
                        source: b,
                        state: i.getState()
                    }, a))
                })
            }
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.onKeyDown = f;
    var p = r(28),
        d = r(6),
        h = ["event", "props", "refresh", "store"]
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function s(e) {
        var t, r, n, i, u = e.plugins,
            c = e.options,
            s = null === (t = ((null === (r = c.__autocomplete_metadata) || void 0 === r ? void 0 : r.userAgents) || [])[0]) || void 0 === t ? void 0 : t.segment,
            l = s ? a({}, s, Object.keys((null === (n = c.__autocomplete_metadata) || void 0 === n ? void 0 : n.options) || {})) : {};
        return {
            plugins: u.map(function(e) {
                return {
                    name: e.name,
                    options: Object.keys(e.__autocomplete_pluginOptions || [])
                }
            }),
            options: o({
                "autocomplete-core": Object.keys(c)
            }, l),
            ua: f.userAgents.concat((null === (i = c.__autocomplete_metadata) || void 0 === i ? void 0 : i.userAgents) || [])
        }
    }

    function l(e) {
        var t, r, n = e.metadata,
            i = e.environment;
        if (null === (t = i.navigator) || void 0 === t ? void 0 : null === (r = t.userAgent) || void 0 === r ? void 0 : r.includes("Algolia Crawler")) {
            var o = i.document.createElement("meta"),
                a = i.document.querySelector("head");
            o.name = "algolia:metadata", setTimeout(function() {
                o.content = JSON.stringify(n), a.appendChild(o)
            }, 0)
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.getMetadata = s, t.injectMetadata = l;
    var f = r(4)
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.stateReducer = void 0;
    var s = r(4),
        l = r(214),
        f = r(6),
        p = function(e, t) {
            switch (t.type) {
                case "setActiveItemId":
                    return o(o({}, e), {}, {
                        activeItemId: t.payload
                    });
                case "setQuery":
                    return o(o({}, e), {}, {
                        query: t.payload,
                        completion: null
                    });
                case "setCollections":
                    return o(o({}, e), {}, {
                        collections: t.payload
                    });
                case "setIsOpen":
                    return o(o({}, e), {}, {
                        isOpen: t.payload
                    });
                case "setStatus":
                    return o(o({}, e), {}, {
                        status: t.payload
                    });
                case "setContext":
                    return o(o({}, e), {}, {
                        context: o(o({}, e.context), t.payload)
                    });
                case "ArrowDown":
                    var r = o(o({}, e), {}, {
                        activeItemId: t.payload.hasOwnProperty("nextActiveItemId") ? t.payload.nextActiveItemId : (0, f.getNextActiveItemId)(1, e.activeItemId, (0, s.getItemsCount)(e), t.props.defaultActiveItemId)
                    });
                    return o(o({}, r), {}, {
                        completion: (0, l.getCompletion)({
                            state: r
                        })
                    });
                case "ArrowUp":
                    var n = o(o({}, e), {}, {
                        activeItemId: (0, f.getNextActiveItemId)(-1, e.activeItemId, (0, s.getItemsCount)(e), t.props.defaultActiveItemId)
                    });
                    return o(o({}, n), {}, {
                        completion: (0, l.getCompletion)({
                            state: n
                        })
                    });
                case "Escape":
                    return e.isOpen ? o(o({}, e), {}, {
                        activeItemId: null,
                        isOpen: !1,
                        completion: null
                    }) : o(o({}, e), {}, {
                        activeItemId: null,
                        query: "",
                        status: "idle",
                        collections: []
                    });
                case "submit":
                    return o(o({}, e), {}, {
                        activeItemId: null,
                        isOpen: !1,
                        status: "idle"
                    });
                case "reset":
                    return o(o({}, e), {}, {
                        activeItemId: !0 === t.props.openOnFocus ? t.props.defaultActiveItemId : null,
                        status: "idle",
                        query: ""
                    });
                case "focus":
                    return o(o({}, e), {}, {
                        activeItemId: t.props.defaultActiveItemId,
                        isOpen: (t.props.openOnFocus || Boolean(e.query)) && t.props.shouldPanelOpen({
                            state: e
                        })
                    });
                case "blur":
                    return t.props.debug ? e : o(o({}, e), {}, {
                        isOpen: !1,
                        activeItemId: null
                    });
                case "mousemove":
                    return o(o({}, e), {}, {
                        activeItemId: t.payload
                    });
                case "mouseleave":
                    return o(o({}, e), {}, {
                        activeItemId: t.props.defaultActiveItemId
                    });
                default:
                    return (0, s.invariant)(!1, "The reducer action ".concat(JSON.stringify(t.type), " is not supported.")), e
            }
        };
    t.stateReducer = p
}, function(e, t, r) {
    "use strict";

    function n(e) {
        var t, r = e.state;
        return !1 === r.isOpen || null === r.activeItemId ? null : (null === (t = (0, i.getActiveItem)(r)) || void 0 === t ? void 0 : t.itemInputValue) || null
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.getCompletion = n;
    var i = r(6)
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = r(216);
    Object.keys(n).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === n[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return n[e]
            }
        }))
    });
    var i = r(228);
    Object.keys(i).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === i[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return i[e]
            }
        }))
    });
    var o = r(229);
    Object.keys(o).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === o[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return o[e]
            }
        }))
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = r(217);
    Object.keys(n).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === n[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return n[e]
            }
        }))
    });
    var i = r(218);
    Object.keys(i).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === i[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return i[e]
            }
        }))
    });
    var o = r(219);
    Object.keys(o).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === o[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return o[e]
            }
        }))
    });
    var a = r(220);
    Object.keys(a).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === a[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return a[e]
            }
        }))
    });
    var u = r(221);
    Object.keys(u).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === u[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return u[e]
            }
        }))
    });
    var c = r(222);
    Object.keys(c).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === c[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return c[e]
            }
        }))
    });
    var s = r(223);
    Object.keys(s).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === s[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return s[e]
            }
        }))
    });
    var l = r(224);
    Object.keys(l).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === l[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return l[e]
            }
        }))
    });
    var f = r(225);
    Object.keys(f).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === f[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return f[e]
            }
        }))
    });
    var p = r(226);
    Object.keys(p).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === p[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return p[e]
            }
        }))
    });
    var d = r(227);
    Object.keys(d).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === d[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return d[e]
            }
        }))
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function s(e) {
        var t = e.autocomplete,
            r = e.autocompleteScopeApi,
            n = e.classNames,
            i = e.environment,
            a = e.isDetached,
            u = e.placeholder,
            c = void 0 === u ? "Search" : u,
            s = e.propGetters,
            p = e.setIsModalOpen,
            d = e.state,
            h = e.translations,
            m = (0, f.getCreateDomElement)(i),
            y = s.getRootProps(o({
                state: d,
                props: t.getRootProps({})
            }, r)),
            b = m("div", o({
                class: n.root
            }, y)),
            v = m("div", {
                class: n.detachedContainer,
                onMouseDown: function(e) {
                    e.stopPropagation()
                }
            }),
            g = m("div", {
                class: n.detachedOverlay,
                children: [v],
                onMouseDown: function() {
                    p(!1), t.setIsOpen(!1)
                }
            }),
            _ = s.getLabelProps(o({
                state: d,
                props: t.getLabelProps({})
            }, r)),
            O = m("button", {
                class: n.submitButton,
                type: "submit",
                title: h.submitButtonTitle,
                children: [(0, l.SearchIcon)({
                    environment: i
                })]
            }),
            j = m("label", o({
                class: n.label,
                children: [O]
            }, _)),
            P = m("button", {
                class: n.clearButton,
                type: "reset",
                title: h.clearButtonTitle,
                children: [(0, l.ClearIcon)({
                    environment: i
                })]
            }),
            S = m("div", {
                class: n.loadingIndicator,
                children: [(0, l.LoadingIcon)({
                    environment: i
                })]
            }),
            w = (0, l.Input)({
                class: n.input,
                environment: i,
                state: d,
                getInputProps: s.getInputProps,
                getInputPropsCore: t.getInputProps,
                autocompleteScopeApi: r,
                isDetached: a
            }),
            E = m("div", {
                class: n.inputWrapperPrefix,
                children: [j, S]
            }),
            R = m("div", {
                class: n.inputWrapperSuffix,
                children: [P]
            }),
            x = m("div", {
                class: n.inputWrapper,
                children: [w]
            }),
            I = s.getFormProps(o({
                state: d,
                props: t.getFormProps({
                    inputElement: w
                })
            }, r)),
            k = m("form", o({
                class: n.form,
                children: [E, x, R]
            }, I)),
            M = s.getPanelProps(o({
                state: d,
                props: t.getPanelProps({})
            }, r)),
            A = m("div", o({
                class: n.panel
            }, M)),
            N = m("div", {
                class: n.detachedSearchButtonQuery,
                textContent: d.query
            }),
            C = m("div", {
                class: n.detachedSearchButtonPlaceholder,
                hidden: Boolean(d.query),
                textContent: c
            });
        if (a) {
            var T = m("div", {
                    class: n.detachedSearchButtonIcon,
                    children: [(0, l.SearchIcon)({
                        environment: i
                    })]
                }),
                F = m("button", {
                    type: "button",
                    class: n.detachedSearchButton,
                    onClick: function() {
                        p(!0)
                    },
                    children: [T, C, N]
                }),
                D = m("button", {
                    type: "button",
                    class: n.detachedCancelButton,
                    textContent: h.detachedCancelButtonText,
                    onTouchStart: function(e) {
                        e.stopPropagation()
                    },
                    onClick: function() {
                        t.setIsOpen(!1), p(!1)
                    }
                }),
                H = m("div", {
                    class: n.detachedFormContainer,
                    children: [k, D]
                });
            v.appendChild(H), b.appendChild(F)
        } else b.appendChild(k);
        return {
            detachedContainer: v,
            detachedOverlay: g,
            detachedSearchButtonQuery: N,
            detachedSearchButtonPlaceholder: C,
            inputWrapper: x,
            input: w,
            root: b,
            form: k,
            label: j,
            submitButton: O,
            clearButton: P,
            loadingIndicator: S,
            panel: A
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.createAutocompleteDom = s;
    var l = r(231),
        f = r(57);
    r(9)
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = r(232);
    Object.keys(n).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === n[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return n[e]
            }
        }))
    });
    var i = r(233);
    Object.keys(i).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === i[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return i[e]
            }
        }))
    });
    var o = r(239);
    Object.keys(o).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === o[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return o[e]
            }
        }))
    });
    var a = r(240);
    Object.keys(a).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === a[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return a[e]
            }
        }))
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.ClearIcon = void 0;
    var n = function(e) {
        var t = e.environment,
            r = t.document.createElementNS("http://www.w3.org/2000/svg", "svg");
        r.setAttribute("class", "aa-ClearIcon"), r.setAttribute("viewBox", "0 0 24 24"), r.setAttribute("width", "18"), r.setAttribute("height", "18"), r.setAttribute("fill", "currentColor");
        var n = t.document.createElementNS("http://www.w3.org/2000/svg", "path");
        return n.setAttribute("d", "M5.293 6.707l5.293 5.293-5.293 5.293c-0.391 0.391-0.391 1.024 0 1.414s1.024 0.391 1.414 0l5.293-5.293 5.293 5.293c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414l-5.293-5.293 5.293-5.293c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0l-5.293 5.293-5.293-5.293c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414z"), r.appendChild(n), r
    };
    t.ClearIcon = n
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function s(e, t) {
        if (null == e) return {};
        var r, n, i = l(e, t);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
        }
        return i
    }

    function l(e, t) {
        if (null == e) return {};
        var r, n, i = {},
            o = Object.keys(e);
        for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || (i[r] = e[r]);
        return i
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.Input = void 0;
    var f = r(57),
        p = r(9),
        d = ["autocompleteScopeApi", "environment", "classNames", "getInputProps", "getInputPropsCore", "isDetached", "state"],
        h = function(e) {
            var t = e.autocompleteScopeApi,
                r = e.environment,
                n = (e.classNames, e.getInputProps),
                i = e.getInputPropsCore,
                a = e.isDetached,
                u = e.state,
                c = s(e, d),
                l = (0, f.getCreateDomElement)(r),
                h = l("input", c),
                m = n(o({
                    state: u,
                    props: i({
                        inputElement: h
                    }),
                    inputElement: h
                }, t));
            return (0, p.setProperties)(h, o(o({}, m), {}, {
                onKeyDown: function(e) {
                    a && "Tab" === e.key || m.onKeyDown(e)
                }
            })), h
        };
    t.Input = h
}, function(e, t, r) {
    "use strict";

    function n(e, t) {
        if ("string" == typeof t) {
            var r = e.document.querySelector(t);
            return (0, i.invariant)(null !== r, "The element ".concat(JSON.stringify(t), " is not in the document.")), r
        }
        return t
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.getHTMLElement = n;
    var i = r(4)
}, function(e, t, r) {
    "use strict";

    function n() {
        for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
        return t.reduce(function(e, t) {
            return Object.keys(t).forEach(function(r) {
                var n = e[r],
                    i = t[r];
                n !== i && (e[r] = [n, i].filter(Boolean).join(" "))
            }), e
        }, {})
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.mergeClassNames = n
}, function(e, t, r) {
    "use strict";

    function n(e) {
        return u(e) || a(e) || o(e) || i()
    }

    function i() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
    }

    function o(e, t) {
        if (e) {
            if ("string" == typeof e) return c(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? c(e, t) : void 0
        }
    }

    function a(e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e)
    }

    function u(e) {
        if (Array.isArray(e)) return c(e)
    }

    function c(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
        return n
    }

    function s(e) {
        "@babel/helpers - typeof";
        return (s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function l() {
        for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
        return t.reduce(function(e, t) {
            return Object.keys(t).forEach(function(r) {
                var i = e[r],
                    o = t[r];
                Array.isArray(i) && Array.isArray(o) ? e[r] = i.concat.apply(i, n(o)) : f(i) && f(o) ? e[r] = l(i, o) : e[r] = o
            }), e
        }, {})
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.mergeDeep = l;
    var f = function(e) {
        return e && "object" === s(e) && "[object Object]" === Object.prototype.toString.call(e)
    }
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function s(e, t) {
        return h(e) || d(e, t) || f(e, t) || l()
    }

    function l() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
    }

    function f(e, t) {
        if (e) {
            if ("string" == typeof e) return p(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? p(e, t) : void 0
        }
    }

    function p(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
        return n
    }

    function d(e, t) {
        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (null != r) {
            var n, i, o, a, u = [],
                c = !0,
                s = !1;
            try {
                if (o = (r = r.call(e)).next, 0 === t) {
                    if (Object(r) !== r) return;
                    c = !1
                } else
                    for (; !(c = (n = o.call(r)).done) && (u.push(n.value), u.length !== t); c = !0);
            } catch (e) {
                s = !0, i = e
            } finally {
                try {
                    if (!c && null != r.return && (a = r.return(), Object(a) !== a)) return
                } finally {
                    if (s) throw i
                }
            }
            return u
        }
    }

    function h(e) {
        if (Array.isArray(e)) return e
    }

    function m(e, t) {
        return Object.entries(e).reduce(function(e, r) {
            var n = s(r, 2),
                i = n[0],
                u = n[1];
            return t({
                key: i,
                value: u
            }) ? o(o({}, e), {}, a({}, i, u)) : e
        }, {})
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.pickBy = m
}, function(e, t, r) {
    "use strict";

    function n(e, t, r) {
        e[t] = null === r ? "" : "number" != typeof r ? r : r + "px"
    }

    function i(e) {
        this._listeners[e.type](e)
    }

    function o(e, t, r) {
        var o, a, u = e[t];
        if ("style" === t)
            if ("string" == typeof r) e.style = r;
            else if (null === r) e.style = "";
        else
            for (t in r) u && r[t] === u[t] || n(e.style, t, r[t]);
        else "o" === t[0] && "n" === t[1] ? (o = t !== (t = t.replace(/Capture$/, "")), a = t.toLowerCase(), (a in e || s.includes(a)) && (t = a), t = t.slice(2), e._listeners || (e._listeners = {}), e._listeners[t] = r, r ? u || e.addEventListener(t, i, o) : e.removeEventListener(t, i, o)) : "list" !== t && "tagName" !== t && "form" !== t && "type" !== t && "size" !== t && "download" !== t && "href" !== t && t in e ? e[t] = null == r ? "" : r : "function" != typeof r && "dangerouslySetInnerHTML" !== t && (null == r || !1 === r && !/^ar/.test(t) ? e.removeAttribute(t) : e.setAttribute(t, r))
    }

    function a(e) {
        switch (e) {
            case "onChange":
                return "onInput";
            default:
                return e
        }
    }

    function u(e, t) {
        for (var r in t) o(e, a(r), t[r])
    }

    function c(e, t) {
        for (var r in t) "o" === r[0] && "n" === r[1] || o(e, a(r), t[r])
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.setProperties = u, t.setPropertiesWithoutEvents = c, t.setProperty = o;
    var s = ["ontouchstart", "ontouchend", "ontouchmove", "ontouchcancel"]
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.LoadingIcon = void 0;
    var n = function(e) {
        var t = e.environment,
            r = t.document.createElementNS("http://www.w3.org/2000/svg", "svg");
        return r.setAttribute("class", "aa-LoadingIcon"), r.setAttribute("viewBox", "0 0 100 100"), r.setAttribute("width", "20"), r.setAttribute("height", "20"), r.innerHTML = '<circle\n  cx="50"\n  cy="50"\n  fill="none"\n  r="35"\n  stroke="currentColor"\n  stroke-dasharray="164.93361431346415 56.97787143782138"\n  stroke-width="6"\n>\n  <animateTransform\n    attributeName="transform"\n    type="rotate"\n    repeatCount="indefinite"\n    dur="1s"\n    values="0 50 50;90 50 50;180 50 50;360 50 50"\n    keyTimes="0;0.40;0.65;1"\n  />\n</circle>', r
    };
    t.LoadingIcon = n
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.SearchIcon = void 0;
    var n = function(e) {
        var t = e.environment,
            r = t.document.createElementNS("http://www.w3.org/2000/svg", "svg");
        r.setAttribute("class", "aa-SubmitIcon"), r.setAttribute("viewBox", "0 0 24 24"), r.setAttribute("width", "20"), r.setAttribute("height", "20"), r.setAttribute("fill", "currentColor");
        var n = t.document.createElementNS("http://www.w3.org/2000/svg", "path");
        return n.setAttribute("d", "M16.041 15.856c-0.034 0.026-0.067 0.055-0.099 0.087s-0.060 0.064-0.087 0.099c-1.258 1.213-2.969 1.958-4.855 1.958-1.933 0-3.682-0.782-4.95-2.050s-2.050-3.017-2.050-4.95 0.782-3.682 2.050-4.95 3.017-2.050 4.95-2.050 3.682 0.782 4.95 2.050 2.050 3.017 2.050 4.95c0 1.886-0.745 3.597-1.959 4.856zM21.707 20.293l-3.675-3.675c1.231-1.54 1.968-3.493 1.968-5.618 0-2.485-1.008-4.736-2.636-6.364s-3.879-2.636-6.364-2.636-4.736 1.008-6.364 2.636-2.636 3.879-2.636 6.364 1.008 4.736 2.636 6.364 3.879 2.636 6.364 2.636c2.125 0 4.078-0.737 5.618-1.968l3.675 3.675c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414z"), r.appendChild(n), r
    };
    t.SearchIcon = n
}, function(e, t, r) {
    "use strict";

    function n() {
        function e(e) {
            t.push(e);
            var n = e();
            r.push(n)
        }
        var t = [],
            r = [];
        return {
            runEffect: e,
            cleanupEffects: function() {
                var e = r;
                r = [], e.forEach(function(e) {
                    e()
                })
            },
            runEffects: function() {
                var r = t;
                t = [], r.forEach(function(t) {
                    e(t)
                })
            }
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.createEffectWrapper = n
}, function(e, t, r) {
    "use strict";

    function n() {
        var e = [];
        return {
            reactive: function(t) {
                var r = t(),
                    n = {
                        _fn: t,
                        _ref: {
                            current: r
                        },
                        get value() {
                            return this._ref.current
                        },
                        set value(e) {
                            this._ref.current = e
                        }
                    };
                return e.push(n), n
            },
            runReactives: function() {
                e.forEach(function(e) {
                    e._ref.current = e._fn()
                })
            }
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.createReactiveWrapper = n
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function s(e, t) {
        if (null == e) return {};
        var r, n, i = l(e, t);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
        }
        return i
    }

    function l(e, t) {
        if (null == e) return {};
        var r, n, i = {},
            o = Object.keys(e);
        for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || (i[r] = e[r]);
        return i
    }

    function f(e) {
        var t, r = e.classNames,
            n = e.container,
            i = e.getEnvironmentProps,
            a = e.getFormProps,
            u = e.getInputProps,
            c = e.getItemProps,
            l = e.getLabelProps,
            f = e.getListProps,
            d = e.getPanelProps,
            _ = e.getRootProps,
            O = e.panelContainer,
            j = e.panelPlacement,
            P = e.render,
            S = e.renderNoResults,
            w = e.renderer,
            E = e.detachedMediaQuery,
            R = e.components,
            x = e.translations,
            I = s(e, y),
            k = "undefined" != typeof window ? window : {},
            M = (0, m.getHTMLElement)(k, n);
        (0, p.invariant)("INPUT" !== M.tagName, "The `container` option does not support `input` elements. You need to change the container to a `div`.");
        var A = o(o({}, g), w),
            N = {
                Highlight: (0, h.createHighlightComponent)(A),
                ReverseHighlight: (0, h.createReverseHighlightComponent)(A),
                ReverseSnippet: (0, h.createReverseSnippetComponent)(A),
                Snippet: (0, h.createSnippetComponent)(A)
            },
            C = {
                clearButtonTitle: "Clear",
                detachedCancelButtonText: "Close",
                submitButtonTitle: "Submit"
            };
        return {
            renderer: {
                classNames: (0, m.mergeClassNames)(b, null !== r && void 0 !== r ? r : {}),
                container: M,
                getEnvironmentProps: null !== i && void 0 !== i ? i : function(e) {
                    return e.props
                },
                getFormProps: null !== a && void 0 !== a ? a : function(e) {
                    return e.props
                },
                getInputProps: null !== u && void 0 !== u ? u : function(e) {
                    return e.props
                },
                getItemProps: null !== c && void 0 !== c ? c : function(e) {
                    return e.props
                },
                getLabelProps: null !== l && void 0 !== l ? l : function(e) {
                    return e.props
                },
                getListProps: null !== f && void 0 !== f ? f : function(e) {
                    return e.props
                },
                getPanelProps: null !== d && void 0 !== d ? d : function(e) {
                    return e.props
                },
                getRootProps: null !== _ && void 0 !== _ ? _ : function(e) {
                    return e.props
                },
                panelContainer: O ? (0, m.getHTMLElement)(k, O) : k.document.body,
                panelPlacement: null !== j && void 0 !== j ? j : "input-wrapper-width",
                render: null !== P && void 0 !== P ? P : v,
                renderNoResults: S,
                renderer: A,
                detachedMediaQuery: null !== E && void 0 !== E ? E : getComputedStyle(k.document.documentElement).getPropertyValue("--aa-detached-media-query"),
                components: o(o({}, N), R),
                translations: o(o({}, C), x)
            },
            core: o(o({}, I), {}, {
                id: null !== (t = I.id) && void 0 !== t ? t : (0, p.generateAutocompleteId)(),
                environment: k
            })
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.getDefaultOptions = f;
    var p = r(4),
        d = r(244),
        h = r(245),
        m = r(9),
        y = ["classNames", "container", "getEnvironmentProps", "getFormProps", "getInputProps", "getItemProps", "getLabelProps", "getListProps", "getPanelProps", "getRootProps", "panelContainer", "panelPlacement", "render", "renderNoResults", "renderer", "detachedMediaQuery", "components", "translations"],
        b = {
            clearButton: "aa-ClearButton",
            detachedCancelButton: "aa-DetachedCancelButton",
            detachedContainer: "aa-DetachedContainer",
            detachedFormContainer: "aa-DetachedFormContainer",
            detachedOverlay: "aa-DetachedOverlay",
            detachedSearchButton: "aa-DetachedSearchButton",
            detachedSearchButtonIcon: "aa-DetachedSearchButtonIcon",
            detachedSearchButtonPlaceholder: "aa-DetachedSearchButtonPlaceholder",
            detachedSearchButtonQuery: "aa-DetachedSearchButtonQuery",
            form: "aa-Form",
            input: "aa-Input",
            inputWrapper: "aa-InputWrapper",
            inputWrapperPrefix: "aa-InputWrapperPrefix",
            inputWrapperSuffix: "aa-InputWrapperSuffix",
            item: "aa-Item",
            label: "aa-Label",
            list: "aa-List",
            loadingIndicator: "aa-LoadingIndicator",
            panel: "aa-Panel",
            panelLayout: "aa-PanelLayout aa-Panel--scrollable",
            root: "aa-Autocomplete",
            source: "aa-Source",
            sourceFooter: "aa-SourceFooter",
            sourceHeader: "aa-SourceHeader",
            sourceNoResults: "aa-SourceNoResults",
            submitButton: "aa-SubmitButton"
        },
        v = function(e, t) {
            var r = e.children;
            (0, e.render)(r, t)
        },
        g = {
            createElement: d.createElement,
            Fragment: d.Fragment,
            render: d.render
        }
}, function(e, t, r) {
    "use strict";

    function n(e, t) {
        for (var r in t) e[r] = t[r];
        return e
    }

    function i(e) {
        var t = e.parentNode;
        t && t.removeChild(e)
    }

    function o(e, t, r) {
        var n, i, o, u = {};
        for (o in t) "key" == o ? n = t[o] : "ref" == o ? i = t[o] : u[o] = t[o];
        if (arguments.length > 2 && (u.children = arguments.length > 3 ? C.call(arguments, 2) : r), "function" == typeof e && null != e.defaultProps)
            for (o in e.defaultProps) void 0 === u[o] && (u[o] = e.defaultProps[o]);
        return a(e, u, n, i, null)
    }

    function a(e, t, r, n, i) {
        var o = {
            type: e,
            props: t,
            key: r,
            ref: n,
            __k: null,
            __: null,
            __b: 0,
            __e: null,
            __d: void 0,
            __c: null,
            __h: null,
            constructor: void 0,
            __v: null == i ? ++F : i
        };
        return null == i && null != T.vnode && T.vnode(o), o
    }

    function u() {
        return {
            current: null
        }
    }

    function c(e) {
        return e.children
    }

    function s(e, t) {
        this.props = e, this.context = t
    }

    function l(e, t) {
        if (null == t) return e.__ ? l(e.__, e.__.__k.indexOf(e) + 1) : null;
        for (var r; t < e.__k.length; t++)
            if (null != (r = e.__k[t]) && null != r.__e) return r.__e;
        return "function" == typeof e.type ? l(e) : null
    }

    function f(e) {
        var t, r;
        if (null != (e = e.__) && null != e.__c) {
            for (e.__e = e.__c.base = null, t = 0; t < e.__k.length; t++)
                if (null != (r = e.__k[t]) && null != r.__e) {
                    e.__e = e.__c.base = r.__e;
                    break
                }
            return f(e)
        }
    }

    function p(e) {
        (!e.__d && (e.__d = !0) && H.push(e) && !d.__r++ || L !== T.debounceRendering) && ((L = T.debounceRendering) || q)(d)
    }

    function d() {
        var e, t, r, i, o, a, u, c;
        for (H.sort(B); e = H.shift();) e.__d && (t = H.length, i = void 0, o = void 0, u = (a = (r = e).__v).__e, (c = r.__P) && (i = [], (o = n({}, a)).__v = a.__v + 1, S(c, a, o, r.__n, void 0 !== c.ownerSVGElement, null != a.__h ? [u] : null, i, null == u ? l(a) : u, a.__h), w(i, a), a.__e != u && f(a)), H.length > t && H.sort(B));
        d.__r = 0
    }

    function h(e, t, r, n, i, o, u, s, f, p) {
        var d, h, y, g, _, O, j, P = n && n.__k || V,
            w = P.length;
        for (r.__k = [], d = 0; d < t.length; d++)
            if (null != (g = r.__k[d] = null == (g = t[d]) || "boolean" == typeof g || "function" == typeof g ? null : "string" == typeof g || "number" == typeof g || "bigint" == typeof g ? a(null, g, null, null, g) : $(g) ? a(c, {
                    children: g
                }, null, null, null) : g.__b > 0 ? a(g.type, g.props, g.key, g.ref ? g.ref : null, g.__v) : g)) {
                if (g.__ = r, g.__b = r.__b + 1, null === (y = P[d]) || y && g.key == y.key && g.type === y.type) P[d] = void 0;
                else
                    for (h = 0; h < w; h++) {
                        if ((y = P[h]) && g.key == y.key && g.type === y.type) {
                            P[h] = void 0;
                            break
                        }
                        y = null
                    }
                S(e, g, y = y || W, i, o, u, s, f, p), _ = g.__e, (h = g.ref) && y.ref != h && (j || (j = []), y.ref && j.push(y.ref, null, g), j.push(h, g.__c || _, g)), null != _ ? (null == O && (O = _), "function" == typeof g.type && g.__k === y.__k ? g.__d = f = m(g, f, e) : f = b(e, g, y, P, _, f), "function" == typeof r.type && (r.__d = f)) : f && y.__e == f && f.parentNode != e && (f = l(y))
            }
        for (r.__e = O, d = w; d--;) null != P[d] && ("function" == typeof r.type && null != P[d].__e && P[d].__e == r.__d && (r.__d = v(n).nextSibling), x(P[d], P[d]));
        if (j)
            for (d = 0; d < j.length; d++) R(j[d], j[++d], j[++d])
    }

    function m(e, t, r) {
        for (var n, i = e.__k, o = 0; i && o < i.length; o++)(n = i[o]) && (n.__ = e, t = "function" == typeof n.type ? m(n, t, r) : b(r, n, n, i, n.__e, t));
        return t
    }

    function y(e, t) {
        return t = t || [], null == e || "boolean" == typeof e || ($(e) ? e.some(function(e) {
            y(e, t)
        }) : t.push(e)), t
    }

    function b(e, t, r, n, i, o) {
        var a, u, c;
        if (void 0 !== t.__d) a = t.__d, t.__d = void 0;
        else if (null == r || i != o || null == i.parentNode) e: if (null == o || o.parentNode !== e) e.appendChild(i), a = null;
            else {
                for (u = o, c = 0;
                    (u = u.nextSibling) && c < n.length; c += 1)
                    if (u == i) break e;
                e.insertBefore(i, o), a = o
            }
        return void 0 !== a ? a : i.nextSibling
    }

    function v(e) {
        var t, r, n;
        if (null == e.type || "string" == typeof e.type) return e.__e;
        if (e.__k)
            for (t = e.__k.length - 1; t >= 0; t--)
                if ((r = e.__k[t]) && (n = v(r))) return n;
        return null
    }

    function g(e, t, r, n, i) {
        var o;
        for (o in r) "children" === o || "key" === o || o in t || O(e, o, null, r[o], n);
        for (o in t) i && "function" != typeof t[o] || "children" === o || "key" === o || "value" === o || "checked" === o || r[o] === t[o] || O(e, o, t[o], r[o], n)
    }

    function _(e, t, r) {
        "-" === t[0] ? e.setProperty(t, null == r ? "" : r) : e[t] = null == r ? "" : "number" != typeof r || Q.test(t) ? r : r + "px"
    }

    function O(e, t, r, n, i) {
        var o;
        e: if ("style" === t)
            if ("string" == typeof r) e.style.cssText = r;
            else {
                if ("string" == typeof n && (e.style.cssText = n = ""), n)
                    for (t in n) r && t in r || _(e.style, t, "");
                if (r)
                    for (t in r) n && r[t] === n[t] || _(e.style, t, r[t])
            }
        else if ("o" === t[0] && "n" === t[1]) o = t !== (t = t.replace(/Capture$/, "")), t = t.toLowerCase() in e ? t.toLowerCase().slice(2) : t.slice(2), e.l || (e.l = {}), e.l[t + o] = r, r ? n || e.addEventListener(t, o ? P : j, o) : e.removeEventListener(t, o ? P : j, o);
        else if ("dangerouslySetInnerHTML" !== t) {
            if (i) t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
            else if ("width" !== t && "height" !== t && "href" !== t && "list" !== t && "form" !== t && "tabIndex" !== t && "download" !== t && "rowSpan" !== t && "colSpan" !== t && t in e) try {
                e[t] = null == r ? "" : r;
                break e
            } catch (e) {}
            "function" == typeof r || (null == r || !1 === r && "-" !== t[4] ? e.removeAttribute(t) : e.setAttribute(t, r))
        }
    }

    function j(e) {
        return this.l[e.type + !1](T.event ? T.event(e) : e)
    }

    function P(e) {
        return this.l[e.type + !0](T.event ? T.event(e) : e)
    }

    function S(e, t, r, i, o, a, u, l, f) {
        var p, d, m, y, b, v, g, _, O, j, P, S, w, R, x, k = t.type;
        if (void 0 !== t.constructor) return null;
        null != r.__h && (f = r.__h, l = t.__e = r.__e, t.__h = null, a = [l]), (p = T.__b) && p(t);
        try {
            e: if ("function" == typeof k) {
                if (_ = t.props, O = (p = k.contextType) && i[p.__c], j = p ? O ? O.props.value : p.__ : i, r.__c ? g = (d = t.__c = r.__c).__ = d.__E : ("prototype" in k && k.prototype.render ? t.__c = d = new k(_, j) : (t.__c = d = new s(_, j), d.constructor = k, d.render = I), O && O.sub(d), d.props = _, d.state || (d.state = {}), d.context = j, d.__n = i, m = d.__d = !0, d.__h = [], d._sb = []), null == d.__s && (d.__s = d.state), null != k.getDerivedStateFromProps && (d.__s == d.state && (d.__s = n({}, d.__s)), n(d.__s, k.getDerivedStateFromProps(_, d.__s))), y = d.props, b = d.state, d.__v = t, m) null == k.getDerivedStateFromProps && null != d.componentWillMount && d.componentWillMount(), null != d.componentDidMount && d.__h.push(d.componentDidMount);
                else {
                    if (null == k.getDerivedStateFromProps && _ !== y && null != d.componentWillReceiveProps && d.componentWillReceiveProps(_, j), !d.__e && null != d.shouldComponentUpdate && !1 === d.shouldComponentUpdate(_, d.__s, j) || t.__v === r.__v) {
                        for (t.__v !== r.__v && (d.props = _, d.state = d.__s, d.__d = !1), d.__e = !1, t.__e = r.__e, t.__k = r.__k, t.__k.forEach(function(e) {
                                e && (e.__ = t)
                            }), P = 0; P < d._sb.length; P++) d.__h.push(d._sb[P]);
                        d._sb = [], d.__h.length && u.push(d);
                        break e
                    }
                    null != d.componentWillUpdate && d.componentWillUpdate(_, d.__s, j), null != d.componentDidUpdate && d.__h.push(function() {
                        d.componentDidUpdate(y, b, v)
                    })
                }
                if (d.context = j, d.props = _, d.__P = e, S = T.__r, w = 0, "prototype" in k && k.prototype.render) {
                    for (d.state = d.__s, d.__d = !1, S && S(t), p = d.render(d.props, d.state, d.context), R = 0; R < d._sb.length; R++) d.__h.push(d._sb[R]);
                    d._sb = []
                } else
                    do {
                        d.__d = !1, S && S(t), p = d.render(d.props, d.state, d.context), d.state = d.__s
                    } while (d.__d && ++w < 25);
                d.state = d.__s, null != d.getChildContext && (i = n(n({}, i), d.getChildContext())), m || null == d.getSnapshotBeforeUpdate || (v = d.getSnapshotBeforeUpdate(y, b)), h(e, $(x = null != p && p.type === c && null == p.key ? p.props.children : p) ? x : [x], t, r, i, o, a, u, l, f), d.base = t.__e, t.__h = null, d.__h.length && u.push(d), g && (d.__E = d.__ = null), d.__e = !1
            } else null == a && t.__v === r.__v ? (t.__k = r.__k, t.__e = r.__e) : t.__e = E(r.__e, t, r, i, o, a, u, f);
            (p = T.diffed) && p(t)
        }
        catch (e) {
            t.__v = null, (f || null != a) && (t.__e = l, t.__h = !!f, a[a.indexOf(l)] = null), T.__e(e, t, r)
        }
    }

    function w(e, t) {
        T.__c && T.__c(t, e), e.some(function(t) {
            try {
                e = t.__h, t.__h = [], e.some(function(e) {
                    e.call(t)
                })
            } catch (e) {
                T.__e(e, t.__v)
            }
        })
    }

    function E(e, t, r, n, o, a, u, c) {
        var s, f, p, d = r.props,
            m = t.props,
            y = t.type,
            b = 0;
        if ("svg" === y && (o = !0), null != a)
            for (; b < a.length; b++)
                if ((s = a[b]) && "setAttribute" in s == !!y && (y ? s.localName === y : 3 === s.nodeType)) {
                    e = s, a[b] = null;
                    break
                }
        if (null == e) {
            if (null === y) return document.createTextNode(m);
            e = o ? document.createElementNS("http://www.w3.org/2000/svg", y) : document.createElement(y, m.is && m), a = null, c = !1
        }
        if (null === y) d === m || c && e.data === m || (e.data = m);
        else {
            if (a = a && C.call(e.childNodes), f = (d = r.props || W).dangerouslySetInnerHTML, p = m.dangerouslySetInnerHTML, !c) {
                if (null != a)
                    for (d = {}, b = 0; b < e.attributes.length; b++) d[e.attributes[b].name] = e.attributes[b].value;
                (p || f) && (p && (f && p.__html == f.__html || p.__html === e.innerHTML) || (e.innerHTML = p && p.__html || ""))
            }
            if (g(e, m, d, o, c), p) t.__k = [];
            else if (h(e, $(b = t.props.children) ? b : [b], t, r, n, o && "foreignObject" !== y, a, u, a ? a[0] : r.__k && l(r, 0), c), null != a)
                for (b = a.length; b--;) null != a[b] && i(a[b]);
            c || ("value" in m && void 0 !== (b = m.value) && (b !== e.value || "progress" === y && !b || "option" === y && b !== d.value) && O(e, "value", b, d.value, !1), "checked" in m && void 0 !== (b = m.checked) && b !== e.checked && O(e, "checked", b, d.checked, !1))
        }
        return e
    }

    function R(e, t, r) {
        try {
            "function" == typeof e ? e(t) : e.current = t
        } catch (e) {
            T.__e(e, r)
        }
    }

    function x(e, t, r) {
        var n, o;
        if (T.unmount && T.unmount(e), (n = e.ref) && (n.current && n.current !== e.__e || R(n, null, t)), null != (n = e.__c)) {
            if (n.componentWillUnmount) try {
                n.componentWillUnmount()
            } catch (e) {
                T.__e(e, t)
            }
            n.base = n.__P = null, e.__c = void 0
        }
        if (n = e.__k)
            for (o = 0; o < n.length; o++) n[o] && x(n[o], t, r || "function" != typeof e.type);
        r || null == e.__e || i(e.__e), e.__ = e.__e = e.__d = void 0
    }

    function I(e, t, r) {
        return this.constructor(e, r)
    }

    function k(e, t, r) {
        var n, i, a;
        T.__ && T.__(e, t), i = (n = "function" == typeof r) ? null : r && r.__k || t.__k, a = [], S(t, e = (!n && r || t).__k = o(c, null, [e]), i || W, W, void 0 !== t.ownerSVGElement, !n && r ? [r] : i ? null : t.firstChild ? C.call(t.childNodes) : null, a, !n && r ? r : i ? i.__e : t.firstChild, n), w(a, e)
    }

    function M(e, t) {
        k(e, t, M)
    }

    function A(e, t, r) {
        var i, o, u, c, s = n({}, e.props);
        for (u in e.type && e.type.defaultProps && (c = e.type.defaultProps), t) "key" == u ? i = t[u] : "ref" == u ? o = t[u] : s[u] = void 0 === t[u] && void 0 !== c ? c[u] : t[u];
        return arguments.length > 2 && (s.children = arguments.length > 3 ? C.call(arguments, 2) : r), a(e.type, s, i || e.key, o || e.ref, null)
    }

    function N(e, t) {
        var r = {
            __c: t = "__cC" + U++,
            __: e,
            Consumer: function(e, t) {
                return e.children(t)
            },
            Provider: function(e) {
                var r, n;
                return this.getChildContext || (r = [], (n = {})[t] = this, this.getChildContext = function() {
                    return n
                }, this.shouldComponentUpdate = function(e) {
                    this.props.value !== e.value && r.some(function(e) {
                        e.__e = !0, p(e)
                    })
                }, this.sub = function(e) {
                    r.push(e);
                    var t = e.componentWillUnmount;
                    e.componentWillUnmount = function() {
                        r.splice(r.indexOf(e), 1), t && t.call(e)
                    }
                }), e.children
            }
        };
        return r.Provider.__ = r.Consumer.contextType = r
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.Component = s, t.Fragment = c, t.cloneElement = A, t.createContext = N, t.h = t.createElement = o, t.createRef = u, t.hydrate = M, t.options = t.isValidElement = void 0, t.render = k, t.toChildArray = y;
    var C, T, F, D, H, L, q, B, U, W = {},
        V = [],
        Q = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i,
        $ = Array.isArray;
    t.isValidElement = D, t.options = T, C = V.slice, t.options = T = {
        __e: function(e, t, r, n) {
            for (var i, o, a; t = t.__;)
                if ((i = t.__c) && !i.__) try {
                    if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(e)), a = i.__d), null != i.componentDidCatch && (i.componentDidCatch(e, n || {}), a = i.__d), a) return i.__E = i
                } catch (t) {
                    e = t
                }
            throw e
        }
    }, F = 0, t.isValidElement = D = function(e) {
        return null != e && void 0 === e.constructor
    }, s.prototype.setState = function(e, t) {
        var r;
        r = null != this.__s && this.__s !== this.state ? this.__s : this.__s = n({}, this.state), "function" == typeof e && (e = e(n({}, r), this.props)), e && n(r, e), null != e && this.__v && (t && this._sb.push(t), p(this))
    }, s.prototype.forceUpdate = function(e) {
        this.__v && (this.__e = !0, e && this.__h.push(e), p(this))
    }, s.prototype.render = c, H = [], q = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, B = function(e, t) {
        return e.__v.__b - t.__v.__b
    }, d.__r = 0, U = 0
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = r(246);
    Object.keys(n).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === n[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return n[e]
            }
        }))
    });
    var i = r(262);
    Object.keys(i).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === i[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return i[e]
            }
        }))
    });
    var o = r(263);
    Object.keys(o).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === o[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return o[e]
            }
        }))
    });
    var a = r(264);
    Object.keys(a).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === a[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return a[e]
            }
        }))
    })
}, function(e, t, r) {
    "use strict";

    function n(e) {
        function t(e) {
            var t = e.hit,
                o = e.attribute,
                a = e.tagName,
                u = void 0 === a ? "mark" : a;
            return r(n, {}, (0, i.parseAlgoliaHitHighlight)({
                hit: t,
                attribute: o
            }).map(function(e, t) {
                return e.isHighlighted ? r(u, {
                    key: t
                }, e.value) : e.value
            }))
        }
        var r = e.createElement,
            n = e.Fragment;
        return t.__autocomplete_componentName = "Highlight", t
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.createHighlightComponent = n;
    var i = r(11)
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = r(248);
    Object.keys(n).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === n[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return n[e]
            }
        }))
    });
    var i = r(58);
    Object.keys(i).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === i[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return i[e]
            }
        }))
    });
    var o = r(249);
    Object.keys(o).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === o[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return o[e]
            }
        }))
    });
    var a = r(251);
    Object.keys(a).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === a[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return a[e]
            }
        }))
    });
    var u = r(62);
    Object.keys(u).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === u[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return u[e]
            }
        }))
    });
    var c = r(252);
    Object.keys(c).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === c[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return c[e]
            }
        }))
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";

    function n(e) {
        return (0, o.reverseHighlightedParts)((0, i.parseAlgoliaHitHighlight)(e))
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.parseAlgoliaHitReverseHighlight = n;
    var i = r(58),
        o = r(61)
}, function(e, t, r) {
    "use strict";

    function n(e) {
        return e && c.test(e) ? e.replace(u, function(e) {
            return o[e]
        }) : e
    }

    function i(e, t) {
        var r, i, o = e[t],
            u = (null === (r = e[t + 1]) || void 0 === r ? void 0 : r.isHighlighted) || !0,
            c = (null === (i = e[t - 1]) || void 0 === i ? void 0 : i.isHighlighted) || !0;
        return a.test(n(o.value)) || c !== u ? o.isHighlighted : c
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.isPartHighlighted = i;
    var o = {
            "&amp;": "&",
            "&lt;": "<",
            "&gt;": ">",
            "&quot;": '"',
            "&#39;": "'"
        },
        a = new RegExp(/\w/i),
        u = /&(amp|quot|lt|gt|#39);/g,
        c = RegExp(u.source)
}, function(e, t, r) {
    "use strict";

    function n(e) {
        return (0, o.reverseHighlightedParts)((0, i.parseAlgoliaHitSnippet)(e))
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.parseAlgoliaHitReverseSnippet = n;
    var i = r(62),
        o = r(61)
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = r(63);
    Object.keys(n).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === n[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return n[e]
            }
        }))
    });
    var i = r(254);
    Object.keys(i).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === i[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return i[e]
            }
        }))
    });
    var o = r(258);
    Object.keys(o).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === o[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return o[e]
            }
        }))
    })
}, function(e, t, r) {
    "use strict";

    function n(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function i(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? n(Object(r), !0).forEach(function(t) {
                o(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : n(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function o(e, t, r) {
        return t = a(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function a(e) {
        var t = u(e, "string");
        return "symbol" === c(t) ? t : String(t)
    }

    function u(e, t) {
        if ("object" !== c(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" !== c(n)) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function c(e) {
        "@babel/helpers - typeof";
        return (c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function s(e) {
        (0, l.invariant)("object" === c(e.searchClient), "The `searchClient` parameter is required for getAlgoliaFacets({ searchClient }).");
        var t = (0, f.createAlgoliaRequester)({
                transformResponse: function(e) {
                    return e.facetHits
                }
            }),
            r = e.queries.map(function(e) {
                return i(i({}, e), {}, {
                    type: "facet"
                })
            });
        return t(i(i({}, e), {}, {
            queries: r
        }))
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.getAlgoliaFacets = s;
    var l = r(4),
        f = r(64)
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function s(e, t) {
        if (null == e) return {};
        var r, n, i = l(e, t);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
        }
        return i
    }

    function l(e, t) {
        if (null == e) return {};
        var r, n, i = {},
            o = Object.keys(e);
        for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || (i[r] = e[r]);
        return i
    }

    function f(e) {
        return m(e) || h(e) || d(e) || p()
    }

    function p() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
    }

    function d(e, t) {
        if (e) {
            if ("string" == typeof e) return y(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? y(e, t) : void 0
        }
    }

    function h(e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e)
    }

    function m(e) {
        if (Array.isArray(e)) return y(e)
    }

    function y(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
        return n
    }

    function b(e) {
        var t = e.searchClient,
            r = e.queries,
            n = e.userAgents,
            i = void 0 === n ? [] : n;
        "function" == typeof t.addAlgoliaAgent && [].concat(f(v.userAgents), f(i)).forEach(function(e) {
            var r = e.segment,
                n = e.version;
            t.addAlgoliaAgent(r, n)
        });
        var a = (0, _.getAppIdAndApiKey)(t),
            u = a.appId,
            c = a.apiKey;
        return (0, v.invariant)(Boolean(u), "The Algolia `appId` was not accessible from the searchClient passed."), (0, v.invariant)(Boolean(c), "The Algolia `apiKey` was not accessible from the searchClient passed."), t.search(r.map(function(e) {
            var t = e.params;
            return o(o({}, s(e, O)), {}, {
                params: o({
                    hitsPerPage: 5,
                    highlightPreTag: g.HIGHLIGHT_PRE_TAG,
                    highlightPostTag: g.HIGHLIGHT_POST_TAG
                }, t)
            })
        })).then(function(e) {
            return e.results.map(function(e, t) {
                var n;
                return o(o({}, e), {}, {
                    hits: null === (n = e.hits) || void 0 === n ? void 0 : n.map(function(n) {
                        return o(o({}, n), {}, {
                            __autocomplete_indexName: e.index || r[t].indexName,
                            __autocomplete_queryID: e.queryID,
                            __autocomplete_algoliaCredentials: {
                                appId: u,
                                apiKey: c
                            }
                        })
                    })
                })
            })
        })
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.fetchAlgoliaResults = b;
    var v = r(4),
        g = r(60),
        _ = r(256),
        O = ["params"]
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = r(257);
    Object.keys(n).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === n[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return n[e]
            }
        }))
    })
}, function(e, t, r) {
    "use strict";

    function n(e) {
        var t = e.transporter || {},
            r = t.headers,
            n = void 0 === r ? {} : r,
            i = t.queryParameters,
            o = void 0 === i ? {} : i,
            a = "x-algolia-application-id";
        return {
            appId: n[a] || o[a],
            apiKey: n["x-algolia-api-key"] || o["x-algolia-api-key"]
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.getAppIdAndApiKey = n
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e) {
        return (0, o.invariant)("object" === n(e.searchClient), "The `searchClient` parameter is required for getAlgoliaResults({ searchClient })."), (0, a.createAlgoliaRequester)({
            transformResponse: function(e) {
                return e.hits
            }
        })(e)
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.getAlgoliaResults = i;
    var o = r(4),
        a = r(64)
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = r(260);
    Object.keys(n).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === n[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return n[e]
            }
        }))
    });
    var i = r(261);
    Object.keys(i).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === i[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return i[e]
            }
        }))
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";

    function n(e) {
        function t(e) {
            var t = e.hit,
                o = e.attribute,
                a = e.tagName,
                u = void 0 === a ? "mark" : a;
            return r(n, {}, (0, i.parseAlgoliaHitReverseHighlight)({
                hit: t,
                attribute: o
            }).map(function(e, t) {
                return e.isHighlighted ? r(u, {
                    key: t
                }, e.value) : e.value
            }))
        }
        var r = e.createElement,
            n = e.Fragment;
        return t.__autocomplete_componentName = "ReverseHighlight", t
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.createReverseHighlightComponent = n;
    var i = r(11)
}, function(e, t, r) {
    "use strict";

    function n(e) {
        function t(e) {
            var t = e.hit,
                o = e.attribute,
                a = e.tagName,
                u = void 0 === a ? "mark" : a;
            return r(n, {}, (0, i.parseAlgoliaHitReverseSnippet)({
                hit: t,
                attribute: o
            }).map(function(e, t) {
                return e.isHighlighted ? r(u, {
                    key: t
                }, e.value) : e.value
            }))
        }
        var r = e.createElement,
            n = e.Fragment;
        return t.__autocomplete_componentName = "ReverseSnippet", t
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.createReverseSnippetComponent = n;
    var i = r(11)
}, function(e, t, r) {
    "use strict";

    function n(e) {
        function t(e) {
            var t = e.hit,
                o = e.attribute,
                a = e.tagName,
                u = void 0 === a ? "mark" : a;
            return r(n, {}, (0, i.parseAlgoliaHitSnippet)({
                hit: t,
                attribute: o
            }).map(function(e, t) {
                return e.isHighlighted ? r(u, {
                    key: t
                }, e.value) : e.value
            }))
        }
        var r = e.createElement,
            n = e.Fragment;
        return t.__autocomplete_componentName = "Snippet", t
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.createSnippetComponent = n;
    var i = r(11)
}, function(e, t, r) {
    "use strict";

    function n(e) {
        var t = e.panelPlacement,
            r = e.container,
            n = e.form,
            i = e.environment,
            o = r.getBoundingClientRect(),
            a = i.pageYOffset || i.document.documentElement.scrollTop || i.document.body.scrollTop || 0,
            u = a + o.top + o.height;
        switch (t) {
            case "start":
                return {
                    top: u,
                    left: o.left
                };
            case "end":
                return {
                    top: u,
                    right: i.document.documentElement.clientWidth - (o.left + o.width)
                };
            case "full-width":
                return {
                    top: u,
                    left: 0,
                    right: 0,
                    width: "unset",
                    maxWidth: "unset"
                };
            case "input-wrapper-width":
                var c = n.getBoundingClientRect();
                return {
                    top: u,
                    left: c.left,
                    right: i.document.documentElement.clientWidth - (c.left + c.width),
                    width: "unset",
                    maxWidth: "unset"
                };
            default:
                throw new Error("[Autocomplete] The `panelPlacement` value ".concat(JSON.stringify(t), " is not valid."))
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.getPanelPlacementStyle = n
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i() {
        return i = Object.assign ? Object.assign.bind() : function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = arguments[t];
                for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
            }
            return e
        }, i.apply(this, arguments)
    }

    function o(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function a(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? o(Object(r), !0).forEach(function(t) {
                u(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : o(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function u(e, t, r) {
        return t = c(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function c(e) {
        var t = s(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function s(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function l(e) {
        var t = e.autocomplete,
            r = e.autocompleteScopeApi,
            n = e.dom,
            i = e.propGetters,
            o = e.state;
        (0, p.setPropertiesWithoutEvents)(n.root, i.getRootProps(a({
            state: o,
            props: t.getRootProps({})
        }, r))), (0, p.setPropertiesWithoutEvents)(n.input, i.getInputProps(a({
            state: o,
            props: t.getInputProps({
                inputElement: n.input
            }),
            inputElement: n.input
        }, r))), (0, p.setProperties)(n.label, {
            hidden: "stalled" === o.status
        }), (0, p.setProperties)(n.loadingIndicator, {
            hidden: "stalled" !== o.status
        }), (0, p.setProperties)(n.clearButton, {
            hidden: !o.query
        }), (0, p.setProperties)(n.detachedSearchButtonQuery, {
            textContent: o.query
        }), (0, p.setProperties)(n.detachedSearchButtonPlaceholder, {
            hidden: Boolean(o.query)
        })
    }

    function f(e, t) {
        var r = t.autocomplete,
            n = t.autocompleteScopeApi,
            o = t.classNames,
            u = t.html,
            c = t.dom,
            s = t.panelContainer,
            l = t.propGetters,
            f = t.state,
            p = t.components,
            d = t.renderer;
        if (!f.isOpen) return void(s.contains(c.panel) && s.removeChild(c.panel));
        s.contains(c.panel) || "loading" === f.status || s.appendChild(c.panel), c.panel.classList.toggle("aa-Panel--stalled", "stalled" === f.status);
        var h = f.collections.filter(function(e) {
                var t = e.source,
                    r = e.items;
                return t.templates.noResults || r.length > 0
            }).map(function(e, t) {
                var c = e.source,
                    s = e.items;
                return d.createElement("section", {
                    key: t,
                    className: o.source,
                    "data-autocomplete-source-id": c.sourceId
                }, c.templates.header && d.createElement("div", {
                    className: o.sourceHeader
                }, c.templates.header({
                    components: p,
                    createElement: d.createElement,
                    Fragment: d.Fragment,
                    items: s,
                    source: c,
                    state: f,
                    html: u
                })), c.templates.noResults && 0 === s.length ? d.createElement("div", {
                    className: o.sourceNoResults
                }, c.templates.noResults({
                    components: p,
                    createElement: d.createElement,
                    Fragment: d.Fragment,
                    source: c,
                    state: f,
                    html: u
                })) : d.createElement("ul", i({
                    className: o.list
                }, l.getListProps(a({
                    state: f,
                    props: r.getListProps({
                        sourceIndex: t
                    })
                }, n))), s.map(function(e) {
                    var s = r.getItemProps({
                        item: e,
                        source: c,
                        sourceIndex: t
                    });
                    return d.createElement("li", i({
                        key: s.id,
                        className: o.item
                    }, l.getItemProps(a({
                        state: f,
                        props: s
                    }, n))), c.templates.item({
                        components: p,
                        createElement: d.createElement,
                        Fragment: d.Fragment,
                        item: e,
                        state: f,
                        html: u
                    }))
                })), c.templates.footer && d.createElement("div", {
                    className: o.sourceFooter
                }, c.templates.footer({
                    components: p,
                    createElement: d.createElement,
                    Fragment: d.Fragment,
                    items: s,
                    source: c,
                    state: f,
                    html: u
                })))
            }),
            m = d.createElement(d.Fragment, null, d.createElement("div", {
                className: o.panelLayout
            }, h), d.createElement("div", {
                className: "aa-GradientBottom"
            })),
            y = h.reduce(function(e, t) {
                return e[t.props["data-autocomplete-source-id"]] = t, e
            }, {});
        e(a(a({
            children: m,
            state: f,
            sections: h,
            elements: y
        }, d), {}, {
            components: p,
            html: u
        }, n), c.panel)
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.renderPanel = f, t.renderSearchBox = l;
    var p = r(9)
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = r(268);
    Object.keys(n).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === n[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return n[e]
            }
        }))
    });
    var i = r(269);
    Object.keys(i).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === i[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return i[e]
            }
        }))
    })
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function s(e) {
        var t = (0, l.createAlgoliaRequester)({
                transformResponse: function(e) {
                    return e.facetHits
                }
            }),
            r = e.queries.map(function(e) {
                return o(o({}, e), {}, {
                    type: "facet"
                })
            });
        return t(o(o({}, e), {}, {
            queries: r
        }))
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.getAlgoliaFacets = s;
    var l = r(67)
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.getAlgoliaResults = void 0;
    var n = r(67),
        i = (0, n.createAlgoliaRequester)({
            transformResponse: function(e) {
                return e.hits
            }
        });
    t.getAlgoliaResults = i
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = r(54);
    Object.keys(n).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === n[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return n[e]
            }
        }))
    });
    var i = r(271);
    Object.keys(i).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === i[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return i[e]
            }
        }))
    });
    var o = r(272);
    Object.keys(o).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === o[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return o[e]
            }
        }))
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = r(274);
    Object.keys(n).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === n[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return n[e]
            }
        }))
    });
    var i = r(68);
    Object.keys(i).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === i[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return i[e]
            }
        }))
    })
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function s(e, t) {
        var r = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (!r) {
            if (Array.isArray(e) || (r = l(e)) || t && e && "number" == typeof e.length) {
                r && (e = r);
                var n = 0,
                    i = function() {};
                return {
                    s: i,
                    n: function() {
                        return n >= e.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: e[n++]
                        }
                    },
                    e: function(e) {
                        throw e
                    },
                    f: i
                }
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }
        var o, a = !0,
            u = !1;
        return {
            s: function() {
                r = r.call(e)
            },
            n: function() {
                var e = r.next();
                return a = e.done, e
            },
            e: function(e) {
                u = !0, o = e
            },
            f: function() {
                try {
                    a || null == r.return || r.return()
                } finally {
                    if (u) throw o
                }
            }
        }
    }

    function l(e, t) {
        if (e) {
            if ("string" == typeof e) return f(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? f(e, t) : void 0
        }
    }

    function f(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
        return n
    }

    function p(e) {
        var t = d(e),
            r = t.searchClient,
            n = t.indexName,
            i = t.getSearchParams,
            a = t.transformSource,
            u = t.categoryAttribute,
            c = t.itemsWithCategories,
            l = t.categoriesPerItem;
        return {
            name: "aa.querySuggestionsPlugin",
            getSources: function(e) {
                function t(e) {
                    p("".concat(e.query, " ")), d()
                }
                var f = e.query,
                    p = e.setQuery,
                    d = e.refresh,
                    b = e.state;
                return [a({
                    source: {
                        sourceId: "querySuggestionsPlugin",
                        getItemInputValue: function(e) {
                            return e.item.query
                        },
                        getItems: function() {
                            return (0, h.getAlgoliaResults)({
                                searchClient: r,
                                queries: [{
                                    indexName: n,
                                    query: f,
                                    params: i({
                                        state: b
                                    })
                                }],
                                transformResponse: function(e) {
                                    var t = e.hits,
                                        r = t[0];
                                    if (!f || !u) return r;
                                    var n = 0;
                                    return r.reduce(function(e, t) {
                                        var r = [t];
                                        if (n < c) {
                                            var i = ((0, m.getAttributeValueByPath)(t, Array.isArray(u) ? u : [u]) || []).map(function(e) {
                                                return e.value
                                            }).slice(0, l);
                                            i.length > 0 && n++;
                                            var a, f = s(i);
                                            try {
                                                for (f.s(); !(a = f.n()).done;) {
                                                    var p = a.value;
                                                    r.push(o({
                                                        __autocomplete_qsCategory: p
                                                    }, t))
                                                }
                                            } catch (e) {
                                                f.e(e)
                                            } finally {
                                                f.f()
                                            }
                                        }
                                        return e.push.apply(e, r), e
                                    }, [])
                                }
                            })
                        },
                        templates: (0, y.getTemplates)({
                            onTapAhead: t
                        })
                    },
                    onTapAhead: t,
                    state: b
                })]
            },
            __autocomplete_pluginOptions: e
        }
    }

    function d(e) {
        return o({
            getSearchParams: function() {
                return {}
            },
            transformSource: function(e) {
                return e.source
            },
            itemsWithCategories: 1,
            categoriesPerItem: 1
        }, e)
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.createQuerySuggestionsPlugin = p;
    var h = r(52),
        m = r(4),
        y = r(68)
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function s(e, t) {
        return h(e) || d(e, t) || f(e, t) || l()
    }

    function l() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
    }

    function f(e, t) {
        if (e) {
            if ("string" == typeof e) return p(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? p(e, t) : void 0
        }
    }

    function p(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
        return n
    }

    function d(e, t) {
        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (null != r) {
            var n, i, o, a, u = [],
                c = !0,
                s = !1;
            try {
                if (o = (r = r.call(e)).next, 0 === t) {
                    if (Object(r) !== r) return;
                    c = !1
                } else
                    for (; !(c = (n = o.call(r)).done) && (u.push(n.value), u.length !== t); c = !0);
            } catch (e) {
                s = !0, i = e
            } finally {
                try {
                    if (!c && null != r.return && (a = r.return(), Object(a) !== a)) return
                } finally {
                    if (s) throw i
                }
            }
            return u
        }
    }

    function h(e) {
        if (Array.isArray(e)) return e
    }
    var m = r(1);
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var y = r(3),
        b = r(2),
        v = m(r(278)),
        g = m(r(281)),
        _ = r(5),
        O = r(0),
        j = (0, O.createDocumentationMessageGenerator)({
            name: "range-slider"
        }),
        P = (0, _.component)("RangeSlider"),
        S = function(e) {
            var t = e.containerNode,
                r = e.cssClasses,
                n = e.pips,
                i = e.step,
                o = e.tooltips;
            return function(e, a) {
                var u = e.refine,
                    c = e.range,
                    l = e.start;
                if (!a) {
                    var f = c.min,
                        p = c.max,
                        d = s(l, 2),
                        h = d[0],
                        m = d[1],
                        y = h === -1 / 0 ? f : h,
                        g = m === 1 / 0 ? p : m,
                        _ = [y > p ? p : y, g < f ? f : g];
                    (0, b.render)((0, b.h)(v.default, {
                        cssClasses: r,
                        refine: u,
                        min: f,
                        max: p,
                        values: _,
                        tooltips: o,
                        step: i,
                        pips: n
                    }), t)
                }
            }
        },
        w = function(e) {
            var t = e || {},
                r = t.container,
                n = t.attribute,
                i = t.min,
                a = t.max,
                u = t.cssClasses,
                c = void 0 === u ? {} : u,
                s = t.step,
                l = t.pips,
                f = void 0 === l || l,
                p = t.precision,
                d = void 0 === p ? 0 : p,
                h = t.tooltips,
                m = void 0 === h || h;
            if (!r) throw new Error(j("The `container` option is required."));
            var v = (0, O.getContainerNode)(r),
                _ = {
                    root: (0, y.cx)(P(), c.root),
                    disabledRoot: (0, y.cx)(P({
                        modifierName: "disabled"
                    }), c.disabledRoot)
                },
                w = S({
                    containerNode: v,
                    step: s,
                    pips: f,
                    tooltips: m,
                    cssClasses: _
                });
            return o(o({}, (0, g.default)(w, function() {
                return (0, b.render)(null, v)
            })({
                attribute: n,
                min: i,
                max: a,
                precision: d
            })), {}, {
                $$type: "ais.rangeSlider",
                $$widgetType: "ais.rangeSlider"
            })
        },
        E = w;
    t.default = E
}, function(e, t, r) {
    "use strict";

    function n() {
        for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
        return t.reduce(function(e, t) {
            return Array.isArray(t) ? e.concat(t) : e.concat([t])
        }, []).filter(Boolean).join(" ")
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.cx = n
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    })
}, function(e, t, r) {
    "use strict";

    function n(e) {
        return u(e) || a(e) || o(e) || i()
    }

    function i() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
    }

    function o(e, t) {
        if (e) {
            if ("string" == typeof e) return c(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? c(e, t) : void 0
        }
    }

    function a(e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e)
    }

    function u(e) {
        if (Array.isArray(e)) return c(e)
    }

    function c(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
        return n
    }

    function s() {
        return s = Object.assign ? Object.assign.bind() : function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = arguments[t];
                for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
            }
            return e
        }, s.apply(this, arguments)
    }

    function l(e) {
        "@babel/helpers - typeof";
        return (l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function f(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
    }

    function p(e, t) {
        for (var r = 0; r < t.length; r++) {
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, j(n.key), n)
        }
    }

    function d(e, t, r) {
        return t && p(e.prototype, t), r && p(e, r), Object.defineProperty(e, "prototype", {
            writable: !1
        }), e
    }

    function h(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
            constructor: {
                value: e,
                writable: !0,
                configurable: !0
            }
        }), Object.defineProperty(e, "prototype", {
            writable: !1
        }), t && m(e, t)
    }

    function m(e, t) {
        return (m = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
            return e.__proto__ = t, e
        })(e, t)
    }

    function y(e) {
        var t = g();
        return function() {
            var r, n = _(e);
            if (t) {
                var i = _(this).constructor;
                r = Reflect.construct(n, arguments, i)
            } else r = n.apply(this, arguments);
            return b(this, r)
        }
    }

    function b(e, t) {
        if (t && ("object" === l(t) || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return v(e)
    }

    function v(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e
    }

    function g() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0
        } catch (e) {
            return !1
        }
    }

    function _(e) {
        return (_ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e)
        })(e)
    }

    function O(e, t, r) {
        return t = j(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function j(e) {
        var t = P(e, "string");
        return "symbol" === l(t) ? t : String(t)
    }

    function P(e, t) {
        if ("object" !== l(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" !== l(n)) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }
    var S = r(1);
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var w = r(3),
        E = r(2),
        R = r(0),
        x = S(r(279)),
        I = S(r(280)),
        k = function(e) {
            function t() {
                var e;
                f(this, t);
                for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++) i[o] = arguments[o];
                return e = r.call.apply(r, [this].concat(i)), O(v(e), "handleChange", function(t) {
                    var r = t.values;
                    e.isDisabled || e.props.refine(r)
                }), O(v(e), "createHandleComponent", function(e) {
                    return function(t) {
                        var r = Math.round(100 * parseFloat(t["aria-valuenow"])) / 100,
                            n = "object" === l(e) && e.format ? e.format(r) : r,
                            i = (0, w.cx)(t.className, 0 === t["data-handle-key"] && "rheostat-handle-lower", 1 === t["data-handle-key"] && "rheostat-handle-upper");
                        return (0, E.h)("div", s({}, t, {
                            className: i
                        }), e && (0, E.h)("div", {
                            className: "rheostat-tooltip"
                        }, n))
                    }
                }), e
            }
            h(t, e);
            var r = y(t);
            return d(t, [{
                key: "isDisabled",
                get: function() {
                    return this.props.min >= this.props.max
                }
            }, {
                key: "computeDefaultPitPoints",
                value: function(e) {
                    var t = e.min,
                        r = e.max,
                        i = r - t,
                        o = i / 34;
                    return [t].concat(n((0, R.range)({
                        end: 33
                    }).map(function(e) {
                        return t + o * (e + 1)
                    })), [r])
                }
            }, {
                key: "computeSnapPoints",
                value: function(e) {
                    var t = e.min,
                        r = e.max,
                        i = e.step;
                    if (i) return [].concat(n((0, R.range)({
                        start: t,
                        end: r,
                        step: i
                    })), [r])
                }
            }, {
                key: "render",
                value: function() {
                    var e = this.props,
                        t = e.tooltips,
                        r = e.step,
                        n = e.pips,
                        i = e.values,
                        o = e.cssClasses,
                        a = this.isDisabled ? {
                            min: this.props.min,
                            max: this.props.max + .001
                        } : this.props,
                        u = a.min,
                        c = a.max,
                        s = this.computeSnapPoints({
                            min: u,
                            max: c,
                            step: r
                        }),
                        l = !1 === n ? [] : this.computeDefaultPitPoints({
                            min: u,
                            max: c
                        });
                    return (0, E.h)("div", {
                        className: (0, w.cx)(o.root, this.isDisabled && o.disabledRoot)
                    }, (0, E.h)(I.default, {
                        handle: this.createHandleComponent(t),
                        onChange: this.handleChange,
                        min: u,
                        max: c,
                        pitComponent: x.default,
                        pitPoints: l,
                        snap: !0,
                        snapPoints: s,
                        values: this.isDisabled ? [u, c] : i,
                        disabled: this.isDisabled
                    }))
                }
            }]), t
        }(E.Component),
        M = k;
    t.default = M
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var s = r(3),
        l = r(2),
        f = function(e) {
            var t = e.style,
                r = e.children,
                n = Math.round(parseFloat(t.left)),
                i = [0, 50, 100].includes(n),
                a = r,
                u = Math.round(100 * parseInt(a, 10)) / 100;
            return (0, l.h)("div", {
                style: o(o({}, t), {}, {
                    marginLeft: 100 === n ? "-2px" : 0
                }),
                className: (0, s.cx)("rheostat-marker", "rheostat-marker-horizontal", i && "rheostat-marker-large")
            }, i && (0, l.h)("div", {
                className: "rheostat-value"
            }, u))
        },
        p = f;
    t.default = p
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        for (var r = 0; r < t.length; r++) {
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, m(n.key), n)
        }
    }

    function o(e, t, r) {
        return t && i(e.prototype, t), r && i(e, r), Object.defineProperty(e, "prototype", {
            writable: !1
        }), e
    }

    function a(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
    }

    function u(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
            constructor: {
                value: e,
                writable: !0,
                configurable: !0
            }
        }), Object.defineProperty(e, "prototype", {
            writable: !1
        }), t && c(e, t)
    }

    function c(e, t) {
        return (c = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
            return e.__proto__ = t, e
        })(e, t)
    }

    function s(e) {
        var t = p();
        return function() {
            var r, n = d(e);
            if (t) {
                var i = d(this).constructor;
                r = Reflect.construct(n, arguments, i)
            } else r = n.apply(this, arguments);
            return l(this, r)
        }
    }

    function l(e, t) {
        if (t && ("object" === n(t) || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return f(e)
    }

    function f(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e
    }

    function p() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0
        } catch (e) {
            return !1
        }
    }

    function d(e) {
        return (d = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e)
        })(e)
    }

    function h(e, t, r) {
        return t = m(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function m(e) {
        var t = y(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function y(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function b() {
        return b = Object.assign ? Object.assign.bind() : function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = arguments[t];
                for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
            }
            return e
        }, b.apply(this, arguments)
    }

    function v(e, t, r) {
        return (e - t) / (r - t) * 100
    }

    function g(e, t, r) {
        var n = e / 100;
        return 0 === e ? t : 100 === e ? r : Math.round((r - t) * n + t)
    }

    function _(e) {
        return ["rheostat", "vertical" === e.orientation ? "rheostat-vertical" : "rheostat-horizontal"].concat(e.className.split(" ")).join(" ")
    }

    function O(e) {
        return Number(e.currentTarget.getAttribute("data-handle-key"))
    }

    function j(e) {
        e.stopPropagation(), e.preventDefault()
    }

    function P(e) {
        return (0, S.h)("button", b({}, e, {
            type: "button"
        }))
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var S = r(2),
        w = {
            DOWN: 40,
            END: 35,
            ESC: 27,
            HOME: 36,
            LEFT: 37,
            PAGE_DOWN: 34,
            PAGE_UP: 33,
            RIGHT: 39,
            UP: 38
        },
        E = 0,
        R = 100,
        x = (0, S.h)("div", {
            className: "rheostat-background"
        }),
        I = function(e) {
            function t() {
                var e;
                a(this, t);
                for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++) i[o] = arguments[o];
                return e = r.call.apply(r, [this].concat(i)), h(f(e), "x", [0, 0].map(function(e) {
                    return e
                })), h(f(e), "state", {
                    className: _(e.props),
                    handlePos: e.props.values.map(function(t) {
                        return v(t, e.props.min, e.props.max)
                    }),
                    handleDimensions: 0,
                    mousePos: null,
                    sliderBox: {},
                    slidingIndex: null,
                    values: e.props.values
                }), h(f(e), "rheostat", (0, S.createRef)()), h(f(e), "componentWillReceiveProps", function(t) {
                    var r = e.props,
                        n = r.className,
                        i = r.disabled,
                        o = r.min,
                        a = r.max,
                        u = r.orientation,
                        c = e.state,
                        s = c.values,
                        l = c.slidingIndex,
                        f = t.min !== o || t.max !== a,
                        p = s.length !== t.values.length || s.some(function(e, r) {
                            return t.values[r] !== e
                        }),
                        d = t.className !== n || t.orientation !== u,
                        h = t.disabled && !i;
                    d && e.setState({
                        className: _(t)
                    }), (f || p) && e.updateNewValues(t), h && null !== l && e.endSlide()
                }), h(f(e), "getPublicState", function() {
                    var t = e.props,
                        r = t.min;
                    return {
                        max: t.max,
                        min: r,
                        values: e.state.values
                    }
                }), h(f(e), "getSliderBoundingBox", function() {
                    var t = e.rheostat.current,
                        r = t.getBoundingClientRect();
                    return {
                        height: r.height || t.clientHeight,
                        left: r.left,
                        top: r.top,
                        width: r.width || t.clientWidth
                    }
                }), h(f(e), "getProgressStyle", function(t) {
                    var r = e.state.handlePos,
                        n = r[t];
                    if (0 === t) return "vertical" === e.props.orientation ? {
                        height: "".concat(n, "%"),
                        top: 0
                    } : {
                        left: 0,
                        width: "".concat(n, "%")
                    };
                    var i = r[t - 1],
                        o = n - i;
                    return "vertical" === e.props.orientation ? {
                        height: "".concat(o, "%"),
                        top: "".concat(i, "%")
                    } : {
                        left: "".concat(i, "%"),
                        width: "".concat(o, "%")
                    }
                }), h(f(e), "getMinValue", function(t) {
                    return e.state.values[t - 1] ? Math.max(e.props.min, e.state.values[t - 1]) : e.props.min
                }), h(f(e), "getMaxValue", function(t) {
                    return e.state.values[t + 1] ? Math.min(e.props.max, e.state.values[t + 1]) : e.props.max
                }), h(f(e), "getHandleDimensions", function(t, r) {
                    var n = t.currentTarget || null;
                    return n ? "vertical" === e.props.orientation ? n.clientHeight / r.height * R / 2 : n.clientWidth / r.width * R / 2 : 0
                }), h(f(e), "getClosestSnapPoint", function(t) {
                    return e.props.snapPoints.length ? e.props.snapPoints.reduce(function(e, r) {
                        return Math.abs(e - t) < Math.abs(r - t) ? e : r
                    }) : t
                }), h(f(e), "getSnapPosition", function(t) {
                    if (!e.props.snap) return t;
                    var r = e.props,
                        n = r.max,
                        i = r.min,
                        o = g(t, i, n);
                    return v(e.getClosestSnapPoint(o), i, n)
                }), h(f(e), "getNextPositionForKey", function(t, r) {
                    var n, i = e.state,
                        o = i.handlePos,
                        a = i.values,
                        u = e.props,
                        c = u.max,
                        s = u.min,
                        l = u.snapPoints,
                        f = e.props.snap,
                        p = a[t],
                        d = o[t],
                        m = d,
                        y = 1;
                    c >= 100 ? d = Math.round(d) : y = 100 / (c - s);
                    var b = null;
                    f && (b = l.indexOf(e.getClosestSnapPoint(a[t])));
                    var g = (n = {}, h(n, w.LEFT, function(e) {
                        return -1 * e
                    }), h(n, w.RIGHT, function(e) {
                        return e
                    }), h(n, w.UP, function(e) {
                        return e
                    }), h(n, w.DOWN, function(e) {
                        return -1 * e
                    }), h(n, w.PAGE_DOWN, function(e) {
                        return e > 1 ? -e : -10 * e
                    }), h(n, w.PAGE_UP, function(e) {
                        return e > 1 ? e : 10 * e
                    }), n);
                    if (Object.prototype.hasOwnProperty.call(g, r)) d += g[r](y), f && b && (d > m ? b < l.length - 1 && (p = l[b + 1]) : b > 0 && (p = l[b - 1]));
                    else if (r === w.HOME) d = E, f && (p = l[0]);
                    else {
                        if (r !== w.END) return null;
                        d = R, f && (p = l[l.length - 1])
                    }
                    return f ? v(p, s, c) : d
                }), h(f(e), "getNextState", function(t, r) {
                    var n = e.state.handlePos,
                        i = e.props,
                        o = i.max,
                        a = i.min,
                        u = e.validatePosition(t, r),
                        c = n.map(function(e, r) {
                            return r === t ? u : e
                        });
                    return {
                        handlePos: c,
                        values: c.map(function(e) {
                            return g(e, a, o)
                        })
                    }
                }), h(f(e), "getClosestHandle", function(t) {
                    var r = e.state.handlePos;
                    return r.reduce(function(e, n, i) {
                        return Math.abs(r[i] - t) < Math.abs(r[e] - t) ? i : e
                    }, 0)
                }), h(f(e), "setStartSlide", function(t, r, n) {
                    var i = e.getSliderBoundingBox();
                    e.setState({
                        handleDimensions: e.getHandleDimensions(t, i),
                        mousePos: {
                            x: r,
                            y: n
                        },
                        sliderBox: i,
                        slidingIndex: O(t)
                    })
                }), h(f(e), "startMouseSlide", function(t) {
                    e.setStartSlide(t, t.clientX, t.clientY), document.addEventListener("mousemove", e.handleMouseSlide, !1), document.addEventListener("mouseup", e.endSlide, !1), j(t)
                }), h(f(e), "startTouchSlide", function(t) {
                    if (!(t.changedTouches.length > 1)) {
                        var r = t.changedTouches[0];
                        e.setStartSlide(t, r.clientX, r.clientY), document.addEventListener("touchmove", e.handleTouchSlide, !1), document.addEventListener("touchend", e.endSlide, !1), e.props.onSliderDragStart && e.props.onSliderDragStart(), j(t)
                    }
                }), h(f(e), "handleMouseSlide", function(t) {
                    null !== e.state.slidingIndex && (e.handleSlide(t.clientX, t.clientY), j(t))
                }), h(f(e), "handleTouchSlide", function(t) {
                    if (null !== e.state.slidingIndex) {
                        if (t.changedTouches.length > 1) return void e.endSlide();
                        var r = t.changedTouches[0];
                        e.handleSlide(r.clientX, r.clientY), j(t)
                    }
                }), h(f(e), "handleSlide", function(t, r) {
                    var n = e.state,
                        i = n.slidingIndex,
                        o = n.sliderBox,
                        a = "vertical" === e.props.orientation ? (r - o.top) / o.height * R : (t - o.left) / o.width * R;
                    e.slideTo(i, a), e.canMove(i, a) && (e.setState({
                        mousePos: {
                            x: t,
                            y: r
                        }
                    }), e.props.onSliderDragMove && e.props.onSliderDragMove())
                }), h(f(e), "endSlide", function() {
                    var t = e.state.slidingIndex;
                    if (e.setState({
                            slidingIndex: null
                        }), document.removeEventListener("mouseup", e.endSlide, !1), document.removeEventListener("touchend", e.endSlide, !1), document.removeEventListener("touchmove", e.handleTouchSlide, !1), document.removeEventListener("mousemove", e.handleMouseSlide, !1), e.props.onSliderDragEnd && e.props.onSliderDragEnd(), e.props.snap) {
                        var r = e.getSnapPosition(e.state.handlePos[t]);
                        e.slideTo(t, r, function() {
                            return e.fireChangeEvent()
                        })
                    } else e.fireChangeEvent()
                }), h(f(e), "handleClick", function(t) {
                    if (!t.target.getAttribute("data-handle-key")) {
                        var r = e.getSliderBoundingBox(),
                            n = "vertical" === e.props.orientation ? (t.clientY - r.top) / r.height : (t.clientX - r.left) / r.width,
                            i = n * R,
                            o = e.getClosestHandle(i),
                            a = e.getSnapPosition(i);
                        e.slideTo(o, a, function() {
                            return e.fireChangeEvent()
                        }), e.props.onClick && e.props.onClick()
                    }
                }), h(f(e), "handleKeydown", function(t) {
                    var r = O(t);
                    if (t.keyCode === w.ESC) return void t.currentTarget.blur();
                    var n = e.getNextPositionForKey(r, t.keyCode);
                    null !== n && (e.canMove(r, n) && (e.slideTo(r, n, function() {
                        return e.fireChangeEvent()
                    }), e.props.onKeyPress && e.props.onKeyPress()), j(t))
                }), h(f(e), "validatePosition", function(t, r) {
                    var n = e.state,
                        i = n.handlePos,
                        o = n.handleDimensions;
                    return Math.max(Math.min(r, void 0 !== i[t + 1] ? i[t + 1] - o : R), void 0 !== i[t - 1] ? i[t - 1] + o : E)
                }), h(f(e), "validateValues", function(t, r) {
                    var n = r || e.props,
                        i = n.max,
                        o = n.min;
                    return t.map(function(e, t, r) {
                        var n = Math.max(Math.min(e, i), o);
                        return r.length && n < r[t - 1] ? r[t - 1] : n
                    })
                }), h(f(e), "canMove", function(t, r) {
                    var n = e.state,
                        i = n.handlePos,
                        o = n.handleDimensions;
                    return !(r < E || r > R || r > (void 0 !== i[t + 1] ? i[t + 1] - o : 1 / 0) || r < (void 0 !== i[t - 1] ? i[t - 1] + o : -1 / 0))
                }), h(f(e), "fireChangeEvent", function() {
                    var t = e.props.onChange;
                    t && t(e.getPublicState())
                }), h(f(e), "slideTo", function(t, r, n) {
                    var i = e.getNextState(t, r);
                    e.setState(i, function() {
                        var t = e.props.onValuesUpdated;
                        t && t(e.getPublicState()), n && n()
                    })
                }), h(f(e), "updateNewValues", function(t) {
                    if (null === e.state.slidingIndex) {
                        var r = t.max,
                            n = t.min,
                            i = t.values,
                            o = e.validateValues(i, t);
                        e.setState({
                            handlePos: o.map(function(e) {
                                return v(e, n, r)
                            }),
                            values: o
                        }, function() {
                            return e.fireChangeEvent()
                        })
                    }
                }), h(f(e), "render", function() {
                    var t = e.props,
                        r = t.children,
                        n = t.disabled,
                        i = t.handle,
                        o = t.max,
                        a = t.min,
                        u = t.orientation,
                        c = t.pitComponent,
                        s = t.pitPoints,
                        l = t.progressBar,
                        f = e.state,
                        p = f.className,
                        d = f.handlePos,
                        h = f.values;
                    return (0, S.h)("div", {
                        className: p,
                        ref: e.rheostat,
                        onClick: n ? void 0 : e.handleClick,
                        style: {
                            position: "relative"
                        }
                    }, x, d.map(function(t, r) {
                        var o = "vertical" === u ? {
                            top: "".concat(t, "%"),
                            position: "absolute"
                        } : {
                            left: "".concat(t, "%"),
                            position: "absolute"
                        };
                        return (0, S.h)(i, {
                            "aria-valuemax": e.getMaxValue(r),
                            "aria-valuemin": e.getMinValue(r),
                            "aria-valuenow": h[r],
                            "aria-disabled": n,
                            "data-handle-key": r,
                            className: "rheostat-handle",
                            key: "handle-".concat(r),
                            onClick: j,
                            onKeyDown: n ? void 0 : e.handleKeydown,
                            onMouseDown: n ? void 0 : e.startMouseSlide,
                            onTouchStart: n ? void 0 : e.startTouchSlide,
                            role: "slider",
                            style: o,
                            tabIndex: 0
                        })
                    }), d.map(function(t, r, n) {
                        return 0 === r && n.length > 1 ? null : (0, S.h)(l, {
                            className: "rheostat-progress",
                            key: "progress-bar-".concat(r),
                            style: e.getProgressStyle(r)
                        })
                    }), c && s.map(function(e) {
                        var t = v(e, a, o),
                            r = "vertical" === u ? {
                                top: "".concat(t, "%"),
                                position: "absolute"
                            } : {
                                left: "".concat(t, "%"),
                                position: "absolute"
                            };
                        return (0, S.h)(c, {
                            key: "pit-".concat(e),
                            style: r
                        }, e)
                    }), r)
                }), e
            }
            u(t, e);
            var r = s(t);
            return o(t)
        }(S.Component);
    h(I, "defaultProps", {
        className: "",
        children: null,
        disabled: !1,
        handle: P,
        max: R,
        min: E,
        onClick: null,
        onChange: null,
        onKeyPress: null,
        onSliderDragEnd: null,
        onSliderDragMove: null,
        onSliderDragStart: null,
        onValuesUpdated: null,
        orientation: "horizontal",
        pitComponent: null,
        pitPoints: [],
        progressBar: "div",
        snap: !1,
        snapPoints: [],
        values: [E]
    });
    var k = I;
    t.default = k
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function s(e, t) {
        return h(e) || d(e, t) || f(e, t) || l()
    }

    function l() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
    }

    function f(e, t) {
        if (e) {
            if ("string" == typeof e) return p(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? p(e, t) : void 0
        }
    }

    function p(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
        return n
    }

    function d(e, t) {
        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (null != r) {
            var n, i, o, a, u = [],
                c = !0,
                s = !1;
            try {
                if (o = (r = r.call(e)).next, 0 === t) {
                    if (Object(r) !== r) return;
                    c = !1
                } else
                    for (; !(c = (n = o.call(r)).done) && (u.push(n.value), u.length !== t); c = !0);
            } catch (e) {
                s = !0, i = e
            } finally {
                try {
                    if (!c && null != r.return && (a = r.return(), Object(a) !== a)) return
                } finally {
                    if (s) throw i
                }
            }
            return u
        }
    }

    function h(e) {
        if (Array.isArray(e)) return e
    }

    function m(e) {
        var t = e.min,
            r = e.max,
            n = e.precision,
            i = Math.pow(10, n);
        return {
            min: t ? Math.floor(t * i) / i : t,
            max: r ? Math.ceil(r * i) / i : r
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var y = r(0),
        b = (0, y.createDocumentationMessageGenerator)({
            name: "range-input",
            connector: !0
        }, {
            name: "range-slider",
            connector: !0
        }),
        v = function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : y.noop;
            return (0, y.checkRendering)(e, b()),
                function(r) {
                    function n(e) {
                        var t;
                        t = (0, y.isFiniteNumber)(p) ? p : (0, y.isFiniteNumber)(e.min) ? e.min : 0;
                        var r;
                        return r = (0, y.isFiniteNumber)(d) ? d : (0, y.isFiniteNumber)(e.max) ? e.max : 0, m({
                            min: t,
                            max: r,
                            precision: v
                        })
                    }

                    function i(e) {
                        var t = e.getNumericRefinement(f, ">=") || [],
                            r = s(t, 1),
                            n = r[0],
                            i = e.getNumericRefinement(f, "<=") || [],
                            o = s(i, 1),
                            a = o[0];
                        return [(0, y.isFiniteNumber)(n) ? n : -1 / 0, (0, y.isFiniteNumber)(a) ? a : 1 / 0]
                    }

                    function u(e, t) {
                        return function() {
                            var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [void 0, void 0],
                                n = s(r, 2),
                                i = n[0],
                                o = n[1],
                                a = O(e, t, i, o);
                            a && e.setState(a).search()
                        }
                    }
                    var c = r || {},
                        l = c.attribute,
                        f = void 0 === l ? "" : l,
                        p = c.min,
                        d = c.max,
                        h = c.precision,
                        v = void 0 === h ? 0 : h;
                    if (!f) throw new Error(b("The `attribute` option is required."));
                    if ((0, y.isFiniteNumber)(p) && (0, y.isFiniteNumber)(d) && p > d) throw new Error(b("The `max` option can't be lower than `min`."));
                    var g = function(e) {
                            return Number(Number(e).toFixed(v))
                        },
                        _ = {
                            from: function(e) {
                                return e.toLocaleString()
                            },
                            to: function(e) {
                                return g(e).toLocaleString()
                            }
                        },
                        O = function(e, t, r, n) {
                            var i, o = e.state,
                                a = t.min,
                                u = t.max,
                                c = o.getNumericRefinement(f, ">=") || [],
                                l = s(c, 1),
                                h = l[0],
                                b = o.getNumericRefinement(f, "<=") || [],
                                g = s(b, 1),
                                _ = g[0],
                                O = void 0 === r || "" === r,
                                j = void 0 === n || "" === n,
                                P = m({
                                    min: O ? void 0 : parseFloat(r),
                                    max: j ? void 0 : parseFloat(n),
                                    precision: v
                                }),
                                S = P.min,
                                w = P.max;
                            i = (0, y.isFiniteNumber)(p) || a !== S ? (0, y.isFiniteNumber)(p) && O ? p : S : void 0;
                            var E;
                            E = (0, y.isFiniteNumber)(d) || u !== w ? (0, y.isFiniteNumber)(d) && j ? d : w : void 0;
                            var R = void 0 === i,
                                x = (0, y.isFiniteNumber)(a) && a <= i,
                                I = R || (0, y.isFiniteNumber)(i) && (!(0, y.isFiniteNumber)(a) || x),
                                k = void 0 === E,
                                M = (0, y.isFiniteNumber)(E) && u >= E,
                                A = k || (0, y.isFiniteNumber)(E) && (!(0, y.isFiniteNumber)(u) || M),
                                N = h !== i,
                                C = _ !== E;
                            return (N || C) && I && A ? (o = o.removeNumericRefinement(f), (0, y.isFiniteNumber)(i) && (o = o.addNumericRefinement(f, ">=", i)), (0, y.isFiniteNumber)(E) && (o = o.addNumericRefinement(f, "<=", E)), o.resetPage()) : null
                        },
                        j = function(e) {
                            return function() {
                                if (1 === arguments.length) return void e.sendEventToInsights(arguments.length <= 0 ? void 0 : arguments[0])
                            }
                        };
                    return {
                        $$type: "ais.range",
                        init: function(t) {
                            e(o(o({}, this.getWidgetRenderState(t)), {}, {
                                instantSearchInstance: t.instantSearchInstance
                            }), !0)
                        },
                        render: function(t) {
                            e(o(o({}, this.getWidgetRenderState(t)), {}, {
                                instantSearchInstance: t.instantSearchInstance
                            }), !1)
                        },
                        getRenderState: function(e, t) {
                            return o(o({}, e), {}, {
                                range: o(o({}, e.range), {}, a({}, f, this.getWidgetRenderState(t)))
                            })
                        },
                        getWidgetRenderState: function(e) {
                            var t, a = e.results,
                                c = e.helper,
                                s = e.instantSearchInstance,
                                l = a && a.disjunctiveFacets || [],
                                p = (0, y.find)(l, function(e) {
                                    return e.name === f
                                }),
                                d = p && p.stats || {
                                    min: void 0,
                                    max: void 0
                                },
                                h = n(d),
                                m = i(c);
                            return t = a ? u(c, h) : u(c, {
                                min: void 0,
                                max: void 0
                            }), {
                                refine: t,
                                canRefine: h.min !== h.max,
                                format: _,
                                range: h,
                                sendEvent: j(s),
                                widgetParams: o(o({}, r), {}, {
                                    precision: v
                                }),
                                start: m
                            }
                        },
                        dispose: function(e) {
                            var r = e.state;
                            return t(), r.removeDisjunctiveFacet(f).removeNumericRefinement(f)
                        },
                        getWidgetUiState: function(e, t) {
                            var r = t.searchParameters,
                                n = r.getNumericRefinements(f),
                                i = n[">="],
                                u = void 0 === i ? [] : i,
                                c = n["<="],
                                s = void 0 === c ? [] : c;
                            return 0 === u.length && 0 === s.length ? e : o(o({}, e), {}, {
                                range: o(o({}, e.range), {}, a({}, f, "".concat(u, ":").concat(s)))
                            })
                        },
                        getWidgetSearchParameters: function(e, t) {
                            var r = t.uiState,
                                n = e.addDisjunctiveFacet(f).setQueryParameters({
                                    numericRefinements: o(o({}, e.numericRefinements), {}, a({}, f, {}))
                                });
                            (0, y.isFiniteNumber)(p) && (n = n.addNumericRefinement(f, ">=", p)), (0, y.isFiniteNumber)(d) && (n = n.addNumericRefinement(f, "<=", d));
                            var i = r.range && r.range[f];
                            if (!i || -1 === i.indexOf(":")) return n;
                            var u = i.split(":").map(parseFloat),
                                c = s(u, 2),
                                l = c[0],
                                h = c[1];
                            return (0, y.isFiniteNumber)(l) && (!(0, y.isFiniteNumber)(p) || p < l) && (n = n.removeNumericRefinement(f, ">="), n = n.addNumericRefinement(f, ">=", l)), (0, y.isFiniteNumber)(h) && (!(0, y.isFiniteNumber)(d) || h < d) && (n = n.removeNumericRefinement(f, "<="), n = n.addNumericRefinement(f, "<=", h)), n
                        }
                    }
                }
        },
        g = v;
    t.default = g
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }
    var s = r(1);
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var l = r(3),
        f = r(2),
        p = s(r(71)),
        d = s(r(303)),
        h = r(5),
        m = r(10),
        y = r(0),
        b = s(r(304)),
        v = (0, y.createDocumentationMessageGenerator)({
            name: "menu"
        }),
        g = (0, h.component)("Menu"),
        _ = function(e) {
            var t = e.containerNode,
                r = e.cssClasses,
                n = e.renderState,
                i = e.templates,
                a = e.showMore;
            return function(e, u) {
                var c = e.refine,
                    s = e.items,
                    l = e.createURL,
                    d = e.instantSearchInstance,
                    h = e.isShowingMore,
                    y = e.toggleShowMore,
                    v = e.canToggleShowMore;
                if (u) return void(n.templateProps = (0, m.prepareTemplateProps)({
                    defaultTemplates: b.default,
                    templatesConfig: d.templatesConfig,
                    templates: i
                }));
                var g = s.map(function(e) {
                    return o(o({}, e), {}, {
                        url: l(e.value)
                    })
                });
                (0, f.render)((0, f.h)(p.default, {
                    createURL: l,
                    cssClasses: r,
                    facetValues: g,
                    showMore: a,
                    templateProps: n.templateProps,
                    toggleRefinement: c,
                    toggleShowMore: y,
                    isShowingMore: h,
                    canToggleShowMore: v
                }), t)
            }
        },
        O = function(e) {
            var t = e || {},
                r = t.container,
                n = t.attribute,
                i = t.sortBy,
                a = t.limit,
                u = t.showMore,
                c = t.showMoreLimit,
                s = t.cssClasses,
                p = void 0 === s ? {} : s,
                h = t.templates,
                m = void 0 === h ? {} : h,
                b = t.transformItems;
            if (!r) throw new Error(v("The `container` option is required."));
            var O = (0, y.getContainerNode)(r),
                j = {
                    root: (0, l.cx)(g(), p.root),
                    noRefinementRoot: (0, l.cx)(g({
                        modifierName: "noRefinement"
                    }), p.noRefinementRoot),
                    list: (0, l.cx)(g({
                        descendantName: "list"
                    }), p.list),
                    item: (0, l.cx)(g({
                        descendantName: "item"
                    }), p.item),
                    selectedItem: (0, l.cx)(g({
                        descendantName: "item",
                        modifierName: "selected"
                    }), p.selectedItem),
                    link: (0, l.cx)(g({
                        descendantName: "link"
                    }), p.link),
                    label: (0, l.cx)(g({
                        descendantName: "label"
                    }), p.label),
                    count: (0, l.cx)(g({
                        descendantName: "count"
                    }), p.count),
                    showMore: (0, l.cx)(g({
                        descendantName: "showMore"
                    }), p.showMore),
                    disabledShowMore: (0, l.cx)(g({
                        descendantName: "showMore",
                        modifierName: "disabled"
                    }), p.disabledShowMore)
                },
                P = _({
                    containerNode: O,
                    cssClasses: j,
                    renderState: {},
                    templates: m,
                    showMore: u
                });
            return o(o({}, (0, d.default)(P, function() {
                return (0, f.render)(null, O)
            })({
                attribute: n,
                limit: a,
                showMore: u,
                showMoreLimit: c,
                sortBy: i,
                transformItems: b
            })), {}, {
                $$widgetType: "ais.menu"
            })
        },
        j = O;
    t.default = j
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function s(e) {
        return d(e) || p(e) || f(e) || l()
    }

    function l() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
    }

    function f(e, t) {
        if (e) {
            if ("string" == typeof e) return h(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? h(e, t) : void 0
        }
    }

    function p(e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e)
    }

    function d(e) {
        if (Array.isArray(e)) return h(e)
    }

    function h(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
        return n
    }

    function m(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return (0, b.uniq)([].concat(s(Object.keys(e || {})), s(Object.keys(t)))).reduce(function(r, n) {
            var i = e ? e[n] : void 0,
                o = t[n],
                a = void 0 !== o && o !== i;
            return r.templates[n] = a ? o : i, r.useCustomCompileOptions[n] = a, r
        }, {
            templates: {},
            useCustomCompileOptions: {}
        })
    }

    function y(e) {
        var t = e.defaultTemplates,
            r = e.templates;
        return o({
            templatesConfig: e.templatesConfig
        }, m(t, r))
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.prepareTemplateProps = y;
    var b = r(20)
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function s() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = arguments.length > 1 ? arguments[1] : void 0,
            r = arguments.length > 2 ? arguments[2] : void 0;
        return Object.keys(e).reduce(function(n, i) {
            return o(o({}, n), {}, a({}, i, function() {
                var n = this;
                return function(o) {
                    var a = function(e) {
                        return p.default.compile(e, t).render(n)
                    };
                    return e[i].call(r, o, a)
                }
            }))
        }, {})
    }

    function l(e) {
        var t = e.templates,
            r = e.templateKey,
            i = e.compileOptions,
            a = e.helpers,
            u = e.data,
            c = e.bindEvent,
            l = e.sendEvent,
            f = t[r];
        if ("string" != typeof f && "function" != typeof f) throw new Error("Template must be 'string' or 'function', was '".concat(n(f), "' (key: ").concat(r, ")"));
        if ("function" == typeof f) {
            var m = c || {};
            return m.html = d.html, m.sendEvent = l, m.components = {
                Highlight: h.Highlight,
                ReverseHighlight: h.ReverseHighlight,
                Snippet: h.Snippet,
                ReverseSnippet: h.ReverseSnippet
            }, f(u, m)
        }
        var y = s(a, i, u);
        return p.default.compile(f, i).render(o(o({}, u), {}, {
            helpers: y
        })).replace(/[ \n\r\t\f\xA0]+/g, function(e) {
            return e.replace(/(^|\xA0+)[^\xA0]+/g, "$1 ")
        }).trim()
    }
    var f = r(1);
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.renderTemplate = l;
    var p = f(r(285)),
        d = r(70),
        h = r(288)
}, function(e, t, r) {
    "use strict";
    var n = r(286);
    n.Template = r(287).Template, n.template = n.Template, e.exports = n
}, function(e, t, r) {
    "use strict";
    ! function(e) {
        function t(e) {
            "}" === e.n.substr(e.n.length - 1) && (e.n = e.n.substring(0, e.n.length - 1))
        }

        function r(e) {
            return e.trim ? e.trim() : e.replace(/^\s*|\s*$/g, "")
        }

        function n(e, t, r) {
            if (t.charAt(r) != e.charAt(0)) return !1;
            for (var n = 1, i = e.length; n < i; n++)
                if (t.charAt(r + n) != e.charAt(n)) return !1;
            return !0
        }

        function i(t, r, n, u) {
            var c = [],
                s = null,
                l = null,
                f = null;
            for (l = n[n.length - 1]; t.length > 0;) {
                if (f = t.shift(), l && "<" == l.tag && !(f.tag in O)) throw new Error("Illegal content in < super tag.");
                if (e.tags[f.tag] <= e.tags.$ || o(f, u)) n.push(f), f.nodes = i(t, f.tag, n, u);
                else {
                    if ("/" == f.tag) {
                        if (0 === n.length) throw new Error("Closing tag without opener: /" + f.n);
                        if (s = n.pop(), f.n != s.n && !a(f.n, s.n, u)) throw new Error("Nesting error: " + s.n + " vs. " + f.n);
                        return s.end = f.i, c
                    }
                    "\n" == f.tag && (f.last = 0 == t.length || "\n" == t[0].tag)
                }
                c.push(f)
            }
            if (n.length > 0) throw new Error("missing closing tag: " + n.pop().n);
            return c
        }

        function o(e, t) {
            for (var r = 0, n = t.length; r < n; r++)
                if (t[r].o == e.n) return e.tag = "#", !0
        }

        function a(e, t, r) {
            for (var n = 0, i = r.length; n < i; n++)
                if (r[n].c == e && r[n].o == t) return !0
        }

        function u(e) {
            var t = [];
            for (var r in e) t.push('"' + s(r) + '": function(c,p,t,i) {' + e[r] + "}");
            return "{ " + t.join(",") + " }"
        }

        function c(e) {
            var t = [];
            for (var r in e.partials) t.push('"' + s(r) + '":{name:"' + s(e.partials[r].name) + '", ' + c(e.partials[r]) + "}");
            return "partials: {" + t.join(",") + "}, subs: " + u(e.subs)
        }

        function s(e) {
            return e.replace(v, "\\\\").replace(m, '\\"').replace(y, "\\n").replace(b, "\\r").replace(g, "\\u2028").replace(_, "\\u2029")
        }

        function l(e) {
            return ~e.indexOf(".") ? "d" : "f"
        }

        function f(e, t) {
            var r = "<" + (t.prefix || ""),
                n = r + e.n + j++;
            return t.partials[n] = {
                name: e.n,
                partials: {}
            }, t.code += 't.b(t.rp("' + s(n) + '",c,p,"' + (e.indent || "") + '"));', n
        }

        function p(e, t) {
            t.code += "t.b(t.t(t." + l(e.n) + '("' + s(e.n) + '",c,p,0)));'
        }

        function d(e) {
            return "t.b(" + e + ");"
        }
        var h = /\S/,
            m = /\"/g,
            y = /\n/g,
            b = /\r/g,
            v = /\\/g,
            g = /\u2028/,
            _ = /\u2029/;
        e.tags = {
            "#": 1,
            "^": 2,
            "<": 3,
            $: 4,
            "/": 5,
            "!": 6,
            ">": 7,
            "=": 8,
            _v: 9,
            "{": 10,
            "&": 11,
            _t: 12
        }, e.scan = function(i, o) {
            function a() {
                d.length > 0 && (m.push({
                    tag: "_t",
                    text: new String(d)
                }), d = "")
            }

            function u() {
                for (var t = !0, r = v; r < m.length; r++)
                    if (!(t = e.tags[m[r].tag] < e.tags._v || "_t" == m[r].tag && null === m[r].text.match(h))) return !1;
                return t
            }

            function c(e, t) {
                if (a(), e && u())
                    for (var r, n = v; n < m.length; n++) m[n].text && ((r = m[n + 1]) && ">" == r.tag && (r.indent = m[n].text.toString()), m.splice(n, 1));
                else t || m.push({
                    tag: "\n"
                });
                y = !1, v = m.length
            }
            var s = i.length,
                l = 0,
                f = null,
                p = null,
                d = "",
                m = [],
                y = !1,
                b = 0,
                v = 0,
                g = "{{",
                _ = "}}";
            for (o && (o = o.split(" "), g = o[0], _ = o[1]), b = 0; b < s; b++) 0 == l ? n(g, i, b) ? (--b, a(), l = 1) : "\n" == i.charAt(b) ? c(y) : d += i.charAt(b) : 1 == l ? (b += g.length - 1, p = e.tags[i.charAt(b + 1)], f = p ? i.charAt(b + 1) : "_v", "=" == f ? (b = function(e, t) {
                var n = "=" + _,
                    i = e.indexOf(n, t),
                    o = r(e.substring(e.indexOf("=", t) + 1, i)).split(" ");
                return g = o[0], _ = o[o.length - 1], i + n.length - 1
            }(i, b), l = 0) : (p && b++, l = 2), y = b) : n(_, i, b) ? (m.push({
                tag: f,
                n: r(d),
                otag: g,
                ctag: _,
                i: "/" == f ? y - g.length : b + _.length
            }), d = "", b += _.length - 1, l = 0, "{" == f && ("}}" == _ ? b++ : t(m[m.length - 1]))) : d += i.charAt(b);
            return c(y, !0), m
        };
        var O = {
            _t: !0,
            "\n": !0,
            $: !0,
            "/": !0
        };
        e.stringify = function(t, r, n) {
            return "{code: function (c,p,i) { " + e.wrapMain(t.code) + " }," + c(t) + "}"
        };
        var j = 0;
        e.generate = function(t, r, n) {
            j = 0;
            var i = {
                code: "",
                subs: {},
                partials: {}
            };
            return e.walk(t, i), n.asString ? this.stringify(i, r, n) : this.makeTemplate(i, r, n)
        }, e.wrapMain = function(e) {
            return 'var t=this;t.b(i=i||"");' + e + "return t.fl();"
        }, e.template = e.Template, e.makeTemplate = function(e, t, r) {
            var n = this.makePartials(e);
            return n.code = new Function("c", "p", "i", this.wrapMain(e.code)), new this.template(n, t, this, r)
        }, e.makePartials = function(e) {
            var t, r = {
                subs: {},
                partials: e.partials,
                name: e.name
            };
            for (t in r.partials) r.partials[t] = this.makePartials(r.partials[t]);
            for (t in e.subs) r.subs[t] = new Function("c", "p", "t", "i", e.subs[t]);
            return r
        }, e.codegen = {
            "#": function(t, r) {
                r.code += "if(t.s(t." + l(t.n) + '("' + s(t.n) + '",c,p,1),c,p,0,' + t.i + "," + t.end + ',"' + t.otag + " " + t.ctag + '")){t.rs(c,p,function(c,p,t){', e.walk(t.nodes, r), r.code += "});c.pop();}"
            },
            "^": function(t, r) {
                r.code += "if(!t.s(t." + l(t.n) + '("' + s(t.n) + '",c,p,1),c,p,1,0,0,"")){', e.walk(t.nodes, r), r.code += "};"
            },
            ">": f,
            "<": function(t, r) {
                var n = {
                    partials: {},
                    code: "",
                    subs: {},
                    inPartial: !0
                };
                e.walk(t.nodes, n);
                var i = r.partials[f(t, r)];
                i.subs = n.subs, i.partials = n.partials
            },
            $: function(t, r) {
                var n = {
                    subs: {},
                    code: "",
                    partials: r.partials,
                    prefix: t.n
                };
                e.walk(t.nodes, n), r.subs[t.n] = n.code, r.inPartial || (r.code += 't.sub("' + s(t.n) + '",c,p,i);')
            },
            "\n": function(e, t) {
                t.code += d('"\\n"' + (e.last ? "" : " + i"))
            },
            _v: function(e, t) {
                t.code += "t.b(t.v(t." + l(e.n) + '("' + s(e.n) + '",c,p,0)));'
            },
            _t: function(e, t) {
                t.code += d('"' + s(e.text) + '"')
            },
            "{": p,
            "&": p
        }, e.walk = function(t, r) {
            for (var n, i = 0, o = t.length; i < o; i++)(n = e.codegen[t[i].tag]) && n(t[i], r);
            return r
        }, e.parse = function(e, t, r) {
            return r = r || {}, i(e, "", [], r.sectionTags || [])
        }, e.cache = {}, e.cacheKey = function(e, t) {
            return [e, !!t.asString, !!t.disableLambda, t.delimiters, !!t.modelGet].join("||")
        }, e.compile = function(t, r) {
            r = r || {};
            var n = e.cacheKey(t, r),
                i = this.cache[n];
            if (i) {
                var o = i.partials;
                for (var a in o) delete o[a].instance;
                return i
            }
            return i = this.generate(this.parse(this.scan(t, r.delimiters), t, r), t, r), this.cache[n] = i
        }
    }(t)
}, function(e, t, r) {
    "use strict";
    var n = r(1),
        i = n(r(8));
    ! function(e) {
        function t(e, t, r) {
            var n;
            return t && "object" == (0, i.default)(t) && (void 0 !== t[e] ? n = t[e] : r && t.get && "function" == typeof t.get && (n = t.get(e))), n
        }

        function r(e, t, r, n, i, o) {
            function a() {}

            function u() {}
            a.prototype = e, u.prototype = e.subs;
            var c, s = new a;
            s.subs = new u, s.subsText = {}, s.buf = "", n = n || {}, s.stackSubs = n, s.subsText = o;
            for (c in t) n[c] || (n[c] = t[c]);
            for (c in n) s.subs[c] = n[c];
            i = i || {}, s.stackPartials = i;
            for (c in r) i[c] || (i[c] = r[c]);
            for (c in i) s.partials[c] = i[c];
            return s
        }

        function n(e) {
            return String(null === e || void 0 === e ? "" : e)
        }

        function o(e) {
            return e = n(e), f.test(e) ? e.replace(a, "&amp;").replace(u, "&lt;").replace(c, "&gt;").replace(s, "&#39;").replace(l, "&quot;") : e
        }
        e.Template = function(e, t, r, n) {
            e = e || {}, this.r = e.code || this.r, this.c = r, this.options = n || {}, this.text = t || "", this.partials = e.partials || {}, this.subs = e.subs || {}, this.buf = ""
        }, e.Template.prototype = {
            r: function(e, t, r) {
                return ""
            },
            v: o,
            t: n,
            render: function(e, t, r) {
                return this.ri([e], t || {}, r)
            },
            ri: function(e, t, r) {
                return this.r(e, t, r)
            },
            ep: function(e, t) {
                var n = this.partials[e],
                    i = t[n.name];
                if (n.instance && n.base == i) return n.instance;
                if ("string" == typeof i) {
                    if (!this.c) throw new Error("No compiler available.");
                    i = this.c.compile(i, this.options)
                }
                if (!i) return null;
                if (this.partials[e].base = i, n.subs) {
                    t.stackText || (t.stackText = {});
                    for (key in n.subs) t.stackText[key] || (t.stackText[key] = void 0 !== this.activeSub && t.stackText[this.activeSub] ? t.stackText[this.activeSub] : this.text);
                    i = r(i, n.subs, n.partials, this.stackSubs, this.stackPartials, t.stackText)
                }
                return this.partials[e].instance = i, i
            },
            rp: function(e, t, r, n) {
                var i = this.ep(e, r);
                return i ? i.ri(t, r, n) : ""
            },
            rs: function(e, t, r) {
                var n = e[e.length - 1];
                if (!p(n)) return void r(e, t, this);
                for (var i = 0; i < n.length; i++) e.push(n[i]), r(e, t, this), e.pop()
            },
            s: function(e, t, r, n, o, a, u) {
                var c;
                return (!p(e) || 0 !== e.length) && ("function" == typeof e && (e = this.ms(e, t, r, n, o, a, u)), c = !!e, !n && c && t && t.push("object" == (0, i.default)(e) ? e : t[t.length - 1]), c)
            },
            d: function(e, r, n, i) {
                var o, a = e.split("."),
                    u = this.f(a[0], r, n, i),
                    c = this.options.modelGet,
                    s = null;
                if ("." === e && p(r[r.length - 2])) u = r[r.length - 1];
                else
                    for (var l = 1; l < a.length; l++) o = t(a[l], u, c), void 0 !== o ? (s = u, u = o) : u = "";
                return !(i && !u) && (i || "function" != typeof u || (r.push(s), u = this.mv(u, r, n), r.pop()), u)
            },
            f: function(e, r, n, i) {
                for (var o = !1, a = null, u = !1, c = this.options.modelGet, s = r.length - 1; s >= 0; s--)
                    if (a = r[s], void 0 !== (o = t(e, a, c))) {
                        u = !0;
                        break
                    }
                return u ? (i || "function" != typeof o || (o = this.mv(o, r, n)), o) : !i && ""
            },
            ls: function(e, t, r, i, o) {
                var a = this.options.delimiters;
                return this.options.delimiters = o, this.b(this.ct(n(e.call(t, i)), t, r)), this.options.delimiters = a, !1
            },
            ct: function(e, t, r) {
                if (this.options.disableLambda) throw new Error("Lambda features disabled.");
                return this.c.compile(e, this.options).render(t, r)
            },
            b: function(e) {
                this.buf += e
            },
            fl: function() {
                var e = this.buf;
                return this.buf = "", e
            },
            ms: function(e, t, r, n, i, o, a) {
                var u, c = t[t.length - 1],
                    s = e.call(c);
                return "function" == typeof s ? !!n || (u = this.activeSub && this.subsText && this.subsText[this.activeSub] ? this.subsText[this.activeSub] : this.text, this.ls(s, c, r, u.substring(i, o), a)) : s
            },
            mv: function(e, t, r) {
                var i = t[t.length - 1],
                    o = e.call(i);
                return "function" == typeof o ? this.ct(n(o.call(i)), i, r) : o
            },
            sub: function(e, t, r, n) {
                var i = this.subs[e];
                i && (this.activeSub = e, i(t, r, this, n), this.activeSub = !1)
            }
        };
        var a = /&/g,
            u = /</g,
            c = />/g,
            s = /\'/g,
            l = /\"/g,
            f = /[&<>\"\']/,
            p = Array.isArray || function(e) {
                return "[object Array]" === Object.prototype.toString.call(e)
            }
    }(t)
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = r(289);
    Object.keys(n).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === n[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return n[e]
            }
        }))
    });
    var i = r(296);
    Object.keys(i).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === i[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return i[e]
            }
        }))
    });
    var o = r(298);
    Object.keys(o).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === o[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return o[e]
            }
        }))
    });
    var a = r(300);
    Object.keys(a).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === a[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return a[e]
            }
        }))
    })
}, function(e, t, r) {
    "use strict";

    function n() {
        return n = Object.assign ? Object.assign.bind() : function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = arguments[t];
                for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
            }
            return e
        }, n.apply(this, arguments)
    }

    function i(e, t) {
        if (null == e) return {};
        var r, n, i = o(e, t);
        if (Object.getOwnPropertySymbols) {
            var a = Object.getOwnPropertySymbols(e);
            for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
        }
        return i
    }

    function o(e, t) {
        if (null == e) return {};
        var r, n, i = {},
            o = Object.keys(e);
        for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || (i[r] = e[r]);
        return i
    }

    function a(e) {
        var t = e.hit,
            r = e.attribute,
            o = e.cssClasses,
            a = i(e, l),
            f = (0, s.getPropertyByPath)(t._highlightResult, r) || [],
            p = (0, s.toArray)(f),
            d = p.map(function(e) {
                var t = e.value;
                return (0, s.getHighlightedParts)((0, s.unescape)(t || ""))
            });
        return (0, u.h)(c.Highlight, n({}, a, {
            parts: d,
            classNames: o
        }))
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.Highlight = a;
    var u = r(2),
        c = r(290),
        s = r(0),
        l = ["hit", "attribute", "cssClasses"]
}, function(e, t, r) {
    "use strict";

    function n() {
        return n = Object.assign ? Object.assign.bind() : function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = arguments[t];
                for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
            }
            return e
        }, n.apply(this, arguments)
    }

    function i(e, t) {
        if (null == e) return {};
        var r, n, i = o(e, t);
        if (Object.getOwnPropertySymbols) {
            var a = Object.getOwnPropertySymbols(e);
            for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
        }
        return i
    }

    function o(e, t) {
        if (null == e) return {};
        var r, n, i = {},
            o = Object.keys(e);
        for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || (i[r] = e[r]);
        return i
    }

    function a(e) {
        var t = e.classNames,
            r = void 0 === t ? {} : t,
            o = i(e, l);
        return (0, c.h)(s.InternalHighlight, n({
            classNames: {
                root: (0, u.cx)("ais-Highlight", r.root),
                highlighted: (0, u.cx)("ais-Highlight-highlighted", r.highlighted),
                nonHighlighted: (0, u.cx)("ais-Highlight-nonHighlighted", r.nonHighlighted),
                separator: (0, u.cx)("ais-Highlight-separator", r.separator)
            }
        }, o))
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.Highlight = a;
    var u = r(3),
        c = r(2),
        s = r(15),
        l = ["classNames"]
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = r(292);
    Object.keys(n).forEach(function(e) {
        "default" !== e && "__esModule" !== e && (e in t && t[e] === n[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function() {
                return n[e]
            }
        }))
    })
}, function(e, t, r) {
    "use strict";

    function n(e) {
        var t = e.createElement;
        return function(e) {
            var r = e.classNames,
                n = e.children,
                i = e.highlightedTagName,
                o = e.isHighlighted,
                a = e.nonHighlightedTagName;
            return t(o ? i : a, {
                className: o ? r.highlighted : r.nonHighlighted
            }, n)
        }
    }

    function i(e) {
        var t = e.createElement,
            r = e.Fragment,
            i = n({
                createElement: t,
                Fragment: r
            });
        return function(e) {
            var n = e.parts,
                o = e.highlightedTagName,
                l = void 0 === o ? "mark" : o,
                f = e.nonHighlightedTagName,
                p = void 0 === f ? "span" : f,
                d = e.separator,
                h = void 0 === d ? ", " : d,
                m = e.className,
                y = e.classNames,
                b = void 0 === y ? {} : y,
                v = (0, u.default)(e, s);
            return t("span", (0, a.default)({}, v, {
                className: (0, c.cx)(b.root, m)
            }), n.map(function(e, o) {
                var a = o === n.length - 1;
                return t(r, {
                    key: o
                }, e.map(function(e, r) {
                    return t(i, {
                        key: r,
                        classNames: b,
                        highlightedTagName: l,
                        nonHighlightedTagName: p,
                        isHighlighted: e.isHighlighted
                    }, e.value)
                }), !a && t("span", {
                    className: b.separator
                }, h))
            }))
        }
    }
    var o = r(1);
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.createHighlightComponent = i;
    var a = o(r(293)),
        u = o(r(294)),
        c = r(3),
        s = ["parts", "highlightedTagName", "nonHighlightedTagName", "separator", "className", "classNames"]
}, function(e, t, r) {
    "use strict";

    function n() {
        return e.exports = n = Object.assign ? Object.assign.bind() : function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = arguments[t];
                for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
            }
            return e
        }, e.exports.__esModule = !0, e.exports.default = e.exports, n.apply(this, arguments)
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports
}, function(e, t, r) {
    "use strict";

    function n(e, t) {
        if (null == e) return {};
        var r, n, o = i(e, t);
        if (Object.getOwnPropertySymbols) {
            var a = Object.getOwnPropertySymbols(e);
            for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r])
        }
        return o
    }
    var i = r(295);
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports
}, function(e, t, r) {
    "use strict";

    function n(e, t) {
        if (null == e) return {};
        var r, n, i = {},
            o = Object.keys(e);
        for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || (i[r] = e[r]);
        return i
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i() {
        return i = Object.assign ? Object.assign.bind() : function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = arguments[t];
                for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
            }
            return e
        }, i.apply(this, arguments)
    }

    function o(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function a(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? o(Object(r), !0).forEach(function(t) {
                u(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : o(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function u(e, t, r) {
        return t = c(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function c(e) {
        var t = s(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function s(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function l(e, t) {
        if (null == e) return {};
        var r, n, i = f(e, t);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
        }
        return i
    }

    function f(e, t) {
        if (null == e) return {};
        var r, n, i = {},
            o = Object.keys(e);
        for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || (i[r] = e[r]);
        return i
    }

    function p(e) {
        var t = e.hit,
            r = e.attribute,
            n = e.cssClasses,
            o = l(e, y),
            u = (0, m.getPropertyByPath)(t._highlightResult, r) || [],
            c = (0, m.toArray)(u),
            s = c.map(function(e) {
                var t = e.value;
                return (0, m.getHighlightedParts)((0, m.unescape)(t || "")).map(function(e) {
                    var t = e.isHighlighted;
                    return a(a({}, l(e, b)), {}, {
                        isHighlighted: !t
                    })
                })
            });
        return (0, d.h)(h.ReverseHighlight, i({}, o, {
            parts: s,
            classNames: n
        }))
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.ReverseHighlight = p;
    var d = r(2),
        h = r(297),
        m = r(0),
        y = ["hit", "attribute", "cssClasses"],
        b = ["isHighlighted"]
}, function(e, t, r) {
    "use strict";

    function n() {
        return n = Object.assign ? Object.assign.bind() : function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = arguments[t];
                for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
            }
            return e
        }, n.apply(this, arguments)
    }

    function i(e, t) {
        if (null == e) return {};
        var r, n, i = o(e, t);
        if (Object.getOwnPropertySymbols) {
            var a = Object.getOwnPropertySymbols(e);
            for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
        }
        return i
    }

    function o(e, t) {
        if (null == e) return {};
        var r, n, i = {},
            o = Object.keys(e);
        for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || (i[r] = e[r]);
        return i
    }

    function a(e) {
        var t = e.classNames,
            r = void 0 === t ? {} : t,
            o = i(e, l);
        return (0, c.h)(s.InternalHighlight, n({
            classNames: {
                root: (0, u.cx)("ais-ReverseHighlight", r.root),
                highlighted: (0, u.cx)("ais-ReverseHighlight-highlighted", r.highlighted),
                nonHighlighted: (0, u.cx)("ais-ReverseHighlight-nonHighlighted", r.nonHighlighted),
                separator: (0, u.cx)("ais-ReverseHighlight-separator", r.separator)
            }
        }, o))
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.ReverseHighlight = a;
    var u = r(3),
        c = r(2),
        s = r(15),
        l = ["classNames"]
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i() {
        return i = Object.assign ? Object.assign.bind() : function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = arguments[t];
                for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
            }
            return e
        }, i.apply(this, arguments)
    }

    function o(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function a(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? o(Object(r), !0).forEach(function(t) {
                u(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : o(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function u(e, t, r) {
        return t = c(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function c(e) {
        var t = s(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function s(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function l(e, t) {
        if (null == e) return {};
        var r, n, i = f(e, t);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
        }
        return i
    }

    function f(e, t) {
        if (null == e) return {};
        var r, n, i = {},
            o = Object.keys(e);
        for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || (i[r] = e[r]);
        return i
    }

    function p(e) {
        var t = e.hit,
            r = e.attribute,
            n = e.cssClasses,
            o = l(e, y),
            u = (0, m.getPropertyByPath)(t._snippetResult, r) || [],
            c = (0, m.toArray)(u),
            s = c.map(function(e) {
                var t = e.value;
                return (0, m.getHighlightedParts)((0, m.unescape)(t || "")).map(function(e) {
                    var t = e.isHighlighted;
                    return a(a({}, l(e, b)), {}, {
                        isHighlighted: !t
                    })
                })
            });
        return (0, d.h)(h.ReverseSnippet, i({}, o, {
            parts: s,
            classNames: n
        }))
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.ReverseSnippet = p;
    var d = r(2),
        h = r(299),
        m = r(0),
        y = ["hit", "attribute", "cssClasses"],
        b = ["isHighlighted"]
}, function(e, t, r) {
    "use strict";

    function n() {
        return n = Object.assign ? Object.assign.bind() : function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = arguments[t];
                for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
            }
            return e
        }, n.apply(this, arguments)
    }

    function i(e, t) {
        if (null == e) return {};
        var r, n, i = o(e, t);
        if (Object.getOwnPropertySymbols) {
            var a = Object.getOwnPropertySymbols(e);
            for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
        }
        return i
    }

    function o(e, t) {
        if (null == e) return {};
        var r, n, i = {},
            o = Object.keys(e);
        for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || (i[r] = e[r]);
        return i
    }

    function a(e) {
        var t = e.classNames,
            r = void 0 === t ? {} : t,
            o = i(e, l);
        return (0, c.h)(s.InternalHighlight, n({
            classNames: {
                root: (0, u.cx)("ais-ReverseSnippet", r.root),
                highlighted: (0, u.cx)("ais-ReverseSnippet-highlighted", r.highlighted),
                nonHighlighted: (0, u.cx)("ais-ReverseSnippet-nonHighlighted", r.nonHighlighted),
                separator: (0, u.cx)("ais-ReverseSnippet-separator", r.separator)
            }
        }, o))
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.ReverseSnippet = a;
    var u = r(3),
        c = r(2),
        s = r(15),
        l = ["classNames"]
}, function(e, t, r) {
    "use strict";

    function n() {
        return n = Object.assign ? Object.assign.bind() : function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = arguments[t];
                for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
            }
            return e
        }, n.apply(this, arguments)
    }

    function i(e, t) {
        if (null == e) return {};
        var r, n, i = o(e, t);
        if (Object.getOwnPropertySymbols) {
            var a = Object.getOwnPropertySymbols(e);
            for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
        }
        return i
    }

    function o(e, t) {
        if (null == e) return {};
        var r, n, i = {},
            o = Object.keys(e);
        for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || (i[r] = e[r]);
        return i
    }

    function a(e) {
        var t = e.hit,
            r = e.attribute,
            o = e.cssClasses,
            a = i(e, l),
            f = (0, s.getPropertyByPath)(t._snippetResult, r) || [],
            p = (0, s.toArray)(f),
            d = p.map(function(e) {
                var t = e.value;
                return (0, s.getHighlightedParts)((0, s.unescape)(t || ""))
            });
        return (0, u.h)(c.Snippet, n({}, a, {
            parts: d,
            classNames: o
        }))
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.Snippet = a;
    var u = r(2),
        c = r(301),
        s = r(0),
        l = ["hit", "attribute", "cssClasses"]
}, function(e, t, r) {
    "use strict";

    function n() {
        return n = Object.assign ? Object.assign.bind() : function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = arguments[t];
                for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
            }
            return e
        }, n.apply(this, arguments)
    }

    function i(e, t) {
        if (null == e) return {};
        var r, n, i = o(e, t);
        if (Object.getOwnPropertySymbols) {
            var a = Object.getOwnPropertySymbols(e);
            for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
        }
        return i
    }

    function o(e, t) {
        if (null == e) return {};
        var r, n, i = {},
            o = Object.keys(e);
        for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || (i[r] = e[r]);
        return i
    }

    function a(e) {
        var t = e.classNames,
            r = void 0 === t ? {} : t,
            o = i(e, l);
        return (0, c.h)(s.InternalHighlight, n({
            classNames: {
                root: (0, u.cx)("ais-Snippet", r.root),
                highlighted: (0, u.cx)("ais-Snippet-highlighted", r.highlighted),
                nonHighlighted: (0, u.cx)("ais-Snippet-nonHighlighted", r.nonHighlighted),
                separator: (0, u.cx)("ais-Snippet-separator", r.separator)
            }
        }, o))
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.Snippet = a;
    var u = r(3),
        c = r(2),
        s = r(15),
        l = ["classNames"]
}, function(e, t, r) {
    "use strict";

    function n() {
        return n = Object.assign ? Object.assign.bind() : function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = arguments[t];
                for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
            }
            return e
        }, n.apply(this, arguments)
    }

    function i(e) {
        var t = e.className,
            r = e.handleClick,
            i = e.facetValueToRefine,
            o = e.isRefined,
            c = e.templateProps,
            s = e.templateKey,
            l = e.templateData,
            f = e.subItems;
        return (0, a.h)("li", {
            className: t,
            onClick: function(e) {
                r({
                    facetValueToRefine: i,
                    isRefined: o,
                    originalEvent: e
                })
            }
        }, (0, a.h)(u.default, n({}, c, {
            templateKey: s,
            data: l
        })), f)
    }
    var o = r(1);
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var a = r(2),
        u = o(r(7)),
        c = i;
    t.default = c
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        if (null == e) return {};
        var r, n, i = o(e, t);
        if (Object.getOwnPropertySymbols) {
            var a = Object.getOwnPropertySymbols(e);
            for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
        }
        return i
    }

    function o(e, t) {
        if (null == e) return {};
        var r, n, i = {},
            o = Object.keys(e);
        for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || (i[r] = e[r]);
        return i
    }

    function a(e, t) {
        return f(e) || l(e, t) || c(e, t) || u()
    }

    function u() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
    }

    function c(e, t) {
        if (e) {
            if ("string" == typeof e) return s(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? s(e, t) : void 0
        }
    }

    function s(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
        return n
    }

    function l(e, t) {
        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (null != r) {
            var n, i, o, a, u = [],
                c = !0,
                s = !1;
            try {
                if (o = (r = r.call(e)).next, 0 === t) {
                    if (Object(r) !== r) return;
                    c = !1
                } else
                    for (; !(c = (n = o.call(r)).done) && (u.push(n.value), u.length !== t); c = !0);
            } catch (e) {
                s = !0, i = e
            } finally {
                try {
                    if (!c && null != r.return && (a = r.return(), Object(a) !== a)) return
                } finally {
                    if (s) throw i
                }
            }
            return u
        }
    }

    function f(e) {
        if (Array.isArray(e)) return e
    }

    function p(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function d(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? p(Object(r), !0).forEach(function(t) {
                h(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : p(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function h(e, t, r) {
        return t = m(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function m(e) {
        var t = y(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function y(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var b = r(0),
        v = ["name", "escapedValue", "path"],
        g = (0, b.createDocumentationMessageGenerator)({
            name: "menu",
            connector: !0
        }),
        _ = ["isRefined", "name:asc"],
        O = function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : b.noop;
            return (0, b.checkRendering)(e, g()),
                function(r) {
                    function n(e, t) {
                        return function() {
                            I = !I, t.render(e)
                        }
                    }

                    function o() {
                        k()
                    }

                    function u() {
                        return I ? O : f
                    }
                    var c = r || {},
                        s = c.attribute,
                        l = c.limit,
                        f = void 0 === l ? 10 : l,
                        p = c.showMore,
                        m = void 0 !== p && p,
                        y = c.showMoreLimit,
                        O = void 0 === y ? 20 : y,
                        j = c.sortBy,
                        P = void 0 === j ? _ : j,
                        S = c.transformItems,
                        w = void 0 === S ? function(e) {
                            return e
                        } : S;
                    if (!s) throw new Error(g("The `attribute` option is required."));
                    if (!0 === m && O <= f) throw new Error(g("The `showMoreLimit` option must be greater than `limit`."));
                    var E, R, x, I = !1,
                        k = function() {};
                    return {
                        $$type: "ais.menu",
                        init: function(t) {
                            var r = t.instantSearchInstance;
                            e(d(d({}, this.getWidgetRenderState(t)), {}, {
                                instantSearchInstance: r
                            }), !0)
                        },
                        render: function(t) {
                            var r = t.instantSearchInstance;
                            e(d(d({}, this.getWidgetRenderState(t)), {}, {
                                instantSearchInstance: r
                            }), !1)
                        },
                        dispose: function(e) {
                            var r = e.state;
                            return t(), r.removeHierarchicalFacet(s).setQueryParameter("maxValuesPerFacet", void 0)
                        },
                        getRenderState: function(e, t) {
                            return d(d({}, e), {}, {
                                menu: d(d({}, e.menu), {}, h({}, s, this.getWidgetRenderState(t)))
                            })
                        },
                        getWidgetRenderState: function(e) {
                            var t = e.results,
                                c = e.createURL,
                                l = e.instantSearchInstance,
                                f = e.helper,
                                p = [],
                                h = !1;
                            if (E || (E = (0, b.createSendEventForFacet)({
                                    instantSearchInstance: l,
                                    helper: f,
                                    attribute: s,
                                    widgetType: this.$$type
                                })), R || (R = function(e) {
                                    return c(f.state.resetPage().toggleFacetRefinement(s, e))
                                }), x || (x = function(e) {
                                    var t = f.getHierarchicalFacetBreadcrumb(s),
                                        r = a(t, 1),
                                        n = r[0];
                                    E("click:internal", e || n), f.toggleFacetRefinement(s, e || n).search()
                                }), e.results && (k = n(e, this)), t) {
                                var y = t.getFacetValues(s, {
                                        sortBy: P,
                                        facetOrdering: P === _
                                    }),
                                    g = y && !Array.isArray(y) && y.data ? y.data : [];
                                h = m && (I || g.length > u()), p = w(g.slice(0, u()).map(function(e) {
                                    var t = e.name,
                                        r = e.escapedValue;
                                    return e.path, d(d({}, i(e, v)), {}, {
                                        label: t,
                                        value: r
                                    })
                                }), {
                                    results: t
                                })
                            }
                            return {
                                items: p,
                                createURL: R,
                                refine: x,
                                sendEvent: E,
                                canRefine: p.length > 0,
                                widgetParams: r,
                                isShowingMore: I,
                                toggleShowMore: o,
                                canToggleShowMore: h
                            }
                        },
                        getWidgetUiState: function(e, t) {
                            var r = t.searchParameters,
                                n = r.getHierarchicalFacetBreadcrumb(s),
                                i = a(n, 1),
                                o = i[0];
                            return o ? d(d({}, e), {}, {
                                menu: d(d({}, e.menu), {}, h({}, s, o))
                            }) : e
                        },
                        getWidgetSearchParameters: function(e, t) {
                            var r = t.uiState,
                                n = r.menu && r.menu[s];
                            if (e.isConjunctiveFacet(s) || e.isDisjunctiveFacet(s)) return e;
                            var i = e.removeHierarchicalFacet(s).addHierarchicalFacet({
                                    name: s,
                                    attributes: [s]
                                }),
                                o = i.maxValuesPerFacet || 0,
                                a = Math.max(o, m ? O : f),
                                u = i.setQueryParameter("maxValuesPerFacet", a);
                            return n ? u.addHierarchicalFacetRefinement(s, n) : u.setQueryParameters({
                                hierarchicalFacetsRefinements: d(d({}, u.hierarchicalFacetsRefinements), {}, h({}, s, []))
                            })
                        }
                    }
                }
        },
        j = O;
    t.default = j
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var n = r(3),
        i = r(2),
        o = r(14),
        a = {
            item: function(e) {
                var t = e.cssClasses,
                    r = e.url,
                    a = e.label,
                    u = e.count;
                return (0, i.h)("a", {
                    className: (0, n.cx)(t.link),
                    href: r
                }, (0, i.h)("span", {
                    className: (0, n.cx)(t.label)
                }, a), (0, i.h)("span", {
                    className: (0, n.cx)(t.count)
                }, (0, o.formatNumber)(u)))
            },
            showMoreText: function(e) {
                return e.isShowingMore ? "Show less" : "Show more"
            }
        },
        u = a;
    t.default = u
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }
    var s = r(1);
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var l = r(3),
        f = r(2),
        p = s(r(71)),
        d = s(r(306)),
        h = r(5),
        m = r(10),
        y = r(0),
        b = s(r(73)),
        v = s(r(307)),
        g = (0, y.createDocumentationMessageGenerator)({
            name: "refinement-list"
        }),
        _ = (0, h.component)("RefinementList"),
        O = (0, h.component)("SearchBox"),
        j = function(e) {
            var t = e.containerNode,
                r = e.cssClasses,
                n = e.templates,
                i = e.searchBoxTemplates,
                o = e.renderState,
                a = e.showMore,
                u = e.searchable,
                c = e.searchablePlaceholder,
                s = e.searchableIsAlwaysActive;
            return function(e, l) {
                var d = e.refine,
                    h = e.items,
                    y = e.createURL,
                    g = e.searchForItems,
                    _ = e.isFromSearch,
                    O = e.instantSearchInstance,
                    j = e.toggleShowMore,
                    P = e.isShowingMore,
                    S = e.hasExhaustiveItems,
                    w = e.canToggleShowMore;
                if (l) return o.templateProps = (0, m.prepareTemplateProps)({
                    defaultTemplates: v.default,
                    templatesConfig: O.templatesConfig,
                    templates: n
                }), void(o.searchBoxTemplateProps = (0, m.prepareTemplateProps)({
                    defaultTemplates: b.default,
                    templatesConfig: O.templatesConfig,
                    templates: i
                }));
                (0, f.render)((0, f.h)(p.default, {
                    createURL: y,
                    cssClasses: r,
                    facetValues: h,
                    templateProps: o.templateProps,
                    searchBoxTemplateProps: o.searchBoxTemplateProps,
                    toggleRefinement: d,
                    searchFacetValues: u ? g : void 0,
                    searchPlaceholder: c,
                    searchIsAlwaysActive: s,
                    isFromSearch: _,
                    showMore: a && !_ && h.length > 0,
                    toggleShowMore: j,
                    isShowingMore: P,
                    hasExhaustiveItems: S,
                    canToggleShowMore: w
                }), t)
            }
        },
        P = function(e) {
            var t = e || {},
                r = t.container,
                n = t.attribute,
                i = t.operator,
                a = t.sortBy,
                u = t.limit,
                c = t.showMore,
                s = t.showMoreLimit,
                p = t.searchable,
                h = void 0 !== p && p,
                m = t.searchablePlaceholder,
                b = void 0 === m ? "Search..." : m,
                v = t.searchableEscapeFacetValues,
                P = void 0 === v || v,
                S = t.searchableIsAlwaysActive,
                w = void 0 === S || S,
                E = t.cssClasses,
                R = void 0 === E ? {} : E,
                x = t.templates,
                I = void 0 === x ? {} : x,
                k = t.transformItems;
            if (!r) throw new Error(g("The `container` option is required."));
            var M = !!h && Boolean(P),
                A = (0, y.getContainerNode)(r),
                N = {
                    root: (0, l.cx)(_(), R.root),
                    noRefinementRoot: (0, l.cx)(_({
                        modifierName: "noRefinement"
                    }), R.noRefinementRoot),
                    list: (0, l.cx)(_({
                        descendantName: "list"
                    }), R.list),
                    item: (0, l.cx)(_({
                        descendantName: "item"
                    }), R.item),
                    selectedItem: (0, l.cx)(_({
                        descendantName: "item",
                        modifierName: "selected"
                    }), R.selectedItem),
                    searchBox: (0, l.cx)(_({
                        descendantName: "searchBox"
                    }), R.searchBox),
                    label: (0, l.cx)(_({
                        descendantName: "label"
                    }), R.label),
                    checkbox: (0, l.cx)(_({
                        descendantName: "checkbox"
                    }), R.checkbox),
                    labelText: (0, l.cx)(_({
                        descendantName: "labelText"
                    }), R.labelText),
                    count: (0, l.cx)(_({
                        descendantName: "count"
                    }), R.count),
                    noResults: (0, l.cx)(_({
                        descendantName: "noResults"
                    }), R.noResults),
                    showMore: (0, l.cx)(_({
                        descendantName: "showMore"
                    }), R.showMore),
                    disabledShowMore: (0, l.cx)(_({
                        descendantName: "showMore",
                        modifierName: "disabled"
                    }), R.disabledShowMore),
                    searchable: {
                        root: (0, l.cx)(O(), R.searchableRoot),
                        form: (0, l.cx)(O({
                            descendantName: "form"
                        }), R.searchableForm),
                        input: (0, l.cx)(O({
                            descendantName: "input"
                        }), R.searchableInput),
                        submit: (0, l.cx)(O({
                            descendantName: "submit"
                        }), R.searchableSubmit),
                        submitIcon: (0, l.cx)(O({
                            descendantName: "submitIcon"
                        }), R.searchableSubmitIcon),
                        reset: (0, l.cx)(O({
                            descendantName: "reset"
                        }), R.searchableReset),
                        resetIcon: (0, l.cx)(O({
                            descendantName: "resetIcon"
                        }), R.searchableResetIcon),
                        loadingIndicator: (0, l.cx)(O({
                            descendantName: "loadingIndicator"
                        }), R.searchableLoadingIndicator),
                        loadingIcon: (0, l.cx)(O({
                            descendantName: "loadingIcon"
                        }), R.searchableLoadingIcon)
                    }
                },
                C = j({
                    containerNode: A,
                    cssClasses: N,
                    templates: I,
                    searchBoxTemplates: {
                        submit: I.searchableSubmit,
                        reset: I.searchableReset,
                        loadingIndicator: I.searchableLoadingIndicator
                    },
                    renderState: {},
                    searchable: h,
                    searchablePlaceholder: b,
                    searchableIsAlwaysActive: w,
                    showMore: c
                });
            return o(o({}, (0, d.default)(C, function() {
                return (0, f.render)(null, A)
            })({
                attribute: n,
                operator: i,
                limit: u,
                showMore: c,
                showMoreLimit: s,
                sortBy: a,
                escapeFacetValues: M,
                transformItems: k
            })), {}, {
                $$widgetType: "ais.refinementList"
            })
        },
        S = P;
    t.default = S
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function s(e, t) {
        if (null == e) return {};
        var r, n, i = l(e, t);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
        }
        return i
    }

    function l(e, t) {
        if (null == e) return {};
        var r, n, i = {},
            o = Object.keys(e);
        for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || (i[r] = e[r]);
        return i
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var f = r(0),
        p = ["name", "escapedValue"],
        d = ["escapedValue", "value"],
        h = (0, f.createDocumentationMessageGenerator)({
            name: "refinement-list",
            connector: !0
        }),
        m = ["isRefined", "count:desc", "name:asc"],
        y = function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : f.noop;
            return (0, f.checkRendering)(e, h()),
                function(r) {
                    function n() {
                        D()
                    }

                    function i(e, t) {
                        return function() {
                            F = !F, t.render(e)
                        }
                    }

                    function u() {
                        return F ? P : g
                    }
                    var c = r || {},
                        l = c.attribute,
                        y = c.operator,
                        b = void 0 === y ? "or" : y,
                        v = c.limit,
                        g = void 0 === v ? 10 : v,
                        _ = c.showMore,
                        O = void 0 !== _ && _,
                        j = c.showMoreLimit,
                        P = void 0 === j ? 20 : j,
                        S = c.sortBy,
                        w = void 0 === S ? m : S,
                        E = c.escapeFacetValues,
                        R = void 0 === E || E,
                        x = c.transformItems,
                        I = void 0 === x ? function(e) {
                            return e
                        } : x;
                    if (!l) throw new Error(h("The `attribute` option is required."));
                    if (!/^(and|or)$/.test(b)) throw new Error(h('The `operator` must one of: `"and"`, `"or"` (got "'.concat(b, '").')));
                    if (!0 === O && P <= g) throw new Error(h("`showMoreLimit` should be greater than `limit`."));
                    var k, M, A, N = function(e) {
                            var t = e.name,
                                r = e.escapedValue;
                            return o(o({}, s(e, p)), {}, {
                                value: r,
                                label: t,
                                highlighted: t
                            })
                        },
                        C = [],
                        T = !0,
                        F = !1,
                        D = function() {},
                        H = function() {
                            return function() {}
                        },
                        L = function(t, r) {
                            return function(n) {
                                return function(i) {
                                    var a = n.instantSearchInstance,
                                        c = n.results;
                                    if ("" === i && C) e(o(o({}, r.getWidgetRenderState(o(o({}, n), {}, {
                                        results: k
                                    }))), {}, {
                                        instantSearchInstance: a
                                    }), !1);
                                    else {
                                        var p = {
                                            highlightPreTag: R ? f.TAG_PLACEHOLDER.highlightPreTag : f.TAG_REPLACEMENT.highlightPreTag,
                                            highlightPostTag: R ? f.TAG_PLACEHOLDER.highlightPostTag : f.TAG_REPLACEMENT.highlightPostTag
                                        };
                                        t.searchForFacetValues(l, i, Math.min(u(), 100), p).then(function(t) {
                                            var i = R ? (0, f.escapeFacets)(t.facetHits) : t.facetHits,
                                                u = I(i.map(function(e) {
                                                    var t = e.escapedValue,
                                                        r = e.value;
                                                    return o(o({}, s(e, d)), {}, {
                                                        value: t,
                                                        label: r
                                                    })
                                                }), {
                                                    results: c
                                                });
                                            e(o(o({}, r.getWidgetRenderState(o(o({}, n), {}, {
                                                results: k
                                            }))), {}, {
                                                items: u,
                                                canToggleShowMore: !1,
                                                canRefine: !0,
                                                isFromSearch: !0,
                                                instantSearchInstance: a
                                            }), !1)
                                        })
                                    }
                                }
                            }
                        };
                    return {
                        $$type: "ais.refinementList",
                        init: function(t) {
                            e(o(o({}, this.getWidgetRenderState(t)), {}, {
                                instantSearchInstance: t.instantSearchInstance
                            }), !0)
                        },
                        render: function(t) {
                            e(o(o({}, this.getWidgetRenderState(t)), {}, {
                                instantSearchInstance: t.instantSearchInstance
                            }), !1)
                        },
                        getRenderState: function(e, t) {
                            return o(o({}, e), {}, {
                                refinementList: o(o({}, e.refinementList), {}, a({}, l, this.getWidgetRenderState(t)))
                            })
                        },
                        getWidgetRenderState: function(e) {
                            var t = e.results,
                                o = e.state,
                                a = e.createURL,
                                c = e.instantSearchInstance,
                                s = e.helper,
                                p = [],
                                d = [];
                            if (A && M && H || (A = (0, f.createSendEventForFacet)({
                                    instantSearchInstance: c,
                                    helper: s,
                                    attribute: l,
                                    widgetType: this.$$type
                                }), M = function(e) {
                                    A("click:internal", e), s.toggleFacetRefinement(l, e).search()
                                }, H = L(s, this)), t) {
                                var h = t.getFacetValues(l, {
                                    sortBy: w,
                                    facetOrdering: w === m
                                });
                                d = h && Array.isArray(h) ? h : [], p = I(d.slice(0, u()).map(N), {
                                    results: t
                                });
                                var y = o.maxValuesPerFacet,
                                    b = u();
                                T = y > b ? d.length <= b : d.length < b, k = t, C = p, e.results && (D = i(e, this))
                            }
                            var v = H && H(e),
                                _ = F && C.length > g,
                                j = O && !T,
                                P = _ || j;
                            return {
                                createURL: function(e) {
                                    return a(o.resetPage().toggleFacetRefinement(l, e))
                                },
                                items: p,
                                refine: M,
                                searchForItems: v,
                                isFromSearch: !1,
                                canRefine: p.length > 0,
                                widgetParams: r,
                                isShowingMore: F,
                                canToggleShowMore: P,
                                toggleShowMore: n,
                                sendEvent: A,
                                hasExhaustiveItems: T
                            }
                        },
                        dispose: function(e) {
                            var r = e.state;
                            t();
                            var n = r.setQueryParameter("maxValuesPerFacet", void 0);
                            return "and" === b ? n.removeFacet(l) : n.removeDisjunctiveFacet(l)
                        },
                        getWidgetUiState: function(e, t) {
                            var r = t.searchParameters,
                                n = "or" === b ? r.getDisjunctiveRefinements(l) : r.getConjunctiveRefinements(l);
                            return n.length ? o(o({}, e), {}, {
                                refinementList: o(o({}, e.refinementList), {}, a({}, l, n))
                            }) : e
                        },
                        getWidgetSearchParameters: function(e, t) {
                            var r = t.uiState,
                                n = "or" === b;
                            if (e.isHierarchicalFacet(l)) return e;
                            if (n && e.isConjunctiveFacet(l) || !n && e.isDisjunctiveFacet(l)) return e;
                            var i = r.refinementList && r.refinementList[l],
                                u = e.clearRefinements(l),
                                c = n ? u.addDisjunctiveFacet(l) : u.addFacet(l),
                                s = c.maxValuesPerFacet || 0,
                                f = Math.max(s, O ? P : g),
                                p = c.setQueryParameter("maxValuesPerFacet", f);
                            if (!i) {
                                var d = n ? "disjunctiveFacetsRefinements" : "facetsRefinements";
                                return p.setQueryParameters(a({}, d, o(o({}, p[d]), {}, a({}, l, []))))
                            }
                            return i.reduce(function(e, t) {
                                return n ? e.addDisjunctiveFacetRefinement(l, t) : e.addFacetRefinement(l, t)
                            }, p)
                        }
                    }
                }
        },
        b = y;
    t.default = b
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var n = r(3),
        i = r(2),
        o = r(14),
        a = {
            item: function(e) {
                var t = e.cssClasses,
                    r = e.count,
                    a = e.value,
                    u = e.highlighted,
                    c = e.isRefined,
                    s = e.isFromSearch;
                return (0, i.h)("label", {
                    className: (0, n.cx)(t.label)
                }, (0, i.h)("input", {
                    type: "checkbox",
                    className: (0, n.cx)(t.checkbox),
                    value: a,
                    defaultChecked: c
                }), (0, i.h)("span", {
                    className: (0, n.cx)(t.labelText),
                    dangerouslySetInnerHTML: s ? {
                        __html: u
                    } : void 0
                }, !s && u), (0, i.h)("span", {
                    className: (0, n.cx)(t.count)
                }, (0, o.formatNumber)(r)))
            },
            showMoreText: function(e) {
                return e.isShowingMore ? "Show less" : "Show more"
            },
            searchableNoResults: function() {
                return "No results"
            }
        },
        u = a;
    t.default = u
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }
    var s = r(1);
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var l = r(3),
        f = r(2),
        p = s(r(72)),
        d = s(r(309)),
        h = r(5),
        m = r(0),
        y = s(r(73)),
        b = (0, m.createDocumentationMessageGenerator)({
            name: "search-box"
        }),
        v = (0, h.component)("SearchBox"),
        g = function(e) {
            var t = e.containerNode,
                r = e.cssClasses,
                n = e.placeholder,
                i = e.templates,
                o = e.autofocus,
                a = e.searchAsYouType,
                u = e.showReset,
                c = e.showSubmit,
                s = e.showLoadingIndicator;
            return function(e) {
                var l = e.refine,
                    d = e.query,
                    h = e.isSearchStalled;
                (0, f.render)((0, f.h)(p.default, {
                    query: d,
                    placeholder: n,
                    autofocus: o,
                    refine: l,
                    searchAsYouType: a,
                    templates: i,
                    showSubmit: c,
                    showReset: u,
                    showLoadingIndicator: s,
                    isSearchStalled: h,
                    cssClasses: r
                }), t)
            }
        },
        _ = function(e) {
            var t = e || {},
                r = t.container,
                n = t.placeholder,
                i = void 0 === n ? "" : n,
                a = t.cssClasses,
                u = void 0 === a ? {} : a,
                c = t.autofocus,
                s = void 0 !== c && c,
                p = t.searchAsYouType,
                h = void 0 === p || p,
                _ = t.showReset,
                O = void 0 === _ || _,
                j = t.showSubmit,
                P = void 0 === j || j,
                S = t.showLoadingIndicator,
                w = void 0 === S || S,
                E = t.queryHook,
                R = t.templates,
                x = void 0 === R ? {} : R;
            if (!r) throw new Error(b("The `container` option is required."));
            var I = (0, m.getContainerNode)(r),
                k = {
                    root: (0, l.cx)(v(), u.root),
                    form: (0, l.cx)(v({
                        descendantName: "form"
                    }), u.form),
                    input: (0, l.cx)(v({
                        descendantName: "input"
                    }), u.input),
                    submit: (0, l.cx)(v({
                        descendantName: "submit"
                    }), u.submit),
                    submitIcon: (0, l.cx)(v({
                        descendantName: "submitIcon"
                    }), u.submitIcon),
                    reset: (0, l.cx)(v({
                        descendantName: "reset"
                    }), u.reset),
                    resetIcon: (0, l.cx)(v({
                        descendantName: "resetIcon"
                    }), u.resetIcon),
                    loadingIndicator: (0, l.cx)(v({
                        descendantName: "loadingIndicator"
                    }), u.loadingIndicator),
                    loadingIcon: (0, l.cx)(v({
                        descendantName: "loadingIcon"
                    }), u.loadingIcon)
                },
                M = o(o({}, y.default), x),
                A = g({
                    containerNode: I,
                    cssClasses: k,
                    placeholder: i,
                    templates: M,
                    autofocus: s,
                    searchAsYouType: h,
                    showReset: O,
                    showSubmit: P,
                    showLoadingIndicator: w
                });
            return o(o({}, (0, d.default)(A, function() {
                return (0, f.render)(null, I)
            })({
                queryHook: E
            })), {}, {
                $$widgetType: "ais.searchBox"
            })
        },
        O = _;
    t.default = O
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var s = r(0),
        l = (0, s.createDocumentationMessageGenerator)({
            name: "search-box",
            connector: !0
        }),
        f = function(e, t) {
            return t(e)
        },
        p = function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : s.noop;
            return (0, s.checkRendering)(e, l()),
                function(r) {
                    var n, i, a = r || {},
                        u = a.queryHook,
                        c = void 0 === u ? f : u;
                    return {
                        $$type: "ais.searchBox",
                        init: function(t) {
                            var r = t.instantSearchInstance;
                            e(o(o({}, this.getWidgetRenderState(t)), {}, {
                                instantSearchInstance: r
                            }), !0)
                        },
                        render: function(t) {
                            var r = t.instantSearchInstance;
                            e(o(o({}, this.getWidgetRenderState(t)), {}, {
                                instantSearchInstance: r
                            }), !1)
                        },
                        dispose: function(e) {
                            var r = e.state;
                            return t(), r.setQueryParameter("query", void 0)
                        },
                        getRenderState: function(e, t) {
                            return o(o({}, e), {}, {
                                searchBox: this.getWidgetRenderState(t)
                            })
                        },
                        getWidgetRenderState: function(e) {
                            var t = e.helper,
                                o = e.searchMetadata,
                                a = e.state;
                            return n || (n = function(e) {
                                c(e, function(e) {
                                    return t.setQuery(e).search()
                                })
                            }, i = function() {
                                t.setQuery("").search()
                            }), {
                                query: a.query || "",
                                refine: n,
                                clear: i,
                                widgetParams: r,
                                isSearchStalled: o.isSearchStalled
                            }
                        },
                        getWidgetUiState: function(e, t) {
                            var r = t.searchParameters,
                                n = r.query || "";
                            return "" === n || e && e.query === n ? e : o(o({}, e), {}, {
                                query: n
                            })
                        },
                        getWidgetSearchParameters: function(e, t) {
                            var r = t.uiState;
                            return e.setQueryParameter("query", r.query || "")
                        }
                    }
                }
        },
        d = p;
    t.default = d
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function s(e) {
        var t = e.nbHits,
            r = e.hasNoSortedResults,
            n = e.hasOneSortedResults,
            i = e.hasManySortedResults,
            o = e.nbSortedHits,
            a = "sorted out of ".concat((0, y.formatNumber)(t));
        return r ? "No relevant results ".concat(a) : n ? "1 relevant result ".concat(a) : i ? "".concat((0, y.formatNumber)(o || 0), " relevant results ").concat(a) : ""
    }

    function l(e) {
        var t = e.nbHits,
            r = e.hasNoResults,
            n = e.hasOneResult,
            i = e.hasManyResults;
        return r ? "No results" : n ? "1 result" : i ? "".concat((0, y.formatNumber)(t), " results") : ""
    }
    var f = r(1);
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.defaultTemplates = t.default = void 0;
    var p = r(3),
        d = r(2),
        h = f(r(311)),
        m = f(r(312)),
        y = r(14),
        b = r(5),
        v = r(10),
        g = r(0),
        _ = (0, g.createDocumentationMessageGenerator)({
            name: "stats"
        }),
        O = (0, b.component)("Stats"),
        j = {
            text: function(e) {
                return "".concat(e.areHitsSorted ? s(e) : l(e), " found in ").concat(e.processingTimeMS, "ms")
            }
        };
    t.defaultTemplates = j;
    var P = function(e) {
            var t = e.renderState,
                r = e.cssClasses,
                n = e.containerNode,
                i = e.templates;
            return function(e, o) {
                var a = e.hitsPerPage,
                    u = e.nbHits,
                    c = e.nbSortedHits,
                    s = e.areHitsSorted,
                    l = e.nbPages,
                    f = e.page,
                    p = e.processingTimeMS,
                    m = e.query,
                    y = e.instantSearchInstance;
                if (o) return void(t.templateProps = (0, v.prepareTemplateProps)({
                    defaultTemplates: j,
                    templatesConfig: y.templatesConfig,
                    templates: i
                }));
                (0, d.render)((0, d.h)(h.default, {
                    cssClasses: r,
                    hitsPerPage: a,
                    nbHits: u,
                    nbSortedHits: c,
                    areHitsSorted: s,
                    nbPages: l,
                    page: f,
                    processingTimeMS: p,
                    query: m,
                    templateProps: t.templateProps
                }), n)
            }
        },
        S = function(e) {
            var t = e || {},
                r = t.container,
                n = t.cssClasses,
                i = void 0 === n ? {} : n,
                a = t.templates,
                u = void 0 === a ? {} : a;
            if (!r) throw new Error(_("The `container` option is required."));
            var c = (0, g.getContainerNode)(r),
                s = {
                    root: (0, p.cx)(O(), i.root),
                    text: (0, p.cx)(O({
                        descendantName: "text"
                    }), i.text)
                },
                l = P({
                    containerNode: c,
                    cssClasses: s,
                    templates: u,
                    renderState: {}
                });
            return o(o({}, (0, m.default)(l, function() {
                return (0, d.render)(null, c)
            })({})), {}, {
                $$widgetType: "ais.stats"
            })
        },
        w = S;
    t.default = w
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i() {
        return i = Object.assign ? Object.assign.bind() : function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = arguments[t];
                for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
            }
            return e
        }, i.apply(this, arguments)
    }

    function o(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function a(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? o(Object(r), !0).forEach(function(t) {
                u(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : o(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function u(e, t, r) {
        return t = c(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function c(e) {
        var t = s(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function s(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function l(e, t) {
        if (null == e) return {};
        var r, n, i = f(e, t);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r])
        }
        return i
    }

    function f(e, t) {
        if (null == e) return {};
        var r, n, i = {},
            o = Object.keys(e);
        for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || (i[r] = e[r]);
        return i
    }
    var p = r(1);
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var d = r(3),
        h = r(2),
        m = p(r(7)),
        y = ["nbHits", "nbSortedHits", "cssClasses", "templateProps"],
        b = function(e) {
            var t = e.nbHits,
                r = e.nbSortedHits,
                n = e.cssClasses,
                o = e.templateProps,
                u = l(e, y);
            return (0, h.h)("div", {
                className: (0, d.cx)(n.root)
            }, (0, h.h)(m.default, i({}, o, {
                templateKey: "text",
                rootTagName: "span",
                rootProps: {
                    className: n.text
                },
                data: a({
                    hasManySortedResults: r && r > 1,
                    hasNoSortedResults: 0 === r,
                    hasOneSortedResults: 1 === r,
                    hasManyResults: t > 1,
                    hasNoResults: 0 === t,
                    hasOneResult: 1 === t,
                    nbHits: t,
                    nbSortedHits: r,
                    cssClasses: n
                }, u)
            })))
        },
        v = b;
    t.default = v
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var s = r(0),
        l = (0, s.createDocumentationMessageGenerator)({
            name: "stats",
            connector: !0
        }),
        f = function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : s.noop;
            return (0, s.checkRendering)(e, l()),
                function(r) {
                    return {
                        $$type: "ais.stats",
                        init: function(t) {
                            var r = t.instantSearchInstance;
                            e(o(o({}, this.getWidgetRenderState(t)), {}, {
                                instantSearchInstance: r
                            }), !0)
                        },
                        render: function(t) {
                            var r = t.instantSearchInstance;
                            e(o(o({}, this.getWidgetRenderState(t)), {}, {
                                instantSearchInstance: r
                            }), !1)
                        },
                        dispose: function() {
                            t()
                        },
                        getRenderState: function(e, t) {
                            return o(o({}, e), {}, {
                                stats: this.getWidgetRenderState(t)
                            })
                        },
                        getWidgetRenderState: function(e) {
                            var t = e.results,
                                n = e.state;
                            return t ? {
                                hitsPerPage: t.hitsPerPage,
                                nbHits: t.nbHits,
                                nbSortedHits: t.nbSortedHits,
                                areHitsSorted: void 0 !== t.appliedRelevancyStrictness && t.appliedRelevancyStrictness > 0 && t.nbSortedHits !== t.nbHits,
                                nbPages: t.nbPages,
                                page: t.page,
                                processingTimeMS: t.processingTimeMS,
                                query: t.query,
                                widgetParams: r
                            } : {
                                hitsPerPage: n.hitsPerPage,
                                nbHits: 0,
                                nbSortedHits: void 0,
                                areHitsSorted: !1,
                                nbPages: 0,
                                page: n.page || 0,
                                processingTimeMS: -1,
                                query: n.query || "",
                                widgetParams: r
                            }
                        }
                    }
                }
        },
        p = f;
    t.default = p
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }
    var s = r(1);
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var l = r(3),
        f = r(2),
        p = s(r(314)),
        d = s(r(315)),
        h = r(5),
        m = r(0),
        y = (0, m.createDocumentationMessageGenerator)({
            name: "sort-by"
        }),
        b = (0, h.component)("SortBy"),
        v = function(e) {
            var t = e.containerNode,
                r = e.cssClasses;
            return function(e, n) {
                var i = e.currentRefinement,
                    o = e.options,
                    a = e.refine;
                n || (0, f.render)((0, f.h)("div", {
                    className: r.root
                }, (0, f.h)(p.default, {
                    cssClasses: r,
                    currentValue: i,
                    options: o,
                    setValue: a
                })), t)
            }
        },
        g = function(e) {
            var t = e || {},
                r = t.container,
                n = t.items,
                i = t.cssClasses,
                a = void 0 === i ? {} : i,
                u = t.transformItems;
            if (!r) throw new Error(y("The `container` option is required."));
            var c = (0, m.getContainerNode)(r),
                s = {
                    root: (0, l.cx)(b(), a.root),
                    select: (0, l.cx)(b({
                        descendantName: "select"
                    }), a.select),
                    option: (0, l.cx)(b({
                        descendantName: "option"
                    }), a.option)
                },
                p = v({
                    containerNode: c,
                    cssClasses: s
                });
            return o(o({}, (0, d.default)(p, function() {
                return (0, f.render)(null, c)
            })({
                container: c,
                items: n,
                transformItems: u
            })), {}, {
                $$widgetType: "ais.sortBy"
            })
        },
        _ = g;
    t.default = _
}, function(e, t, r) {
    "use strict";

    function n(e) {
        var t = e.currentValue,
            r = e.options,
            n = e.cssClasses,
            a = e.setValue;
        return (0, o.h)("select", {
            className: (0, i.cx)(n.select),
            onChange: function(e) {
                return a(e.target.value)
            },
            value: "".concat(t)
        }, r.map(function(e) {
            return (0, o.h)("option", {
                className: (0, i.cx)(n.option),
                key: e.label + e.value,
                value: "".concat(e.value)
            }, e.label)
        }))
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var i = r(3),
        o = r(2),
        a = n;
    t.default = a
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var s = r(0),
        l = (0, s.createDocumentationMessageGenerator)({
            name: "sort-by",
            connector: !0
        }),
        f = function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : s.noop;
            (0, s.checkRendering)(e, l());
            var r = {};
            return function(n) {
                var i = n || {},
                    a = i.items,
                    u = i.transformItems,
                    c = void 0 === u ? function(e) {
                        return e
                    } : u;
                if (!Array.isArray(a)) throw new Error(l("The `items` option expects an array of objects."));
                return {
                    $$type: "ais.sortBy",
                    init: function(t) {
                        var r = t.instantSearchInstance,
                            n = this.getWidgetRenderState(t),
                            i = n.currentRefinement;
                        (0, s.find)(a, function(e) {
                            return e.value === i
                        }), e(o(o({}, n), {}, {
                            instantSearchInstance: r
                        }), !0)
                    },
                    render: function(t) {
                        var r = t.instantSearchInstance;
                        e(o(o({}, this.getWidgetRenderState(t)), {}, {
                            instantSearchInstance: r
                        }), !1)
                    },
                    dispose: function(e) {
                        var n = e.state;
                        return t(), r.initialIndex ? n.setIndex(r.initialIndex) : n
                    },
                    getRenderState: function(e, t) {
                        return o(o({}, e), {}, {
                            sortBy: this.getWidgetRenderState(t)
                        })
                    },
                    getWidgetRenderState: function(e) {
                        var t = e.results,
                            i = e.helper,
                            o = e.state,
                            u = e.parent;
                        !r.initialIndex && u && (r.initialIndex = u.getIndexName()), r.setIndex || (r.setIndex = function(e) {
                            i.setIndex(e).search()
                        });
                        var s = !t || 0 === t.nbHits;
                        return {
                            currentRefinement: o.index,
                            options: c(a, {
                                results: t
                            }),
                            refine: r.setIndex,
                            hasNoResults: s,
                            canRefine: !s && a.length > 0,
                            widgetParams: n
                        }
                    },
                    getWidgetUiState: function(e, t) {
                        var n = t.searchParameters,
                            i = n.index;
                        return o(o({}, e), {}, {
                            sortBy: i !== r.initialIndex ? i : void 0
                        })
                    },
                    getWidgetSearchParameters: function(e, t) {
                        var n = t.uiState;
                        return e.setQueryParameter("index", n.sortBy || r.initialIndex || e.index)
                    }
                }
            }
        },
        p = f;
    t.default = p
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }
    var s = r(1);
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var l = r(3),
        f = r(2),
        p = s(r(317)),
        d = s(r(318)),
        h = r(5),
        m = r(10),
        y = r(0),
        b = s(r(319)),
        v = (0, y.createDocumentationMessageGenerator)({
            name: "clear-refinements"
        }),
        g = (0, h.component)("ClearRefinements"),
        _ = function(e) {
            var t = e.containerNode,
                r = e.cssClasses,
                n = e.renderState,
                i = e.templates;
            return function(e, o) {
                var a = e.refine,
                    u = e.canRefine,
                    c = e.instantSearchInstance;
                if (o) return void(n.templateProps = (0, m.prepareTemplateProps)({
                    defaultTemplates: b.default,
                    templatesConfig: c.templatesConfig,
                    templates: i
                }));
                (0, f.render)((0, f.h)(p.default, {
                    refine: a,
                    cssClasses: r,
                    hasRefinements: u,
                    templateProps: n.templateProps
                }), t)
            }
        },
        O = function(e) {
            var t = e || {},
                r = t.container,
                n = t.templates,
                i = void 0 === n ? {} : n,
                a = t.includedAttributes,
                u = t.excludedAttributes,
                c = t.transformItems,
                s = t.cssClasses,
                p = void 0 === s ? {} : s;
            if (!r) throw new Error(v("The `container` option is required."));
            var h = (0, y.getContainerNode)(r),
                m = {
                    root: (0, l.cx)(g(), p.root),
                    button: (0, l.cx)(g({
                        descendantName: "button"
                    }), p.button),
                    disabledButton: (0, l.cx)(g({
                        descendantName: "button",
                        modifierName: "disabled"
                    }), p.disabledButton)
                },
                b = _({
                    containerNode: h,
                    cssClasses: m,
                    renderState: {},
                    templates: i
                });
            return o(o({}, (0, d.default)(b, function() {
                return (0, f.render)(null, h)
            })({
                includedAttributes: a,
                excludedAttributes: u,
                transformItems: c
            })), {}, {
                $$widgetType: "ais.clearRefinements"
            })
        },
        j = O;
    t.default = j
}, function(e, t, r) {
    "use strict";

    function n() {
        return n = Object.assign ? Object.assign.bind() : function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = arguments[t];
                for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
            }
            return e
        }, n.apply(this, arguments)
    }
    var i = r(1);
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var o = r(3),
        a = r(2),
        u = i(r(7)),
        c = function(e) {
            var t = e.hasRefinements,
                r = e.refine,
                i = e.cssClasses,
                c = e.templateProps;
            return (0, a.h)("div", {
                className: i.root
            }, (0, a.h)(u.default, n({}, c, {
                templateKey: "resetLabel",
                rootTagName: "button",
                rootProps: {
                    className: (0, o.cx)(i.button, !t && i.disabledButton),
                    onClick: r,
                    disabled: !t
                },
                data: {
                    hasRefinements: t
                }
            })))
        },
        s = c;
    t.default = s
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e) {
        return c(e) || u(e) || a(e) || o()
    }

    function o() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
    }

    function a(e, t) {
        if (e) {
            if ("string" == typeof e) return s(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? s(e, t) : void 0
        }
    }

    function u(e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e)
    }

    function c(e) {
        if (Array.isArray(e)) return s(e)
    }

    function s(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
        return n
    }

    function l(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function f(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? l(Object(r), !0).forEach(function(t) {
                p(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : l(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function p(e, t, r) {
        return t = d(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function d(e) {
        var t = h(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function h(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function m(e) {
        var t = e.scopedResult,
            r = e.includedAttributes,
            n = e.excludedAttributes,
            i = e.transformItems,
            o = e.results,
            a = -1 !== r.indexOf("query") || -1 === n.indexOf("query");
        return {
            helper: t.helper,
            items: i((0, y.uniq)((0, y.getRefinements)(t.results, t.helper.state, a).map(function(e) {
                return e.attribute
            }).filter(function(e) {
                return 0 === r.length || -1 !== r.indexOf(e)
            }).filter(function(e) {
                return "query" === e && a || -1 === n.indexOf(e)
            })), {
                results: o
            })
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var y = r(0),
        b = (0, y.createDocumentationMessageGenerator)({
            name: "clear-refinements",
            connector: !0
        }),
        v = function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : y.noop;
            return (0, y.checkRendering)(e, b()),
                function(r) {
                    var n = r || {},
                        o = n.includedAttributes,
                        a = void 0 === o ? [] : o,
                        u = n.excludedAttributes,
                        c = void 0 === u ? ["query"] : u,
                        s = n.transformItems,
                        l = void 0 === s ? function(e) {
                            return e
                        } : s;
                    if (r && r.includedAttributes && r.excludedAttributes) throw new Error(b("The options `includedAttributes` and `excludedAttributes` cannot be used together."));
                    var p = {
                            refine: y.noop,
                            createURL: function() {
                                return ""
                            },
                            attributesToClear: []
                        },
                        d = function() {
                            return p.refine()
                        },
                        h = function() {
                            return p.createURL()
                        };
                    return {
                        $$type: "ais.clearRefinements",
                        init: function(t) {
                            var r = t.instantSearchInstance;
                            e(f(f({}, this.getWidgetRenderState(t)), {}, {
                                instantSearchInstance: r
                            }), !0)
                        },
                        render: function(t) {
                            var r = t.instantSearchInstance;
                            e(f(f({}, this.getWidgetRenderState(t)), {}, {
                                instantSearchInstance: r
                            }), !1)
                        },
                        dispose: function() {
                            t()
                        },
                        getRenderState: function(e, t) {
                            return f(f({}, e), {}, {
                                clearRefinements: this.getWidgetRenderState(t)
                            })
                        },
                        getWidgetRenderState: function(e) {
                            var t = e.createURL,
                                n = e.scopedResults,
                                o = e.results;
                            p.attributesToClear = n.reduce(function(e, t) {
                                return e.concat(m({
                                    scopedResult: t,
                                    includedAttributes: a,
                                    excludedAttributes: c,
                                    transformItems: l,
                                    results: o
                                }))
                            }, []), p.refine = function() {
                                p.attributesToClear.forEach(function(e) {
                                    var t = e.helper,
                                        r = e.items;
                                    t.setState((0, y.clearRefinements)({
                                        helper: t,
                                        attributesToClear: r
                                    })).search()
                                })
                            }, p.createURL = function() {
                                return t(y.mergeSearchParameters.apply(void 0, i(p.attributesToClear.map(function(e) {
                                    var t = e.helper,
                                        r = e.items;
                                    return (0, y.clearRefinements)({
                                        helper: t,
                                        attributesToClear: r
                                    })
                                }))))
                            };
                            var u = p.attributesToClear.some(function(e) {
                                return e.items.length > 0
                            });
                            return {
                                canRefine: u,
                                hasRefinements: u,
                                refine: d,
                                createURL: h,
                                widgetParams: r
                            }
                        }
                    }
                }
        },
        g = v;
    t.default = g
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var n = {
            resetLabel: function() {
                return "Clear refinements"
            }
        },
        i = n;
    t.default = i
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }
    var s = r(1);
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var l = r(3),
        f = r(2),
        p = s(r(321)),
        d = r(5),
        h = r(0),
        m = (0, h.createDocumentationMessageGenerator)({
            name: "panel"
        }),
        y = (0, d.component)("Panel"),
        b = function(e) {
            var t = e.containerNode,
                r = e.bodyContainerNode,
                n = e.cssClasses,
                i = e.templates;
            return function(e) {
                var o = e.options,
                    a = e.hidden,
                    u = e.collapsible,
                    c = e.collapsed;
                (0, f.render)((0, f.h)(p.default, {
                    cssClasses: n,
                    hidden: a,
                    collapsible: u,
                    isCollapsed: c,
                    templates: i,
                    data: o,
                    bodyElement: r
                }), t)
            }
        },
        v = function(e) {
            var t = e || {},
                r = t.templates,
                n = void 0 === r ? {} : r,
                i = t.hidden,
                a = void 0 === i ? function() {
                    return !1
                } : i,
                u = t.collapsed,
                c = t.cssClasses,
                s = void 0 === c ? {} : c,
                p = document.createElement("div"),
                d = Boolean(u),
                v = "function" == typeof u ? u : function() {
                    return !1
                },
                g = {
                    root: (0, l.cx)(y(), s.root),
                    noRefinementRoot: (0, l.cx)(y({
                        modifierName: "noRefinement"
                    }), s.noRefinementRoot),
                    collapsibleRoot: (0, l.cx)(y({
                        modifierName: "collapsible"
                    }), s.collapsibleRoot),
                    collapsedRoot: (0, l.cx)(y({
                        modifierName: "collapsed"
                    }), s.collapsedRoot),
                    collapseButton: (0, l.cx)(y({
                        descendantName: "collapseButton"
                    }), s.collapseButton),
                    collapseIcon: (0, l.cx)(y({
                        descendantName: "collapseIcon"
                    }), s.collapseIcon),
                    body: (0, l.cx)(y({
                        descendantName: "body"
                    }), s.body),
                    header: (0, l.cx)(y({
                        descendantName: "header"
                    }), s.header),
                    footer: (0, l.cx)(y({
                        descendantName: "footer"
                    }), s.footer)
                };
            return function(e) {
                return function(t) {
                    if (!t || !t.container) throw new Error(m("The `container` option is required in the widget within the panel."));
                    var r = (0, h.getContainerNode)(t.container),
                        i = {
                            collapseButtonText: function(e) {
                                var t = e.collapsed;
                                return '<svg\n          class="'.concat(g.collapseIcon, '"\n          style="width: 1em; height: 1em;"\n          viewBox="0 0 500 500"\n        >\n        <path d="').concat(t ? "M100 250l300-150v300z" : "M250 400l150-300H100z", '" fill="currentColor" />\n        </svg>')
                            }
                        },
                        u = b({
                            containerNode: r,
                            bodyContainerNode: p,
                            cssClasses: g,
                            templates: o(o({}, i), n)
                        }),
                        c = e(o(o({}, t), {}, {
                            container: p
                        }));
                    return o(o({}, c), {}, {
                        init: function() {
                            for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
                            var n = t[0],
                                i = o(o({}, c.getWidgetRenderState ? c.getWidgetRenderState(n) : {}), n);
                            if (u({
                                    options: i,
                                    hidden: !0,
                                    collapsible: d,
                                    collapsed: !1
                                }), "function" == typeof c.init) {
                                var a;
                                (a = c.init).call.apply(a, [this].concat(t))
                            }
                        },
                        render: function() {
                            for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
                            var n = t[0],
                                i = o(o({}, c.getWidgetRenderState ? c.getWidgetRenderState(n) : {}), n);
                            if (u({
                                    options: i,
                                    hidden: Boolean(a(i)),
                                    collapsible: d,
                                    collapsed: Boolean(v(i))
                                }), "function" == typeof c.render) {
                                var s;
                                (s = c.render).call.apply(s, [this].concat(t))
                            }
                        },
                        dispose: function() {
                            if ((0, f.render)(null, r), "function" == typeof c.dispose) {
                                for (var e, t = arguments.length, n = new Array(t), i = 0; i < t; i++) n[i] = arguments[i];
                                return (e = c.dispose).call.apply(e, [this].concat(n))
                            }
                        }
                    })
                }
            }
        },
        g = v;
    t.default = g
}, function(e, t, r) {
    "use strict";

    function n(e, t) {
        return c(e) || u(e, t) || o(e, t) || i()
    }

    function i() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
    }

    function o(e, t) {
        if (e) {
            if ("string" == typeof e) return a(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? a(e, t) : void 0
        }
    }

    function a(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
        return n
    }

    function u(e, t) {
        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (null != r) {
            var n, i, o, a, u = [],
                c = !0,
                s = !1;
            try {
                if (o = (r = r.call(e)).next, 0 === t) {
                    if (Object(r) !== r) return;
                    c = !1
                } else
                    for (; !(c = (n = o.call(r)).done) && (u.push(n.value), u.length !== t); c = !0);
            } catch (e) {
                s = !0, i = e
            } finally {
                try {
                    if (!c && null != r.return && (a = r.return(), Object(a) !== a)) return
                } finally {
                    if (s) throw i
                }
            }
            return u
        }
    }

    function c(e) {
        if (Array.isArray(e)) return e
    }

    function s(e) {
        var t = (0, d.useState)(e.isCollapsed),
            r = n(t, 2),
            i = r[0],
            o = r[1],
            a = (0, d.useState)(!1),
            u = n(a, 2),
            c = u[0],
            s = u[1],
            l = (0, d.useRef)(null);
        return (0, d.useEffect)(function() {
            var t = l.current;
            if (t) return t.appendChild(e.bodyElement),
                function() {
                    t.removeChild(e.bodyElement)
                }
        }, [l, e.bodyElement]), c || e.isCollapsed === i || o(e.isCollapsed), (0, p.h)("div", {
            className: (0, f.cx)(e.cssClasses.root, e.hidden && e.cssClasses.noRefinementRoot, e.collapsible && e.cssClasses.collapsibleRoot, i && e.cssClasses.collapsedRoot),
            hidden: e.hidden
        }, e.templates.header && (0, p.h)("div", {
            className: e.cssClasses.header
        }, (0, p.h)(h.default, {
            templates: e.templates,
            templateKey: "header",
            rootTagName: "span",
            data: e.data
        }), e.collapsible && (0, p.h)("button", {
            className: e.cssClasses.collapseButton,
            "aria-expanded": !i,
            onClick: function(e) {
                e.preventDefault(), s(!0), o(function(e) {
                    return !e
                })
            }
        }, (0, p.h)(h.default, {
            templates: e.templates,
            templateKey: "collapseButtonText",
            rootTagName: "span",
            data: {
                collapsed: i
            }
        }))), (0, p.h)("div", {
            className: e.cssClasses.body,
            ref: l
        }), e.templates.footer && (0, p.h)(h.default, {
            templates: e.templates,
            templateKey: "footer",
            rootProps: {
                className: e.cssClasses.footer
            },
            data: e.data
        }))
    }
    var l = r(1);
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var f = r(3),
        p = r(2),
        d = r(322),
        h = l(r(7)),
        m = s;
    t.default = m
}, function(e, t, r) {
    "use strict";

    function n(e, t) {
        E.options.__h && E.options.__h(P, e, R || t), R = 0;
        var r = P.__H || (P.__H = {
            __: [],
            __h: []
        });
        return e >= r.__.length && r.__.push({
            __V: I
        }), r.__[e]
    }

    function i(e) {
        return R = 1, o(O, e)
    }

    function o(e, t, r) {
        var i = n(j++, 2);
        if (i.t = e, !i.__c && (i.__ = [r ? r(t) : O(void 0, t), function(e) {
                var t = i.__N ? i.__N[0] : i.__[0],
                    r = i.t(t, e);
                t !== r && (i.__N = [r, i.__[1]], i.__c.setState({}))
            }], i.__c = P, !P.u)) {
            var o = function(e, t, r) {
                if (!i.__c.__H) return !0;
                var n = i.__c.__H.__.filter(function(e) {
                    return e.__c
                });
                if (n.every(function(e) {
                        return !e.__N
                    })) return !a || a.call(this, e, t, r);
                var o = !1;
                return n.forEach(function(e) {
                    if (e.__N) {
                        var t = e.__[0];
                        e.__ = e.__N, e.__N = void 0, t !== e.__[0] && (o = !0)
                    }
                }), !(!o && i.__c.props === e) && (!a || a.call(this, e, t, r))
            };
            P.u = !0;
            var a = P.shouldComponentUpdate,
                u = P.componentWillUpdate;
            P.componentWillUpdate = function(e, t, r) {
                if (this.__e) {
                    var n = a;
                    a = void 0, o(e, t, r), a = n
                }
                u && u.call(this, e, t, r)
            }, P.shouldComponentUpdate = o
        }
        return i.__N || i.__
    }

    function a(e, t) {
        var r = n(j++, 3);
        !E.options.__s && _(r.__H, t) && (r.__ = e, r.i = t, P.__H.__h.push(r))
    }

    function u(e, t) {
        var r = n(j++, 4);
        !E.options.__s && _(r.__H, t) && (r.__ = e, r.i = t, P.__h.push(r))
    }

    function c(e) {
        return R = 5, l(function() {
            return {
                current: e
            }
        }, [])
    }

    function s(e, t, r) {
        R = 6, u(function() {
            return "function" == typeof e ? (e(t()), function() {
                return e(null)
            }) : e ? (e.current = t(), function() {
                return e.current = null
            }) : void 0
        }, null == r ? r : r.concat(e))
    }

    function l(e, t) {
        var r = n(j++, 7);
        return _(r.__H, t) ? (r.__V = e(), r.i = t, r.__h = e, r.__V) : r.__
    }

    function f(e, t) {
        return R = 8, l(function() {
            return e
        }, t)
    }

    function p(e) {
        var t = P.context[e.__c],
            r = n(j++, 9);
        return r.c = e, t ? (null == r.__ && (r.__ = !0, t.sub(P)), t.props.value) : e.__
    }

    function d(e, t) {
        E.options.useDebugValue && E.options.useDebugValue(t ? t(e) : e)
    }

    function h(e) {
        var t = n(j++, 10),
            r = i();
        return t.__ = e, P.componentDidCatch || (P.componentDidCatch = function(e, n) {
            t.__ && t.__(e, n), r[1](e)
        }), [r[0], function() {
            r[1](void 0)
        }]
    }

    function m() {
        var e = n(j++, 11);
        if (!e.__) {
            for (var t = P.__v; null !== t && !t.__m && null !== t.__;) t = t.__;
            var r = t.__m || (t.__m = [0, 0]);
            e.__ = "P" + r[0] + "-" + r[1]++
        }
        return e.__
    }

    function y() {
        for (var e; e = x.shift();)
            if (e.__P && e.__H) try {
                e.__H.__h.forEach(v), e.__H.__h.forEach(g), e.__H.__h = []
            } catch (t) {
                e.__H.__h = [], E.options.__e(t, e.__v)
            }
    }

    function b(e) {
        var t, r = function() {
                clearTimeout(n), T && cancelAnimationFrame(t), setTimeout(e)
            },
            n = setTimeout(r, 100);
        T && (t = requestAnimationFrame(r))
    }

    function v(e) {
        var t = P,
            r = e.__c;
        "function" == typeof r && (e.__c = void 0, r()), P = t
    }

    function g(e) {
        var t = P;
        e.__c = e.__(), P = t
    }

    function _(e, t) {
        return !e || e.length !== t.length || t.some(function(t, r) {
            return t !== e[r]
        })
    }

    function O(e, t) {
        return "function" == typeof t ? t(e) : t
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.useCallback = f, t.useContext = p, t.useDebugValue = d, t.useEffect = a, t.useErrorBoundary = h, t.useId = m, t.useImperativeHandle = s, t.useLayoutEffect = u, t.useMemo = l, t.useReducer = o, t.useRef = c, t.useState = i;
    var j, P, S, w, E = r(2),
        R = 0,
        x = [],
        I = [],
        k = E.options.__b,
        M = E.options.__r,
        A = E.options.diffed,
        N = E.options.__c,
        C = E.options.unmount;
    E.options.__b = function(e) {
        P = null, k && k(e)
    }, E.options.__r = function(e) {
        M && M(e), j = 0;
        var t = (P = e.__c).__H;
        t && (S === P ? (t.__h = [], P.__h = [], t.__.forEach(function(e) {
            e.__N && (e.__ = e.__N), e.__V = I, e.__N = e.i = void 0
        })) : (t.__h.forEach(v), t.__h.forEach(g), t.__h = [], j = 0)), S = P
    }, E.options.diffed = function(e) {
        A && A(e);
        var t = e.__c;
        t && t.__H && (t.__H.__h.length && (1 !== x.push(t) && w === E.options.requestAnimationFrame || ((w = E.options.requestAnimationFrame) || b)(y)), t.__H.__.forEach(function(e) {
            e.i && (e.__H = e.i), e.__V !== I && (e.__ = e.__V), e.i = void 0, e.__V = I
        })), S = P = null
    }, E.options.__c = function(e, t) {
        t.some(function(e) {
            try {
                e.__h.forEach(v), e.__h = e.__h.filter(function(e) {
                    return !e.__ || g(e)
                })
            } catch (r) {
                t.some(function(e) {
                    e.__h && (e.__h = [])
                }), t = [], E.options.__e(r, e.__v)
            }
        }), N && N(e, t)
    }, E.options.unmount = function(e) {
        C && C(e);
        var t, r = e.__c;
        r && r.__H && (r.__H.__.forEach(function(e) {
            try {
                v(e)
            } catch (e) {
                t = e
            }
        }), r.__H = void 0, t && E.options.__e(t, r.__v))
    };
    var T = "function" == typeof requestAnimationFrame
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }
    var s = r(1);
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var l = r(3),
        f = r(2),
        p = s(r(324)),
        d = s(r(325)),
        h = r(326),
        m = r(5),
        y = r(10),
        b = r(0),
        v = s(r(328)),
        g = (0, b.createDocumentationMessageGenerator)({
            name: "hits"
        }),
        _ = (0, m.component)("Hits"),
        O = function(e) {
            var t = e.renderState,
                r = e.cssClasses,
                n = e.containerNode,
                i = e.templates;
            return function(e, o) {
                var a = e.hits,
                    u = e.results,
                    c = e.instantSearchInstance,
                    s = e.insights,
                    l = e.bindEvent,
                    d = e.sendEvent;
                if (o) return void(t.templateProps = (0, y.prepareTemplateProps)({
                    defaultTemplates: v.default,
                    templatesConfig: c.templatesConfig,
                    templates: i
                }));
                (0, f.render)((0, f.h)(p.default, {
                    cssClasses: r,
                    hits: a,
                    results: u,
                    templateProps: t.templateProps,
                    insights: s,
                    sendEvent: d,
                    bindEvent: l
                }), n)
            }
        },
        j = function(e) {
            var t = e || {},
                r = t.container,
                n = t.escapeHTML,
                i = t.transformItems,
                a = t.templates,
                u = void 0 === a ? {} : a,
                c = t.cssClasses,
                s = void 0 === c ? {} : c;
            if (!r) throw new Error(g("The `container` option is required."));
            var p = (0, b.getContainerNode)(r),
                m = {
                    root: (0, l.cx)(_(), s.root),
                    emptyRoot: (0, l.cx)(_({
                        modifierName: "empty"
                    }), s.emptyRoot),
                    list: (0, l.cx)(_({
                        descendantName: "list"
                    }), s.list),
                    item: (0, l.cx)(_({
                        descendantName: "item"
                    }), s.item)
                },
                y = O({
                    containerNode: p,
                    cssClasses: m,
                    renderState: {},
                    templates: u
                });
            return o(o({}, (0, h.withInsights)(d.default)(y, function() {
                return (0, f.render)(null, p)
            })({
                escapeHTML: n,
                transformItems: i
            })), {}, {
                $$widgetType: "ais.hits"
            })
        },
        P = j;
    t.default = P
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function s() {
        return s = Object.assign ? Object.assign.bind() : function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var r = arguments[t];
                for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
            }
            return e
        }, s.apply(this, arguments)
    }

    function l(e) {
        var t = e.results,
            r = e.hits,
            n = e.insights,
            i = e.bindEvent,
            a = e.sendEvent,
            u = e.cssClasses,
            c = e.templateProps,
            l = (0, h.createInsightsEventHandler)({
                insights: n,
                sendEvent: a
            });
        return 0 === t.hits.length ? (0, d.h)(m.default, s({}, c, {
            templateKey: "empty",
            rootProps: {
                className: (0, p.cx)(u.root, u.emptyRoot),
                onClick: l
            },
            data: t
        })) : (0, d.h)("div", {
            className: u.root
        }, (0, d.h)("ol", {
            className: u.list
        }, r.map(function(e, t) {
            return (0, d.h)(m.default, s({}, c, {
                templateKey: "item",
                rootTagName: "li",
                rootProps: {
                    className: u.item,
                    onClick: function(t) {
                        l(t), a("click:internal", e, "Hit Clicked")
                    }
                },
                key: e.objectID,
                data: o(o({}, e), {}, {
                    get __hitIndex() {
                        return t
                    }
                }),
                bindEvent: i,
                sendEvent: a
            }))
        })))
    }
    var f = r(1);
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = l;
    var p = r(3),
        d = r(2),
        h = r(74),
        m = (r(0), f(r(7)))
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var s = r(0),
        l = (0, s.createDocumentationMessageGenerator)({
            name: "hits",
            connector: !0
        }),
        f = function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : s.noop;
            return (0, s.checkRendering)(e, l()),
                function(r) {
                    var n, i, u = r || {},
                        c = u.escapeHTML,
                        l = void 0 === c || c,
                        f = u.transformItems,
                        p = void 0 === f ? function(e) {
                            return e
                        } : f;
                    return {
                        $$type: "ais.hits",
                        init: function(t) {
                            e(o(o({}, this.getWidgetRenderState(t)), {}, {
                                instantSearchInstance: t.instantSearchInstance
                            }), !0)
                        },
                        render: function(t) {
                            var r = this.getWidgetRenderState(t);
                            e(o(o({}, r), {}, {
                                instantSearchInstance: t.instantSearchInstance
                            }), !1), r.sendEvent("view:internal", r.hits)
                        },
                        getRenderState: function(e, t) {
                            return o(o({}, e), {}, {
                                hits: this.getWidgetRenderState(t)
                            })
                        },
                        getWidgetRenderState: function(e) {
                            var t = e.results,
                                o = e.helper,
                                a = e.instantSearchInstance;
                            if (n || (n = (0, s.createSendEventForHits)({
                                    instantSearchInstance: a,
                                    index: o.getIndex(),
                                    widgetType: this.$$type
                                })), i || (i = (0, s.createBindEventForHits)({
                                    index: o.getIndex(),
                                    widgetType: this.$$type,
                                    instantSearchInstance: a
                                })), !t) return {
                                hits: [],
                                results: void 0,
                                sendEvent: n,
                                bindEvent: i,
                                widgetParams: r
                            };
                            l && t.hits.length > 0 && (t.hits = (0, s.escapeHits)(t.hits));
                            var u = (0, s.addAbsolutePosition)(t.hits, t.page, t.hitsPerPage),
                                c = (0, s.addQueryID)(u, t.queryID);
                            return {
                                hits: p(c, {
                                    results: t
                                }),
                                results: t,
                                sendEvent: n,
                                bindEvent: i,
                                widgetParams: r
                            }
                        },
                        dispose: function(e) {
                            var r = e.state;
                            return t(), l ? r.setQueryParameters(Object.keys(s.TAG_PLACEHOLDER).reduce(function(e, t) {
                                return o(o({}, e), {}, a({}, t, void 0))
                            }, {})) : r
                        },
                        getWidgetSearchParameters: function(e) {
                            return l ? e.setQueryParameters(s.TAG_PLACEHOLDER) : e
                        }
                    }
                }
        },
        p = f;
    t.default = p
}, function(e, t, r) {
    "use strict";

    function n(e) {
        if ("function" != typeof WeakMap) return null;
        var t = new WeakMap,
            r = new WeakMap;
        return (n = function(e) {
            return e ? r : t
        })(e)
    }
    var i = r(1),
        o = r(29);
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), Object.defineProperty(t, "inferInsightsPayload", {
        enumerable: !0,
        get: function() {
            return a.inferPayload
        }
    }), Object.defineProperty(t, "withInsights", {
        enumerable: !0,
        get: function() {
            return a.default
        }
    }), Object.defineProperty(t, "withInsightsListener", {
        enumerable: !0,
        get: function() {
            return u.default
        }
    });
    var a = function(e, t) {
            if (e && e.__esModule) return e;
            if (null === e || "object" !== o(e) && "function" != typeof e) return {
                default: e
            };
            var r = n(t);
            if (r && r.has(e)) return r.get(e);
            var i = {},
                a = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var u in e)
                if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
                    var c = a ? Object.getOwnPropertyDescriptor(e, u) : null;
                    c && (c.get || c.set) ? Object.defineProperty(i, u, c) : i[u] = e[u]
                }
            return i.default = e, r && r.set(e, i), i
        }(r(327)),
        u = i(r(74))
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function s(e) {
        return function(t, r) {
            return e(function(e, r) {
                var n = e.results,
                    i = e.hits,
                    a = e.instantSearchInstance;
                if (n && i && a) {
                    var u = m(a.insightsClient, n, i);
                    return t(o(o({}, e), {}, {
                        insights: u
                    }), r)
                }
                return t(e, r)
            }, r)
        }
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = s, t.inferPayload = void 0;
    var l = r(0),
        f = function(e, t) {
            return t.map(function(t) {
                var r = (0, l.find)(e, function(e) {
                    return e.objectID === t
                });
                if (void 0 === r) throw new Error('Could not find objectID "'.concat(t, '" passed to `clickedObjectIDsAfterSearch` in the returned hits. This is necessary to infer the absolute position and the query ID.'));
                return r
            })
        },
        p = function(e) {
            var t = (0, l.uniq)(e.map(function(e) {
                return e.__queryID
            }));
            if (t.length > 1) throw new Error("Insights currently allows a single `queryID`. The `objectIDs` provided map to multiple `queryID`s.");
            var r = t[0];
            if ("string" != typeof r) throw new Error("Could not infer `queryID`. Ensure InstantSearch `clickAnalytics: true` was added with the Configure widget.\n\nSee: https://alg.li/lNiZZ7");
            return r
        },
        d = function(e) {
            return e.map(function(e) {
                return e.__position
            })
        },
        h = function(e) {
            var t = e.method,
                r = e.results,
                n = e.hits,
                i = e.objectIDs,
                o = r.index,
                a = f(n, i),
                u = p(a);
            switch (t) {
                case "clickedObjectIDsAfterSearch":
                    return {
                        index: o,
                        queryID: u,
                        objectIDs: i,
                        positions: d(a)
                    };
                case "convertedObjectIDsAfterSearch":
                    return {
                        index: o,
                        queryID: u,
                        objectIDs: i
                    };
                default:
                    throw new Error('Unsupported method passed to insights: "'.concat(t, '".'))
            }
        };
    t.inferPayload = h;
    var m = function(e, t, r) {
        return function(n) {
            for (var i = arguments.length, a = new Array(i > 1 ? i - 1 : 0), u = 1; u < i; u++) a[u - 1] = arguments[u];
            var c = a[0];
            if (!e) {
                var s = (0, l.createDocumentationMessageGenerator)({
                    name: "instantsearch"
                });
                throw new Error(s("The `insightsClient` option has not been provided to `instantsearch`."))
            }
            if (!Array.isArray(c.objectIDs)) throw new TypeError("Expected `objectIDs` to be an array.");
            var f = h({
                method: n,
                results: t,
                hits: r,
                objectIDs: c.objectIDs
            });
            e(n, o(o({}, f), c))
        }
    }
}, function(e, t, r) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var n = r(0),
        i = {
            empty: function() {
                return "No results"
            },
            item: function(e) {
                return JSON.stringify((0, n.omit)(e, ["__hitIndex"]), null, 2)
            }
        },
        o = i;
    t.default = o
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }
    var s = r(1);
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var l = r(3),
        f = r(2),
        p = s(r(330)),
        d = s(r(331)),
        h = r(5),
        m = r(0),
        y = (0, h.component)("Pagination"),
        b = (0, m.createDocumentationMessageGenerator)({
            name: "pagination"
        }),
        v = {
            previous: function() {
                return "‹"
            },
            next: function() {
                return "›"
            },
            page: function(e) {
                return "".concat(e.page)
            },
            first: function() {
                return "«"
            },
            last: function() {
                return "»"
            }
        },
        g = function(e) {
            var t = e.containerNode,
                r = e.cssClasses,
                n = e.templates,
                i = e.showFirst,
                o = e.showLast,
                a = e.showPrevious,
                u = e.showNext,
                c = e.scrollToNode;
            return function(e, s) {
                var l = e.createURL,
                    d = e.currentRefinement,
                    h = e.nbPages,
                    m = e.pages,
                    y = e.isFirstPage,
                    b = e.isLastPage,
                    v = e.refine;
                if (!s) {
                    var g = function(e) {
                        v(e), !1 !== c && c.scrollIntoView()
                    };
                    (0, f.render)((0, f.h)(p.default, {
                        createURL: l,
                        cssClasses: r,
                        currentPage: d,
                        templates: n,
                        nbPages: h,
                        pages: m,
                        isFirstPage: y,
                        isLastPage: b,
                        setCurrentPage: g,
                        showFirst: i,
                        showLast: o,
                        showPrevious: a,
                        showNext: u
                    }), t)
                }
            }
        },
        _ = function(e) {
            var t = e || {},
                r = t.container,
                n = t.templates,
                i = void 0 === n ? {} : n,
                a = t.cssClasses,
                u = void 0 === a ? {} : a,
                c = t.totalPages,
                s = t.padding,
                p = t.showFirst,
                h = void 0 === p || p,
                _ = t.showLast,
                O = void 0 === _ || _,
                j = t.showPrevious,
                P = void 0 === j || j,
                S = t.showNext,
                w = void 0 === S || S,
                E = t.scrollTo,
                R = void 0 === E ? "body" : E;
            if (!r) throw new Error(b("The `container` option is required."));
            var x = (0, m.getContainerNode)(r),
                I = !0 === R ? "body" : R,
                k = !1 !== I && (0, m.getContainerNode)(I),
                M = {
                    root: (0, l.cx)(y(), u.root),
                    noRefinementRoot: (0, l.cx)(y({
                        modifierName: "noRefinement"
                    }), u.noRefinementRoot),
                    list: (0, l.cx)(y({
                        descendantName: "list"
                    }), u.list),
                    item: (0, l.cx)(y({
                        descendantName: "item"
                    }), u.item),
                    firstPageItem: (0, l.cx)(y({
                        descendantName: "item",
                        modifierName: "firstPage"
                    }), u.firstPageItem),
                    lastPageItem: (0, l.cx)(y({
                        descendantName: "item",
                        modifierName: "lastPage"
                    }), u.lastPageItem),
                    previousPageItem: (0, l.cx)(y({
                        descendantName: "item",
                        modifierName: "previousPage"
                    }), u.previousPageItem),
                    nextPageItem: (0, l.cx)(y({
                        descendantName: "item",
                        modifierName: "nextPage"
                    }), u.nextPageItem),
                    pageItem: (0, l.cx)(y({
                        descendantName: "item",
                        modifierName: "page"
                    }), u.pageItem),
                    selectedItem: (0, l.cx)(y({
                        descendantName: "item",
                        modifierName: "selected"
                    }), u.selectedItem),
                    disabledItem: (0, l.cx)(y({
                        descendantName: "item",
                        modifierName: "disabled"
                    }), u.disabledItem),
                    link: (0, l.cx)(y({
                        descendantName: "link"
                    }), u.link)
                },
                A = o(o({}, v), i),
                N = g({
                    containerNode: x,
                    cssClasses: M,
                    templates: A,
                    showFirst: h,
                    showLast: O,
                    showPrevious: P,
                    showNext: w,
                    scrollToNode: k
                });
            return o(o({}, (0, d.default)(N, function() {
                return (0, f.render)(null, x)
            })({
                totalPages: c,
                padding: s
            })), {}, {
                $$widgetType: "ais.pagination"
            })
        },
        O = _;
    t.default = O
}, function(e, t, r) {
    "use strict";

    function n(e) {
        function t(t) {
            return function(r) {
                (0, c.isSpecialClick)(r) || (r.preventDefault(), e.setCurrentPage(t))
            }
        }
        return (0, u.h)("div", {
            className: (0, a.cx)(e.cssClasses.root, e.nbPages <= 1 && e.cssClasses.noRefinementRoot)
        }, (0, u.h)("ul", {
            className: e.cssClasses.list
        }, e.showFirst && (0, u.h)(i, {
            ariaLabel: "First",
            className: e.cssClasses.firstPageItem,
            isDisabled: e.isFirstPage,
            templates: e.templates,
            templateKey: "first",
            pageNumber: 0,
            createURL: e.createURL,
            cssClasses: e.cssClasses,
            createClickHandler: t
        }), e.showPrevious && (0, u.h)(i, {
            ariaLabel: "Previous",
            className: e.cssClasses.previousPageItem,
            isDisabled: e.isFirstPage,
            templates: e.templates,
            templateKey: "previous",
            pageNumber: e.currentPage - 1,
            createURL: e.createURL,
            cssClasses: e.cssClasses,
            createClickHandler: t
        }), e.pages.map(function(r) {
            return (0, u.h)(i, {
                key: r,
                ariaLabel: "Page ".concat(r + 1),
                className: e.cssClasses.pageItem,
                isSelected: r === e.currentPage,
                templates: e.templates,
                templateKey: "page",
                pageNumber: r,
                createURL: e.createURL,
                cssClasses: e.cssClasses,
                createClickHandler: t
            })
        }), e.showNext && (0, u.h)(i, {
            ariaLabel: "Next",
            className: e.cssClasses.nextPageItem,
            isDisabled: e.isLastPage,
            templates: e.templates,
            templateKey: "next",
            pageNumber: e.currentPage + 1,
            createURL: e.createURL,
            cssClasses: e.cssClasses,
            createClickHandler: t
        }), e.showLast && (0, u.h)(i, {
            ariaLabel: "Last",
            className: e.cssClasses.lastPageItem,
            isDisabled: e.isLastPage,
            templates: e.templates,
            templateKey: "last",
            pageNumber: e.nbPages - 1,
            createURL: e.createURL,
            cssClasses: e.cssClasses,
            createClickHandler: t
        })))
    }

    function i(e) {
        var t = e.templates,
            r = e.templateKey,
            n = e.ariaLabel,
            i = e.pageNumber,
            o = e.className,
            c = e.isDisabled,
            l = void 0 !== c && c,
            f = e.isSelected,
            p = void 0 !== f && f,
            d = e.cssClasses,
            h = e.createURL,
            m = e.createClickHandler;
        return (0, u.h)("li", {
            className: (0, a.cx)(d.item, o, l && d.disabledItem, p && d.selectedItem)
        }, l ? (0, u.h)(s.default, {
            rootTagName: "span",
            rootProps: {
                className: d.link
            },
            templateKey: r,
            templates: t,
            data: {
                page: i + 1
            }
        }) : (0, u.h)(s.default, {
            rootTagName: "a",
            rootProps: {
                className: d.link,
                "aria-label": n,
                href: h(i),
                onClick: m(i)
            },
            templateKey: r,
            templates: t,
            data: {
                page: i + 1
            }
        }))
    }
    var o = r(1);
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var a = r(3),
        u = r(2),
        c = r(0),
        s = o(r(7)),
        l = n;
    t.default = l
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }
    var s = r(1);
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var l = r(0),
        f = s(r(332)),
        p = (0, l.createDocumentationMessageGenerator)({
            name: "pagination",
            connector: !0
        }),
        d = function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : l.noop;
            return (0, l.checkRendering)(e, p()),
                function(r) {
                    function n(e) {
                        var t = e.nbPages;
                        return void 0 !== a ? Math.min(a, t) : t
                    }
                    var i = r || {},
                        a = i.totalPages,
                        u = i.padding,
                        c = void 0 === u ? 3 : u,
                        s = new f.default({
                            currentPage: 0,
                            total: 0,
                            padding: c
                        }),
                        l = {};
                    return {
                        $$type: "ais.pagination",
                        init: function(t) {
                            var r = t.instantSearchInstance;
                            e(o(o({}, this.getWidgetRenderState(t)), {}, {
                                instantSearchInstance: r
                            }), !0)
                        },
                        render: function(t) {
                            var r = t.instantSearchInstance;
                            e(o(o({}, this.getWidgetRenderState(t)), {}, {
                                instantSearchInstance: r
                            }), !1)
                        },
                        dispose: function(e) {
                            var r = e.state;
                            return t(), r.setQueryParameter("page", void 0)
                        },
                        getWidgetUiState: function(e, t) {
                            var r = t.searchParameters,
                                n = r.page || 0;
                            return n ? o(o({}, e), {}, {
                                page: n + 1
                            }) : e
                        },
                        getWidgetSearchParameters: function(e, t) {
                            var r = t.uiState,
                                n = r.page ? r.page - 1 : 0;
                            return e.setQueryParameter("page", n)
                        },
                        getWidgetRenderState: function(e) {
                            var t = e.results,
                                i = e.helper,
                                o = e.state,
                                a = e.createURL;
                            l.refine || (l.refine = function(e) {
                                i.setPage(e), i.search()
                            }), l.createURL || (l.createURL = function(e) {
                                return function(t) {
                                    return a(e.setPage(t))
                                }
                            });
                            var u = o.page || 0,
                                c = n(t || {
                                    nbPages: 0
                                });
                            return s.currentPage = u, s.total = c, {
                                createURL: l.createURL(o),
                                refine: l.refine,
                                canRefine: c > 1,
                                currentRefinement: u,
                                nbHits: (null === t || void 0 === t ? void 0 : t.nbHits) || 0,
                                nbPages: c,
                                pages: t ? s.pages() : [],
                                isFirstPage: s.isFirstPage(),
                                isLastPage: s.isLastPage(),
                                widgetParams: r
                            }
                        },
                        getRenderState: function(e, t) {
                            return o(o({}, e), {}, {
                                pagination: this.getWidgetRenderState(t)
                            })
                        }
                    }
                }
        },
        h = d;
    t.default = h
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
    }

    function o(e, t) {
        for (var r = 0; r < t.length; r++) {
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, c(n.key), n)
        }
    }

    function a(e, t, r) {
        return t && o(e.prototype, t), r && o(e, r), Object.defineProperty(e, "prototype", {
            writable: !1
        }), e
    }

    function u(e, t, r) {
        return t = c(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function c(e) {
        var t = s(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function s(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var l = r(0),
        f = function() {
            function e(t) {
                i(this, e), u(this, "currentPage", void 0), u(this, "total", void 0), u(this, "padding", void 0), this.currentPage = t.currentPage, this.total = t.total, this.padding = t.padding
            }
            return a(e, [{
                key: "pages",
                value: function() {
                    var e = this.total,
                        t = this.currentPage,
                        r = this.padding;
                    if (0 === e) return [0];
                    var n = this.nbPagesDisplayed(r, e);
                    if (n === e) return (0, l.range)({
                        end: e
                    });
                    var i = this.calculatePaddingLeft(t, r, e, n),
                        o = n - i,
                        a = t - i,
                        u = t + o;
                    return (0, l.range)({
                        start: a,
                        end: u
                    })
                }
            }, {
                key: "nbPagesDisplayed",
                value: function(e, t) {
                    return Math.min(2 * e + 1, t)
                }
            }, {
                key: "calculatePaddingLeft",
                value: function(e, t, r, n) {
                    return e <= t ? e : e >= r - t ? n - (r - e) : t
                }
            }, {
                key: "isLastPage",
                value: function() {
                    return this.currentPage === this.total - 1 || 0 === this.total
                }
            }, {
                key: "isFirstPage",
                value: function() {
                    return 0 === this.currentPage
                }
            }]), e
        }(),
        p = f;
    t.default = p
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }
    var s = r(1);
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var l = s(r(334)),
        f = r(0),
        p = function(e) {
            return o(o({}, (0, l.default)(f.noop)({
                searchParameters: e
            })), {}, {
                $$widgetType: "ais.configure"
            })
        },
        d = p;
    t.default = d
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(r), !0).forEach(function(t) {
                a(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function a(e, t, r) {
        return t = u(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function u(e) {
        var t = c(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function c(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function s(e, t) {
        return e.setQueryParameters(Object.keys(t.searchParameters).reduce(function(e, t) {
            return o(o({}, e), {}, a({}, t, void 0))
        }, {}))
    }
    var l = r(1);
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var f = l(r(22)),
        p = r(0),
        d = (0, p.createDocumentationMessageGenerator)({
            name: "configure",
            connector: !0
        }),
        h = function() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : p.noop,
                t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : p.noop;
            return function(r) {
                function n(e) {
                    return function(t) {
                        var n = s(e.state, r),
                            i = (0, p.mergeSearchParameters)(n, new f.default.SearchParameters(t));
                        r.searchParameters = t, e.setState(i).search()
                    }
                }
                if (!r || !(0, p.isPlainObject)(r.searchParameters)) throw new Error(d("The `searchParameters` option expects an object."));
                var i = {};
                return {
                    $$type: "ais.configure",
                    init: function(t) {
                        var r = t.instantSearchInstance;
                        e(o(o({}, this.getWidgetRenderState(t)), {}, {
                            instantSearchInstance: r
                        }), !0)
                    },
                    render: function(t) {
                        var r = t.instantSearchInstance;
                        e(o(o({}, this.getWidgetRenderState(t)), {}, {
                            instantSearchInstance: r
                        }), !1)
                    },
                    dispose: function(e) {
                        var n = e.state;
                        return t(), s(n, r)
                    },
                    getRenderState: function(e, t) {
                        var r, n = this.getWidgetRenderState(t);
                        return o(o({}, e), {}, {
                            configure: o(o({}, n), {}, {
                                widgetParams: o(o({}, n.widgetParams), {}, {
                                    searchParameters: (0, p.mergeSearchParameters)(new f.default.SearchParameters(null === (r = e.configure) || void 0 === r ? void 0 : r.widgetParams.searchParameters), new f.default.SearchParameters(n.widgetParams.searchParameters)).getQueryParams()
                                })
                            })
                        })
                    },
                    getWidgetRenderState: function(e) {
                        var t = e.helper;
                        return i.refine || (i.refine = n(t)), {
                            refine: i.refine,
                            widgetParams: r
                        }
                    },
                    getWidgetSearchParameters: function(e, t) {
                        var n = t.uiState;
                        return (0, p.mergeSearchParameters)(e, new f.default.SearchParameters(o(o({}, n.configure), r.searchParameters)))
                    },
                    getWidgetUiState: function(e) {
                        return o(o({}, e), {}, {
                            configure: o(o({}, e.configure), r.searchParameters)
                        })
                    }
                }
            }
        },
        m = h;
    t.default = m
}, function(e, t, r) {
    "use strict";

    function n(e) {
        "@babel/helpers - typeof";
        return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function i(e) {
        return c(e) || u(e) || a(e) || o()
    }

    function o() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
    }

    function a(e, t) {
        if (e) {
            if ("string" == typeof e) return s(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? s(e, t) : void 0
        }
    }

    function u(e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e)
    }

    function c(e) {
        if (Array.isArray(e)) return s(e)
    }

    function s(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
        return n
    }

    function l(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            })), r.push.apply(r, n)
        }
        return r
    }

    function f(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? l(Object(r), !0).forEach(function(t) {
                p(e, t, r[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : l(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            })
        }
        return e
    }

    function p(e, t, r) {
        return t = d(t), t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e
    }

    function d(e) {
        var t = h(e, "string");
        return "symbol" === n(t) ? t : String(t)
    }

    function h(e, t) {
        if ("object" !== n(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
            var i = r.call(e, t || "default");
            if ("object" !== n(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.")
        }
        return ("string" === t ? String : Number)(e)
    }

    function m(e) {
        var t = e.results,
            r = e.helper,
            n = e.indexId,
            o = e.includedAttributes,
            a = e.excludedAttributes,
            u = -1 !== (o || []).indexOf("query") || -1 === (a || []).indexOf("query"),
            c = o ? function(e) {
                return -1 !== o.indexOf(e.attribute)
            } : function(e) {
                return -1 === a.indexOf(e.attribute)
            },
            s = (0, O.getRefinements)(t, r.state, u).map(g).filter(c);
        return s.reduce(function(e, t) {
            return [].concat(i(e.filter(function(e) {
                return e.attribute !== t.attribute
            })), [{
                indexName: r.state.index,
                indexId: n,
                attribute: t.attribute,
                label: t.attribute,
                refinements: s.filter(function(e) {
                    return e.attribute === t.attribute
                }).sort(function(e, t) {
                    return "numeric" === e.type ? e.value - t.value : 0
                }),
                refine: function(e) {
                    return b(r, e)
                }
            }])
        }, [])
    }

    function y(e, t) {
        switch (e = e.resetPage(), t.type) {
            case "facet":
                return e.removeFacetRefinement(t.attribute, String(t.value));
            case "disjunctive":
                return e.removeDisjunctiveFacetRefinement(t.attribute, String(t.value));
            case "hierarchical":
                return e.removeHierarchicalFacetRefinement(t.attribute);
            case "exclude":
                return e.removeExcludeRefinement(t.attribute, String(t.value));
            case "numeric":
                return e.removeNumericRefinement(t.attribute, t.operator, String(t.value));
            case "tag":
                return e.removeTagRefinement(String(t.value));
            case "query":
                return e.setQueryParameter("query", "");
            default:
                return e
        }
    }

    function b(e, t) {
        e.setState(y(e.state, t)).search()
    }

    function v(e) {
        switch (e) {
            case ">=":
                return "≥";
            case "<=":
                return "≤";
            default:
                return e
        }
    }

    function g(e) {
        var t = _(e),
            r = e.operator ? "".concat(v(e.operator), " ").concat(e.name) : e.name,
            n = {
                attribute: e.attribute,
                type: e.type,
                value: t,
                label: r
            };
        return void 0 !== e.operator && (n.operator = e.operator), void 0 !== e.count && (n.count = e.count), void 0 !== e.exhaustive && (n.exhaustive = e.exhaustive), n
    }

    function _(e) {
        return "numeric" === e.type ? Number(e.name) : "escapedValue" in e ? e.escapedValue : e.name
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = void 0;
    var O = r(0),
        j = (0, O.createDocumentationMessageGenerator)({
            name: "current-refinements",
            connector: !0
        }),
        P = function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : O.noop;
            return (0, O.checkRendering)(e, j()),
                function(r) {
                    if ((r || {}).includedAttributes && (r || {}).excludedAttributes) throw new Error(j("The options `includedAttributes` and `excludedAttributes` cannot be used together."));
                    var n = r || {},
                        i = n.includedAttributes,
                        o = n.excludedAttributes,
                        a = void 0 === o ? ["query"] : o,
                        u = n.transformItems,
                        c = void 0 === u ? function(e) {
                            return e
                        } : u;
                    return {
                        $$type: "ais.currentRefinements",
                        init: function(t) {
                            var r = t.instantSearchInstance;
                            e(f(f({}, this.getWidgetRenderState(t)), {}, {
                                instantSearchInstance: r
                            }), !0)
                        },
                        render: function(t) {
                            var r = t.instantSearchInstance;
                            e(f(f({}, this.getWidgetRenderState(t)), {}, {
                                instantSearchInstance: r
                            }), !1)
                        },
                        dispose: function() {
                            t()
                        },
                        getRenderState: function(e, t) {
                            return f(f({}, e), {}, {
                                currentRefinements: this.getWidgetRenderState(t)
                            })
                        },
                        getWidgetRenderState: function(e) {
                            var t = e.results,
                                n = e.scopedResults,
                                o = e.createURL,
                                u = e.helper,
                                s = function() {
                                    return t ? n.reduce(function(e, r) {
                                        return e.concat(c(m({
                                            results: r.results,
                                            helper: r.helper,
                                            indexId: r.indexId,
                                            includedAttributes: i,
                                            excludedAttributes: a
                                        }), {
                                            results: t
                                        }))
                                    }, []) : c(m({
                                        results: {},
                                        helper: u,
                                        indexId: u.state.index,
                                        includedAttributes: i,
                                        excludedAttributes: a
                                    }), {
                                        results: t
                                    })
                                }();
                            return {
                                items: s,
                                canRefine: s.length > 0,
                                refine: function(e) {
                                    return b(u, e)
                                },
                                createURL: function(e) {
                                    return o(y(u.state, e))
                                },
                                widgetParams: r
                            }
                        }
                    }
                }
        },
        S = P;
    t.default = S
}]);